import { POI } from "@state/mapStore"

export const poisWithDistances: POI[] = [
  {
    name: "University College London",
    category: "Universities",
    coordinates: {
      lat: 51.52464261757258,
      lng: -0.1342948647163309,
    },
    id: "671b6f548844e00026fe9a67",
    routes: {
      driving: {
        distances: {},
        path: [
          [-0.17163, 51.52116],
          [-0.17143000000000003, 51.521],
          [-0.17120000000000002, 51.52087],
          [-0.17077, 51.520520000000005],
          [-0.17046, 51.52028000000001],
          [-0.17019, 51.52009],
          [-0.16994, 51.520100000000006],
          [-0.16922, 51.520160000000004],
          [-0.16849, 51.52029],
          [-0.16758, 51.52049],
          [-0.16724000000000003, 51.520500000000006],
          [-0.16679000000000002, 51.520610000000005],
          [-0.16646000000000002, 51.520680000000006],
          [-0.16606, 51.52076],
          [-0.16464, 51.52094],
          [-0.16364, 51.52113000000001],
          [-0.16257000000000002, 51.52131000000001],
          [-0.16033, 51.5217],
          [-0.15892, 51.521950000000004],
          [-0.15717, 51.52225000000001],
          [-0.15316000000000002, 51.52297],
          [-0.15243, 51.52310000000001],
          [-0.15137, 51.52317000000001],
          [-0.1506, 51.523230000000005],
          [-0.14953000000000002, 51.52331],
          [-0.14888, 51.52338],
          [-0.14789000000000002, 51.52355000000001],
          [-0.14614000000000002, 51.523860000000006],
          [-0.14546, 51.52398],
          [-0.14500000000000002, 51.524060000000006],
          [-0.14477, 51.52409],
          [-0.14450000000000002, 51.52412],
          [-0.14402, 51.524080000000005],
          [-0.1436, 51.52404000000001],
          [-0.14332, 51.52404000000001],
          [-0.14295000000000002, 51.524010000000004],
          [-0.1428, 51.524010000000004],
          [-0.14237000000000002, 51.52405],
          [-0.14159000000000002, 51.52422000000001],
          [-0.14105, 51.524370000000005],
          [-0.14085, 51.524420000000006],
          [-0.14070000000000002, 51.52451000000001],
          [-0.14063, 51.52454],
          [-0.13978000000000002, 51.52478000000001],
          [-0.13868, 51.525090000000006],
          [-0.13831000000000002, 51.525180000000006],
          [-0.13811, 51.52523000000001],
          [-0.13801000000000002, 51.525110000000005],
          [-0.13790000000000002, 51.52499],
          [-0.13773000000000002, 51.52501],
          [-0.13770000000000002, 51.52503],
          [-0.13741, 51.52505000000001],
          [-0.13694, 51.52517],
          [-0.13668000000000002, 51.525290000000005],
          [-0.13637000000000002, 51.525400000000005],
          [-0.13608, 51.52548],
          [-0.13594, 51.525510000000004],
          [-0.13591, 51.525510000000004],
          [-0.13578, 51.52539],
          [-0.13546000000000002, 51.5251],
          [-0.13526000000000002, 51.524910000000006],
          [-0.13475, 51.52445],
        ],
        steps: [
          {
            distance: "0.2 km",
            duration: "1 min",
            instructions:
              "Head <b>southeast</b> on <b>Edgware Rd</b>/<wbr/><b>A5</b> toward <b>Newcastle Pl</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "0.2 km",
            duration: "1 min",
            instructions:
              "Turn <b>left</b> (signs for <b>Ring Rd E</b>/<wbr/><b>A400</b>/<wbr/><b>A1</b>/<wbr/><b>The City</b>/<wbr/><b>Euston</b>/<wbr/><b>Kings Cross</b>)",
            travelMode: "DRIVING",
          },
          {
            distance: "1.9 km",
            duration: "7 mins",
            instructions:
              'Merge onto <b>Marylebone Rd</b>/<wbr/><b>Marylebone Flyover</b>/<wbr/><b>A501</b><div style="font-size:0.9em">Continue to follow A501</div>',
            travelMode: "DRIVING",
          },
          {
            distance: "0.2 km",
            duration: "1 min",
            instructions:
              "Take the <b>A400</b> exit toward <b>Holloway</b>/<wbr/><b>Camden Town</b>/<wbr/><b>West End</b>/<wbr/><b>Westminster</b>/<wbr/><b>Holborn</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "0.2 km",
            duration: "1 min",
            instructions: "Keep <b>right</b> to continue on <b>Euston Rd.</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "0.1 km",
            duration: "1 min",
            instructions:
              '<b>Euston Rd.</b> turns <b>right</b> and becomes <b>Gower St</b><div style="font-size:0.9em">Entering toll zone</div><div style="font-size:0.9em">Destination will be on the left</div>',
            travelMode: "DRIVING",
          },
        ],
      },
      walking: {
        distances: {},
        path: [
          [-0.17170000000000002, 51.52112],
          [-0.17154000000000003, 51.521],
          [-0.17139000000000001, 51.521080000000005],
          [-0.17135, 51.521040000000006],
          [-0.17125, 51.520970000000005],
          [-0.17114000000000001, 51.520900000000005],
          [-0.17076000000000002, 51.520590000000006],
          [-0.17047, 51.520390000000006],
          [-0.17022, 51.52024],
          [-0.17013, 51.52013],
          [-0.17002, 51.520140000000005],
          [-0.16979000000000002, 51.52015],
          [-0.16945000000000002, 51.52018],
          [-0.16898000000000002, 51.52024],
          [-0.16848000000000002, 51.52033],
          [-0.16807000000000002, 51.520430000000005],
          [-0.16776000000000002, 51.520500000000006],
          [-0.16746000000000003, 51.520540000000004],
          [-0.16728, 51.520570000000006],
          [-0.16688, 51.52066000000001],
          [-0.16657000000000002, 51.520720000000004],
          [-0.16636, 51.520770000000006],
          [-0.16608, 51.52082000000001],
          [-0.16589, 51.52084000000001],
          [-0.16569, 51.520860000000006],
          [-0.16569, 51.52084000000001],
          [-0.16567, 51.52076],
          [-0.16553, 51.52078],
          [-0.16552, 51.52073000000001],
          [-0.16587000000000002, 51.520700000000005],
          [-0.16584000000000002, 51.52062],
          [-0.16584000000000002, 51.5206],
          [-0.16552, 51.52062],
          [-0.16552, 51.520610000000005],
          [-0.16541, 51.52062],
          [-0.16541, 51.52065],
          [-0.1653, 51.52066000000001],
          [-0.16533, 51.520630000000004],
          [-0.16528, 51.520610000000005],
          [-0.16522, 51.52065],
          [-0.16495, 51.520700000000005],
          [-0.16449000000000003, 51.52078],
          [-0.16410000000000002, 51.520860000000006],
          [-0.16409, 51.52084000000001],
          [-0.16394, 51.52087],
          [-0.16390000000000002, 51.52087],
          [-0.16391, 51.520900000000005],
          [-0.16379000000000002, 51.52091000000001],
          [-0.16328, 51.520990000000005],
          [-0.16291000000000003, 51.521060000000006],
          [-0.16290000000000002, 51.521060000000006],
          [-0.16281, 51.521080000000005],
          [-0.16282000000000002, 51.52109],
          [-0.16245, 51.52114],
          [-0.16209, 51.521190000000004],
          [-0.16157000000000002, 51.52127],
          [-0.16113000000000002, 51.521330000000006],
          [-0.16093000000000002, 51.52136],
          [-0.16095, 51.52141],
          [-0.16080000000000003, 51.52141],
          [-0.16059, 51.521440000000005],
          [-0.16033, 51.52149000000001],
          [-0.15966000000000002, 51.52161],
          [-0.15964, 51.521570000000004],
          [-0.15944000000000003, 51.52160000000001],
          [-0.15947, 51.52167000000001],
          [-0.15937, 51.52169000000001],
          [-0.15813000000000002, 51.521910000000005],
          [-0.15753, 51.522000000000006],
          [-0.15746000000000002, 51.52205000000001],
          [-0.15736, 51.522040000000004],
          [-0.15713000000000002, 51.522090000000006],
          [-0.15676, 51.52215],
          [-0.15653, 51.52219],
          [-0.15618, 51.52221],
          [-0.15575, 51.522290000000005],
          [-0.15509, 51.522450000000006],
          [-0.15335000000000001, 51.52277],
          [-0.15269000000000002, 51.522870000000005],
          [-0.15253, 51.522920000000006],
          [-0.15239000000000003, 51.52295],
          [-0.15214000000000003, 51.52295],
          [-0.15189000000000002, 51.522960000000005],
          [-0.15174, 51.52297],
          [-0.15156, 51.523010000000006],
          [-0.15124, 51.523030000000006],
          [-0.15123, 51.523],
          [-0.15105000000000002, 51.52302],
          [-0.15106, 51.52306],
          [-0.15096, 51.523070000000004],
          [-0.15097000000000002, 51.52315],
          [-0.15100000000000002, 51.52315],
          [-0.15101, 51.523160000000004],
          [-0.15100000000000002, 51.523160000000004],
          [-0.15082, 51.52317000000001],
          [-0.15084, 51.523270000000004],
          [-0.15066000000000002, 51.52328000000001],
          [-0.15013, 51.52333],
          [-0.14905000000000002, 51.52342],
          [-0.1486, 51.523480000000006],
          [-0.1481, 51.52356],
          [-0.14803000000000002, 51.52358],
          [-0.14806000000000002, 51.52362],
          [-0.14787, 51.52366000000001],
          [-0.14783000000000002, 51.52366000000001],
          [-0.14782, 51.52364000000001],
          [-0.14768, 51.52366000000001],
          [-0.14737, 51.523720000000004],
          [-0.14627, 51.523920000000004],
          [-0.14607, 51.52394],
          [-0.14570000000000002, 51.524010000000004],
          [-0.14502, 51.52413000000001],
          [-0.14495000000000002, 51.52414],
          [-0.14483000000000001, 51.524100000000004],
          [-0.14472000000000002, 51.52411000000001],
          [-0.14469, 51.52416],
          [-0.14464000000000002, 51.52416],
          [-0.14450000000000002, 51.524170000000005],
          [-0.14432, 51.52416],
          [-0.14425000000000002, 51.52416],
          [-0.14425000000000002, 51.52420000000001],
          [-0.14409000000000002, 51.524190000000004],
          [-0.14409000000000002, 51.524150000000006],
          [-0.14385, 51.52412],
          [-0.14358, 51.52409],
          [-0.14350000000000002, 51.52409],
          [-0.14348000000000002, 51.52411000000001],
          [-0.14337000000000003, 51.52409],
          [-0.14336000000000002, 51.52412],
          [-0.14333, 51.524080000000005],
          [-0.14322000000000001, 51.524100000000004],
          [-0.14321, 51.52409],
          [-0.14312000000000002, 51.524080000000005],
          [-0.1429, 51.52407],
          [-0.14264000000000002, 51.524100000000004],
          [-0.14209000000000002, 51.52418],
          [-0.14133, 51.52438],
          [-0.14088, 51.52447],
          [-0.14075000000000001, 51.52454],
          [-0.14048000000000002, 51.52463],
          [-0.13990000000000002, 51.52479],
          [-0.13978000000000002, 51.524860000000004],
          [-0.13945000000000002, 51.524950000000004],
          [-0.13929000000000002, 51.525020000000005],
          [-0.13911, 51.52505000000001],
          [-0.13879000000000002, 51.52514000000001],
          [-0.13862000000000002, 51.525180000000006],
          [-0.13853000000000001, 51.52523000000001],
          [-0.13848000000000002, 51.52517],
          [-0.13846, 51.52514000000001],
          [-0.13835, 51.52516000000001],
          [-0.13820000000000002, 51.52496000000001],
          [-0.1383, 51.524910000000006],
          [-0.13824, 51.52483],
          [-0.13797, 51.52494],
          [-0.13769, 51.52497],
          [-0.13740000000000002, 51.52499],
          [-0.13725, 51.525000000000006],
          [-0.13705, 51.52505000000001],
          [-0.13663, 51.52526],
          [-0.13648000000000002, 51.525330000000004],
          [-0.13606000000000001, 51.525450000000006],
          [-0.13598000000000002, 51.52546],
          [-0.13588, 51.52537],
          [-0.13585, 51.525380000000006],
          [-0.13571, 51.52544],
          [-0.13566, 51.525400000000005],
          [-0.13551000000000002, 51.52528],
          [-0.13523000000000002, 51.52501],
          [-0.13489, 51.524680000000004],
          [-0.13455, 51.52436],
          [-0.1345, 51.52431000000001],
          [-0.13422, 51.52443],
          [-0.13441, 51.52459],
        ],
        steps: [
          {
            distance: "0.2 km",
            duration: "2 mins",
            instructions:
              "Head <b>southeast</b> on <b>Edgware Rd</b>/<wbr/><b>A5</b> toward <b>Newcastle Pl</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.2 km",
            duration: "3 mins",
            instructions:
              "Turn <b>left</b> (signs for <b>Ring Rd E</b>/<wbr/><b>A400</b>/<wbr/><b>A1</b>/<wbr/><b>The City</b>/<wbr/><b>Euston</b>/<wbr/><b>Kings Cross</b>)",
            travelMode: "WALKING",
          },
          {
            distance: "0.1 km",
            duration: "2 mins",
            instructions:
              'Continue onto <b>Marylebone Rd</b>/<wbr/><b>Marylebone Flyover</b>/<wbr/><b>A501</b><div style="font-size:0.9em">Continue to follow Marylebone Rd/<wbr/>A501</div>',
            travelMode: "WALKING",
          },
          {
            distance: "15 m",
            duration: "1 min",
            instructions:
              "Turn <b>right</b> onto <b>Cosway St</b>/<wbr/><b>Old Marylebone Rd</b>/<wbr/><b>A501</b>",
            travelMode: "WALKING",
          },
          {
            distance: "1.0 km",
            duration: "15 mins",
            instructions:
              "Turn <b>left</b> onto <b>Marylebone Rd</b>/<wbr/><b>A501</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.7 km",
            duration: "11 mins",
            instructions: "Take the crosswalk",
            travelMode: "WALKING",
          },
          {
            distance: "0.2 km",
            duration: "3 mins",
            instructions:
              "Take the <b>A400</b> exit toward <b>Holloway</b>/<wbr/><b>Camden Town</b>/<wbr/><b>West End</b>/<wbr/><b>Westminster</b>/<wbr/><b>Holborn</b>",
            travelMode: "WALKING",
          },
          {
            distance: "28 m",
            duration: "1 min",
            instructions: "Turn <b>right</b> onto <b>Tottenham Ct Rd</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.2 km",
            duration: "3 mins",
            instructions: "Turn <b>left</b> onto <b>Euston Rd.</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.2 km",
            duration: "2 mins",
            instructions:
              "<b>Euston Rd.</b> turns <b>right</b> and becomes <b>Gower St</b>",
            travelMode: "WALKING",
          },
          {
            distance: "29 m",
            duration: "1 min",
            instructions: "Turn <b>left</b>",
            travelMode: "WALKING",
          },
          {
            distance: "22 m",
            duration: "1 min",
            instructions:
              'Turn <b>left</b><div style="font-size:0.9em">Destination will be on the right</div>',
            travelMode: "WALKING",
          },
        ],
      },
      bicycling: {
        distances: {},
        path: [
          [-0.17163, 51.52116],
          [-0.17143000000000003, 51.521],
          [-0.17120000000000002, 51.52087],
          [-0.17077, 51.520520000000005],
          [-0.17046, 51.52028000000001],
          [-0.16955, 51.51966],
          [-0.16810000000000003, 51.518660000000004],
          [-0.16721000000000003, 51.518040000000006],
          [-0.16667, 51.51766000000001],
          [-0.16634000000000002, 51.51789],
          [-0.16564, 51.51840000000001],
          [-0.16512000000000002, 51.51877],
          [-0.16489, 51.51885000000001],
          [-0.16455, 51.51888],
          [-0.16429000000000002, 51.51892],
          [-0.16343000000000002, 51.519070000000006],
          [-0.16236, 51.51928],
          [-0.16028, 51.519670000000005],
          [-0.15730000000000002, 51.52019000000001],
          [-0.15537, 51.520540000000004],
          [-0.15495, 51.520610000000005],
          [-0.15479, 51.52062],
          [-0.1547, 51.52062],
          [-0.15466000000000002, 51.520540000000004],
          [-0.15459, 51.520390000000006],
          [-0.15442, 51.520300000000006],
          [-0.15424000000000002, 51.52026000000001],
          [-0.15414, 51.52026000000001],
          [-0.15412, 51.520270000000004],
          [-0.15411000000000002, 51.520270000000004],
          [-0.15407, 51.52026000000001],
          [-0.15406, 51.52024],
          [-0.15407, 51.52024],
          [-0.1537, 51.52019000000001],
          [-0.15362, 51.519740000000006],
          [-0.15342, 51.51975],
          [-0.15298, 51.519780000000004],
          [-0.15274000000000001, 51.519800000000004],
          [-0.15249000000000001, 51.51981000000001],
          [-0.15176, 51.51986],
          [-0.15178000000000003, 51.519980000000004],
          [-0.15105000000000002, 51.520010000000006],
          [-0.15089000000000002, 51.520030000000006],
          [-0.14987, 51.520210000000006],
          [-0.14770000000000003, 51.52058],
          [-0.14486000000000002, 51.521060000000006],
          [-0.14391, 51.52121],
          [-0.14347000000000001, 51.521280000000004],
          [-0.14322000000000001, 51.52129000000001],
          [-0.14301, 51.5208],
          [-0.14231000000000002, 51.52093000000001],
          [-0.14156000000000002, 51.52105],
          [-0.14036, 51.521300000000004],
          [-0.14011, 51.52136],
          [-0.13989000000000001, 51.52145],
          [-0.13994, 51.52152],
          [-0.13994, 51.52156],
          [-0.13991, 51.521620000000006],
          [-0.13945000000000002, 51.52181],
          [-0.13851000000000002, 51.522220000000004],
          [-0.13693000000000002, 51.522870000000005],
          [-0.13646, 51.52309],
          [-0.13614, 51.523230000000005],
          [-0.13478, 51.523740000000004],
          [-0.13422, 51.523950000000006],
          [-0.13452, 51.524240000000006],
          [-0.13457000000000002, 51.524280000000005],
          [-0.13422, 51.52443],
          [-0.13441, 51.52459],
        ],
        steps: [
          {
            distance: "0.5 km",
            duration: "2 mins",
            instructions:
              "Head <b>southeast</b> on <b>Edgware Rd</b>/<wbr/><b>A5</b> toward <b>Newcastle Pl</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.8 km",
            duration: "3 mins",
            instructions:
              'Turn <b>left</b> onto <b>Crawford Pl</b><div style="font-size:0.9em">Entering toll zone</div><div style="font-size:0.9em">Leaving toll zone</div>',
            travelMode: "BICYCLING",
          },
          {
            distance: "0.1 km",
            duration: "1 min",
            instructions:
              'Continue onto <b>Paddington St</b>/<wbr/><b>B524</b><div style="font-size:0.9em">Entering toll zone</div>',
            travelMode: "BICYCLING",
          },
          {
            distance: "28 m",
            duration: "1 min",
            instructions:
              'Turn <b>right</b> toward <b>Moxon St</b><div style="font-size:0.9em">Leaving toll zone</div>',
            travelMode: "BICYCLING",
          },
          {
            distance: "41 m",
            duration: "1 min",
            instructions: "Turn <b>left</b> toward <b>Moxon St</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "4 m",
            duration: "1 min",
            instructions: "Turn <b>right</b> toward <b>Moxon St</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "26 m",
            duration: "1 min",
            instructions: "Turn <b>left</b> toward <b>Moxon St</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "65 m",
            duration: "1 min",
            instructions: "Turn <b>right</b> toward <b>Moxon St</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.1 km",
            duration: "1 min",
            instructions:
              'Continue onto <b>Moxon St</b><div style="font-size:0.9em">Entering toll zone</div>',
            travelMode: "BICYCLING",
          },
          {
            distance: "13 m",
            duration: "1 min",
            instructions:
              "Turn <b>left</b> onto <b>Marylebone High St</b>/<wbr/><b>B524</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.6 km",
            duration: "3 mins",
            instructions:
              'Turn <b>right</b> onto <b>Weymouth St</b><div style="font-size:0.9em">Leaving toll zone</div>',
            travelMode: "BICYCLING",
          },
          {
            distance: "56 m",
            duration: "1 min",
            instructions:
              "Turn <b>right</b> onto <b>Great Portland St</b>/<wbr/><b>B506</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.2 km",
            duration: "1 min",
            instructions:
              'Turn <b>left</b> onto <b>Clipstone St</b><div style="font-size:0.9em">Entering toll zone</div>',
            travelMode: "BICYCLING",
          },
          {
            distance: "19 m",
            duration: "1 min",
            instructions: "Turn <b>left</b> onto <b>Cleveland St</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.3 km",
            duration: "1 min",
            instructions:
              'Turn <b>right</b> onto <b>Maple St</b><div style="font-size:0.9em">Leaving toll zone</div>',
            travelMode: "BICYCLING",
          },
          {
            distance: "0.2 km",
            duration: "1 min",
            instructions:
              'Continue onto <b>University St</b><div style="font-size:0.9em">Entering toll zone</div>',
            travelMode: "BICYCLING",
          },
          {
            distance: "44 m",
            duration: "1 min",
            instructions: "Turn <b>left</b> onto <b>Gower St</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "29 m",
            duration: "1 min",
            instructions:
              'Turn <b>right</b><div style="font-size:0.9em">Leaving toll zone</div>',
            travelMode: "BICYCLING",
          },
          {
            distance: "22 m",
            duration: "1 min",
            instructions:
              'Turn <b>left</b><div style="font-size:0.9em">Destination will be on the right</div>',
            travelMode: "BICYCLING",
          },
        ],
      },
      transit: {
        distances: {},
        path: [
          [-0.17170000000000002, 51.52112],
          [-0.17154000000000003, 51.521],
          [-0.17139000000000001, 51.521080000000005],
          [-0.17135, 51.521040000000006],
          [-0.17125, 51.520970000000005],
          [-0.17114000000000001, 51.520900000000005],
          [-0.17076000000000002, 51.520590000000006],
          [-0.17047, 51.520390000000006],
          [-0.17022, 51.52024],
          [-0.17011, 51.52013],
          [-0.16999, 51.520050000000005],
          [-0.17001000000000002, 51.520050000000005],
          [-0.16978000000000001, 51.519890000000004],
          [-0.16968000000000003, 51.519830000000006],
          [-0.16951000000000002, 51.51986],
          [-0.16902, 51.51993],
          [-0.16869, 51.51997],
          [-0.1685, 51.520010000000006],
          [-0.16839, 51.51988000000001],
          [-0.16812000000000002, 51.51957],
          [-0.16799, 51.519670000000005],
          [-0.16708, 51.520270000000004],
          [-0.16703, 51.5202],
          [-0.16675, 51.52029],
          [-0.16556, 51.52067],
          [-0.16494, 51.52082000000001],
          [-0.16303, 51.521170000000005],
          [-0.15929000000000001, 51.52181],
          [-0.15677000000000002, 51.52226],
          [-0.15498, 51.522580000000005],
          [-0.15252000000000002, 51.523030000000006],
          [-0.15218, 51.523070000000004],
          [-0.15079, 51.52315],
          [-0.14939000000000002, 51.523270000000004],
          [-0.14899, 51.52331],
          [-0.14791, 51.52349],
          [-0.14728000000000002, 51.5236],
          [-0.14474, 51.52404000000001],
          [-0.14456000000000002, 51.524060000000006],
          [-0.1444, 51.524060000000006],
          [-0.1438, 51.524],
          [-0.14349, 51.523970000000006],
          [-0.14305, 51.523950000000006],
          [-0.14272, 51.523970000000006],
          [-0.14233, 51.52402000000001],
          [-0.14194, 51.52409],
          [-0.14118, 51.52427],
          [-0.13984000000000002, 51.524640000000005],
          [-0.13761, 51.52525000000001],
          [-0.13652, 51.52552000000001],
          [-0.13571, 51.52568],
          [-0.13526000000000002, 51.525800000000004],
          [-0.13509000000000002, 51.525850000000005],
          [-0.13514, 51.52590000000001],
          [-0.13549, 51.525360000000006],
          [-0.13554000000000002, 51.525310000000005],
          [-0.13534000000000002, 51.525110000000005],
          [-0.13514, 51.524910000000006],
          [-0.13455, 51.52436],
          [-0.1345, 51.52431000000001],
          [-0.13422, 51.52443],
          [-0.13441, 51.52459],
        ],
        steps: [
          {
            distance: "0.4 km",
            duration: "7 mins",
            instructions: "Walk to Edgware Road",
            travelMode: "WALKING",
          },
          {
            distance: "2.3 km",
            duration: "6 mins",
            instructions: "Subway towards Barking via Liverpool St",
            travelMode: "TRANSIT",
          },
          {
            distance: "0.3 km",
            duration: "5 mins",
            instructions: "Walk to Bernard Katz, London WC1E 6BT, UK",
            travelMode: "WALKING",
          },
        ],
      },
    },
    distances: {
      DRIVING: {
        distance: "2.8 km",
        duration: "11 mins",
      },
      WALKING: {
        distance: "2.9 km",
        duration: "42 mins",
      },
      BICYCLING: {
        distance: "3.2 km",
        duration: "15 mins",
      },
      TRANSIT: {
        distance: "3.0 km",
        duration: "18 mins",
      },
    },
  },
  {
    name: "University of London",
    category: "Universities",
    coordinates: {
      lat: 51.52340066877794,
      lng: -0.13087757163256974,
    },
    id: "671b6f798844e00026fe9a68",
    routes: {
      driving: {
        distances: {},
        path: [
          [-0.17163, 51.52116],
          [-0.17143000000000003, 51.521],
          [-0.17120000000000002, 51.52087],
          [-0.17077, 51.520520000000005],
          [-0.17046, 51.52028000000001],
          [-0.17019, 51.52009],
          [-0.16994, 51.520100000000006],
          [-0.16922, 51.520160000000004],
          [-0.16849, 51.52029],
          [-0.16758, 51.52049],
          [-0.16724000000000003, 51.520500000000006],
          [-0.16679000000000002, 51.520610000000005],
          [-0.16646000000000002, 51.520680000000006],
          [-0.16606, 51.52076],
          [-0.16464, 51.52094],
          [-0.16364, 51.52113000000001],
          [-0.16257000000000002, 51.52131000000001],
          [-0.16033, 51.5217],
          [-0.15892, 51.521950000000004],
          [-0.15717, 51.52225000000001],
          [-0.15316000000000002, 51.52297],
          [-0.15243, 51.52310000000001],
          [-0.15137, 51.52317000000001],
          [-0.1506, 51.523230000000005],
          [-0.14953000000000002, 51.52331],
          [-0.14888, 51.52338],
          [-0.14789000000000002, 51.52355000000001],
          [-0.14614000000000002, 51.523860000000006],
          [-0.14546, 51.52398],
          [-0.14500000000000002, 51.524060000000006],
          [-0.14477, 51.52409],
          [-0.14450000000000002, 51.52412],
          [-0.14402, 51.524080000000005],
          [-0.1436, 51.52404000000001],
          [-0.14332, 51.52404000000001],
          [-0.14295000000000002, 51.524010000000004],
          [-0.1428, 51.524010000000004],
          [-0.14237000000000002, 51.52405],
          [-0.14159000000000002, 51.52422000000001],
          [-0.14105, 51.524370000000005],
          [-0.14085, 51.524420000000006],
          [-0.14070000000000002, 51.52451000000001],
          [-0.14063, 51.52454],
          [-0.13978000000000002, 51.52478000000001],
          [-0.13868, 51.525090000000006],
          [-0.13831000000000002, 51.525180000000006],
          [-0.13811, 51.52523000000001],
          [-0.13801000000000002, 51.525110000000005],
          [-0.13790000000000002, 51.52499],
          [-0.13773000000000002, 51.52501],
          [-0.13770000000000002, 51.52503],
          [-0.13741, 51.52505000000001],
          [-0.13694, 51.52517],
          [-0.13668000000000002, 51.525290000000005],
          [-0.13637000000000002, 51.525400000000005],
          [-0.13608, 51.52548],
          [-0.13594, 51.525510000000004],
          [-0.13591, 51.525510000000004],
          [-0.13578, 51.52539],
          [-0.13546000000000002, 51.5251],
          [-0.13526000000000002, 51.524910000000006],
          [-0.13462000000000002, 51.524330000000006],
          [-0.13307000000000002, 51.522890000000004],
          [-0.13266, 51.522510000000004],
          [-0.13261, 51.52246],
          [-0.13232000000000002, 51.522580000000005],
          [-0.13151000000000002, 51.522890000000004],
          [-0.13112000000000001, 51.523050000000005],
          [-0.13104000000000002, 51.52311],
          [-0.13103, 51.523160000000004],
          [-0.131, 51.523300000000006],
          [-0.13095, 51.523360000000004],
          [-0.13087000000000001, 51.523390000000006],
        ],
        steps: [
          {
            distance: "0.2 km",
            duration: "1 min",
            instructions:
              "Head <b>southeast</b> on <b>Edgware Rd</b>/<wbr/><b>A5</b> toward <b>Newcastle Pl</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "0.2 km",
            duration: "1 min",
            instructions:
              "Turn <b>left</b> (signs for <b>Ring Rd E</b>/<wbr/><b>A400</b>/<wbr/><b>A1</b>/<wbr/><b>The City</b>/<wbr/><b>Euston</b>/<wbr/><b>Kings Cross</b>)",
            travelMode: "DRIVING",
          },
          {
            distance: "1.9 km",
            duration: "7 mins",
            instructions:
              'Merge onto <b>Marylebone Rd</b>/<wbr/><b>Marylebone Flyover</b>/<wbr/><b>A501</b><div style="font-size:0.9em">Continue to follow A501</div>',
            travelMode: "DRIVING",
          },
          {
            distance: "0.2 km",
            duration: "1 min",
            instructions:
              "Take the <b>A400</b> exit toward <b>Holloway</b>/<wbr/><b>Camden Town</b>/<wbr/><b>West End</b>/<wbr/><b>Westminster</b>/<wbr/><b>Holborn</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "0.2 km",
            duration: "1 min",
            instructions: "Keep <b>right</b> to continue on <b>Euston Rd.</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "0.4 km",
            duration: "2 mins",
            instructions:
              '<b>Euston Rd.</b> turns <b>right</b> and becomes <b>Gower St</b><div style="font-size:0.9em">Entering toll zone</div>',
            travelMode: "DRIVING",
          },
          {
            distance: "70 m",
            duration: "1 min",
            instructions: "Turn <b>left</b> onto <b>Torrington Pl</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "0.1 km",
            duration: "1 min",
            instructions: "Continue onto <b>Byng Pl</b>",
            travelMode: "DRIVING",
          },
        ],
      },
      walking: {
        distances: {},
        path: [
          [-0.17170000000000002, 51.52112],
          [-0.17154000000000003, 51.521],
          [-0.17139000000000001, 51.521080000000005],
          [-0.17135, 51.521040000000006],
          [-0.17125, 51.520970000000005],
          [-0.17114000000000001, 51.520900000000005],
          [-0.17076000000000002, 51.520590000000006],
          [-0.17047, 51.520390000000006],
          [-0.17022, 51.52024],
          [-0.17013, 51.52013],
          [-0.17002, 51.520140000000005],
          [-0.16979000000000002, 51.52015],
          [-0.16945000000000002, 51.52018],
          [-0.16898000000000002, 51.52024],
          [-0.16848000000000002, 51.52033],
          [-0.16807000000000002, 51.520430000000005],
          [-0.16776000000000002, 51.520500000000006],
          [-0.16746000000000003, 51.520540000000004],
          [-0.16728, 51.520570000000006],
          [-0.16688, 51.52066000000001],
          [-0.16657000000000002, 51.520720000000004],
          [-0.16636, 51.520770000000006],
          [-0.16608, 51.52082000000001],
          [-0.16589, 51.52084000000001],
          [-0.16569, 51.520860000000006],
          [-0.16569, 51.52084000000001],
          [-0.16567, 51.52076],
          [-0.16553, 51.52078],
          [-0.16552, 51.52073000000001],
          [-0.16587000000000002, 51.520700000000005],
          [-0.16584000000000002, 51.52062],
          [-0.16584000000000002, 51.5206],
          [-0.16552, 51.52062],
          [-0.16552, 51.520610000000005],
          [-0.16541, 51.52062],
          [-0.16541, 51.52065],
          [-0.1653, 51.52066000000001],
          [-0.16533, 51.520630000000004],
          [-0.16528, 51.520610000000005],
          [-0.16522, 51.52065],
          [-0.16495, 51.520700000000005],
          [-0.16449000000000003, 51.52078],
          [-0.16410000000000002, 51.520860000000006],
          [-0.16409, 51.52084000000001],
          [-0.16394, 51.52087],
          [-0.16390000000000002, 51.52087],
          [-0.16391, 51.520900000000005],
          [-0.16379000000000002, 51.52091000000001],
          [-0.16328, 51.520990000000005],
          [-0.16291000000000003, 51.521060000000006],
          [-0.16290000000000002, 51.521060000000006],
          [-0.16281, 51.521080000000005],
          [-0.16282000000000002, 51.52109],
          [-0.16245, 51.52114],
          [-0.16209, 51.521190000000004],
          [-0.16157000000000002, 51.52127],
          [-0.16113000000000002, 51.521330000000006],
          [-0.16093000000000002, 51.52136],
          [-0.16095, 51.52141],
          [-0.16080000000000003, 51.52141],
          [-0.16059, 51.521440000000005],
          [-0.16033, 51.52149000000001],
          [-0.15966000000000002, 51.52161],
          [-0.15964, 51.521570000000004],
          [-0.15944000000000003, 51.52160000000001],
          [-0.15947, 51.52167000000001],
          [-0.15937, 51.52169000000001],
          [-0.15813000000000002, 51.521910000000005],
          [-0.15753, 51.522000000000006],
          [-0.15746000000000002, 51.52205000000001],
          [-0.15736, 51.522040000000004],
          [-0.15713000000000002, 51.522090000000006],
          [-0.15676, 51.52215],
          [-0.15653, 51.52219],
          [-0.15618, 51.52221],
          [-0.15575, 51.522290000000005],
          [-0.15509, 51.522450000000006],
          [-0.15335000000000001, 51.52277],
          [-0.15269000000000002, 51.522870000000005],
          [-0.15253, 51.522920000000006],
          [-0.15239000000000003, 51.52295],
          [-0.15214000000000003, 51.52295],
          [-0.15189000000000002, 51.522960000000005],
          [-0.15174, 51.52297],
          [-0.15156, 51.523010000000006],
          [-0.15124, 51.523030000000006],
          [-0.15123, 51.523],
          [-0.15105000000000002, 51.52302],
          [-0.15106, 51.52306],
          [-0.15096, 51.523070000000004],
          [-0.15097000000000002, 51.52315],
          [-0.15100000000000002, 51.52315],
          [-0.15101, 51.523160000000004],
          [-0.15100000000000002, 51.523160000000004],
          [-0.15082, 51.52317000000001],
          [-0.15084, 51.523270000000004],
          [-0.15066000000000002, 51.52328000000001],
          [-0.15013, 51.52333],
          [-0.14905000000000002, 51.52342],
          [-0.1486, 51.523480000000006],
          [-0.1481, 51.52356],
          [-0.14803000000000002, 51.52358],
          [-0.14806000000000002, 51.52362],
          [-0.14787, 51.52366000000001],
          [-0.14783000000000002, 51.52366000000001],
          [-0.14782, 51.52364000000001],
          [-0.14768, 51.52366000000001],
          [-0.14737, 51.523720000000004],
          [-0.14627, 51.523920000000004],
          [-0.14607, 51.52394],
          [-0.14570000000000002, 51.524010000000004],
          [-0.14502, 51.52413000000001],
          [-0.14495000000000002, 51.52414],
          [-0.14483000000000001, 51.524100000000004],
          [-0.14472000000000002, 51.52411000000001],
          [-0.14469, 51.52416],
          [-0.14464000000000002, 51.52416],
          [-0.14450000000000002, 51.524170000000005],
          [-0.14432, 51.52416],
          [-0.14425000000000002, 51.52416],
          [-0.14425000000000002, 51.52420000000001],
          [-0.14409000000000002, 51.524190000000004],
          [-0.14409000000000002, 51.524150000000006],
          [-0.14385, 51.52412],
          [-0.14358, 51.52409],
          [-0.14350000000000002, 51.52409],
          [-0.14348000000000002, 51.52411000000001],
          [-0.14337000000000003, 51.52409],
          [-0.14336000000000002, 51.52412],
          [-0.14333, 51.524080000000005],
          [-0.14322000000000001, 51.524100000000004],
          [-0.14321, 51.52409],
          [-0.14312000000000002, 51.524080000000005],
          [-0.1429, 51.52407],
          [-0.14264000000000002, 51.524100000000004],
          [-0.14209000000000002, 51.52418],
          [-0.14133, 51.52438],
          [-0.14088, 51.52447],
          [-0.14075000000000001, 51.52454],
          [-0.14048000000000002, 51.52463],
          [-0.13990000000000002, 51.52479],
          [-0.13978000000000002, 51.524860000000004],
          [-0.13945000000000002, 51.524950000000004],
          [-0.13929000000000002, 51.525020000000005],
          [-0.13911, 51.52505000000001],
          [-0.13879000000000002, 51.52514000000001],
          [-0.13862000000000002, 51.525180000000006],
          [-0.13853000000000001, 51.52523000000001],
          [-0.13848000000000002, 51.52517],
          [-0.13846, 51.52514000000001],
          [-0.13835, 51.52516000000001],
          [-0.13820000000000002, 51.52496000000001],
          [-0.1383, 51.524910000000006],
          [-0.13824, 51.52483],
          [-0.13797, 51.52494],
          [-0.13769, 51.52497],
          [-0.13740000000000002, 51.52499],
          [-0.13725, 51.525000000000006],
          [-0.13705, 51.52505000000001],
          [-0.13663, 51.52526],
          [-0.13648000000000002, 51.525330000000004],
          [-0.13606000000000001, 51.525450000000006],
          [-0.13598000000000002, 51.52546],
          [-0.13588, 51.52537],
          [-0.13585, 51.525380000000006],
          [-0.13571, 51.52544],
          [-0.13566, 51.525400000000005],
          [-0.13551000000000002, 51.52528],
          [-0.13523000000000002, 51.52501],
          [-0.13489, 51.524680000000004],
          [-0.13404000000000002, 51.523880000000005],
          [-0.13348000000000002, 51.52335000000001],
          [-0.13331, 51.523230000000005],
          [-0.13288, 51.522850000000005],
          [-0.13255, 51.522540000000006],
          [-0.13240000000000002, 51.522600000000004],
          [-0.13186, 51.52279000000001],
          [-0.13158, 51.522920000000006],
          [-0.13114, 51.52309],
          [-0.13108, 51.52317000000001],
          [-0.13105, 51.52331],
          [-0.131, 51.52342],
          [-0.13094, 51.523450000000004],
        ],
        steps: [
          {
            distance: "0.2 km",
            duration: "2 mins",
            instructions:
              "Head <b>southeast</b> on <b>Edgware Rd</b>/<wbr/><b>A5</b> toward <b>Newcastle Pl</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.2 km",
            duration: "3 mins",
            instructions:
              "Turn <b>left</b> (signs for <b>Ring Rd E</b>/<wbr/><b>A400</b>/<wbr/><b>A1</b>/<wbr/><b>The City</b>/<wbr/><b>Euston</b>/<wbr/><b>Kings Cross</b>)",
            travelMode: "WALKING",
          },
          {
            distance: "0.1 km",
            duration: "2 mins",
            instructions:
              'Continue onto <b>Marylebone Rd</b>/<wbr/><b>Marylebone Flyover</b>/<wbr/><b>A501</b><div style="font-size:0.9em">Continue to follow Marylebone Rd/<wbr/>A501</div>',
            travelMode: "WALKING",
          },
          {
            distance: "15 m",
            duration: "1 min",
            instructions:
              "Turn <b>right</b> onto <b>Cosway St</b>/<wbr/><b>Old Marylebone Rd</b>/<wbr/><b>A501</b>",
            travelMode: "WALKING",
          },
          {
            distance: "1.0 km",
            duration: "15 mins",
            instructions:
              "Turn <b>left</b> onto <b>Marylebone Rd</b>/<wbr/><b>A501</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.7 km",
            duration: "11 mins",
            instructions: "Take the crosswalk",
            travelMode: "WALKING",
          },
          {
            distance: "0.2 km",
            duration: "3 mins",
            instructions:
              "Take the <b>A400</b> exit toward <b>Holloway</b>/<wbr/><b>Camden Town</b>/<wbr/><b>West End</b>/<wbr/><b>Westminster</b>/<wbr/><b>Holborn</b>",
            travelMode: "WALKING",
          },
          {
            distance: "28 m",
            duration: "1 min",
            instructions: "Turn <b>right</b> onto <b>Tottenham Ct Rd</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.2 km",
            duration: "3 mins",
            instructions: "Turn <b>left</b> onto <b>Euston Rd.</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.4 km",
            duration: "6 mins",
            instructions:
              "<b>Euston Rd.</b> turns <b>right</b> and becomes <b>Gower St</b>",
            travelMode: "WALKING",
          },
          {
            distance: "70 m",
            duration: "1 min",
            instructions: "Turn <b>left</b> onto <b>Torrington Pl</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.1 km",
            duration: "1 min",
            instructions: "Continue onto <b>Byng Pl</b>",
            travelMode: "WALKING",
          },
        ],
      },
      bicycling: {
        distances: {},
        path: [
          [-0.17163, 51.52116],
          [-0.17143000000000003, 51.521],
          [-0.17120000000000002, 51.52087],
          [-0.17077, 51.520520000000005],
          [-0.17046, 51.52028000000001],
          [-0.16955, 51.51966],
          [-0.16810000000000003, 51.518660000000004],
          [-0.16721000000000003, 51.518040000000006],
          [-0.16667, 51.51766000000001],
          [-0.16634000000000002, 51.51789],
          [-0.16564, 51.51840000000001],
          [-0.16512000000000002, 51.51877],
          [-0.16489, 51.51885000000001],
          [-0.16455, 51.51888],
          [-0.16429000000000002, 51.51892],
          [-0.16343000000000002, 51.519070000000006],
          [-0.16236, 51.51928],
          [-0.16028, 51.519670000000005],
          [-0.15730000000000002, 51.52019000000001],
          [-0.15537, 51.520540000000004],
          [-0.15495, 51.520610000000005],
          [-0.15479, 51.52062],
          [-0.1547, 51.52062],
          [-0.15466000000000002, 51.520540000000004],
          [-0.15459, 51.520390000000006],
          [-0.15442, 51.520300000000006],
          [-0.15424000000000002, 51.52026000000001],
          [-0.15414, 51.52026000000001],
          [-0.15412, 51.520270000000004],
          [-0.15411000000000002, 51.520270000000004],
          [-0.15407, 51.52026000000001],
          [-0.15406, 51.52024],
          [-0.15407, 51.52024],
          [-0.1537, 51.52019000000001],
          [-0.15362, 51.519740000000006],
          [-0.15342, 51.51975],
          [-0.15298, 51.519780000000004],
          [-0.15274000000000001, 51.519800000000004],
          [-0.15249000000000001, 51.51981000000001],
          [-0.15176, 51.51986],
          [-0.15178000000000003, 51.519980000000004],
          [-0.15105000000000002, 51.520010000000006],
          [-0.15089000000000002, 51.520030000000006],
          [-0.14987, 51.520210000000006],
          [-0.14770000000000003, 51.52058],
          [-0.14486000000000002, 51.521060000000006],
          [-0.14391, 51.52121],
          [-0.14347000000000001, 51.521280000000004],
          [-0.14322000000000001, 51.52129000000001],
          [-0.14301, 51.5208],
          [-0.14231000000000002, 51.52093000000001],
          [-0.14156000000000002, 51.52105],
          [-0.14036, 51.521300000000004],
          [-0.14011, 51.52136],
          [-0.13989000000000001, 51.52145],
          [-0.13994, 51.52152],
          [-0.13994, 51.52156],
          [-0.13991, 51.521620000000006],
          [-0.13945000000000002, 51.52181],
          [-0.13851000000000002, 51.522220000000004],
          [-0.13693000000000002, 51.522870000000005],
          [-0.13646, 51.52309],
          [-0.13614, 51.523230000000005],
          [-0.13478, 51.523740000000004],
          [-0.13422, 51.523950000000006],
          [-0.13407000000000002, 51.52382000000001],
          [-0.13346000000000002, 51.52326000000001],
          [-0.13266, 51.522510000000004],
          [-0.13261, 51.52246],
          [-0.13232000000000002, 51.522580000000005],
          [-0.13151000000000002, 51.522890000000004],
          [-0.13112000000000001, 51.523050000000005],
          [-0.13104000000000002, 51.52311],
          [-0.13103, 51.523160000000004],
          [-0.131, 51.523300000000006],
          [-0.13095, 51.523360000000004],
          [-0.13087000000000001, 51.523390000000006],
        ],
        steps: [
          {
            distance: "0.5 km",
            duration: "2 mins",
            instructions:
              "Head <b>southeast</b> on <b>Edgware Rd</b>/<wbr/><b>A5</b> toward <b>Newcastle Pl</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.8 km",
            duration: "3 mins",
            instructions:
              'Turn <b>left</b> onto <b>Crawford Pl</b><div style="font-size:0.9em">Entering toll zone</div><div style="font-size:0.9em">Leaving toll zone</div>',
            travelMode: "BICYCLING",
          },
          {
            distance: "0.1 km",
            duration: "1 min",
            instructions:
              'Continue onto <b>Paddington St</b>/<wbr/><b>B524</b><div style="font-size:0.9em">Entering toll zone</div>',
            travelMode: "BICYCLING",
          },
          {
            distance: "28 m",
            duration: "1 min",
            instructions:
              'Turn <b>right</b> toward <b>Moxon St</b><div style="font-size:0.9em">Leaving toll zone</div>',
            travelMode: "BICYCLING",
          },
          {
            distance: "41 m",
            duration: "1 min",
            instructions: "Turn <b>left</b> toward <b>Moxon St</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "4 m",
            duration: "1 min",
            instructions: "Turn <b>right</b> toward <b>Moxon St</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "26 m",
            duration: "1 min",
            instructions: "Turn <b>left</b> toward <b>Moxon St</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "65 m",
            duration: "1 min",
            instructions: "Turn <b>right</b> toward <b>Moxon St</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.1 km",
            duration: "1 min",
            instructions:
              'Continue onto <b>Moxon St</b><div style="font-size:0.9em">Entering toll zone</div>',
            travelMode: "BICYCLING",
          },
          {
            distance: "13 m",
            duration: "1 min",
            instructions:
              "Turn <b>left</b> onto <b>Marylebone High St</b>/<wbr/><b>B524</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.6 km",
            duration: "3 mins",
            instructions:
              'Turn <b>right</b> onto <b>Weymouth St</b><div style="font-size:0.9em">Leaving toll zone</div>',
            travelMode: "BICYCLING",
          },
          {
            distance: "56 m",
            duration: "1 min",
            instructions:
              "Turn <b>right</b> onto <b>Great Portland St</b>/<wbr/><b>B506</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.2 km",
            duration: "1 min",
            instructions:
              'Turn <b>left</b> onto <b>Clipstone St</b><div style="font-size:0.9em">Entering toll zone</div>',
            travelMode: "BICYCLING",
          },
          {
            distance: "19 m",
            duration: "1 min",
            instructions: "Turn <b>left</b> onto <b>Cleveland St</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.3 km",
            duration: "1 min",
            instructions:
              'Turn <b>right</b> onto <b>Maple St</b><div style="font-size:0.9em">Leaving toll zone</div>',
            travelMode: "BICYCLING",
          },
          {
            distance: "0.2 km",
            duration: "1 min",
            instructions:
              'Continue onto <b>University St</b><div style="font-size:0.9em">Entering toll zone</div>',
            travelMode: "BICYCLING",
          },
          {
            distance: "0.2 km",
            duration: "1 min",
            instructions:
              'Turn <b>right</b> onto <b>Gower St</b><div style="font-size:0.9em">Leaving toll zone</div>',
            travelMode: "BICYCLING",
          },
          {
            distance: "70 m",
            duration: "1 min",
            instructions: "Turn <b>left</b> onto <b>Torrington Pl</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.1 km",
            duration: "1 min",
            instructions: "Continue onto <b>Byng Pl</b>",
            travelMode: "BICYCLING",
          },
        ],
      },
      transit: {
        distances: {},
        path: [
          [-0.17170000000000002, 51.52112],
          [-0.17154000000000003, 51.521],
          [-0.17139000000000001, 51.521080000000005],
          [-0.17135, 51.521040000000006],
          [-0.17125, 51.520970000000005],
          [-0.17114000000000001, 51.520900000000005],
          [-0.17076000000000002, 51.520590000000006],
          [-0.17047, 51.520390000000006],
          [-0.17022, 51.52024],
          [-0.17011, 51.52013],
          [-0.16999, 51.520050000000005],
          [-0.17001000000000002, 51.520050000000005],
          [-0.16978000000000001, 51.519890000000004],
          [-0.16968000000000003, 51.519830000000006],
          [-0.16951000000000002, 51.51986],
          [-0.16902, 51.51993],
          [-0.16869, 51.51997],
          [-0.1685, 51.520010000000006],
          [-0.16839, 51.51988000000001],
          [-0.16812000000000002, 51.51957],
          [-0.16799, 51.519670000000005],
          [-0.16708, 51.520270000000004],
          [-0.16703, 51.5202],
          [-0.16675, 51.52029],
          [-0.16556, 51.52067],
          [-0.16494, 51.52082000000001],
          [-0.16303, 51.521170000000005],
          [-0.15929000000000001, 51.52181],
          [-0.15677000000000002, 51.52226],
          [-0.15498, 51.522580000000005],
          [-0.15252000000000002, 51.523030000000006],
          [-0.15218, 51.523070000000004],
          [-0.15079, 51.52315],
          [-0.14939000000000002, 51.523270000000004],
          [-0.14899, 51.52331],
          [-0.14791, 51.52349],
          [-0.14728000000000002, 51.5236],
          [-0.14474, 51.52404000000001],
          [-0.14456000000000002, 51.524060000000006],
          [-0.1444, 51.524060000000006],
          [-0.1438, 51.524],
          [-0.14349, 51.523970000000006],
          [-0.14305, 51.523950000000006],
          [-0.14272, 51.523970000000006],
          [-0.14233, 51.52402000000001],
          [-0.14194, 51.52409],
          [-0.14118, 51.52427],
          [-0.13984000000000002, 51.524640000000005],
          [-0.13761, 51.52525000000001],
          [-0.13652, 51.52552000000001],
          [-0.13571, 51.52568],
          [-0.13526000000000002, 51.525800000000004],
          [-0.13509000000000002, 51.525850000000005],
          [-0.13514, 51.52590000000001],
          [-0.13549, 51.525360000000006],
          [-0.13554000000000002, 51.525310000000005],
          [-0.13534000000000002, 51.525110000000005],
          [-0.13514, 51.524910000000006],
          [-0.13455, 51.52436],
          [-0.13418000000000002, 51.524010000000004],
          [-0.13348000000000002, 51.52335000000001],
          [-0.13331, 51.523230000000005],
          [-0.13297, 51.52293],
          [-0.13288, 51.522850000000005],
          [-0.13255, 51.522540000000006],
          [-0.13240000000000002, 51.522600000000004],
          [-0.13186, 51.52279000000001],
          [-0.13158, 51.522920000000006],
          [-0.13114, 51.52309],
          [-0.13108, 51.52317000000001],
          [-0.13105, 51.52331],
          [-0.131, 51.52342],
          [-0.13094, 51.523450000000004],
        ],
        steps: [
          {
            distance: "0.4 km",
            duration: "7 mins",
            instructions: "Walk to Edgware Road",
            travelMode: "WALKING",
          },
          {
            distance: "2.3 km",
            duration: "6 mins",
            instructions: "Subway towards Barking via Liverpool St",
            travelMode: "TRANSIT",
          },
          {
            distance: "0.6 km",
            duration: "10 mins",
            instructions: "Walk to 5 Gordon Sq, London WC1H 0AG, UK",
            travelMode: "WALKING",
          },
        ],
      },
    },
    distances: {
      DRIVING: {
        distance: "3.2 km",
        duration: "13 mins",
      },
      WALKING: {
        distance: "3.2 km",
        duration: "47 mins",
      },
      BICYCLING: {
        distance: "3.5 km",
        duration: "16 mins",
      },
      TRANSIT: {
        distance: "3.4 km",
        duration: "25 mins",
      },
    },
  },
  {
    name: "University of Westminster",
    category: "Universities",
    coordinates: {
      lat: 51.52237758452927,
      lng: -0.15498962706492794,
    },
    id: "6745a5021128c70026d05c41",
    routes: {
      driving: {
        distances: {},
        path: [
          [-0.17163, 51.52116],
          [-0.17143000000000003, 51.521],
          [-0.17120000000000002, 51.52087],
          [-0.17077, 51.520520000000005],
          [-0.17046, 51.52028000000001],
          [-0.17019, 51.52009],
          [-0.16994, 51.520100000000006],
          [-0.16922, 51.520160000000004],
          [-0.16849, 51.52029],
          [-0.16758, 51.52049],
          [-0.16724000000000003, 51.520500000000006],
          [-0.16679000000000002, 51.520610000000005],
          [-0.16646000000000002, 51.520680000000006],
          [-0.16606, 51.52076],
          [-0.16464, 51.52094],
          [-0.16364, 51.52113000000001],
          [-0.16257000000000002, 51.52131000000001],
          [-0.16033, 51.5217],
          [-0.15892, 51.521950000000004],
          [-0.15717, 51.52225000000001],
          [-0.15316000000000002, 51.52297],
          [-0.15243, 51.52310000000001],
          [-0.15137, 51.52317000000001],
          [-0.1506, 51.523230000000005],
          [-0.14953000000000002, 51.52331],
          [-0.14918, 51.523340000000005],
          [-0.14908000000000002, 51.52331],
          [-0.14898, 51.52329],
          [-0.14892000000000002, 51.523270000000004],
          [-0.14915, 51.523250000000004],
          [-0.1497, 51.5232],
          [-0.15019000000000002, 51.52315],
          [-0.15099, 51.52309],
          [-0.15221, 51.52302],
          [-0.15261000000000002, 51.522960000000005],
          [-0.15327000000000002, 51.52284],
          [-0.15506, 51.522510000000004],
        ],
        steps: [
          {
            distance: "0.2 km",
            duration: "1 min",
            instructions:
              "Head <b>southeast</b> on <b>Edgware Rd</b>/<wbr/><b>A5</b> toward <b>Newcastle Pl</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "0.2 km",
            duration: "1 min",
            instructions:
              "Turn <b>left</b> (signs for <b>Ring Rd E</b>/<wbr/><b>A400</b>/<wbr/><b>A1</b>/<wbr/><b>The City</b>/<wbr/><b>Euston</b>/<wbr/><b>Kings Cross</b>)",
            travelMode: "DRIVING",
          },
          {
            distance: "1.3 km",
            duration: "5 mins",
            instructions:
              'Merge onto <b>Marylebone Rd</b>/<wbr/><b>Marylebone Flyover</b>/<wbr/><b>A501</b><div style="font-size:0.9em">Continue to follow Marylebone Rd/<wbr/>A501</div>',
            travelMode: "DRIVING",
          },
          {
            distance: "0.5 km",
            duration: "2 mins",
            instructions:
              'Make a <b>U-turn</b> at <b>Brunswick Pl</b><div style="font-size:0.9em">Destination will be on the left</div>',
            travelMode: "DRIVING",
          },
        ],
      },
      walking: {
        distances: {},
        path: [
          [-0.17170000000000002, 51.52112],
          [-0.17154000000000003, 51.521],
          [-0.17139000000000001, 51.521080000000005],
          [-0.17135, 51.521040000000006],
          [-0.17125, 51.520970000000005],
          [-0.17114000000000001, 51.520900000000005],
          [-0.17076000000000002, 51.520590000000006],
          [-0.17047, 51.520390000000006],
          [-0.17022, 51.52024],
          [-0.17013, 51.52013],
          [-0.17002, 51.520140000000005],
          [-0.16979000000000002, 51.52015],
          [-0.16945000000000002, 51.52018],
          [-0.16898000000000002, 51.52024],
          [-0.16848000000000002, 51.52033],
          [-0.16807000000000002, 51.520430000000005],
          [-0.16776000000000002, 51.520500000000006],
          [-0.16746000000000003, 51.520540000000004],
          [-0.16728, 51.520570000000006],
          [-0.16688, 51.52066000000001],
          [-0.16657000000000002, 51.520720000000004],
          [-0.16636, 51.520770000000006],
          [-0.16608, 51.52082000000001],
          [-0.16589, 51.52084000000001],
          [-0.16569, 51.520860000000006],
          [-0.16569, 51.52084000000001],
          [-0.16567, 51.52076],
          [-0.16553, 51.52078],
          [-0.16552, 51.52073000000001],
          [-0.16587000000000002, 51.520700000000005],
          [-0.16584000000000002, 51.52062],
          [-0.16584000000000002, 51.5206],
          [-0.16552, 51.52062],
          [-0.16552, 51.520610000000005],
          [-0.16541, 51.52062],
          [-0.16541, 51.52065],
          [-0.1653, 51.52066000000001],
          [-0.16533, 51.520630000000004],
          [-0.16528, 51.520610000000005],
          [-0.16522, 51.52065],
          [-0.16495, 51.520700000000005],
          [-0.16449000000000003, 51.52078],
          [-0.16410000000000002, 51.520860000000006],
          [-0.16409, 51.52084000000001],
          [-0.16394, 51.52087],
          [-0.16390000000000002, 51.52087],
          [-0.16391, 51.520900000000005],
          [-0.16379000000000002, 51.52091000000001],
          [-0.16328, 51.520990000000005],
          [-0.16291000000000003, 51.521060000000006],
          [-0.16290000000000002, 51.521060000000006],
          [-0.16281, 51.521080000000005],
          [-0.16282000000000002, 51.52109],
          [-0.16245, 51.52114],
          [-0.16209, 51.521190000000004],
          [-0.16157000000000002, 51.52127],
          [-0.16113000000000002, 51.521330000000006],
          [-0.16093000000000002, 51.52136],
          [-0.16095, 51.52141],
          [-0.16080000000000003, 51.52141],
          [-0.16059, 51.521440000000005],
          [-0.16033, 51.52149000000001],
          [-0.15966000000000002, 51.52161],
          [-0.15964, 51.521570000000004],
          [-0.15944000000000003, 51.52160000000001],
          [-0.15947, 51.52167000000001],
          [-0.15937, 51.52169000000001],
          [-0.15813000000000002, 51.521910000000005],
          [-0.15753, 51.522000000000006],
          [-0.15746000000000002, 51.52205000000001],
          [-0.15736, 51.522040000000004],
          [-0.15713000000000002, 51.522090000000006],
          [-0.15676, 51.52215],
          [-0.15653, 51.52219],
          [-0.15618, 51.52221],
          [-0.15575, 51.522290000000005],
          [-0.15548, 51.522360000000006],
          [-0.15504, 51.52246],
        ],
        steps: [
          {
            distance: "0.2 km",
            duration: "2 mins",
            instructions:
              "Head <b>southeast</b> on <b>Edgware Rd</b>/<wbr/><b>A5</b> toward <b>Newcastle Pl</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.2 km",
            duration: "3 mins",
            instructions:
              "Turn <b>left</b> (signs for <b>Ring Rd E</b>/<wbr/><b>A400</b>/<wbr/><b>A1</b>/<wbr/><b>The City</b>/<wbr/><b>Euston</b>/<wbr/><b>Kings Cross</b>)",
            travelMode: "WALKING",
          },
          {
            distance: "0.1 km",
            duration: "2 mins",
            instructions:
              'Continue onto <b>Marylebone Rd</b>/<wbr/><b>Marylebone Flyover</b>/<wbr/><b>A501</b><div style="font-size:0.9em">Continue to follow Marylebone Rd/<wbr/>A501</div>',
            travelMode: "WALKING",
          },
          {
            distance: "15 m",
            duration: "1 min",
            instructions:
              "Turn <b>right</b> onto <b>Cosway St</b>/<wbr/><b>Old Marylebone Rd</b>/<wbr/><b>A501</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.7 km",
            duration: "11 mins",
            instructions:
              "Turn <b>left</b> onto <b>Marylebone Rd</b>/<wbr/><b>A501</b>",
            travelMode: "WALKING",
          },
        ],
      },
      bicycling: {
        distances: {},
        path: [
          [-0.17163, 51.52116],
          [-0.17143000000000003, 51.521],
          [-0.17120000000000002, 51.52087],
          [-0.17077, 51.520520000000005],
          [-0.17046, 51.52028000000001],
          [-0.16955, 51.51966],
          [-0.16810000000000003, 51.518660000000004],
          [-0.16721000000000003, 51.518040000000006],
          [-0.16667, 51.51766000000001],
          [-0.16634000000000002, 51.51789],
          [-0.16564, 51.51840000000001],
          [-0.16512000000000002, 51.51877],
          [-0.16489, 51.51885000000001],
          [-0.16455, 51.51888],
          [-0.16429000000000002, 51.51892],
          [-0.16343000000000002, 51.519070000000006],
          [-0.16236, 51.51928],
          [-0.16028, 51.519670000000005],
          [-0.15730000000000002, 51.52019000000001],
          [-0.15537, 51.520540000000004],
          [-0.15495, 51.520610000000005],
          [-0.15393, 51.520680000000006],
          [-0.15412, 51.521910000000005],
          [-0.1542, 51.522560000000006],
          [-0.15421, 51.52263000000001],
          [-0.15422000000000002, 51.522670000000005],
          [-0.15506, 51.522510000000004],
        ],
        steps: [
          {
            distance: "0.5 km",
            duration: "2 mins",
            instructions:
              "Head <b>southeast</b> on <b>Edgware Rd</b>/<wbr/><b>A5</b> toward <b>Newcastle Pl</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.8 km",
            duration: "3 mins",
            instructions:
              'Turn <b>left</b> onto <b>Crawford Pl</b><div style="font-size:0.9em">Entering toll zone</div><div style="font-size:0.9em">Leaving toll zone</div>',
            travelMode: "BICYCLING",
          },
          {
            distance: "0.2 km",
            duration: "1 min",
            instructions:
              'Continue onto <b>Paddington St</b>/<wbr/><b>B524</b><div style="font-size:0.9em">Entering toll zone</div>',
            travelMode: "BICYCLING",
          },
          {
            distance: "0.2 km",
            duration: "1 min",
            instructions: "Turn <b>left</b> onto <b>Luxborough St</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "61 m",
            duration: "1 min",
            instructions:
              'Turn <b>left</b> onto <b>Marylebone Rd</b>/<wbr/><b>A501</b><div style="font-size:0.9em">Leaving toll zone</div><div style="font-size:0.9em">Destination will be on the left</div>',
            travelMode: "BICYCLING",
          },
        ],
      },
      transit: {
        distances: {},
        path: [
          [-0.17170000000000002, 51.52112],
          [-0.17154000000000003, 51.521],
          [-0.17139000000000001, 51.521080000000005],
          [-0.17135, 51.521040000000006],
          [-0.17125, 51.520970000000005],
          [-0.17114000000000001, 51.520900000000005],
          [-0.17076000000000002, 51.520590000000006],
          [-0.17047, 51.520390000000006],
          [-0.17022, 51.52024],
          [-0.17025, 51.520230000000005],
          [-0.17031000000000002, 51.520250000000004],
          [-0.17027, 51.52028000000001],
          [-0.16993000000000003, 51.520540000000004],
          [-0.16951000000000002, 51.52084000000001],
          [-0.16902, 51.52111000000001],
          [-0.16837000000000002, 51.521390000000004],
          [-0.16735000000000003, 51.521710000000006],
          [-0.16608, 51.52203],
          [-0.16368000000000002, 51.52237],
          [-0.16274000000000002, 51.522510000000004],
          [-0.16116000000000003, 51.52268],
          [-0.15709, 51.52311],
          [-0.15718000000000001, 51.52346000000001],
          [-0.15672000000000003, 51.52253],
          [-0.15669000000000002, 51.522450000000006],
          [-0.15678, 51.52244],
          [-0.15676, 51.52239],
          [-0.15666000000000002, 51.52241],
          [-0.15569000000000002, 51.52259],
          [-0.15564, 51.522490000000005],
          [-0.15560000000000002, 51.522490000000005],
          [-0.15552000000000002, 51.522490000000005],
          [-0.1555, 51.52248],
          [-0.15547000000000002, 51.52239],
          [-0.15546000000000001, 51.522360000000006],
          [-0.15544000000000002, 51.522380000000005],
          [-0.15504, 51.52246],
        ],
        steps: [
          {
            distance: "0.1 km",
            duration: "3 mins",
            instructions: "Walk to Edgware Road",
            travelMode: "WALKING",
          },
          {
            distance: "1.0 km",
            duration: "2 mins",
            instructions: "Subway towards Elephant & Castle",
            travelMode: "TRANSIT",
          },
          {
            distance: "0.3 km",
            duration: "4 mins",
            instructions: "Walk to 35 Marylebone Rd, London NW1 5LS, UK",
            travelMode: "WALKING",
          },
        ],
      },
    },
    distances: {
      DRIVING: {
        distance: "2.1 km",
        duration: "9 mins",
      },
      WALKING: {
        distance: "1.3 km",
        duration: "18 mins",
      },
      BICYCLING: {
        distance: "1.8 km",
        duration: "8 mins",
      },
      TRANSIT: {
        distance: "1.3 km",
        duration: "11 mins",
      },
    },
  },
  {
    name: "London Business School",
    category: "Universities",
    coordinates: {
      lat: 51.52628182206884,
      lng: -0.16078068810105828,
    },
    id: "6745a5381128c70026d05c42",
    routes: {
      driving: {
        distances: {},
        path: [
          [-0.17163, 51.52116],
          [-0.17204000000000003, 51.52145],
          [-0.17247, 51.52174],
          [-0.17257, 51.521750000000004],
          [-0.17300000000000001, 51.52201],
          [-0.17305, 51.522090000000006],
          [-0.17321, 51.522200000000005],
          [-0.17347, 51.522380000000005],
          [-0.17413, 51.52284],
          [-0.17479, 51.523300000000006],
          [-0.17432, 51.52357000000001],
          [-0.17397, 51.52389],
          [-0.17302, 51.52469000000001],
          [-0.17182, 51.525710000000004],
          [-0.17132000000000003, 51.52617000000001],
          [-0.17174, 51.526360000000004],
          [-0.17201000000000002, 51.52648000000001],
          [-0.17269, 51.52678],
          [-0.17301000000000002, 51.52694],
          [-0.17294, 51.52698],
          [-0.17283, 51.52704000000001],
          [-0.17183, 51.52751000000001],
          [-0.17041, 51.528180000000006],
          [-0.16953000000000001, 51.52859],
          [-0.16888, 51.52892000000001],
          [-0.16823000000000002, 51.52922],
          [-0.16754000000000002, 51.529520000000005],
          [-0.16729000000000002, 51.529630000000004],
          [-0.16735000000000003, 51.529700000000005],
          [-0.16759000000000002, 51.529810000000005],
          [-0.16781000000000001, 51.52991],
          [-0.16815000000000002, 51.53002000000001],
          [-0.16816, 51.530060000000006],
          [-0.16816, 51.53011000000001],
          [-0.16815000000000002, 51.53018],
          [-0.16813, 51.530210000000004],
          [-0.16786, 51.530330000000006],
          [-0.16777, 51.530330000000006],
          [-0.16770000000000002, 51.53032],
          [-0.16757000000000002, 51.530260000000006],
          [-0.16753, 51.530210000000004],
          [-0.16751000000000002, 51.53013000000001],
          [-0.16752, 51.530060000000006],
          [-0.16752, 51.530030000000004],
          [-0.16747, 51.52993000000001],
          [-0.16738, 51.52975000000001],
          [-0.16729000000000002, 51.529630000000004],
          [-0.16698000000000002, 51.52939000000001],
          [-0.16671000000000002, 51.529180000000004],
          [-0.16658, 51.529070000000004],
          [-0.1663, 51.528850000000006],
          [-0.16620000000000001, 51.52882],
          [-0.16607000000000002, 51.528710000000004],
          [-0.16566, 51.52837],
          [-0.16555, 51.528420000000004],
          [-0.16535000000000002, 51.52845000000001],
          [-0.16503, 51.52845000000001],
          [-0.16448000000000002, 51.52855],
          [-0.16403, 51.52864],
          [-0.16384, 51.52868],
          [-0.16365000000000002, 51.528740000000006],
          [-0.16334, 51.52854000000001],
          [-0.16254000000000002, 51.52805000000001],
          [-0.16166000000000003, 51.5275],
          [-0.16137, 51.52731000000001],
          [-0.16116000000000003, 51.52718],
          [-0.16130000000000003, 51.527100000000004],
          [-0.16146000000000002, 51.527],
          [-0.16153, 51.526900000000005],
          [-0.16160000000000002, 51.52669],
          [-0.16155000000000003, 51.52655000000001],
          [-0.16132000000000002, 51.526320000000005],
          [-0.16112, 51.526180000000004],
        ],
        steps: [
          {
            distance: "0.3 km",
            duration: "1 min",
            instructions:
              "Head <b>northwest</b> on <b>Edgware Rd</b>/<wbr/><b>A5</b> toward <b>Broadley St</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "0.4 km",
            duration: "2 mins",
            instructions: "Turn <b>right</b> onto <b>Frampton St</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "0.1 km",
            duration: "1 min",
            instructions:
              "Turn <b>left</b> onto <b>Lisson Grove</b>/<wbr/><b>B507</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "0.5 km",
            duration: "1 min",
            instructions: "Turn <b>right</b> onto <b>Lodge Rd</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "48 m",
            duration: "1 min",
            instructions:
              "Turn <b>left</b> onto <b>Park Rd</b>/<wbr/><b>A41</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "0.3 km",
            duration: "1 min",
            instructions:
              "At the roundabout, take the <b>3rd</b> exit and stay on <b>Park Rd</b>/<wbr/><b>A41</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "0.1 km",
            duration: "1 min",
            instructions: "Turn <b>left</b> onto <b>Hanover Gate</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "0.2 km",
            duration: "1 min",
            instructions: "Turn <b>right</b> onto <b>Outer Cir</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "0.1 km",
            duration: "1 min",
            instructions:
              'Turn <b>right</b> onto <b>Sussex Pl</b><div style="font-size:0.9em">Restricted usage road</div>',
            travelMode: "DRIVING",
          },
        ],
      },
      walking: {
        distances: {},
        path: [
          [-0.17170000000000002, 51.52112],
          [-0.17154000000000003, 51.521],
          [-0.17139000000000001, 51.521080000000005],
          [-0.17135, 51.521040000000006],
          [-0.17125, 51.520970000000005],
          [-0.17114000000000001, 51.520900000000005],
          [-0.17076000000000002, 51.520590000000006],
          [-0.17047, 51.520390000000006],
          [-0.17022, 51.52024],
          [-0.17013, 51.52013],
          [-0.17002, 51.520140000000005],
          [-0.16979000000000002, 51.52015],
          [-0.16945000000000002, 51.52018],
          [-0.16898000000000002, 51.52024],
          [-0.16848000000000002, 51.52033],
          [-0.16807000000000002, 51.520430000000005],
          [-0.16776000000000002, 51.520500000000006],
          [-0.16746000000000003, 51.520540000000004],
          [-0.16728, 51.520570000000006],
          [-0.16688, 51.52066000000001],
          [-0.16657000000000002, 51.520720000000004],
          [-0.16636, 51.520770000000006],
          [-0.16608, 51.52082000000001],
          [-0.16565000000000002, 51.520860000000006],
          [-0.16512000000000002, 51.52093000000001],
          [-0.16445, 51.521040000000006],
          [-0.1643, 51.521100000000004],
          [-0.16427000000000003, 51.521100000000004],
          [-0.16426000000000002, 51.521080000000005],
          [-0.16408, 51.52113000000001],
          [-0.16373000000000001, 51.52118],
          [-0.16329000000000002, 51.521260000000005],
          [-0.16254000000000002, 51.52138000000001],
          [-0.16208, 51.521480000000004],
          [-0.16205, 51.52147],
          [-0.16187, 51.5215],
          [-0.16130000000000003, 51.52160000000001],
          [-0.16125, 51.521620000000006],
          [-0.16109, 51.52165],
          [-0.16108, 51.521640000000005],
          [-0.16040000000000001, 51.521750000000004],
          [-0.16025, 51.52178000000001],
          [-0.16001, 51.521820000000005],
          [-0.15979000000000002, 51.521860000000004],
          [-0.15981, 51.5219],
          [-0.15961, 51.521930000000005],
          [-0.15958, 51.52194],
          [-0.15956, 51.52192],
          [-0.15941000000000002, 51.52194],
          [-0.15901, 51.52201],
          [-0.15873, 51.52205000000001],
          [-0.15873, 51.52207000000001],
          [-0.15860000000000002, 51.522090000000006],
          [-0.15819000000000003, 51.52216000000001],
          [-0.15796000000000002, 51.522200000000005],
          [-0.15763000000000002, 51.52225000000001],
          [-0.15764, 51.52234000000001],
          [-0.15774000000000002, 51.52244],
          [-0.15784, 51.522690000000004],
          [-0.15789, 51.52281000000001],
          [-0.15809, 51.52313],
          [-0.15834, 51.52367],
          [-0.15842, 51.523860000000006],
          [-0.15856, 51.524170000000005],
          [-0.15877000000000002, 51.52425],
          [-0.15863000000000002, 51.524370000000005],
          [-0.15857000000000002, 51.524350000000005],
          [-0.15858000000000003, 51.52438],
          [-0.15867, 51.52447],
          [-0.15874000000000002, 51.52461],
          [-0.15884, 51.52479],
          [-0.15887, 51.524860000000004],
          [-0.15886, 51.52492],
          [-0.15887, 51.524930000000005],
          [-0.15894000000000003, 51.525000000000006],
          [-0.15906, 51.525150000000004],
          [-0.15923, 51.52532],
          [-0.15932000000000002, 51.52548],
          [-0.15946000000000002, 51.52559],
          [-0.15955000000000003, 51.525710000000004],
          [-0.15966000000000002, 51.525740000000006],
          [-0.15967, 51.52579000000001],
          [-0.15978, 51.52584],
          [-0.15981, 51.52582],
          [-0.15985000000000002, 51.52579000000001],
          [-0.15998, 51.52577],
          [-0.16004000000000002, 51.52579000000001],
          [-0.16059, 51.52619000000001],
          [-0.16074000000000002, 51.526300000000006],
        ],
        steps: [
          {
            distance: "0.2 km",
            duration: "2 mins",
            instructions:
              "Head <b>southeast</b> on <b>Edgware Rd</b>/<wbr/><b>A5</b> toward <b>Newcastle Pl</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.2 km",
            duration: "3 mins",
            instructions:
              "Turn <b>left</b> (signs for <b>Ring Rd E</b>/<wbr/><b>A400</b>/<wbr/><b>A1</b>/<wbr/><b>The City</b>/<wbr/><b>Euston</b>/<wbr/><b>Kings Cross</b>)",
            travelMode: "WALKING",
          },
          {
            distance: "0.7 km",
            duration: "10 mins",
            instructions:
              'Continue onto <b>Marylebone Rd</b>/<wbr/><b>Marylebone Flyover</b>/<wbr/><b>A501</b><div style="font-size:0.9em">Continue to follow Marylebone Rd/<wbr/>A501</div>',
            travelMode: "WALKING",
          },
          {
            distance: "0.3 km",
            duration: "5 mins",
            instructions:
              'Turn <b>left</b> onto <b>Baker St</b>/<wbr/><b>A41</b><div style="font-size:0.9em">Continue to follow Baker St</div>',
            travelMode: "WALKING",
          },
          {
            distance: "0.1 km",
            duration: "1 min",
            instructions: "Slight <b>left</b> onto <b>Outer Cir</b>",
            travelMode: "WALKING",
          },
          {
            distance: "36 m",
            duration: "1 min",
            instructions: "Turn <b>left</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.1 km",
            duration: "1 min",
            instructions:
              'Turn <b>left</b><div style="font-size:0.9em">Destination will be on the left</div>',
            travelMode: "WALKING",
          },
        ],
      },
      bicycling: {
        distances: {},
        path: [
          [-0.17163, 51.52116],
          [-0.17143000000000003, 51.521],
          [-0.17120000000000002, 51.52087],
          [-0.17077, 51.520520000000005],
          [-0.17046, 51.52028000000001],
          [-0.16955, 51.51966],
          [-0.16810000000000003, 51.518660000000004],
          [-0.16721000000000003, 51.518040000000006],
          [-0.16667, 51.51766000000001],
          [-0.16634000000000002, 51.51789],
          [-0.16564, 51.51840000000001],
          [-0.16512000000000002, 51.51877],
          [-0.16489, 51.51885000000001],
          [-0.16455, 51.51888],
          [-0.16429000000000002, 51.51892],
          [-0.16343000000000002, 51.519070000000006],
          [-0.16236, 51.51928],
          [-0.16028, 51.519670000000005],
          [-0.15730000000000002, 51.52019000000001],
          [-0.15708000000000003, 51.520230000000005],
          [-0.15667, 51.52031],
          [-0.15674000000000002, 51.52046000000001],
          [-0.15695, 51.520920000000004],
          [-0.15722000000000003, 51.521510000000006],
          [-0.15728, 51.52167000000001],
          [-0.15741000000000002, 51.521840000000005],
          [-0.15748, 51.52199],
          [-0.15748, 51.52208],
          [-0.15758000000000003, 51.522180000000006],
          [-0.15761, 51.522360000000006],
          [-0.15774000000000002, 51.522740000000006],
          [-0.15784, 51.522920000000006],
          [-0.15817, 51.52358],
          [-0.15856, 51.52445],
          [-0.15864, 51.524620000000006],
          [-0.15835000000000002, 51.524710000000006],
          [-0.15848, 51.524770000000004],
          [-0.15879000000000001, 51.52497],
          [-0.15889, 51.525090000000006],
          [-0.15914, 51.52539],
          [-0.1592, 51.525510000000004],
          [-0.15939, 51.52572000000001],
          [-0.15955000000000003, 51.525710000000004],
          [-0.15964, 51.52573],
          [-0.15967, 51.52575],
          [-0.15967, 51.52579000000001],
          [-0.15978, 51.52584],
          [-0.15985000000000002, 51.52579000000001],
          [-0.15998, 51.52577],
          [-0.16004000000000002, 51.52579000000001],
          [-0.16059, 51.52619000000001],
          [-0.16074000000000002, 51.526300000000006],
        ],
        steps: [
          {
            distance: "0.5 km",
            duration: "2 mins",
            instructions:
              "Head <b>southeast</b> on <b>Edgware Rd</b>/<wbr/><b>A5</b> toward <b>Newcastle Pl</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.8 km",
            duration: "3 mins",
            instructions:
              'Turn <b>left</b> onto <b>Crawford Pl</b><div style="font-size:0.9em">Entering toll zone</div><div style="font-size:0.9em">Leaving toll zone</div>',
            travelMode: "BICYCLING",
          },
          {
            distance: "0.5 km",
            duration: "2 mins",
            instructions:
              'Turn <b>left</b> onto <b>Baker St</b>/<wbr/><b>A41</b><div style="font-size:0.9em">Continue to follow Baker St</div><div style="font-size:0.9em">Entering toll zone</div><div style="font-size:0.9em">Leaving toll zone</div>',
            travelMode: "BICYCLING",
          },
          {
            distance: "22 m",
            duration: "1 min",
            instructions: "Turn <b>right</b> onto <b>Clarence Gate</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.1 km",
            duration: "1 min",
            instructions: "Turn <b>left</b> onto <b>Outer Cir</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "36 m",
            duration: "1 min",
            instructions: "Turn <b>left</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.1 km",
            duration: "1 min",
            instructions:
              'Turn <b>left</b><div style="font-size:0.9em">Destination will be on the left</div>',
            travelMode: "BICYCLING",
          },
        ],
      },
      transit: {
        distances: {},
        path: [
          [-0.17170000000000002, 51.52112],
          [-0.17154000000000003, 51.521],
          [-0.17139000000000001, 51.521080000000005],
          [-0.17135, 51.521040000000006],
          [-0.17125, 51.520970000000005],
          [-0.17114000000000001, 51.520900000000005],
          [-0.17076000000000002, 51.520590000000006],
          [-0.17047, 51.520390000000006],
          [-0.17022, 51.52024],
          [-0.17025, 51.520230000000005],
          [-0.17031000000000002, 51.520250000000004],
          [-0.17027, 51.52028000000001],
          [-0.16993000000000003, 51.520540000000004],
          [-0.16951000000000002, 51.52084000000001],
          [-0.16902, 51.52111000000001],
          [-0.16837000000000002, 51.521390000000004],
          [-0.16735000000000003, 51.521710000000006],
          [-0.16608, 51.52203],
          [-0.16368000000000002, 51.52237],
          [-0.16274000000000002, 51.522510000000004],
          [-0.16116000000000003, 51.52268],
          [-0.15709, 51.52311],
          [-0.15718000000000001, 51.52346000000001],
          [-0.15762, 51.522780000000004],
          [-0.15766000000000002, 51.522760000000005],
          [-0.15769000000000002, 51.52281000000001],
          [-0.15776, 51.52295],
          [-0.15785000000000002, 51.52311],
          [-0.15822, 51.52394],
          [-0.1584, 51.524280000000005],
          [-0.15857000000000002, 51.52436],
          [-0.15858000000000003, 51.52438],
          [-0.15867, 51.52447],
          [-0.15874000000000002, 51.52461],
          [-0.15884, 51.52479],
          [-0.15887, 51.524860000000004],
          [-0.15886, 51.52492],
          [-0.15887, 51.524930000000005],
          [-0.15894000000000003, 51.525000000000006],
          [-0.15906, 51.525150000000004],
          [-0.15923, 51.52532],
          [-0.15932000000000002, 51.52548],
          [-0.15946000000000002, 51.52559],
          [-0.15955000000000003, 51.525710000000004],
          [-0.15966000000000002, 51.525740000000006],
          [-0.15967, 51.52579000000001],
          [-0.15978, 51.52584],
          [-0.15981, 51.52582],
          [-0.15985000000000002, 51.52579000000001],
          [-0.15998, 51.52577],
          [-0.16004000000000002, 51.52579000000001],
          [-0.16059, 51.52619000000001],
          [-0.16074000000000002, 51.526300000000006],
        ],
        steps: [
          {
            distance: "0.1 km",
            duration: "3 mins",
            instructions: "Walk to Edgware Road",
            travelMode: "WALKING",
          },
          {
            distance: "1.0 km",
            duration: "2 mins",
            instructions: "Subway towards Elephant & Castle",
            travelMode: "TRANSIT",
          },
          {
            distance: "0.6 km",
            duration: "9 mins",
            instructions:
              "Walk to London Business School, Regents Park, London NW1 4SA, UK",
            travelMode: "WALKING",
          },
        ],
      },
    },
    distances: {
      DRIVING: {
        distance: "2.3 km",
        duration: "8 mins",
      },
      WALKING: {
        distance: "1.6 km",
        duration: "23 mins",
      },
      BICYCLING: {
        distance: "2.1 km",
        duration: "9 mins",
      },
      TRANSIT: {
        distance: "1.6 km",
        duration: "17 mins",
      },
    },
  },
  {
    name: "Imperial College London",
    category: "Universities",
    coordinates: {
      lat: 51.498908999118115,
      lng: -0.1748198574132328,
    },
    id: "6745a54e1128c70026d05c43",
    routes: {
      driving: {
        distances: {},
        path: [
          [-0.17163, 51.52116],
          [-0.17143000000000003, 51.521],
          [-0.17120000000000002, 51.52087],
          [-0.17077, 51.520520000000005],
          [-0.17046, 51.52028000000001],
          [-0.16955, 51.51966],
          [-0.16810000000000003, 51.518660000000004],
          [-0.16599000000000003, 51.5172],
          [-0.16558, 51.51693],
          [-0.16603, 51.516690000000004],
          [-0.16653, 51.51641000000001],
          [-0.1665, 51.51637],
          [-0.16643000000000002, 51.51628],
          [-0.16634000000000002, 51.5161],
          [-0.16633, 51.516000000000005],
          [-0.16636, 51.51585000000001],
          [-0.16644, 51.515710000000006],
          [-0.16633, 51.51563],
          [-0.16720000000000002, 51.51512],
          [-0.16769, 51.51485],
          [-0.16779000000000002, 51.51491000000001],
          [-0.16783, 51.514920000000004],
          [-0.16794, 51.51494],
          [-0.16811, 51.514920000000004],
          [-0.16827, 51.51491000000001],
          [-0.16821000000000003, 51.514680000000006],
          [-0.16812000000000002, 51.514300000000006],
          [-0.16805, 51.51399000000001],
          [-0.16804000000000002, 51.51399000000001],
          [-0.16802, 51.51399000000001],
          [-0.16801000000000002, 51.513980000000004],
          [-0.168, 51.51395],
          [-0.16801000000000002, 51.51393],
          [-0.16802, 51.51393],
          [-0.16803, 51.513920000000006],
          [-0.16783, 51.51324],
          [-0.16777, 51.513000000000005],
          [-0.16774, 51.512980000000006],
          [-0.16770000000000002, 51.512950000000004],
          [-0.16766, 51.51285000000001],
          [-0.16756000000000001, 51.512480000000004],
          [-0.16876000000000002, 51.512350000000005],
          [-0.16978000000000001, 51.51225],
          [-0.17176000000000002, 51.512060000000005],
          [-0.17222, 51.51202000000001],
          [-0.17215000000000003, 51.511860000000006],
          [-0.17213, 51.511750000000006],
          [-0.17222, 51.51164000000001],
          [-0.17229000000000003, 51.511570000000006],
          [-0.17239000000000002, 51.51153000000001],
          [-0.1726, 51.51144000000001],
          [-0.17266, 51.5114],
          [-0.17272, 51.51135000000001],
          [-0.17276000000000002, 51.51127],
          [-0.17275000000000001, 51.511160000000004],
          [-0.17268000000000003, 51.51106000000001],
          [-0.17247, 51.51095],
          [-0.17112000000000002, 51.510380000000005],
          [-0.17092000000000002, 51.510250000000006],
          [-0.17082000000000003, 51.51015],
          [-0.17070000000000002, 51.510020000000004],
          [-0.17064000000000001, 51.50988],
          [-0.1706, 51.50974],
          [-0.17055, 51.50941],
          [-0.17049, 51.508700000000005],
          [-0.17037000000000002, 51.50750000000001],
          [-0.17040000000000002, 51.507340000000006],
          [-0.17061, 51.50706],
          [-0.17073000000000002, 51.50696000000001],
          [-0.17088, 51.506840000000004],
          [-0.17107000000000003, 51.506730000000005],
          [-0.17122, 51.506690000000006],
          [-0.17139000000000001, 51.50668],
          [-0.17176000000000002, 51.506780000000006],
          [-0.17199, 51.506820000000005],
          [-0.17214000000000002, 51.50679],
          [-0.17224, 51.50674000000001],
          [-0.17236, 51.50661],
          [-0.17295000000000002, 51.505860000000006],
          [-0.17307, 51.50567],
          [-0.17315000000000003, 51.505340000000004],
          [-0.17320000000000002, 51.505210000000005],
          [-0.17351000000000003, 51.50475],
          [-0.17394, 51.504200000000004],
          [-0.17425000000000002, 51.503800000000005],
          [-0.17448000000000002, 51.50347000000001],
          [-0.17459000000000002, 51.50321],
          [-0.17464000000000002, 51.50300000000001],
          [-0.17466, 51.502520000000004],
          [-0.17462000000000003, 51.502430000000004],
          [-0.17457, 51.50224000000001],
          [-0.17455, 51.50216],
          [-0.17453000000000002, 51.501920000000005],
          [-0.17450000000000002, 51.50159000000001],
          [-0.17439000000000002, 51.500280000000004],
          [-0.17437000000000002, 51.50011000000001],
          [-0.17435, 51.50009000000001],
          [-0.17432, 51.50005],
          [-0.17433, 51.50001],
          [-0.17437000000000002, 51.499990000000004],
          [-0.17440000000000003, 51.49998],
          [-0.17441, 51.499970000000005],
          [-0.17439000000000002, 51.499810000000004],
          [-0.17424, 51.4992],
          [-0.17414000000000002, 51.49864],
          [-0.1741, 51.498520000000006],
          [-0.17408, 51.498200000000004],
          [-0.17492000000000002, 51.49813],
          [-0.17513, 51.498110000000004],
          [-0.17517000000000002, 51.498310000000004],
          [-0.17526000000000003, 51.49855],
          [-0.17529, 51.49871],
          [-0.17532, 51.49891],
        ],
        steps: [
          {
            distance: "0.6 km",
            duration: "3 mins",
            instructions:
              "Head <b>southeast</b> on <b>Edgware Rd</b>/<wbr/><b>A5</b> toward <b>Newcastle Pl</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "88 m",
            duration: "1 min",
            instructions: "Turn <b>right</b> onto <b>Burwood Pl</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "82 m",
            duration: "1 min",
            instructions: "Turn <b>left</b> onto <b>Norfolk Cres</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "12 m",
            duration: "1 min",
            instructions: "Turn <b>left</b> to stay on <b>Norfolk Cres</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "0.2 km",
            duration: "1 min",
            instructions: "Turn <b>right</b> onto <b>Oxford Square</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "0.3 km",
            duration: "1 min",
            instructions:
              'Turn <b>left</b> onto <b>Hyde Park St</b><div style="font-size:0.9em">Go through 1 roundabout</div>',
            travelMode: "DRIVING",
          },
          {
            distance: "0.3 km",
            duration: "1 min",
            instructions:
              'Turn <b>right</b> onto <b>Bayswater Rd</b>/<wbr/><b>Hyde Park Pl</b>/<wbr/><b>A402</b><div style="font-size:0.9em">Continue to follow Bayswater Rd/<wbr/>A402</div>',
            travelMode: "DRIVING",
          },
          {
            distance: "1.4 km",
            duration: "5 mins",
            instructions: "Turn <b>left</b> onto <b>N Carriage Dr</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "0.4 km",
            duration: "1 min",
            instructions:
              'Continue onto <b>Exhibition Rd</b><div style="font-size:0.9em">Go through 1 roundabout</div>',
            travelMode: "DRIVING",
          },
          {
            distance: "73 m",
            duration: "1 min",
            instructions: "Turn <b>right</b> onto <b>Imperial College Rd</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "90 m",
            duration: "1 min",
            instructions:
              'Turn <b>right</b> onto <b>Unwin Rd</b><div style="font-size:0.9em">Destination will be on the right</div>',
            travelMode: "DRIVING",
          },
        ],
      },
      walking: {
        distances: {},
        path: [
          [-0.17170000000000002, 51.52112],
          [-0.17154000000000003, 51.521],
          [-0.17139000000000001, 51.521080000000005],
          [-0.17135, 51.521040000000006],
          [-0.17125, 51.520970000000005],
          [-0.17114000000000001, 51.520900000000005],
          [-0.17076000000000002, 51.520590000000006],
          [-0.17047, 51.520390000000006],
          [-0.17022, 51.52024],
          [-0.17011, 51.52013],
          [-0.16999, 51.520050000000005],
          [-0.17001000000000002, 51.520050000000005],
          [-0.16978000000000001, 51.519890000000004],
          [-0.16951000000000002, 51.51973],
          [-0.16907000000000003, 51.519420000000004],
          [-0.169, 51.51935],
          [-0.16897, 51.519360000000006],
          [-0.16890000000000002, 51.5193],
          [-0.16892000000000001, 51.5193],
          [-0.16870000000000002, 51.51915],
          [-0.16849, 51.518980000000006],
          [-0.16757000000000002, 51.51834],
          [-0.16745000000000002, 51.51827],
          [-0.16764, 51.51816],
          [-0.16759000000000002, 51.518130000000006],
          [-0.16770000000000002, 51.51807],
          [-0.16791, 51.51796],
          [-0.16872, 51.517500000000005],
          [-0.16897, 51.517360000000004],
          [-0.16882000000000003, 51.517250000000004],
          [-0.1693, 51.517],
          [-0.16954000000000002, 51.516870000000004],
          [-0.17018000000000003, 51.516490000000005],
          [-0.17063, 51.516270000000006],
          [-0.17101000000000002, 51.51606],
          [-0.17103000000000002, 51.51601],
          [-0.17120000000000002, 51.515930000000004],
          [-0.17117000000000002, 51.51596000000001],
          [-0.17132000000000003, 51.51586],
          [-0.17145000000000002, 51.515800000000006],
          [-0.17158, 51.5157],
          [-0.17197, 51.515480000000004],
          [-0.17267000000000002, 51.51509],
          [-0.17301000000000002, 51.514900000000004],
          [-0.17318, 51.514810000000004],
          [-0.1733, 51.51473000000001],
          [-0.17334000000000002, 51.51476],
          [-0.17343, 51.514720000000004],
          [-0.17366, 51.514590000000005],
          [-0.17401000000000003, 51.51438],
          [-0.17451000000000003, 51.51413],
          [-0.17458, 51.51408000000001],
          [-0.17470000000000002, 51.51395],
          [-0.17494, 51.51382],
          [-0.17500000000000002, 51.513740000000006],
          [-0.17502, 51.51371],
          [-0.17501000000000003, 51.51366],
          [-0.17514000000000002, 51.51348],
          [-0.1753, 51.51328],
          [-0.17544, 51.513180000000006],
          [-0.17547000000000001, 51.51314000000001],
          [-0.17559000000000002, 51.513160000000006],
          [-0.17564000000000002, 51.51317],
          [-0.17565, 51.51306],
          [-0.17565, 51.51301],
          [-0.17564000000000002, 51.51296000000001],
          [-0.17550000000000002, 51.512950000000004],
          [-0.17557, 51.51292],
          [-0.17562000000000003, 51.512950000000004],
          [-0.17565, 51.51286],
          [-0.17577, 51.51287000000001],
          [-0.17577, 51.512800000000006],
          [-0.17587000000000003, 51.51258000000001],
          [-0.17599, 51.51232],
          [-0.17600000000000002, 51.51218],
          [-0.1761, 51.512130000000006],
          [-0.17613, 51.512060000000005],
          [-0.17615, 51.51192],
          [-0.17611000000000002, 51.511660000000006],
          [-0.17614000000000002, 51.51165],
          [-0.17613, 51.51164000000001],
          [-0.17609000000000002, 51.511500000000005],
          [-0.17584000000000002, 51.51153000000001],
          [-0.17584000000000002, 51.511280000000006],
          [-0.17584000000000002, 51.51113],
          [-0.17613, 51.51108000000001],
          [-0.17603000000000002, 51.510830000000006],
          [-0.1759, 51.510360000000006],
          [-0.17589000000000002, 51.510270000000006],
          [-0.17592000000000002, 51.510200000000005],
          [-0.1761, 51.509780000000006],
          [-0.17615, 51.509600000000006],
          [-0.17616, 51.509420000000006],
          [-0.17614000000000002, 51.509240000000005],
          [-0.17606000000000002, 51.50907],
          [-0.17595000000000002, 51.50891000000001],
          [-0.17583000000000001, 51.508700000000005],
          [-0.17576000000000003, 51.50851],
          [-0.17572000000000002, 51.508230000000005],
          [-0.17570000000000002, 51.508140000000004],
          [-0.17561000000000002, 51.50791],
          [-0.17562000000000003, 51.50779000000001],
          [-0.17566, 51.507400000000004],
          [-0.17565, 51.507130000000004],
          [-0.17557, 51.5067],
          [-0.17549, 51.505950000000006],
          [-0.17544, 51.505770000000005],
          [-0.17523000000000002, 51.50531],
          [-0.17518, 51.50527],
          [-0.17509000000000002, 51.504900000000006],
          [-0.17533, 51.50459000000001],
          [-0.17513, 51.50452000000001],
          [-0.17512000000000003, 51.50446],
          [-0.17502, 51.504290000000005],
          [-0.17486000000000002, 51.50406],
          [-0.17482, 51.50397],
          [-0.17481000000000002, 51.5039],
          [-0.17481000000000002, 51.50386],
          [-0.17472000000000001, 51.503820000000005],
          [-0.17462000000000003, 51.50376000000001],
          [-0.17444, 51.503710000000005],
          [-0.17428000000000002, 51.50367000000001],
          [-0.17442000000000002, 51.50345],
          [-0.17453000000000002, 51.50320000000001],
          [-0.17458, 51.50300000000001],
          [-0.1746, 51.502520000000004],
          [-0.17458, 51.50244000000001],
          [-0.17452, 51.502230000000004],
          [-0.17448000000000002, 51.502120000000005],
          [-0.17445000000000002, 51.50184],
          [-0.17438, 51.501850000000005],
          [-0.17438, 51.501830000000005],
          [-0.17435, 51.50168000000001],
          [-0.17445000000000002, 51.50168000000001],
          [-0.17445000000000002, 51.50166],
          [-0.17442000000000002, 51.50122],
          [-0.17436000000000001, 51.50057],
          [-0.17432, 51.50009000000001],
          [-0.17431000000000002, 51.50007],
          [-0.1743, 51.50005],
          [-0.1743, 51.50003],
          [-0.17434000000000002, 51.499990000000004],
          [-0.17440000000000003, 51.49996],
          [-0.17457, 51.499970000000005],
          [-0.17455, 51.49985],
          [-0.17443, 51.49971000000001],
          [-0.17425000000000002, 51.49889],
          [-0.17422, 51.498670000000004],
          [-0.17417000000000002, 51.49855],
          [-0.17415000000000003, 51.49826],
          [-0.17505, 51.49819],
          [-0.1751, 51.498310000000004],
          [-0.17521, 51.49864],
          [-0.17525000000000002, 51.49891],
        ],
        steps: [
          {
            distance: "0.4 km",
            duration: "6 mins",
            instructions:
              "Head <b>southeast</b> on <b>Edgware Rd</b>/<wbr/><b>A5</b> toward <b>Newcastle Pl</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.8 km",
            duration: "12 mins",
            instructions:
              'Turn <b>right</b> onto <b>Sussex Gardens</b>/<wbr/><b>A4209</b><div style="font-size:0.9em">Continue to follow A4209</div>',
            travelMode: "WALKING",
          },
          {
            distance: "0.2 km",
            duration: "2 mins",
            instructions: "Take the crosswalk",
            travelMode: "WALKING",
          },
          {
            distance: "10 m",
            duration: "1 min",
            instructions:
              "Turn <b>left</b> onto <b>Bayswater Rd</b>/<wbr/><b>A402</b>",
            travelMode: "WALKING",
          },
          {
            distance: "55 m",
            duration: "1 min",
            instructions: "Turn <b>right</b>",
            travelMode: "WALKING",
          },
          {
            distance: "20 m",
            duration: "1 min",
            instructions: "Turn <b>right</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.7 km",
            duration: "10 mins",
            instructions: "Turn <b>left</b>",
            travelMode: "WALKING",
          },
          {
            distance: "16 m",
            duration: "1 min",
            instructions: "Turn <b>left</b> toward <b>W Carriage Dr</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.1 km",
            duration: "2 mins",
            instructions: "Turn <b>right</b> toward <b>W Carriage Dr</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.1 km",
            duration: "2 mins",
            instructions: "Turn <b>right</b> onto <b>W Carriage Dr</b>",
            travelMode: "WALKING",
          },
          {
            distance: "86 m",
            duration: "1 min",
            instructions: "Slight <b>left</b> to stay on <b>W Carriage Dr</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.4 km",
            duration: "5 mins",
            instructions:
              'Continue onto <b>Exhibition Rd</b><div style="font-size:0.9em">Go through 1 roundabout</div>',
            travelMode: "WALKING",
          },
          {
            distance: "73 m",
            duration: "1 min",
            instructions: "Turn <b>right</b> onto <b>Imperial College Rd</b>",
            travelMode: "WALKING",
          },
          {
            distance: "86 m",
            duration: "1 min",
            instructions:
              'Turn <b>right</b> onto <b>Unwin Rd</b><div style="font-size:0.9em">Destination will be on the right</div>',
            travelMode: "WALKING",
          },
        ],
      },
      bicycling: {
        distances: {},
        path: [
          [-0.17163, 51.52116],
          [-0.17143000000000003, 51.521],
          [-0.17120000000000002, 51.52087],
          [-0.17077, 51.520520000000005],
          [-0.17046, 51.52028000000001],
          [-0.16955, 51.51966],
          [-0.16810000000000003, 51.518660000000004],
          [-0.16599000000000003, 51.5172],
          [-0.16319, 51.51529000000001],
          [-0.1628, 51.51503],
          [-0.16310000000000002, 51.51498],
          [-0.16382000000000002, 51.514860000000006],
          [-0.16532000000000002, 51.5146],
          [-0.16673000000000002, 51.51437000000001],
          [-0.16698000000000002, 51.514320000000005],
          [-0.1668, 51.513600000000004],
          [-0.16660000000000003, 51.51286],
          [-0.16660000000000003, 51.512730000000005],
          [-0.16649000000000003, 51.51239],
          [-0.16643000000000002, 51.51212],
          [-0.16816, 51.51189],
          [-0.16925, 51.51174],
          [-0.17012000000000002, 51.511660000000006],
          [-0.17081000000000002, 51.511630000000004],
          [-0.17126000000000002, 51.511610000000005],
          [-0.17141, 51.511630000000004],
          [-0.17184000000000002, 51.51165],
          [-0.17217000000000002, 51.51169],
          [-0.17229000000000003, 51.511570000000006],
          [-0.17255, 51.51146000000001],
          [-0.17268000000000003, 51.51138],
          [-0.17275000000000001, 51.51131],
          [-0.17276000000000002, 51.511230000000005],
          [-0.17274, 51.511140000000005],
          [-0.17265000000000003, 51.51104],
          [-0.17204000000000003, 51.51077],
          [-0.17148000000000002, 51.510540000000006],
          [-0.17128000000000002, 51.51046],
          [-0.17102, 51.51032000000001],
          [-0.17079000000000003, 51.51012000000001],
          [-0.17069, 51.510000000000005],
          [-0.17063, 51.50983],
          [-0.17059000000000002, 51.509690000000006],
          [-0.17054000000000002, 51.50929000000001],
          [-0.17047, 51.50854],
          [-0.17039, 51.50771],
          [-0.17038, 51.50744],
          [-0.17042000000000002, 51.5073],
          [-0.17067000000000002, 51.50701],
          [-0.17095000000000002, 51.50679],
          [-0.17109000000000002, 51.50672],
          [-0.17125, 51.50668],
          [-0.17143000000000003, 51.50668],
          [-0.17187000000000002, 51.506800000000005],
          [-0.17202, 51.506820000000005],
          [-0.17218000000000003, 51.50677],
          [-0.17228000000000002, 51.5067],
          [-0.17237000000000002, 51.506600000000006],
          [-0.17300000000000001, 51.5058],
          [-0.17309000000000002, 51.50562000000001],
          [-0.17316, 51.505300000000005],
          [-0.17327, 51.50508000000001],
          [-0.17375000000000002, 51.50444],
          [-0.17417000000000002, 51.503910000000005],
          [-0.17434000000000002, 51.50368],
          [-0.17455, 51.503330000000005],
          [-0.17463, 51.50309000000001],
          [-0.17465000000000003, 51.50294],
          [-0.17466, 51.50262000000001],
          [-0.17466, 51.502520000000004],
          [-0.17462000000000003, 51.50244000000001],
          [-0.17459000000000002, 51.502280000000006],
          [-0.17455, 51.50216],
          [-0.17447000000000001, 51.50119],
          [-0.17441, 51.50056000000001],
          [-0.17439000000000002, 51.50011000000001],
          [-0.17437000000000002, 51.5001],
          [-0.17435, 51.50009000000001],
          [-0.17432, 51.50005],
          [-0.17433, 51.50001],
          [-0.17437000000000002, 51.49998],
          [-0.17440000000000003, 51.49998],
          [-0.17439000000000002, 51.499810000000004],
          [-0.17417000000000002, 51.49882],
          [-0.17411000000000001, 51.49855],
          [-0.17408, 51.498200000000004],
          [-0.17506000000000002, 51.49812000000001],
          [-0.17513, 51.498110000000004],
          [-0.17517000000000002, 51.49826],
          [-0.17518, 51.498360000000005],
          [-0.17528000000000002, 51.49864],
          [-0.1753, 51.498740000000005],
          [-0.17532, 51.49891],
        ],
        steps: [
          {
            distance: "0.9 km",
            duration: "3 mins",
            instructions:
              "Head <b>southeast</b> on <b>Edgware Rd</b>/<wbr/><b>A5</b> toward <b>Newcastle Pl</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.3 km",
            duration: "1 min",
            instructions:
              'Turn <b>right</b> onto <b>Connaught St</b>/<wbr/><b>Upper Berkeley St</b><div style="font-size:0.9em">Continue to follow Connaught St</div>',
            travelMode: "BICYCLING",
          },
          {
            distance: "0.2 km",
            duration: "1 min",
            instructions: "Turn <b>left</b> onto <b>Albion St</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.3 km",
            duration: "1 min",
            instructions: "Turn <b>right</b> onto <b>N Carriage Dr</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "63 m",
            duration: "1 min",
            instructions: "Slight <b>right</b> to stay on <b>N Carriage Dr</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "1.3 km",
            duration: "4 mins",
            instructions: "Turn <b>left</b> onto <b>W Carriage Dr</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.4 km",
            duration: "2 mins",
            instructions:
              'Continue onto <b>Exhibition Rd</b><div style="font-size:0.9em">Go through 1 roundabout</div>',
            travelMode: "BICYCLING",
          },
          {
            distance: "73 m",
            duration: "1 min",
            instructions: "Turn <b>right</b> onto <b>Imperial College Rd</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "90 m",
            duration: "1 min",
            instructions:
              'Turn <b>right</b> onto <b>Unwin Rd</b><div style="font-size:0.9em">Destination will be on the right</div>',
            travelMode: "BICYCLING",
          },
        ],
      },
      transit: {
        distances: {},
        path: [
          [-0.17170000000000002, 51.52112],
          [-0.17154000000000003, 51.521],
          [-0.17139000000000001, 51.521080000000005],
          [-0.17135, 51.521040000000006],
          [-0.17125, 51.520970000000005],
          [-0.17114000000000001, 51.520900000000005],
          [-0.17076000000000002, 51.520590000000006],
          [-0.17047, 51.520390000000006],
          [-0.17022, 51.52024],
          [-0.17011, 51.52013],
          [-0.16999, 51.520050000000005],
          [-0.17001000000000002, 51.520050000000005],
          [-0.16978000000000001, 51.519890000000004],
          [-0.16968000000000003, 51.519830000000006],
          [-0.16951000000000002, 51.51986],
          [-0.16902, 51.51993],
          [-0.16869, 51.51997],
          [-0.1685, 51.520010000000006],
          [-0.16839, 51.51988000000001],
          [-0.16812000000000002, 51.51957],
          [-0.16799, 51.519670000000005],
          [-0.167, 51.52015],
          [-0.16705, 51.52019000000001],
          [-0.16760000000000003, 51.51999000000001],
          [-0.16812000000000002, 51.51977],
          [-0.16873000000000002, 51.519470000000005],
          [-0.17022, 51.51859],
          [-0.1726, 51.51727],
          [-0.17374, 51.51662],
          [-0.17555, 51.51558000000001],
          [-0.17768, 51.51436],
          [-0.17921, 51.51353],
          [-0.18014000000000002, 51.51317],
          [-0.18087, 51.512980000000006],
          [-0.18185, 51.51279],
          [-0.18276, 51.51265],
          [-0.1832, 51.512600000000006],
          [-0.1839, 51.512550000000005],
          [-0.18509, 51.51249000000001],
          [-0.18687, 51.51239],
          [-0.18887, 51.51225],
          [-0.19010000000000002, 51.51214],
          [-0.19102000000000002, 51.51202000000001],
          [-0.19233000000000003, 51.511790000000005],
          [-0.1937, 51.51145],
          [-0.1947, 51.51113],
          [-0.19504000000000002, 51.51098],
          [-0.19519, 51.51088000000001],
          [-0.19541000000000003, 51.51068],
          [-0.19559, 51.510470000000005],
          [-0.19576000000000002, 51.51021],
          [-0.19590000000000002, 51.50992],
          [-0.19598000000000002, 51.50965000000001],
          [-0.19605000000000003, 51.50932],
          [-0.19606, 51.509130000000006],
          [-0.19603, 51.50887],
          [-0.19598000000000002, 51.508680000000005],
          [-0.19589, 51.508390000000006],
          [-0.19515000000000002, 51.5063],
          [-0.19435000000000002, 51.50403000000001],
          [-0.19386, 51.50253000000001],
          [-0.19378, 51.50238],
          [-0.19309, 51.50151],
          [-0.19267, 51.501000000000005],
          [-0.19209, 51.500400000000006],
          [-0.19098, 51.49933000000001],
          [-0.19068000000000002, 51.499100000000006],
          [-0.18978, 51.49857],
          [-0.18960000000000002, 51.498450000000005],
          [-0.18945, 51.49832000000001],
          [-0.18851, 51.497260000000004],
          [-0.18819000000000002, 51.49689000000001],
          [-0.18741000000000002, 51.49604],
          [-0.18714000000000003, 51.495810000000006],
          [-0.18678, 51.49559000000001],
          [-0.18645, 51.49541000000001],
          [-0.18581, 51.49515],
          [-0.18536000000000002, 51.49503000000001],
          [-0.18315, 51.49457],
          [-0.18199, 51.49434],
          [-0.18141000000000002, 51.494260000000004],
          [-0.18059000000000003, 51.49419],
          [-0.17975000000000002, 51.494150000000005],
          [-0.17853000000000002, 51.49416],
          [-0.17499, 51.494200000000006],
          [-0.17356000000000002, 51.494170000000004],
          [-0.17357, 51.49416],
          [-0.17375000000000002, 51.495670000000004],
          [-0.17373000000000002, 51.495670000000004],
          [-0.17371, 51.495630000000006],
          [-0.17369, 51.495630000000006],
          [-0.17372, 51.495830000000005],
          [-0.17377, 51.49607],
          [-0.17372, 51.49615000000001],
          [-0.17372, 51.49626000000001],
          [-0.1738, 51.496640000000006],
          [-0.17393, 51.49667],
          [-0.17395000000000002, 51.496750000000006],
          [-0.17397, 51.49689000000001],
          [-0.17404000000000003, 51.497150000000005],
          [-0.17415000000000003, 51.49768],
          [-0.17419, 51.497930000000004],
          [-0.17423000000000002, 51.49815],
          [-0.17481000000000002, 51.498110000000004],
          [-0.17506000000000002, 51.49808],
          [-0.17506000000000002, 51.49824],
          [-0.17519, 51.498560000000005],
          [-0.17525000000000002, 51.49889],
          [-0.17525000000000002, 51.49891],
        ],
        steps: [
          {
            distance: "0.4 km",
            duration: "7 mins",
            instructions: "Walk to Edgware Road",
            travelMode: "WALKING",
          },
          {
            distance: "5.1 km",
            duration: "12 mins",
            instructions: "Subway towards Hammersmith",
            travelMode: "TRANSIT",
          },
          {
            distance: "0.6 km",
            duration: "9 mins",
            instructions:
              "Walk to Imperial College Business School, South Kensington, London SW7 2BX, UK",
            travelMode: "WALKING",
          },
        ],
      },
    },
    distances: {
      DRIVING: {
        distance: "3.5 km",
        duration: "13 mins",
      },
      WALKING: {
        distance: "3.2 km",
        duration: "44 mins",
      },
      BICYCLING: {
        distance: "3.8 km",
        duration: "13 mins",
      },
      TRANSIT: {
        distance: "6.2 km",
        duration: "28 mins",
      },
    },
  },
  {
    name: "King’s College London",
    category: "Universities",
    coordinates: {
      lat: 51.512603773169836,
      lng: -0.1163370724095914,
    },
    id: "6745a5701128c70026d05c44",
    routes: {
      driving: {
        distances: {},
        path: [
          [-0.17163, 51.52116],
          [-0.17143000000000003, 51.521],
          [-0.17120000000000002, 51.52087],
          [-0.17077, 51.520520000000005],
          [-0.17046, 51.52028000000001],
          [-0.16955, 51.51966],
          [-0.16810000000000003, 51.518660000000004],
          [-0.16599000000000003, 51.5172],
          [-0.16319, 51.51529000000001],
          [-0.16155000000000003, 51.51422],
          [-0.1607, 51.513690000000004],
          [-0.16035000000000002, 51.51348],
          [-0.16011, 51.51335],
          [-0.15998, 51.51332000000001],
          [-0.15990000000000001, 51.51332000000001],
          [-0.15987, 51.51324],
          [-0.1597, 51.513250000000006],
          [-0.15942, 51.51328],
          [-0.15901, 51.51334000000001],
          [-0.15873, 51.513360000000006],
          [-0.15856, 51.51334000000001],
          [-0.15841000000000002, 51.51328],
          [-0.15831, 51.513270000000006],
          [-0.15824000000000002, 51.513160000000006],
          [-0.15796000000000002, 51.51274],
          [-0.15769000000000002, 51.51220000000001],
          [-0.15713000000000002, 51.51111],
          [-0.15683000000000002, 51.510580000000004],
          [-0.15663000000000002, 51.510310000000004],
          [-0.15654, 51.510220000000004],
          [-0.15612, 51.509890000000006],
          [-0.15588000000000002, 51.50974],
          [-0.1555, 51.5095],
          [-0.15507, 51.50918000000001],
          [-0.15376, 51.50797000000001],
          [-0.15304, 51.50735],
          [-0.15247000000000002, 51.506840000000004],
          [-0.15196, 51.506400000000006],
          [-0.15156, 51.506060000000005],
          [-0.15119000000000002, 51.50571000000001],
          [-0.15101, 51.505520000000004],
          [-0.15092, 51.50533],
          [-0.15092, 51.5052],
          [-0.1509, 51.504850000000005],
          [-0.15092, 51.50471],
          [-0.15102000000000002, 51.50441000000001],
          [-0.15108000000000002, 51.50415],
          [-0.15104, 51.50388],
          [-0.15089000000000002, 51.503440000000005],
          [-0.15083000000000002, 51.50336],
          [-0.15079, 51.503330000000005],
          [-0.15071, 51.5033],
          [-0.15045, 51.50332],
          [-0.15014000000000002, 51.50332],
          [-0.15005000000000002, 51.503310000000006],
          [-0.14995, 51.503260000000004],
          [-0.14987, 51.50321],
          [-0.14981, 51.50316],
          [-0.14976, 51.503060000000005],
          [-0.14977000000000001, 51.50292],
          [-0.14980000000000002, 51.502700000000004],
          [-0.14989000000000002, 51.502570000000006],
          [-0.14883000000000002, 51.502520000000004],
          [-0.14519, 51.502370000000006],
          [-0.14369, 51.50231],
          [-0.14341, 51.50226000000001],
          [-0.14244, 51.50222],
          [-0.14196, 51.5022],
          [-0.14105, 51.50217000000001],
          [-0.14059000000000002, 51.502190000000006],
          [-0.14033, 51.50215000000001],
          [-0.14019, 51.502100000000006],
          [-0.1401, 51.502050000000004],
          [-0.1398, 51.50216],
          [-0.13939000000000001, 51.502320000000005],
          [-0.13911, 51.50244000000001],
          [-0.13601000000000002, 51.50372],
          [-0.13472, 51.504250000000006],
          [-0.13136, 51.50564000000001],
          [-0.12928, 51.5065],
          [-0.129, 51.50663],
          [-0.12893000000000002, 51.50668],
          [-0.12867, 51.506800000000005],
          [-0.12822, 51.50704],
          [-0.12805, 51.507160000000006],
          [-0.12797, 51.50728],
          [-0.12802000000000002, 51.507360000000006],
          [-0.128, 51.507450000000006],
          [-0.12787, 51.50755],
          [-0.12771000000000002, 51.507580000000004],
          [-0.12753, 51.50759000000001],
          [-0.12737, 51.507560000000005],
          [-0.12725, 51.50748],
          [-0.12666000000000002, 51.50732000000001],
          [-0.12656, 51.50728],
          [-0.12589, 51.50717],
          [-0.12536, 51.507070000000006],
          [-0.12439000000000001, 51.50688],
          [-0.12403000000000002, 51.506820000000005],
          [-0.12387000000000001, 51.50679],
          [-0.12372000000000001, 51.506800000000005],
          [-0.12310000000000001, 51.5067],
          [-0.12296000000000001, 51.50667000000001],
          [-0.12256000000000002, 51.50658000000001],
          [-0.12243000000000001, 51.506550000000004],
          [-0.12227, 51.506780000000006],
          [-0.12195000000000002, 51.507180000000005],
          [-0.12139000000000001, 51.50784],
          [-0.12104000000000001, 51.508230000000005],
          [-0.12060000000000001, 51.50864000000001],
          [-0.12006000000000001, 51.50903],
          [-0.11935000000000001, 51.509440000000005],
          [-0.11905, 51.50959],
          [-0.11857000000000001, 51.50979],
          [-0.11793000000000001, 51.51001],
          [-0.11770000000000001, 51.51005000000001],
          [-0.11751, 51.5101],
          [-0.11681000000000001, 51.5103],
          [-0.11588000000000001, 51.51052000000001],
          [-0.11557, 51.51059000000001],
          [-0.11555000000000001, 51.510650000000005],
          [-0.11541000000000001, 51.510780000000004],
          [-0.11531000000000001, 51.51089],
          [-0.11526000000000002, 51.510940000000005],
          [-0.11517000000000001, 51.510960000000004],
          [-0.11494000000000001, 51.51102],
          [-0.11513000000000001, 51.51136],
          [-0.11551000000000002, 51.51203],
          [-0.11569000000000002, 51.512370000000004],
          [-0.11572, 51.512440000000005],
          [-0.11599000000000001, 51.5125],
          [-0.11611, 51.512660000000004],
        ],
        steps: [
          {
            distance: "1.2 km",
            duration: "5 mins",
            instructions:
              "Head <b>southeast</b> on <b>Edgware Rd</b>/<wbr/><b>A5</b> toward <b>Newcastle Pl</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "69 m",
            duration: "1 min",
            instructions: "Keep <b>right</b> to continue on <b>Marble Arch</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "60 m",
            duration: "1 min",
            instructions: "Keep <b>right</b> to stay on <b>Marble Arch</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "1.3 km",
            duration: "3 mins",
            instructions: "Continue onto <b>Park Ln</b>/<wbr/><b>A4202</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "46 m",
            duration: "1 min",
            instructions: "Turn <b>left</b> onto <b>Piccadilly</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "91 m",
            duration: "1 min",
            instructions: "Turn <b>right</b> onto <b>Duke of Wellington Pl</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "0.7 km",
            duration: "2 mins",
            instructions:
              'Turn <b>left</b> onto <b>Constitution Hill</b><div style="font-size:0.9em">Entering toll zone</div>',
            travelMode: "DRIVING",
          },
          {
            distance: "1.0 km",
            duration: "4 mins",
            instructions:
              'Turn <b>left</b> onto <b>The Mall</b><div style="font-size:0.9em">Leaving toll zone in 750m</div><div style="font-size:0.9em">Entering toll zone in 750m</div><div style="font-size:0.9em">Leaving toll zone in 950m</div>',
            travelMode: "DRIVING",
          },
          {
            distance: "0.4 km",
            duration: "2 mins",
            instructions:
              'At the roundabout, take the <b>3rd</b> exit onto <b>Northumberland Ave</b><div style="font-size:0.9em">Entering toll zone</div><div style="font-size:0.9em">Leaving toll zone</div><div style="font-size:0.9em">Entering toll zone</div>',
            travelMode: "DRIVING",
          },
          {
            distance: "0.7 km",
            duration: "2 mins",
            instructions:
              "Turn <b>left</b> onto <b>Victoria Embankment</b>/<wbr/><b>A3211</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "69 m",
            duration: "1 min",
            instructions:
              'Turn <b>left</b> onto <b>Temple Pl</b><div style="font-size:0.9em">Leaving toll zone</div><div style="font-size:0.9em">Entering toll zone</div>',
            travelMode: "DRIVING",
          },
          {
            distance: "0.2 km",
            duration: "1 min",
            instructions:
              'Turn <b>left</b> onto <b>Surrey St</b><div style="font-size:0.9em">Leaving toll zone</div>',
            travelMode: "DRIVING",
          },
          {
            distance: "40 m",
            duration: "1 min",
            instructions:
              'Continue onto <b>Melbourne Pl</b><div style="font-size:0.9em">Destination will be on the left</div>',
            travelMode: "DRIVING",
          },
        ],
      },
      walking: {
        distances: {},
        path: [
          [-0.17170000000000002, 51.52112],
          [-0.17154000000000003, 51.521],
          [-0.17139000000000001, 51.521080000000005],
          [-0.17135, 51.521040000000006],
          [-0.17125, 51.520970000000005],
          [-0.17114000000000001, 51.520900000000005],
          [-0.17076000000000002, 51.520590000000006],
          [-0.17047, 51.520390000000006],
          [-0.17022, 51.52024],
          [-0.17011, 51.52013],
          [-0.16999, 51.520050000000005],
          [-0.17001000000000002, 51.520050000000005],
          [-0.16978000000000001, 51.519890000000004],
          [-0.16951000000000002, 51.51973],
          [-0.16907000000000003, 51.519420000000004],
          [-0.169, 51.51935],
          [-0.16897, 51.519360000000006],
          [-0.16890000000000002, 51.5193],
          [-0.16892000000000001, 51.5193],
          [-0.16870000000000002, 51.51915],
          [-0.16849, 51.518980000000006],
          [-0.16757000000000002, 51.51834],
          [-0.16742, 51.51825],
          [-0.16727, 51.518170000000005],
          [-0.16722, 51.51820000000001],
          [-0.16723000000000002, 51.51816],
          [-0.16716, 51.518150000000006],
          [-0.16717, 51.518130000000006],
          [-0.16718000000000002, 51.51807],
          [-0.16668000000000002, 51.517720000000004],
          [-0.16597, 51.517250000000004],
          [-0.16562000000000002, 51.517030000000005],
          [-0.16554000000000002, 51.516940000000005],
          [-0.16548000000000002, 51.516960000000005],
          [-0.16539, 51.51688000000001],
          [-0.16540000000000002, 51.51688000000001],
          [-0.16528, 51.51679000000001],
          [-0.16523000000000002, 51.516760000000005],
          [-0.16469, 51.51639],
          [-0.16413000000000003, 51.515980000000006],
          [-0.16409, 51.516000000000005],
          [-0.16395, 51.5159],
          [-0.16399000000000002, 51.515890000000006],
          [-0.16396000000000002, 51.51587000000001],
          [-0.16385000000000002, 51.51578000000001],
          [-0.16371000000000002, 51.515750000000004],
          [-0.16317, 51.51538000000001],
          [-0.16308, 51.51532],
          [-0.16306, 51.51523],
          [-0.16286, 51.515100000000004],
          [-0.16279000000000002, 51.51511000000001],
          [-0.16276000000000002, 51.51509],
          [-0.16265000000000002, 51.51500000000001],
          [-0.16268000000000002, 51.51500000000001],
          [-0.16182000000000002, 51.514450000000004],
          [-0.16171000000000002, 51.5144],
          [-0.16155000000000003, 51.51429],
          [-0.16152000000000002, 51.51429],
          [-0.16137, 51.514190000000006],
          [-0.16140000000000002, 51.514190000000006],
          [-0.16128, 51.51411],
          [-0.16098, 51.513940000000005],
          [-0.16080000000000003, 51.513850000000005],
          [-0.16053, 51.513670000000005],
          [-0.16023, 51.513510000000004],
          [-0.16003, 51.513400000000004],
          [-0.15995, 51.513380000000005],
          [-0.15980000000000003, 51.513360000000006],
          [-0.15938000000000002, 51.51341000000001],
          [-0.15915, 51.51344],
          [-0.15913000000000002, 51.513450000000006],
          [-0.15909, 51.51353],
          [-0.15897, 51.513560000000005],
          [-0.15894000000000003, 51.513540000000006],
          [-0.15881, 51.51352000000001],
          [-0.15855000000000002, 51.513510000000004],
          [-0.15837, 51.513540000000006],
          [-0.15822, 51.51355],
          [-0.15786, 51.51361000000001],
          [-0.1574, 51.513690000000004],
          [-0.15663000000000002, 51.51379000000001],
          [-0.15639, 51.51377],
          [-0.15625, 51.51379000000001],
          [-0.15607000000000001, 51.5138],
          [-0.15608000000000002, 51.513830000000006],
          [-0.15588000000000002, 51.51384],
          [-0.15586000000000003, 51.51381000000001],
          [-0.15571000000000002, 51.51382],
          [-0.15508000000000002, 51.51388000000001],
          [-0.15448, 51.51391],
          [-0.15434, 51.51395],
          [-0.15419000000000002, 51.51397000000001],
          [-0.15405000000000002, 51.513980000000004],
          [-0.15406, 51.513960000000004],
          [-0.15379, 51.51399000000001],
          [-0.15380000000000002, 51.513960000000004],
          [-0.15359, 51.51399000000001],
          [-0.15337, 51.514010000000006],
          [-0.1529, 51.51406000000001],
          [-0.15241000000000002, 51.51411],
          [-0.15228, 51.51415],
          [-0.15203000000000003, 51.51418],
          [-0.15173, 51.51418],
          [-0.15145, 51.514230000000005],
          [-0.15146, 51.514250000000004],
          [-0.15142, 51.51426000000001],
          [-0.15132, 51.51427],
          [-0.15130000000000002, 51.514230000000005],
          [-0.15075000000000002, 51.51428000000001],
          [-0.15028000000000002, 51.514320000000005],
          [-0.15029, 51.51433],
          [-0.1502, 51.51435000000001],
          [-0.15019000000000002, 51.514320000000005],
          [-0.15005000000000002, 51.51433],
          [-0.14983000000000002, 51.51438],
          [-0.14919000000000002, 51.514430000000004],
          [-0.14911000000000002, 51.514450000000004],
          [-0.14908000000000002, 51.51436],
          [-0.14897000000000002, 51.514340000000004],
          [-0.14885, 51.51438],
          [-0.14863, 51.514410000000005],
          [-0.14831000000000003, 51.514480000000006],
          [-0.14805000000000001, 51.51447],
          [-0.14787, 51.51451],
          [-0.14759, 51.51453000000001],
          [-0.14731000000000002, 51.51456],
          [-0.14696, 51.5146],
          [-0.14691, 51.51456],
          [-0.14678000000000002, 51.514570000000006],
          [-0.14675000000000002, 51.51458],
          [-0.14678000000000002, 51.514610000000005],
          [-0.14636000000000002, 51.51467],
          [-0.14613, 51.514680000000006],
          [-0.14586000000000002, 51.51469],
          [-0.14557, 51.51476],
          [-0.14534000000000002, 51.51478],
          [-0.14518, 51.51485],
          [-0.14492000000000002, 51.514880000000005],
          [-0.14474, 51.514860000000006],
          [-0.14457, 51.51489],
          [-0.14434000000000002, 51.51491000000001],
          [-0.14423000000000002, 51.51493000000001],
          [-0.14393, 51.514970000000005],
          [-0.14376, 51.51502000000001],
          [-0.14334000000000002, 51.515060000000005],
          [-0.14294, 51.51511000000001],
          [-0.14277, 51.51516],
          [-0.14258, 51.515150000000006],
          [-0.14235, 51.51516],
          [-0.1421, 51.515170000000005],
          [-0.14203000000000002, 51.51518],
          [-0.14194, 51.515240000000006],
          [-0.14184000000000002, 51.51522000000001],
          [-0.14175000000000001, 51.515240000000006],
          [-0.14164000000000002, 51.515260000000005],
          [-0.14100000000000001, 51.515330000000006],
          [-0.14083, 51.51538000000001],
          [-0.14072, 51.51540000000001],
          [-0.14006000000000002, 51.51547000000001],
          [-0.13977, 51.5155],
          [-0.13946, 51.5155],
          [-0.13913, 51.515550000000005],
          [-0.13866, 51.51559],
          [-0.13824, 51.51565],
          [-0.13682000000000002, 51.515800000000006],
          [-0.13679000000000002, 51.515800000000006],
          [-0.13676000000000002, 51.51578000000001],
          [-0.13666, 51.51579],
          [-0.13668000000000002, 51.51581],
          [-0.13657000000000002, 51.515820000000005],
          [-0.13640000000000002, 51.515840000000004],
          [-0.13591, 51.515890000000006],
          [-0.13589, 51.51585000000001],
          [-0.13577, 51.51587000000001],
          [-0.13578, 51.5159],
          [-0.13568000000000002, 51.5159],
          [-0.13518000000000002, 51.515950000000004],
          [-0.13491, 51.515980000000006],
          [-0.13454000000000002, 51.516040000000004],
          [-0.13421000000000002, 51.516070000000006],
          [-0.13377, 51.5161],
          [-0.13309, 51.516160000000006],
          [-0.13288, 51.51617],
          [-0.13275, 51.516180000000006],
          [-0.13276000000000002, 51.516200000000005],
          [-0.13258, 51.516220000000004],
          [-0.13158, 51.5163],
          [-0.13086, 51.51634000000001],
          [-0.13052, 51.51637],
          [-0.13046000000000002, 51.516180000000006],
          [-0.13042, 51.51615],
          [-0.13024000000000002, 51.516160000000006],
          [-0.13021000000000002, 51.516160000000006],
          [-0.13017, 51.515980000000006],
          [-0.13016, 51.51594000000001],
          [-0.13011, 51.51594000000001],
          [-0.13007000000000002, 51.515930000000004],
          [-0.13004000000000002, 51.51592],
          [-0.13, 51.51586],
          [-0.12996000000000002, 51.51586],
          [-0.12976000000000001, 51.5159],
          [-0.12972, 51.515930000000004],
          [-0.12944, 51.516020000000005],
          [-0.12934, 51.516020000000005],
          [-0.12910000000000002, 51.515930000000004],
          [-0.12898, 51.515840000000004],
          [-0.12889, 51.51577],
          [-0.12861, 51.51563],
          [-0.12836, 51.51565],
          [-0.12808, 51.51565],
          [-0.1275, 51.51567000000001],
          [-0.12715, 51.51574],
          [-0.12693000000000002, 51.515730000000005],
          [-0.12691000000000002, 51.515660000000004],
          [-0.12689, 51.515660000000004],
          [-0.12691000000000002, 51.51561],
          [-0.1267, 51.51561],
          [-0.12667, 51.515640000000005],
          [-0.12612, 51.515730000000005],
          [-0.12558, 51.51586],
          [-0.12527000000000002, 51.51597],
          [-0.12461000000000001, 51.51615],
          [-0.12446000000000002, 51.516200000000005],
          [-0.12441, 51.516180000000006],
          [-0.12434, 51.51623000000001],
          [-0.12417000000000002, 51.51614000000001],
          [-0.12385000000000002, 51.51592],
          [-0.12372000000000001, 51.515820000000005],
          [-0.12349000000000002, 51.515640000000005],
          [-0.12335000000000002, 51.51549000000001],
          [-0.12326000000000001, 51.515480000000004],
          [-0.12317000000000002, 51.51541],
          [-0.12312000000000001, 51.515330000000006],
          [-0.12302, 51.5153],
          [-0.12288000000000002, 51.51522000000001],
          [-0.12283000000000001, 51.51514],
          [-0.12264000000000001, 51.51505],
          [-0.12242000000000001, 51.514920000000004],
          [-0.12215000000000001, 51.51476],
          [-0.12202, 51.514660000000006],
          [-0.12165000000000001, 51.51446000000001],
          [-0.12137, 51.514320000000005],
          [-0.12095000000000002, 51.51415],
          [-0.12056000000000001, 51.51399000000001],
          [-0.12023, 51.513850000000005],
          [-0.12013000000000001, 51.5138],
          [-0.11996000000000001, 51.51371],
          [-0.11882000000000001, 51.51328],
          [-0.11817000000000001, 51.51303000000001],
          [-0.11787000000000002, 51.513160000000006],
          [-0.11773000000000002, 51.513220000000004],
          [-0.11756000000000001, 51.51305000000001],
          [-0.11760000000000001, 51.5131],
          [-0.11747, 51.513130000000004],
          [-0.11714000000000001, 51.513090000000005],
          [-0.11704, 51.513110000000005],
          [-0.11688000000000001, 51.513130000000004],
          [-0.11673000000000001, 51.51314000000001],
          [-0.11643, 51.51323000000001],
          [-0.11616000000000001, 51.513220000000004],
          [-0.11613000000000001, 51.513220000000004],
          [-0.11614000000000001, 51.51319],
          [-0.11624000000000001, 51.512710000000006],
          [-0.11623000000000001, 51.512690000000006],
        ],
        steps: [
          {
            distance: "0.4 km",
            duration: "6 mins",
            instructions:
              "Head <b>southeast</b> on <b>Edgware Rd</b>/<wbr/><b>A5</b> toward <b>Newcastle Pl</b>",
            travelMode: "WALKING",
          },
          {
            distance: "26 m",
            duration: "1 min",
            instructions:
              "Turn <b>left</b> onto <b>Old Marylebone Rd</b>/<wbr/><b>A501</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.8 km",
            duration: "11 mins",
            instructions:
              "Turn <b>right</b> onto <b>Edgware Rd</b>/<wbr/><b>A5</b>",
            travelMode: "WALKING",
          },
          {
            distance: "61 m",
            duration: "1 min",
            instructions: "Continue onto <b>Marble Arch</b>",
            travelMode: "WALKING",
          },
          {
            distance: "11 m",
            duration: "1 min",
            instructions: "Turn <b>left</b> onto <b>Great Cumberland Pl</b>",
            travelMode: "WALKING",
          },
          {
            distance: "11 m",
            duration: "1 min",
            instructions:
              "Turn <b>right</b> to stay on <b>Great Cumberland Pl</b>",
            travelMode: "WALKING",
          },
          {
            distance: "13 m",
            duration: "1 min",
            instructions: "Turn <b>left</b> onto <b>Marble Arch</b>",
            travelMode: "WALKING",
          },
          {
            distance: "2.0 km",
            duration: "28 mins",
            instructions: "Continue onto <b>Oxford St</b>",
            travelMode: "WALKING",
          },
          {
            distance: "53 m",
            duration: "1 min",
            instructions:
              "Turn <b>right</b> onto <b>Charing Cross Rd</b>/<wbr/><b>A40</b>/<wbr/><b>A400</b>",
            travelMode: "WALKING",
          },
          {
            distance: "39 m",
            duration: "1 min",
            instructions: "Turn <b>left</b> onto <b>St Giles Square</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.1 km",
            duration: "1 min",
            instructions:
              "Slight <b>left</b> to stay on <b>St Giles Square</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.3 km",
            duration: "4 mins",
            instructions:
              'Slight <b>left</b> onto <b>St Giles High St</b>/<wbr/><b>A40</b><div style="font-size:0.9em">Continue to follow A40</div>',
            travelMode: "WALKING",
          },
          {
            distance: "0.6 km",
            duration: "8 mins",
            instructions: "Turn <b>right</b> onto <b>Drury Ln</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.2 km",
            duration: "2 mins",
            instructions:
              "Turn <b>left</b> onto <b>Aldwych</b>/<wbr/><b>A4</b>",
            travelMode: "WALKING",
          },
          {
            distance: "67 m",
            duration: "1 min",
            instructions: "Turn <b>right</b> onto <b>Melbourne Pl</b>",
            travelMode: "WALKING",
          },
        ],
      },
      bicycling: {
        distances: {},
        path: [
          [-0.17163, 51.52116],
          [-0.17143000000000003, 51.521],
          [-0.17120000000000002, 51.52087],
          [-0.17077, 51.520520000000005],
          [-0.17046, 51.52028000000001],
          [-0.16955, 51.51966],
          [-0.16810000000000003, 51.518660000000004],
          [-0.16599000000000003, 51.5172],
          [-0.16319, 51.51529000000001],
          [-0.1628, 51.51503],
          [-0.16310000000000002, 51.51498],
          [-0.16382000000000002, 51.514860000000006],
          [-0.16322, 51.513940000000005],
          [-0.16317, 51.51381000000001],
          [-0.16295, 51.513470000000005],
          [-0.16273, 51.51314000000001],
          [-0.16269, 51.51306],
          [-0.16271000000000002, 51.5129],
          [-0.1627, 51.51281],
          [-0.16262000000000001, 51.512640000000005],
          [-0.16254000000000002, 51.51245],
          [-0.16244, 51.512260000000005],
          [-0.16238000000000002, 51.51216],
          [-0.16215000000000002, 51.512100000000004],
          [-0.16204000000000002, 51.51209000000001],
          [-0.16182000000000002, 51.51209000000001],
          [-0.16125, 51.51209000000001],
          [-0.16083, 51.512060000000005],
          [-0.16048, 51.51198],
          [-0.15996000000000002, 51.5118],
          [-0.1592, 51.511480000000006],
          [-0.15879000000000001, 51.511280000000006],
          [-0.15858000000000003, 51.51115000000001],
          [-0.15839, 51.51102],
          [-0.15826, 51.5108],
          [-0.15789, 51.50996000000001],
          [-0.15766000000000002, 51.509600000000006],
          [-0.15718000000000001, 51.509040000000006],
          [-0.15636, 51.50806000000001],
          [-0.15581, 51.50746],
          [-0.15493, 51.506420000000006],
          [-0.15381, 51.50508000000001],
          [-0.15335000000000001, 51.504540000000006],
          [-0.15319000000000002, 51.504360000000005],
          [-0.15317, 51.504310000000004],
          [-0.15312, 51.50421000000001],
          [-0.1531, 51.504110000000004],
          [-0.1531, 51.50403000000001],
          [-0.15261000000000002, 51.50392],
          [-0.1526, 51.50379],
          [-0.15264000000000003, 51.5037],
          [-0.15265, 51.50365000000001],
          [-0.15247000000000002, 51.50354],
          [-0.15243, 51.50348],
          [-0.15223, 51.503080000000004],
          [-0.15212, 51.502950000000006],
          [-0.15203000000000003, 51.50289],
          [-0.15189000000000002, 51.502770000000005],
          [-0.15181, 51.50265],
          [-0.15177000000000002, 51.502590000000005],
          [-0.15148, 51.502570000000006],
          [-0.15114000000000002, 51.50254],
          [-0.15095, 51.50245],
          [-0.15069000000000002, 51.50242],
          [-0.15027000000000001, 51.502520000000004],
          [-0.15006, 51.50256],
          [-0.14927, 51.50254],
          [-0.14693, 51.50244000000001],
          [-0.14369, 51.50231],
          [-0.14341, 51.50226000000001],
          [-0.14244, 51.50222],
          [-0.14196, 51.5022],
          [-0.14105, 51.50217000000001],
          [-0.14075000000000001, 51.50218],
          [-0.14059000000000002, 51.502190000000006],
          [-0.14044, 51.50218],
          [-0.14019, 51.502100000000006],
          [-0.1401, 51.502050000000004],
          [-0.14007, 51.502010000000006],
          [-0.14004, 51.50193],
          [-0.14003000000000002, 51.50182],
          [-0.14006000000000002, 51.50173],
          [-0.1401, 51.501540000000006],
          [-0.14011, 51.501470000000005],
          [-0.1401, 51.50144],
          [-0.13998000000000002, 51.501310000000004],
          [-0.13992000000000002, 51.501180000000005],
          [-0.13963, 51.500890000000005],
          [-0.13932, 51.500600000000006],
          [-0.13919, 51.50052],
          [-0.13915000000000002, 51.500490000000006],
          [-0.13907, 51.500460000000004],
          [-0.13899, 51.500440000000005],
          [-0.13870000000000002, 51.500440000000005],
          [-0.13662000000000002, 51.50065000000001],
          [-0.13554000000000002, 51.500750000000004],
          [-0.13183, 51.50114000000001],
          [-0.13072, 51.501250000000006],
          [-0.13026000000000001, 51.50128],
          [-0.12969, 51.50128],
          [-0.12903, 51.50123000000001],
          [-0.12760000000000002, 51.50113],
          [-0.12718000000000002, 51.501090000000005],
          [-0.12668000000000001, 51.50104],
          [-0.12557000000000001, 51.501000000000005],
          [-0.12446000000000002, 51.50097],
          [-0.12424000000000002, 51.50097],
          [-0.12414000000000001, 51.50121000000001],
          [-0.12410000000000002, 51.50151],
          [-0.12406, 51.50175],
          [-0.12395, 51.502210000000005],
          [-0.12377, 51.50292],
          [-0.12362000000000001, 51.50348],
          [-0.12315000000000001, 51.505030000000005],
          [-0.12310000000000001, 51.50524000000001],
          [-0.12295, 51.505630000000004],
          [-0.12284, 51.50587],
          [-0.12271000000000001, 51.506080000000004],
          [-0.12250000000000001, 51.506420000000006],
          [-0.12243000000000001, 51.506550000000004],
          [-0.12202, 51.507090000000005],
          [-0.12148, 51.507740000000005],
          [-0.12104000000000001, 51.50822],
          [-0.12090000000000001, 51.50836],
          [-0.12060000000000001, 51.50864000000001],
          [-0.12023, 51.508900000000004],
          [-0.11989000000000001, 51.50914],
          [-0.11913000000000001, 51.509550000000004],
          [-0.11868000000000001, 51.509750000000004],
          [-0.1184, 51.50985000000001],
          [-0.11789000000000001, 51.510020000000004],
          [-0.11757000000000001, 51.51008],
          [-0.11698000000000001, 51.510250000000006],
          [-0.11608, 51.510470000000005],
          [-0.11557, 51.51059000000001],
          [-0.1155, 51.51070000000001],
          [-0.11533000000000002, 51.510870000000004],
          [-0.11529, 51.51091],
          [-0.11521, 51.510960000000004],
          [-0.11514, 51.51097000000001],
          [-0.11494000000000001, 51.51102],
          [-0.11504, 51.5112],
          [-0.11518, 51.51145],
          [-0.11532, 51.511700000000005],
          [-0.11572, 51.512440000000005],
          [-0.11599000000000001, 51.5125],
          [-0.11611, 51.512660000000004],
        ],
        steps: [
          {
            distance: "0.9 km",
            duration: "3 mins",
            instructions:
              "Head <b>southeast</b> on <b>Edgware Rd</b>/<wbr/><b>A5</b> toward <b>Newcastle Pl</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "73 m",
            duration: "1 min",
            instructions:
              'Turn <b>right</b> onto <b>Connaught St</b>/<wbr/><b>Upper Berkeley St</b><div style="font-size:0.9em">Continue to follow Connaught St</div>',
            travelMode: "BICYCLING",
          },
          {
            distance: "0.1 km",
            duration: "1 min",
            instructions: "Turn <b>left</b> onto <b>Connaught Square</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.2 km",
            duration: "1 min",
            instructions: "Continue onto <b>Stanhope Pl</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "1.2 km",
            duration: "3 mins",
            instructions: "Turn <b>left</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "36 m",
            duration: "1 min",
            instructions: "Turn <b>left</b> toward <b>S Carriage Dr</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "30 m",
            duration: "1 min",
            instructions: "Turn <b>right</b> onto <b>S Carriage Dr</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "82 m",
            duration: "1 min",
            instructions: "Turn <b>left</b> toward <b>Apsley Way</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "54 m",
            duration: "1 min",
            instructions: "Continue onto <b>Apsley Way</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.1 km",
            duration: "1 min",
            instructions: "Turn <b>left</b> to stay on <b>Apsley Way</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.7 km",
            duration: "2 mins",
            instructions: "Continue onto <b>Constitution Hill</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.2 km",
            duration: "1 min",
            instructions: "Slight <b>right</b> onto <b>Spur Rd</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "50 m",
            duration: "1 min",
            instructions: "Keep <b>right</b> to stay on <b>Spur Rd</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.6 km",
            duration: "2 mins",
            instructions: "Continue onto <b>Birdcage Walk</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.2 km",
            duration: "1 min",
            instructions:
              "Continue onto <b>Great George St</b>/<wbr/><b>A3214</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.1 km",
            duration: "1 min",
            instructions: "Continue onto <b>Bridge St</b>/<wbr/><b>A302</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "1.3 km",
            duration: "4 mins",
            instructions:
              "Turn <b>left</b> onto <b>Victoria Embankment</b>/<wbr/><b>A3211</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "69 m",
            duration: "1 min",
            instructions:
              'Turn <b>left</b> onto <b>Temple Pl</b><div style="font-size:0.9em">Entering toll zone</div>',
            travelMode: "BICYCLING",
          },
          {
            distance: "0.2 km",
            duration: "1 min",
            instructions:
              'Turn <b>left</b> onto <b>Surrey St</b><div style="font-size:0.9em">Leaving toll zone</div>',
            travelMode: "BICYCLING",
          },
          {
            distance: "20 m",
            duration: "1 min",
            instructions: "Turn <b>left</b> toward <b>Melbourne Pl</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "20 m",
            duration: "1 min",
            instructions:
              'Turn <b>right</b> onto <b>Melbourne Pl</b><div style="font-size:0.9em">Destination will be on the left</div>',
            travelMode: "BICYCLING",
          },
        ],
      },
      transit: {
        distances: {},
        path: [
          [-0.17170000000000002, 51.52112],
          [-0.17154000000000003, 51.521],
          [-0.17139000000000001, 51.521080000000005],
          [-0.17135, 51.521040000000006],
          [-0.17125, 51.520970000000005],
          [-0.17114000000000001, 51.520900000000005],
          [-0.17076000000000002, 51.520590000000006],
          [-0.17047, 51.520390000000006],
          [-0.17022, 51.52024],
          [-0.17011, 51.52013],
          [-0.16999, 51.520050000000005],
          [-0.17001000000000002, 51.520050000000005],
          [-0.16978000000000001, 51.519890000000004],
          [-0.16968000000000003, 51.519830000000006],
          [-0.16951000000000002, 51.51986],
          [-0.16902, 51.51993],
          [-0.16869, 51.51997],
          [-0.1685, 51.520010000000006],
          [-0.16839, 51.51988000000001],
          [-0.16812000000000002, 51.51957],
          [-0.16799, 51.519670000000005],
          [-0.167, 51.52015],
          [-0.16705, 51.52019000000001],
          [-0.16760000000000003, 51.51999000000001],
          [-0.16812000000000002, 51.51977],
          [-0.16873000000000002, 51.519470000000005],
          [-0.17022, 51.51859],
          [-0.1726, 51.51727],
          [-0.17374, 51.51662],
          [-0.17555, 51.51558000000001],
          [-0.17768, 51.51436],
          [-0.17921, 51.51353],
          [-0.18014000000000002, 51.51317],
          [-0.18087, 51.512980000000006],
          [-0.18185, 51.51279],
          [-0.18276, 51.51265],
          [-0.1832, 51.512600000000006],
          [-0.1839, 51.512550000000005],
          [-0.18509, 51.51249000000001],
          [-0.18687, 51.51239],
          [-0.18887, 51.51225],
          [-0.19010000000000002, 51.51214],
          [-0.19102000000000002, 51.51202000000001],
          [-0.19233000000000003, 51.511790000000005],
          [-0.1937, 51.51145],
          [-0.1947, 51.51113],
          [-0.19504000000000002, 51.51098],
          [-0.19519, 51.51088000000001],
          [-0.19541000000000003, 51.51068],
          [-0.19559, 51.510470000000005],
          [-0.19576000000000002, 51.51021],
          [-0.19590000000000002, 51.50992],
          [-0.19598000000000002, 51.50965000000001],
          [-0.19605000000000003, 51.50932],
          [-0.19606, 51.509130000000006],
          [-0.19603, 51.50887],
          [-0.19598000000000002, 51.508680000000005],
          [-0.19589, 51.508390000000006],
          [-0.19515000000000002, 51.5063],
          [-0.19435000000000002, 51.50403000000001],
          [-0.19386, 51.50253000000001],
          [-0.19378, 51.50238],
          [-0.19309, 51.50151],
          [-0.19267, 51.501000000000005],
          [-0.19209, 51.500400000000006],
          [-0.19098, 51.49933000000001],
          [-0.19068000000000002, 51.499100000000006],
          [-0.18978, 51.49857],
          [-0.18960000000000002, 51.498450000000005],
          [-0.18945, 51.49832000000001],
          [-0.18851, 51.497260000000004],
          [-0.18819000000000002, 51.49689000000001],
          [-0.18741000000000002, 51.49604],
          [-0.18714000000000003, 51.495810000000006],
          [-0.18678, 51.49559000000001],
          [-0.18645, 51.49541000000001],
          [-0.18581, 51.49515],
          [-0.18536000000000002, 51.49503000000001],
          [-0.18315, 51.49457],
          [-0.18199, 51.49434],
          [-0.18141000000000002, 51.494260000000004],
          [-0.18059000000000003, 51.49419],
          [-0.17975000000000002, 51.494150000000005],
          [-0.17853000000000002, 51.49416],
          [-0.17499, 51.494200000000006],
          [-0.17356000000000002, 51.494170000000004],
          [-0.17099, 51.49409000000001],
          [-0.16999, 51.494060000000005],
          [-0.1685, 51.49398000000001],
          [-0.16379000000000002, 51.49381],
          [-0.16282000000000002, 51.493770000000005],
          [-0.16213000000000002, 51.49371000000001],
          [-0.16152000000000002, 51.49363],
          [-0.16089, 51.493520000000004],
          [-0.15972, 51.49325],
          [-0.15838000000000002, 51.49286000000001],
          [-0.15652000000000002, 51.492360000000005],
          [-0.15568, 51.49215],
          [-0.15516000000000002, 51.49206],
          [-0.15443, 51.491960000000006],
          [-0.15352000000000002, 51.491890000000005],
          [-0.15291000000000002, 51.491910000000004],
          [-0.15234, 51.49195],
          [-0.15176, 51.492020000000004],
          [-0.15116000000000002, 51.49212000000001],
          [-0.15052000000000001, 51.49231],
          [-0.14979, 51.4926],
          [-0.14924, 51.49291],
          [-0.14876, 51.493230000000004],
          [-0.14808000000000002, 51.49385],
          [-0.14763, 51.49432],
          [-0.14674, 51.49539000000001],
          [-0.1464, 51.495740000000005],
          [-0.14601, 51.496030000000005],
          [-0.14581000000000002, 51.496140000000004],
          [-0.14563, 51.496210000000005],
          [-0.14520000000000002, 51.49629],
          [-0.14441, 51.49635000000001],
          [-0.14366, 51.496370000000006],
          [-0.14309000000000002, 51.496410000000004],
          [-0.14254, 51.49653000000001],
          [-0.1421, 51.49667],
          [-0.14177, 51.49680000000001],
          [-0.14109000000000002, 51.497080000000004],
          [-0.14086, 51.49714],
          [-0.14058, 51.49719],
          [-0.13978000000000002, 51.497310000000006],
          [-0.13903000000000001, 51.497440000000005],
          [-0.13848000000000002, 51.49757],
          [-0.13807, 51.4977],
          [-0.13766, 51.497870000000006],
          [-0.13698000000000002, 51.49819],
          [-0.13581000000000001, 51.49879000000001],
          [-0.13519, 51.499050000000004],
          [-0.13452, 51.49929],
          [-0.13397, 51.49947],
          [-0.13371000000000002, 51.49954],
          [-0.13346000000000002, 51.49958],
          [-0.1332, 51.499610000000004],
          [-0.13285000000000002, 51.49962000000001],
          [-0.13119, 51.49964000000001],
          [-0.12979000000000002, 51.499610000000004],
          [-0.12945, 51.499610000000004],
          [-0.1292, 51.49965],
          [-0.12864, 51.49982000000001],
          [-0.12729000000000001, 51.500280000000004],
          [-0.12565, 51.500910000000005],
          [-0.12511, 51.50114000000001],
          [-0.12478000000000002, 51.50132000000001],
          [-0.12458000000000001, 51.50148],
          [-0.12442000000000002, 51.50161000000001],
          [-0.12424000000000002, 51.50182],
          [-0.12407000000000001, 51.50204],
          [-0.12391, 51.50233000000001],
          [-0.12380000000000001, 51.50262000000001],
          [-0.12355000000000001, 51.503490000000006],
          [-0.12314000000000001, 51.50482],
          [-0.12289000000000001, 51.505570000000006],
          [-0.1228, 51.50578],
          [-0.12255, 51.506220000000006],
          [-0.12228000000000001, 51.50663],
          [-0.12167000000000001, 51.50741000000001],
          [-0.12142000000000001, 51.507720000000006],
          [-0.12113000000000002, 51.508030000000005],
          [-0.12091, 51.508280000000006],
          [-0.12064000000000001, 51.508520000000004],
          [-0.12007000000000001, 51.50894],
          [-0.11937, 51.509350000000005],
          [-0.1188, 51.50963],
          [-0.11813000000000001, 51.509890000000006],
          [-0.11745000000000001, 51.510110000000005],
          [-0.11680000000000001, 51.5103],
          [-0.11615, 51.510450000000006],
          [-0.11492000000000001, 51.51070000000001],
          [-0.11365000000000001, 51.51088000000001],
          [-0.11373000000000001, 51.511100000000006],
          [-0.11365000000000001, 51.51109],
          [-0.11362000000000001, 51.51109],
          [-0.11353, 51.51111],
          [-0.11355000000000001, 51.51115000000001],
          [-0.11358000000000001, 51.511230000000005],
          [-0.11365000000000001, 51.511230000000005],
          [-0.11392000000000001, 51.5112],
          [-0.11421, 51.511140000000005],
          [-0.11481000000000001, 51.511],
          [-0.11492000000000001, 51.51098],
          [-0.11498000000000001, 51.51093],
          [-0.11513000000000001, 51.51118],
          [-0.11527000000000001, 51.511430000000004],
          [-0.11538000000000001, 51.51165],
          [-0.11544000000000001, 51.51171],
          [-0.11561, 51.512010000000004],
          [-0.11579, 51.512350000000005],
          [-0.11584000000000001, 51.51243],
          [-0.11601000000000002, 51.51247000000001],
          [-0.11609000000000001, 51.51249000000001],
          [-0.11620000000000001, 51.512640000000005],
        ],
        steps: [
          {
            distance: "0.4 km",
            duration: "7 mins",
            instructions: "Walk to Edgware Road",
            travelMode: "WALKING",
          },
          {
            distance: "10.4 km",
            duration: "23 mins",
            instructions: "Subway towards Hammersmith",
            travelMode: "TRANSIT",
          },
          {
            distance: "0.3 km",
            duration: "6 mins",
            instructions: "Walk to 300 Strand, London WC2R 1AE, UK",
            travelMode: "WALKING",
          },
        ],
      },
    },
    distances: {
      DRIVING: {
        distance: "5.8 km",
        duration: "22 mins",
      },
      WALKING: {
        distance: "4.6 km",
        duration: "1 hour 5 mins",
      },
      BICYCLING: {
        distance: "6.3 km",
        duration: "23 mins",
      },
      TRANSIT: {
        distance: "5.7 km",
        duration: "42 mins",
      },
    },
  },
  {
    name: "London School of Economics",
    category: "Universities",
    coordinates: {
      lat: 51.51455627695474,
      lng: -0.11647626401662182,
    },
    id: "6745a5ab1128c70026d05c45",
    routes: {
      driving: {
        distances: {},
        path: [
          [-0.17163, 51.52116],
          [-0.17143000000000003, 51.521],
          [-0.17120000000000002, 51.52087],
          [-0.17077, 51.520520000000005],
          [-0.17046, 51.52028000000001],
          [-0.17019, 51.52009],
          [-0.16994, 51.520100000000006],
          [-0.16922, 51.520160000000004],
          [-0.16849, 51.52029],
          [-0.16758, 51.52049],
          [-0.16724000000000003, 51.520500000000006],
          [-0.16679000000000002, 51.520610000000005],
          [-0.16646000000000002, 51.520680000000006],
          [-0.16606, 51.52076],
          [-0.16464, 51.52094],
          [-0.16364, 51.52113000000001],
          [-0.16257000000000002, 51.52131000000001],
          [-0.16033, 51.5217],
          [-0.15892, 51.521950000000004],
          [-0.15717, 51.52225000000001],
          [-0.15316000000000002, 51.52297],
          [-0.15243, 51.52310000000001],
          [-0.15137, 51.52317000000001],
          [-0.1506, 51.523230000000005],
          [-0.14953000000000002, 51.52331],
          [-0.14888, 51.52338],
          [-0.14789000000000002, 51.52355000000001],
          [-0.14614000000000002, 51.523860000000006],
          [-0.14546, 51.52398],
          [-0.14500000000000002, 51.524060000000006],
          [-0.14477, 51.52409],
          [-0.14450000000000002, 51.52412],
          [-0.14402, 51.524080000000005],
          [-0.1436, 51.52404000000001],
          [-0.14332, 51.52404000000001],
          [-0.14295000000000002, 51.524010000000004],
          [-0.1428, 51.524010000000004],
          [-0.14237000000000002, 51.52405],
          [-0.14159000000000002, 51.52422000000001],
          [-0.14018, 51.52459],
          [-0.13802, 51.52517],
          [-0.13722, 51.525400000000005],
          [-0.13624, 51.52562],
          [-0.13544, 51.52581000000001],
          [-0.13509000000000002, 51.525920000000006],
          [-0.13482000000000002, 51.52601000000001],
          [-0.13451000000000002, 51.52610000000001],
          [-0.13417, 51.526230000000005],
          [-0.13396000000000002, 51.52631],
          [-0.13384000000000001, 51.526320000000005],
          [-0.13333, 51.526500000000006],
          [-0.13287000000000002, 51.526680000000006],
          [-0.13217, 51.526920000000004],
          [-0.13149000000000002, 51.52714],
          [-0.131, 51.52731000000001],
          [-0.13085000000000002, 51.527370000000005],
          [-0.13076000000000002, 51.527280000000005],
          [-0.13061, 51.52716],
          [-0.13006, 51.52669],
          [-0.12974000000000002, 51.5264],
          [-0.12909, 51.525800000000004],
          [-0.12807000000000002, 51.524890000000006],
          [-0.12707000000000002, 51.523970000000006],
          [-0.12628, 51.52326000000001],
          [-0.12579, 51.522830000000006],
          [-0.12497000000000001, 51.52217],
          [-0.12392000000000002, 51.521350000000005],
          [-0.12253000000000001, 51.52024],
          [-0.12174000000000001, 51.51952000000001],
          [-0.12156000000000002, 51.51935],
          [-0.12137, 51.51926],
          [-0.12132000000000001, 51.51923000000001],
          [-0.12099000000000001, 51.519070000000006],
          [-0.12090000000000001, 51.519000000000005],
          [-0.12084, 51.518860000000004],
          [-0.12070000000000002, 51.518510000000006],
          [-0.12063000000000001, 51.51838000000001],
          [-0.12055, 51.51814],
          [-0.12043000000000001, 51.51785],
          [-0.12027000000000002, 51.51753],
          [-0.12016, 51.51727],
          [-0.11983, 51.51681000000001],
          [-0.11938000000000001, 51.51614000000001],
          [-0.11889000000000001, 51.51543],
          [-0.11802000000000001, 51.51418],
          [-0.11715, 51.51442],
          [-0.11695000000000001, 51.51453000000001],
          [-0.11692000000000001, 51.51455000000001],
          [-0.11683, 51.51453000000001],
          [-0.1165, 51.51449],
        ],
        steps: [
          {
            distance: "0.2 km",
            duration: "1 min",
            instructions:
              "Head <b>southeast</b> on <b>Edgware Rd</b>/<wbr/><b>A5</b> toward <b>Newcastle Pl</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "0.2 km",
            duration: "1 min",
            instructions:
              "Turn <b>left</b> (signs for <b>Ring Rd E</b>/<wbr/><b>A400</b>/<wbr/><b>A1</b>/<wbr/><b>The City</b>/<wbr/><b>Euston</b>/<wbr/><b>Kings Cross</b>)",
            travelMode: "DRIVING",
          },
          {
            distance: "2.7 km",
            duration: "10 mins",
            instructions:
              'Merge onto <b>Marylebone Rd</b>/<wbr/><b>Marylebone Flyover</b>/<wbr/><b>A501</b><div style="font-size:0.9em">Continue to follow A501</div>',
            travelMode: "DRIVING",
          },
          {
            distance: "1.7 km",
            duration: "8 mins",
            instructions:
              'Turn <b>right</b> onto <b>Upper Woburn Pl</b>/<wbr/><b>A4200</b><div style="font-size:0.9em">Continue to follow A4200</div><div style="font-size:0.9em">Entering toll zone</div><div style="font-size:0.9em">Leaving toll zone</div><div style="font-size:0.9em">Entering toll zone in 290m</div><div style="font-size:0.9em">Leaving toll zone in 750m</div><div style="font-size:0.9em">Entering toll zone in 800m at Southampton Row</div>',
            travelMode: "DRIVING",
          },
          {
            distance: "87 m",
            duration: "1 min",
            instructions: "Turn <b>left</b> onto <b>Portugal St</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "30 m",
            duration: "1 min",
            instructions:
              'Turn <b>right</b> onto <b>St Clement\'s Ln</b><div style="font-size:0.9em">Destination will be on the left</div>',
            travelMode: "DRIVING",
          },
        ],
      },
      walking: {
        distances: {},
        path: [
          [-0.17170000000000002, 51.52112],
          [-0.17154000000000003, 51.521],
          [-0.17139000000000001, 51.521080000000005],
          [-0.17135, 51.521040000000006],
          [-0.17125, 51.520970000000005],
          [-0.17114000000000001, 51.520900000000005],
          [-0.17076000000000002, 51.520590000000006],
          [-0.17047, 51.520390000000006],
          [-0.17022, 51.52024],
          [-0.17011, 51.52013],
          [-0.16999, 51.520050000000005],
          [-0.17001000000000002, 51.520050000000005],
          [-0.16978000000000001, 51.519890000000004],
          [-0.16951000000000002, 51.51973],
          [-0.16907000000000003, 51.519420000000004],
          [-0.169, 51.51935],
          [-0.16897, 51.519360000000006],
          [-0.16890000000000002, 51.5193],
          [-0.16892000000000001, 51.5193],
          [-0.16870000000000002, 51.51915],
          [-0.16849, 51.518980000000006],
          [-0.16757000000000002, 51.51834],
          [-0.16742, 51.51825],
          [-0.16727, 51.518170000000005],
          [-0.16722, 51.51820000000001],
          [-0.16723000000000002, 51.51816],
          [-0.16716, 51.518150000000006],
          [-0.16717, 51.518130000000006],
          [-0.16718000000000002, 51.51807],
          [-0.16668000000000002, 51.517720000000004],
          [-0.16597, 51.517250000000004],
          [-0.16562000000000002, 51.517030000000005],
          [-0.16554000000000002, 51.516940000000005],
          [-0.16548000000000002, 51.516960000000005],
          [-0.16539, 51.51688000000001],
          [-0.16540000000000002, 51.51688000000001],
          [-0.16528, 51.51679000000001],
          [-0.16523000000000002, 51.516760000000005],
          [-0.16469, 51.51639],
          [-0.16413000000000003, 51.515980000000006],
          [-0.16409, 51.516000000000005],
          [-0.16395, 51.5159],
          [-0.16399000000000002, 51.515890000000006],
          [-0.16396000000000002, 51.51587000000001],
          [-0.16385000000000002, 51.51578000000001],
          [-0.16371000000000002, 51.515750000000004],
          [-0.16317, 51.51538000000001],
          [-0.16308, 51.51532],
          [-0.16306, 51.51523],
          [-0.16286, 51.515100000000004],
          [-0.16279000000000002, 51.51511000000001],
          [-0.16276000000000002, 51.51509],
          [-0.16265000000000002, 51.51500000000001],
          [-0.16268000000000002, 51.51500000000001],
          [-0.16182000000000002, 51.514450000000004],
          [-0.16171000000000002, 51.5144],
          [-0.16155000000000003, 51.51429],
          [-0.16152000000000002, 51.51429],
          [-0.16137, 51.514190000000006],
          [-0.16140000000000002, 51.514190000000006],
          [-0.16128, 51.51411],
          [-0.16098, 51.513940000000005],
          [-0.16080000000000003, 51.513850000000005],
          [-0.16053, 51.513670000000005],
          [-0.16023, 51.513510000000004],
          [-0.16003, 51.513400000000004],
          [-0.15995, 51.513380000000005],
          [-0.15980000000000003, 51.513360000000006],
          [-0.15938000000000002, 51.51341000000001],
          [-0.15915, 51.51344],
          [-0.15913000000000002, 51.513450000000006],
          [-0.15909, 51.51353],
          [-0.15897, 51.513560000000005],
          [-0.15894000000000003, 51.513540000000006],
          [-0.15881, 51.51352000000001],
          [-0.15855000000000002, 51.513510000000004],
          [-0.15837, 51.513540000000006],
          [-0.15822, 51.51355],
          [-0.15786, 51.51361000000001],
          [-0.1574, 51.513690000000004],
          [-0.15663000000000002, 51.51379000000001],
          [-0.15639, 51.51377],
          [-0.15625, 51.51379000000001],
          [-0.15607000000000001, 51.5138],
          [-0.15608000000000002, 51.513830000000006],
          [-0.15588000000000002, 51.51384],
          [-0.15586000000000003, 51.51381000000001],
          [-0.15571000000000002, 51.51382],
          [-0.15508000000000002, 51.51388000000001],
          [-0.15448, 51.51391],
          [-0.15434, 51.51395],
          [-0.15419000000000002, 51.51397000000001],
          [-0.15405000000000002, 51.513980000000004],
          [-0.15406, 51.513960000000004],
          [-0.15379, 51.51399000000001],
          [-0.15380000000000002, 51.513960000000004],
          [-0.15359, 51.51399000000001],
          [-0.15337, 51.514010000000006],
          [-0.1529, 51.51406000000001],
          [-0.15241000000000002, 51.51411],
          [-0.15228, 51.51415],
          [-0.15203000000000003, 51.51418],
          [-0.15173, 51.51418],
          [-0.15145, 51.514230000000005],
          [-0.15146, 51.514250000000004],
          [-0.15142, 51.51426000000001],
          [-0.15132, 51.51427],
          [-0.15130000000000002, 51.514230000000005],
          [-0.15075000000000002, 51.51428000000001],
          [-0.15028000000000002, 51.514320000000005],
          [-0.15029, 51.51433],
          [-0.1502, 51.51435000000001],
          [-0.15019000000000002, 51.514320000000005],
          [-0.15005000000000002, 51.51433],
          [-0.14983000000000002, 51.51438],
          [-0.14919000000000002, 51.514430000000004],
          [-0.14911000000000002, 51.514450000000004],
          [-0.14908000000000002, 51.51436],
          [-0.14897000000000002, 51.514340000000004],
          [-0.14885, 51.51438],
          [-0.14863, 51.514410000000005],
          [-0.14831000000000003, 51.514480000000006],
          [-0.14805000000000001, 51.51447],
          [-0.14787, 51.51451],
          [-0.14759, 51.51453000000001],
          [-0.14731000000000002, 51.51456],
          [-0.14696, 51.5146],
          [-0.14691, 51.51456],
          [-0.14678000000000002, 51.514570000000006],
          [-0.14675000000000002, 51.51458],
          [-0.14678000000000002, 51.514610000000005],
          [-0.14636000000000002, 51.51467],
          [-0.14613, 51.514680000000006],
          [-0.14586000000000002, 51.51469],
          [-0.14557, 51.51476],
          [-0.14534000000000002, 51.51478],
          [-0.14518, 51.51485],
          [-0.14492000000000002, 51.514880000000005],
          [-0.14474, 51.514860000000006],
          [-0.14457, 51.51489],
          [-0.14434000000000002, 51.51491000000001],
          [-0.14423000000000002, 51.51493000000001],
          [-0.14393, 51.514970000000005],
          [-0.14376, 51.51502000000001],
          [-0.14334000000000002, 51.515060000000005],
          [-0.14294, 51.51511000000001],
          [-0.14277, 51.51516],
          [-0.14258, 51.515150000000006],
          [-0.14235, 51.51516],
          [-0.1421, 51.515170000000005],
          [-0.14203000000000002, 51.51518],
          [-0.14194, 51.515240000000006],
          [-0.14184000000000002, 51.51522000000001],
          [-0.14175000000000001, 51.515240000000006],
          [-0.14164000000000002, 51.515260000000005],
          [-0.14100000000000001, 51.515330000000006],
          [-0.14083, 51.51538000000001],
          [-0.14072, 51.51540000000001],
          [-0.14006000000000002, 51.51547000000001],
          [-0.13977, 51.5155],
          [-0.13946, 51.5155],
          [-0.13913, 51.515550000000005],
          [-0.13866, 51.51559],
          [-0.13824, 51.51565],
          [-0.13682000000000002, 51.515800000000006],
          [-0.13679000000000002, 51.515800000000006],
          [-0.13676000000000002, 51.51578000000001],
          [-0.13666, 51.51579],
          [-0.13668000000000002, 51.51581],
          [-0.13657000000000002, 51.515820000000005],
          [-0.13640000000000002, 51.515840000000004],
          [-0.13591, 51.515890000000006],
          [-0.13589, 51.51585000000001],
          [-0.13577, 51.51587000000001],
          [-0.13578, 51.5159],
          [-0.13568000000000002, 51.5159],
          [-0.13518000000000002, 51.515950000000004],
          [-0.13491, 51.515980000000006],
          [-0.13454000000000002, 51.516040000000004],
          [-0.13421000000000002, 51.516070000000006],
          [-0.13377, 51.5161],
          [-0.13309, 51.516160000000006],
          [-0.13288, 51.51617],
          [-0.13275, 51.516180000000006],
          [-0.13276000000000002, 51.516200000000005],
          [-0.13258, 51.516220000000004],
          [-0.13158, 51.5163],
          [-0.13086, 51.51634000000001],
          [-0.13052, 51.51637],
          [-0.13046000000000002, 51.516180000000006],
          [-0.13042, 51.51615],
          [-0.13024000000000002, 51.516160000000006],
          [-0.13021000000000002, 51.516160000000006],
          [-0.13018000000000002, 51.51621],
          [-0.13023, 51.51637],
          [-0.13016, 51.516380000000005],
          [-0.13008, 51.516380000000005],
          [-0.12960000000000002, 51.516450000000006],
          [-0.12898, 51.51653],
          [-0.12895, 51.51648],
          [-0.12883, 51.516510000000004],
          [-0.12885000000000002, 51.51655],
          [-0.12856, 51.51659],
          [-0.12784, 51.51668],
          [-0.12752000000000002, 51.51675],
          [-0.1274, 51.516780000000004],
          [-0.12695, 51.516850000000005],
          [-0.1269, 51.516830000000006],
          [-0.12675, 51.516870000000004],
          [-0.12676, 51.516890000000004],
          [-0.12651, 51.516920000000006],
          [-0.12617, 51.51693],
          [-0.12586, 51.51697000000001],
          [-0.12573, 51.51699000000001],
          [-0.12556, 51.517070000000004],
          [-0.12541000000000002, 51.51706],
          [-0.12535000000000002, 51.517050000000005],
          [-0.12505000000000002, 51.517100000000006],
          [-0.12508, 51.517140000000005],
          [-0.12502000000000002, 51.517140000000005],
          [-0.12502000000000002, 51.517120000000006],
          [-0.12493000000000001, 51.51709],
          [-0.12463, 51.51711],
          [-0.12435000000000002, 51.51713],
          [-0.12398, 51.51717000000001],
          [-0.12323, 51.51722],
          [-0.12297000000000001, 51.51724],
          [-0.12289000000000001, 51.517210000000006],
          [-0.1228, 51.51722],
          [-0.12281000000000002, 51.51726000000001],
          [-0.12254000000000001, 51.51727],
          [-0.12248, 51.517210000000006],
          [-0.12219000000000001, 51.51726000000001],
          [-0.12188000000000002, 51.51733],
          [-0.12108000000000001, 51.517480000000006],
          [-0.12070000000000002, 51.51753],
          [-0.12056000000000001, 51.51755000000001],
          [-0.12054000000000001, 51.51749],
          [-0.12022000000000001, 51.51755000000001],
          [-0.12017000000000001, 51.51756],
          [-0.12014000000000001, 51.51749],
          [-0.12009000000000002, 51.517340000000004],
          [-0.12000000000000001, 51.517210000000006],
          [-0.11986000000000001, 51.517030000000005],
          [-0.11977000000000002, 51.516890000000004],
          [-0.11959000000000002, 51.51661000000001],
          [-0.11943000000000001, 51.516380000000005],
          [-0.11934000000000002, 51.516220000000004],
          [-0.11921000000000001, 51.516070000000006],
          [-0.11918000000000001, 51.515980000000006],
          [-0.11902000000000001, 51.515750000000004],
          [-0.11892000000000001, 51.51561],
          [-0.11877000000000001, 51.515420000000006],
          [-0.11875000000000001, 51.51534],
          [-0.11864000000000001, 51.515190000000004],
          [-0.11845000000000001, 51.514950000000006],
          [-0.11796000000000001, 51.514230000000005],
          [-0.1179, 51.514250000000004],
          [-0.1174, 51.51438],
          [-0.11721000000000001, 51.51442],
          [-0.11702000000000001, 51.514520000000005],
          [-0.11692000000000001, 51.5146],
          [-0.11682000000000001, 51.51456],
          [-0.11668, 51.51453000000001],
          [-0.11649000000000001, 51.51451],
        ],
        steps: [
          {
            distance: "0.4 km",
            duration: "6 mins",
            instructions:
              "Head <b>southeast</b> on <b>Edgware Rd</b>/<wbr/><b>A5</b> toward <b>Newcastle Pl</b>",
            travelMode: "WALKING",
          },
          {
            distance: "26 m",
            duration: "1 min",
            instructions:
              "Turn <b>left</b> onto <b>Old Marylebone Rd</b>/<wbr/><b>A501</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.8 km",
            duration: "11 mins",
            instructions:
              "Turn <b>right</b> onto <b>Edgware Rd</b>/<wbr/><b>A5</b>",
            travelMode: "WALKING",
          },
          {
            distance: "61 m",
            duration: "1 min",
            instructions: "Continue onto <b>Marble Arch</b>",
            travelMode: "WALKING",
          },
          {
            distance: "11 m",
            duration: "1 min",
            instructions: "Turn <b>left</b> onto <b>Great Cumberland Pl</b>",
            travelMode: "WALKING",
          },
          {
            distance: "11 m",
            duration: "1 min",
            instructions:
              "Turn <b>right</b> to stay on <b>Great Cumberland Pl</b>",
            travelMode: "WALKING",
          },
          {
            distance: "13 m",
            duration: "1 min",
            instructions: "Turn <b>left</b> onto <b>Marble Arch</b>",
            travelMode: "WALKING",
          },
          {
            distance: "2.0 km",
            duration: "28 mins",
            instructions: "Continue onto <b>Oxford St</b>",
            travelMode: "WALKING",
          },
          {
            distance: "28 m",
            duration: "1 min",
            instructions:
              "Turn <b>right</b> onto <b>Charing Cross Rd</b>/<wbr/><b>A40</b>/<wbr/><b>A400</b>",
            travelMode: "WALKING",
          },
          {
            distance: "28 m",
            duration: "1 min",
            instructions: "Cross the road",
            travelMode: "WALKING",
          },
          {
            distance: "0.4 km",
            duration: "5 mins",
            instructions:
              'Turn <b>right</b> onto <b>New Oxford St</b>/<wbr/><b>A40</b><div style="font-size:0.9em">Continue to follow New Oxford St</div>',
            travelMode: "WALKING",
          },
          {
            distance: "4 m",
            duration: "1 min",
            instructions: "Turn <b>left</b> onto <b>Museum St</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.2 km",
            duration: "2 mins",
            instructions: "Turn <b>right</b> onto <b>New Oxford St</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.1 km",
            duration: "2 mins",
            instructions: "Continue onto <b>High Holborn</b>/<wbr/><b>A40</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.4 km",
            duration: "6 mins",
            instructions:
              "Turn <b>right</b> onto <b>Kingsway</b>/<wbr/><b>A4200</b>",
            travelMode: "WALKING",
          },
          {
            distance: "87 m",
            duration: "1 min",
            instructions: "Turn <b>left</b> onto <b>Portugal St</b>",
            travelMode: "WALKING",
          },
          {
            distance: "30 m",
            duration: "1 min",
            instructions:
              'Turn <b>right</b> onto <b>St Clement\'s Ln</b><div style="font-size:0.9em">Destination will be on the left</div>',
            travelMode: "WALKING",
          },
        ],
      },
      bicycling: {
        distances: {},
        path: [
          [-0.17163, 51.52116],
          [-0.17143000000000003, 51.521],
          [-0.17120000000000002, 51.52087],
          [-0.17077, 51.520520000000005],
          [-0.17046, 51.52028000000001],
          [-0.16955, 51.51966],
          [-0.16810000000000003, 51.518660000000004],
          [-0.16721000000000003, 51.518040000000006],
          [-0.16667, 51.51766000000001],
          [-0.16634000000000002, 51.51789],
          [-0.16564, 51.51840000000001],
          [-0.16512000000000002, 51.51877],
          [-0.16489, 51.51885000000001],
          [-0.16455, 51.51888],
          [-0.16429000000000002, 51.51892],
          [-0.16343000000000002, 51.519070000000006],
          [-0.16236, 51.51928],
          [-0.16028, 51.519670000000005],
          [-0.15899000000000002, 51.519890000000004],
          [-0.15880000000000002, 51.519920000000006],
          [-0.15868000000000002, 51.519650000000006],
          [-0.15844000000000003, 51.5191],
          [-0.15739, 51.51682],
          [-0.15715, 51.516310000000004],
          [-0.15680000000000002, 51.51559],
          [-0.15663000000000002, 51.51521],
          [-0.15655000000000002, 51.515060000000005],
          [-0.15576, 51.51520000000001],
          [-0.15476, 51.51538000000001],
          [-0.15446000000000001, 51.515420000000006],
          [-0.15350000000000003, 51.515570000000004],
          [-0.15215, 51.51579],
          [-0.15098, 51.516000000000005],
          [-0.15000000000000002, 51.51617],
          [-0.14936000000000002, 51.51628],
          [-0.14879, 51.516380000000005],
          [-0.14867000000000002, 51.516110000000005],
          [-0.14833000000000002, 51.51540000000001],
          [-0.14814000000000002, 51.51543],
          [-0.14765, 51.515530000000005],
          [-0.14757, 51.51554],
          [-0.14752, 51.51543],
          [-0.14741, 51.51522000000001],
          [-0.14733000000000002, 51.515100000000004],
          [-0.14696, 51.51471],
          [-0.1469, 51.514660000000006],
          [-0.14645000000000002, 51.51471],
          [-0.14596, 51.514770000000006],
          [-0.14482, 51.514920000000004],
          [-0.14345000000000002, 51.51511000000001],
          [-0.14281000000000002, 51.51521],
          [-0.14234000000000002, 51.51527],
          [-0.14206000000000002, 51.51532],
          [-0.14184000000000002, 51.515330000000006],
          [-0.14118, 51.515420000000006],
          [-0.14035, 51.515530000000005],
          [-0.13733, 51.515820000000005],
          [-0.13589, 51.51596000000001],
          [-0.13412000000000002, 51.516130000000004],
          [-0.13159, 51.516360000000006],
          [-0.13079000000000002, 51.516400000000004],
          [-0.13024000000000002, 51.51644],
          [-0.13008, 51.51644],
          [-0.12969, 51.51650000000001],
          [-0.12865000000000001, 51.516650000000006],
          [-0.12689, 51.516920000000006],
          [-0.12583, 51.517070000000004],
          [-0.12542, 51.517120000000006],
          [-0.12528, 51.51717000000001],
          [-0.12413, 51.517680000000006],
          [-0.12269000000000001, 51.5183],
          [-0.12206000000000002, 51.51859],
          [-0.1218, 51.51868],
          [-0.12143000000000001, 51.518840000000004],
          [-0.12115000000000001, 51.51896000000001],
          [-0.12099000000000001, 51.519070000000006],
          [-0.12057000000000001, 51.519310000000004],
          [-0.12046000000000001, 51.51937],
          [-0.12019, 51.51943000000001],
          [-0.12012, 51.519400000000005],
          [-0.12007000000000001, 51.51939],
          [-0.11988000000000001, 51.519330000000004],
          [-0.11983, 51.51926],
          [-0.11971000000000001, 51.5191],
          [-0.11945000000000001, 51.51876000000001],
          [-0.11936000000000001, 51.518600000000006],
          [-0.11924000000000001, 51.51834],
          [-0.11912, 51.518040000000006],
          [-0.11914000000000001, 51.51798],
          [-0.11910000000000001, 51.51787],
          [-0.11911000000000001, 51.517830000000004],
          [-0.11917000000000001, 51.517770000000006],
          [-0.11921000000000001, 51.51774],
          [-0.11926, 51.51769],
          [-0.11960000000000001, 51.51769],
          [-0.12003000000000001, 51.51767],
          [-0.12019, 51.51766000000001],
          [-0.12033, 51.51764000000001],
          [-0.12027000000000002, 51.51753],
          [-0.12022000000000001, 51.517410000000005],
          [-0.12016, 51.51727],
          [-0.11994, 51.51697000000001],
          [-0.11967000000000001, 51.51659],
          [-0.11910000000000001, 51.515730000000005],
          [-0.11871000000000001, 51.515170000000005],
          [-0.11802000000000001, 51.51418],
          [-0.11741000000000001, 51.514340000000004],
          [-0.11715, 51.51442],
          [-0.11695000000000001, 51.51453000000001],
          [-0.11692000000000001, 51.51455000000001],
          [-0.11683, 51.51453000000001],
          [-0.1165, 51.51449],
        ],
        steps: [
          {
            distance: "0.5 km",
            duration: "2 mins",
            instructions:
              "Head <b>southeast</b> on <b>Edgware Rd</b>/<wbr/><b>A5</b> toward <b>Newcastle Pl</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.6 km",
            duration: "2 mins",
            instructions:
              'Turn <b>left</b> onto <b>Crawford Pl</b><div style="font-size:0.9em">Entering toll zone</div><div style="font-size:0.9em">Leaving toll zone</div>',
            travelMode: "BICYCLING",
          },
          {
            distance: "0.6 km",
            duration: "3 mins",
            instructions:
              'Turn <b>right</b> onto <b>Gloucester Pl</b>/<wbr/><b>A4380</b><div style="font-size:0.9em">Continue to follow A4380</div><div style="font-size:0.9em">Entering toll zone</div>',
            travelMode: "BICYCLING",
          },
          {
            distance: "0.6 km",
            duration: "2 mins",
            instructions:
              'Turn <b>left</b> onto <b>Portman Square</b>/<wbr/><b>A5204</b><div style="font-size:0.9em">Continue to follow A5204</div><div style="font-size:0.9em">Leaving toll zone</div>',
            travelMode: "BICYCLING",
          },
          {
            distance: "0.1 km",
            duration: "1 min",
            instructions:
              'Turn <b>right</b> onto <b>Welbeck St</b>/<wbr/><b>B406</b><div style="font-size:0.9em">Entering toll zone</div>',
            travelMode: "BICYCLING",
          },
          {
            distance: "55 m",
            duration: "1 min",
            instructions:
              'Turn <b>left</b> onto <b>Henrietta Pl</b>/<wbr/><b>B406</b><div style="font-size:0.9em">Leaving toll zone</div>',
            travelMode: "BICYCLING",
          },
          {
            distance: "0.1 km",
            duration: "1 min",
            instructions:
              'Turn <b>right</b> onto <b>Vere St</b>/<wbr/><b>B406</b><div style="font-size:0.9em">Entering toll zone</div>',
            travelMode: "BICYCLING",
          },
          {
            distance: "2.0 km",
            duration: "9 mins",
            instructions:
              'Turn <b>left</b> onto <b>Oxford St</b>/<wbr/><b>A40</b><div style="font-size:0.9em">Continue to follow A40</div><div style="font-size:0.9em">Leaving toll zone</div><div style="font-size:0.9em">Entering toll zone in 1.4 km at Bloomsbury St</div><div style="font-size:0.9em">Leaving toll zone in 1.5 km at Stedham Pl</div>',
            travelMode: "BICYCLING",
          },
          {
            distance: "0.2 km",
            duration: "1 min",
            instructions:
              'Turn <b>right</b> onto <b>Drake St</b>/<wbr/><b>Procter St</b>/<wbr/><b>A40</b><div style="font-size:0.9em">Entering toll zone</div>',
            travelMode: "BICYCLING",
          },
          {
            distance: "42 m",
            duration: "1 min",
            instructions:
              "Slight <b>right</b> to stay on <b>Drake St</b>/<wbr/><b>Procter St</b>/<wbr/><b>A40</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "75 m",
            duration: "1 min",
            instructions:
              'Turn <b>right</b> onto <b>High Holborn</b>/<wbr/><b>A40</b><div style="font-size:0.9em">Leaving toll zone</div>',
            travelMode: "BICYCLING",
          },
          {
            distance: "0.4 km",
            duration: "1 min",
            instructions:
              'Turn <b>left</b> onto <b>Kingsway</b>/<wbr/><b>A4200</b><div style="font-size:0.9em">Entering toll zone</div>',
            travelMode: "BICYCLING",
          },
          {
            distance: "87 m",
            duration: "1 min",
            instructions:
              'Turn <b>left</b> onto <b>Portugal St</b><div style="font-size:0.9em">Leaving toll zone</div>',
            travelMode: "BICYCLING",
          },
          {
            distance: "30 m",
            duration: "1 min",
            instructions:
              'Turn <b>right</b> onto <b>St Clement\'s Ln</b><div style="font-size:0.9em">Entering toll zone</div><div style="font-size:0.9em">Destination will be on the left</div>',
            travelMode: "BICYCLING",
          },
        ],
      },
      transit: {
        distances: {},
        path: [
          [-0.17170000000000002, 51.52112],
          [-0.17154000000000003, 51.521],
          [-0.17139000000000001, 51.521080000000005],
          [-0.17135, 51.521040000000006],
          [-0.17125, 51.520970000000005],
          [-0.17114000000000001, 51.520900000000005],
          [-0.17076000000000002, 51.520590000000006],
          [-0.17047, 51.520390000000006],
          [-0.17022, 51.52024],
          [-0.17025, 51.520230000000005],
          [-0.17031000000000002, 51.520250000000004],
          [-0.17027, 51.52028000000001],
          [-0.16993000000000003, 51.520540000000004],
          [-0.16951000000000002, 51.52084000000001],
          [-0.16902, 51.52111000000001],
          [-0.16837000000000002, 51.521390000000004],
          [-0.16735000000000003, 51.521710000000006],
          [-0.16608, 51.52203],
          [-0.16368000000000002, 51.52237],
          [-0.16274000000000002, 51.522510000000004],
          [-0.16116000000000003, 51.52268],
          [-0.15709, 51.52311],
          [-0.15324000000000002, 51.52355000000001],
          [-0.15105000000000002, 51.52393000000001],
          [-0.14948, 51.52420000000001],
          [-0.14893, 51.524210000000004],
          [-0.14865, 51.52418],
          [-0.14837, 51.52412],
          [-0.14779, 51.52393000000001],
          [-0.14676, 51.52346000000001],
          [-0.1464, 51.52322],
          [-0.14628000000000002, 51.523070000000004],
          [-0.14616, 51.52290000000001],
          [-0.14408, 51.51841],
          [-0.14395000000000002, 51.51825],
          [-0.14317000000000002, 51.51791000000001],
          [-0.14301, 51.517810000000004],
          [-0.1429, 51.51771],
          [-0.14225000000000002, 51.516070000000006],
          [-0.14022, 51.51554],
          [-0.14021, 51.515480000000004],
          [-0.13933, 51.515570000000004],
          [-0.13591, 51.515910000000005],
          [-0.13306, 51.516200000000005],
          [-0.13077, 51.516420000000004],
          [-0.12822, 51.51673],
          [-0.12077000000000002, 51.517630000000004],
          [-0.12050000000000001, 51.51766000000001],
          [-0.11905, 51.517810000000004],
          [-0.11903000000000001, 51.51775000000001],
          [-0.12000000000000001, 51.51738],
          [-0.11998, 51.51738],
          [-0.12009000000000002, 51.517340000000004],
          [-0.11986000000000001, 51.517030000000005],
          [-0.11948, 51.516450000000006],
          [-0.11943000000000001, 51.516380000000005],
          [-0.11934000000000002, 51.516220000000004],
          [-0.11921000000000001, 51.516070000000006],
          [-0.11918000000000001, 51.515980000000006],
          [-0.11902000000000001, 51.515750000000004],
          [-0.11892000000000001, 51.51561],
          [-0.11877000000000001, 51.515420000000006],
          [-0.11875000000000001, 51.51534],
          [-0.11864000000000001, 51.515190000000004],
          [-0.11845000000000001, 51.514950000000006],
          [-0.11796000000000001, 51.514230000000005],
          [-0.1179, 51.514250000000004],
          [-0.1174, 51.51438],
          [-0.11721000000000001, 51.51442],
          [-0.11712000000000002, 51.51446000000001],
          [-0.11702000000000001, 51.514520000000005],
          [-0.11692000000000001, 51.5146],
          [-0.11682000000000001, 51.51456],
          [-0.11668, 51.51453000000001],
          [-0.11649000000000001, 51.51451],
        ],
        steps: [
          {
            distance: "0.1 km",
            duration: "3 mins",
            instructions: "Walk to Edgware Road",
            travelMode: "WALKING",
          },
          {
            distance: "2.6 km",
            duration: "7 mins",
            instructions: "Subway towards Elephant & Castle",
            travelMode: "TRANSIT",
          },
          {
            distance: "0.2 km",
            duration: "1 min",
            instructions: "Walk to Oxford Circus",
            travelMode: "WALKING",
          },
          {
            distance: "1.5 km",
            duration: "3 mins",
            instructions: "Subway towards Epping",
            travelMode: "TRANSIT",
          },
          {
            distance: "0.6 km",
            duration: "9 mins",
            instructions: "Walk to 3 St Clement's Ln, London WC2A 2HD, UK",
            travelMode: "WALKING",
          },
        ],
      },
    },
    distances: {
      DRIVING: {
        distance: "4.9 km",
        duration: "21 mins",
      },
      WALKING: {
        distance: "4.6 km",
        duration: "1 hour 5 mins",
      },
      BICYCLING: {
        distance: "5.3 km",
        duration: "22 mins",
      },
      TRANSIT: {
        distance: "4.8 km",
        duration: "38 mins",
      },
    },
  },
  {
    name: "Tabernacle School",
    category: "Secondary Schools",
    coordinates: {
      lat: 51.50768594887807,
      lng: -0.21483149974074842,
    },
    id: "674d9826deae072033604643",
    routes: {
      driving: {
        distances: {},
        path: [
          [-0.17163, 51.52116],
          [-0.17143000000000003, 51.521],
          [-0.17120000000000002, 51.52087],
          [-0.17077, 51.520520000000005],
          [-0.17046, 51.52028000000001],
          [-0.16955, 51.51966],
          [-0.16901000000000002, 51.519290000000005],
          [-0.16877, 51.51939],
          [-0.16655, 51.519850000000005],
          [-0.16596000000000002, 51.51997],
          [-0.16565000000000002, 51.520120000000006],
          [-0.16555, 51.520300000000006],
          [-0.16546000000000002, 51.520450000000004],
          [-0.16546000000000002, 51.52051],
          [-0.16544, 51.52069],
          [-0.16627, 51.5206],
          [-0.16682000000000002, 51.520500000000006],
          [-0.16761, 51.52033],
          [-0.16867000000000001, 51.52009],
          [-0.16933, 51.51997],
          [-0.16984000000000002, 51.51993],
          [-0.17051000000000002, 51.51991],
          [-0.1758, 51.51999000000001],
          [-0.17793, 51.520030000000006],
          [-0.17941000000000001, 51.52006],
          [-0.17999, 51.520050000000005],
          [-0.18076, 51.520010000000006],
          [-0.18169000000000002, 51.519890000000004],
          [-0.1831, 51.51968],
          [-0.18430000000000002, 51.51952000000001],
          [-0.18481, 51.519490000000005],
          [-0.18558000000000002, 51.51948],
          [-0.18617, 51.5195],
          [-0.18844000000000002, 51.519540000000006],
          [-0.18986000000000003, 51.51957],
          [-0.19124000000000002, 51.519670000000005],
          [-0.19197000000000003, 51.519760000000005],
          [-0.19277000000000002, 51.51990000000001],
          [-0.19382000000000002, 51.52013],
          [-0.19495, 51.520450000000004],
          [-0.19581, 51.520720000000004],
          [-0.19766, 51.521280000000004],
          [-0.19846000000000003, 51.521460000000005],
          [-0.19905, 51.521550000000005],
          [-0.19983, 51.52161],
          [-0.20067000000000002, 51.52160000000001],
          [-0.20120000000000002, 51.52156],
          [-0.20182000000000003, 51.521480000000004],
          [-0.20228000000000002, 51.521390000000004],
          [-0.20314000000000002, 51.521150000000006],
          [-0.20373000000000002, 51.52093000000001],
          [-0.20397, 51.520810000000004],
          [-0.20463, 51.52046000000001],
          [-0.20509000000000002, 51.520140000000005],
          [-0.20563, 51.51971],
          [-0.20635, 51.51916000000001],
          [-0.20684000000000002, 51.518820000000005],
          [-0.20701000000000003, 51.51874],
          [-0.20737000000000003, 51.518550000000005],
          [-0.20777, 51.51840000000001],
          [-0.20838, 51.518150000000006],
          [-0.20920000000000002, 51.51791000000001],
          [-0.21019000000000002, 51.51769],
          [-0.21076000000000003, 51.51756],
          [-0.21142000000000002, 51.517410000000005],
          [-0.21232, 51.51719000000001],
          [-0.21307, 51.516960000000005],
          [-0.21364000000000002, 51.51675],
          [-0.2149, 51.5163],
          [-0.21541000000000002, 51.516130000000004],
          [-0.21577000000000002, 51.51603000000001],
          [-0.21602000000000002, 51.51597],
          [-0.21611000000000002, 51.515890000000006],
          [-0.21622000000000002, 51.51586],
          [-0.21668, 51.515750000000004],
          [-0.21711000000000003, 51.515690000000006],
          [-0.21752000000000002, 51.51563],
          [-0.21851, 51.515550000000005],
          [-0.21931, 51.51549000000001],
          [-0.21959, 51.51541],
          [-0.21974000000000002, 51.515330000000006],
          [-0.21985000000000002, 51.51527],
          [-0.22001, 51.51521],
          [-0.22010000000000002, 51.51516],
          [-0.22022000000000003, 51.51500000000001],
          [-0.22034, 51.51491000000001],
          [-0.22043000000000001, 51.51483],
          [-0.22054, 51.514720000000004],
          [-0.22065, 51.51455000000001],
          [-0.22073, 51.51438],
          [-0.22079000000000001, 51.514160000000004],
          [-0.22077000000000002, 51.514],
          [-0.2207, 51.513720000000006],
          [-0.22067, 51.51364],
          [-0.22047000000000003, 51.51315],
          [-0.22029, 51.51267000000001],
          [-0.22006, 51.512150000000005],
          [-0.21956, 51.51099000000001],
          [-0.21938000000000002, 51.510560000000005],
          [-0.2192, 51.51005000000001],
          [-0.21889000000000003, 51.50916],
          [-0.21886000000000003, 51.509060000000005],
          [-0.21851, 51.50804],
          [-0.21821000000000002, 51.507310000000004],
          [-0.21784, 51.506660000000004],
          [-0.21765, 51.506350000000005],
          [-0.21715, 51.505660000000006],
          [-0.21686000000000002, 51.50527],
          [-0.21672000000000002, 51.50509],
          [-0.21664000000000003, 51.50507],
          [-0.21638000000000002, 51.505010000000006],
          [-0.21618, 51.504960000000004],
          [-0.21599000000000002, 51.504960000000004],
          [-0.21577000000000002, 51.504920000000006],
          [-0.21557, 51.50491],
          [-0.21550000000000002, 51.504920000000006],
          [-0.21518, 51.50499000000001],
          [-0.21521, 51.505210000000005],
          [-0.21518, 51.50536],
          [-0.21512, 51.50551],
          [-0.21499000000000001, 51.50565],
          [-0.21484000000000003, 51.505770000000005],
          [-0.21473, 51.505840000000006],
          [-0.21454, 51.50591000000001],
          [-0.21442000000000003, 51.50602000000001],
          [-0.2144, 51.50607],
          [-0.21459000000000003, 51.50647000000001],
          [-0.21516000000000002, 51.507580000000004],
          [-0.21519000000000002, 51.507650000000005],
          [-0.21491000000000002, 51.50771],
          [-0.21485, 51.507720000000006],
        ],
        steps: [
          {
            distance: "0.3 km",
            duration: "2 mins",
            instructions:
              "Head <b>southeast</b> on <b>Edgware Rd</b>/<wbr/><b>A5</b> toward <b>Newcastle Pl</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "0.2 km",
            duration: "1 min",
            instructions:
              "Turn <b>left</b> onto <b>Chapel St</b>/<wbr/><b>A501</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "93 m",
            duration: "1 min",
            instructions:
              "Slight <b>left</b> onto <b>Old Marylebone Rd</b>/<wbr/><b>A501</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "0.1 km",
            duration: "1 min",
            instructions:
              "Turn <b>left</b> onto <b>Marylebone Rd</b>/<wbr/><b>Marylebone Flyover</b>/<wbr/><b>A501</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "0.4 km",
            duration: "1 min",
            instructions:
              "Keep <b>right</b> to continue on <b>Marylebone Flyover</b>/<wbr/><b>A40</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "3.2 km",
            duration: "4 mins",
            instructions:
              'Keep <b>right</b> to stay on <b>Marylebone Flyover</b>/<wbr/><b>A40</b><div style="font-size:0.9em">Continue to follow A40</div>',
            travelMode: "DRIVING",
          },
          {
            distance: "0.3 km",
            duration: "1 min",
            instructions:
              "Take the <b>A3220</b> ramp to <b>Earls Ct</b>/<wbr/><b>Hammersmith</b>/<wbr/><b>Shepherd's Bush</b>/<wbr/><b>White City</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "1.2 km",
            duration: "2 mins",
            instructions:
              "At <b>Westway Roundabout</b>, take the <b>1st</b> exit onto <b>W Cross Rte</b>/<wbr/><b>A3220</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "0.1 km",
            duration: "1 min",
            instructions:
              "At <b>Holland Park Roundabout</b>, take the <b>2nd</b> exit onto <b>Holland Park Ave</b>/<wbr/><b>A402</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "0.1 km",
            duration: "1 min",
            instructions: "Turn <b>left</b> onto <b>Royal Cres</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "0.2 km",
            duration: "1 min",
            instructions: "Slight <b>left</b> onto <b>St Anns Villas</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "25 m",
            duration: "1 min",
            instructions:
              'Turn <b>right</b> onto <b>St James\'s Gardens</b><div style="font-size:0.9em">Destination will be on the right</div>',
            travelMode: "DRIVING",
          },
        ],
      },
      walking: {
        distances: {},
        path: [
          [-0.17170000000000002, 51.52112],
          [-0.17155, 51.521010000000004],
          [-0.17144, 51.520920000000004],
          [-0.17139000000000001, 51.520830000000004],
          [-0.17163, 51.520680000000006],
          [-0.17171, 51.52065],
          [-0.17229000000000003, 51.52051],
          [-0.17263, 51.52049],
          [-0.17285, 51.520430000000005],
          [-0.17313, 51.520300000000006],
          [-0.17323000000000002, 51.520270000000004],
          [-0.17323000000000002, 51.520210000000006],
          [-0.17322, 51.52017000000001],
          [-0.17382, 51.52018],
          [-0.17426000000000003, 51.52019000000001],
          [-0.17504, 51.520210000000006],
          [-0.17554, 51.520230000000005],
          [-0.17619, 51.52026000000001],
          [-0.17620000000000002, 51.52006],
          [-0.17620000000000002, 51.519870000000004],
          [-0.17621, 51.51981000000001],
          [-0.17620000000000002, 51.519740000000006],
          [-0.17626000000000003, 51.51973],
          [-0.17694000000000001, 51.519580000000005],
          [-0.17722000000000002, 51.51953],
          [-0.17747000000000002, 51.519510000000004],
          [-0.17766, 51.519420000000004],
          [-0.17771, 51.51939],
          [-0.17779, 51.519450000000006],
          [-0.17781000000000002, 51.519450000000006],
          [-0.17797000000000002, 51.51937],
          [-0.17798000000000003, 51.519380000000005],
          [-0.17798000000000003, 51.51939],
          [-0.1781, 51.519470000000005],
          [-0.1786, 51.519180000000006],
          [-0.17905000000000001, 51.51888],
          [-0.17920000000000003, 51.518820000000005],
          [-0.17933000000000002, 51.51874],
          [-0.17964000000000002, 51.51854],
          [-0.18006000000000003, 51.518260000000005],
          [-0.18029, 51.51811000000001],
          [-0.18047000000000002, 51.51805],
          [-0.18072000000000002, 51.517970000000005],
          [-0.18122000000000002, 51.517830000000004],
          [-0.18198, 51.517700000000005],
          [-0.18205000000000002, 51.51775000000001],
          [-0.1821, 51.517720000000004],
          [-0.18230000000000002, 51.51762],
          [-0.18238000000000001, 51.51755000000001],
          [-0.18267000000000003, 51.51746000000001],
          [-0.18296, 51.517390000000006],
          [-0.18338000000000002, 51.51727],
          [-0.18341000000000002, 51.51729],
          [-0.18361000000000002, 51.517210000000006],
          [-0.18432, 51.51702],
          [-0.18680000000000002, 51.516360000000006],
          [-0.18702000000000002, 51.516290000000005],
          [-0.18742, 51.516180000000006],
          [-0.18745, 51.51625000000001],
          [-0.18764000000000003, 51.51619],
          [-0.18761000000000003, 51.516130000000004],
          [-0.18772000000000003, 51.5161],
          [-0.18791000000000002, 51.51606],
          [-0.18801, 51.51601],
          [-0.18836000000000003, 51.515910000000005],
          [-0.18837, 51.515930000000004],
          [-0.18845, 51.515910000000005],
          [-0.18843000000000001, 51.51588],
          [-0.18849000000000002, 51.51586],
          [-0.18885000000000002, 51.515800000000006],
          [-0.18938000000000002, 51.515730000000005],
          [-0.19077000000000002, 51.515570000000004],
          [-0.19129000000000002, 51.51552],
          [-0.19202000000000002, 51.51545],
          [-0.19301000000000001, 51.515330000000006],
          [-0.19347, 51.515280000000004],
          [-0.19387000000000001, 51.515240000000006],
          [-0.19403, 51.515190000000004],
          [-0.19469000000000003, 51.51514],
          [-0.19499000000000002, 51.515100000000004],
          [-0.195, 51.515130000000006],
          [-0.19511, 51.51511000000001],
          [-0.19518000000000002, 51.51511000000001],
          [-0.19517, 51.51509],
          [-0.19701000000000002, 51.514880000000005],
          [-0.19723000000000002, 51.51484000000001],
          [-0.19724000000000003, 51.514860000000006],
          [-0.1978, 51.514770000000006],
          [-0.19910000000000003, 51.51462],
          [-0.19922, 51.514610000000005],
          [-0.20039, 51.51446000000001],
          [-0.20083, 51.5144],
          [-0.2008, 51.51431],
          [-0.20095000000000002, 51.51426000000001],
          [-0.20136, 51.514120000000005],
          [-0.20185000000000003, 51.513980000000004],
          [-0.203, 51.51362],
          [-0.20315000000000003, 51.513600000000004],
          [-0.20313, 51.513580000000005],
          [-0.20318000000000003, 51.513560000000005],
          [-0.20334000000000002, 51.513540000000006],
          [-0.20390000000000003, 51.513380000000005],
          [-0.20419, 51.513290000000005],
          [-0.20423000000000002, 51.513290000000005],
          [-0.20478000000000002, 51.51312],
          [-0.20569, 51.51286],
          [-0.20688, 51.51252],
          [-0.20723000000000003, 51.51236],
          [-0.20743, 51.51221],
          [-0.20753000000000002, 51.51209000000001],
          [-0.20762000000000003, 51.51193000000001],
          [-0.20766, 51.51173000000001],
          [-0.20766, 51.51164000000001],
          [-0.20763, 51.51153000000001],
          [-0.20758000000000001, 51.511410000000005],
          [-0.20755, 51.51137000000001],
          [-0.20774, 51.51131],
          [-0.20782, 51.51129],
          [-0.20829000000000003, 51.51117000000001],
          [-0.2096, 51.510780000000004],
          [-0.20978000000000002, 51.51073],
          [-0.20972000000000002, 51.510690000000004],
          [-0.20964000000000002, 51.51057],
          [-0.20982, 51.51052000000001],
          [-0.21034000000000003, 51.51037],
          [-0.2104, 51.51035],
          [-0.21034000000000003, 51.510250000000006],
          [-0.21043, 51.51024],
          [-0.21039000000000002, 51.51019],
          [-0.21015, 51.51008],
          [-0.21009000000000003, 51.50988],
          [-0.21020000000000003, 51.50974],
          [-0.21023000000000003, 51.50963],
          [-0.21031000000000002, 51.509350000000005],
          [-0.21037000000000003, 51.509260000000005],
          [-0.21055000000000001, 51.50909000000001],
          [-0.21071, 51.50896],
          [-0.21094000000000002, 51.50891000000001],
          [-0.21155000000000002, 51.5088],
          [-0.21204, 51.50871],
          [-0.21182, 51.50827],
          [-0.21320000000000003, 51.508],
          [-0.21405000000000002, 51.507830000000006],
          [-0.21482, 51.507670000000005],
        ],
        steps: [
          {
            distance: "44 m",
            duration: "1 min",
            instructions:
              "Head <b>southeast</b> on <b>Edgware Rd</b>/<wbr/><b>A5</b> toward <b>Newcastle Pl</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.2 km",
            duration: "2 mins",
            instructions: "Turn <b>right</b> onto <b>Newcastle Pl</b>",
            travelMode: "WALKING",
          },
          {
            distance: "13 m",
            duration: "1 min",
            instructions: "Turn <b>left</b> onto <b>Paddington Grn</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.2 km",
            duration: "3 mins",
            instructions:
              "Turn <b>right</b> onto <b>Harrow Rd</b>/<wbr/><b>A404</b>",
            travelMode: "WALKING",
          },
          {
            distance: "47 m",
            duration: "1 min",
            instructions: "Turn <b>left</b> toward <b>Harrow Rd</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.1 km",
            duration: "2 mins",
            instructions: "Turn <b>right</b> onto <b>Harrow Rd</b>",
            travelMode: "WALKING",
          },
          {
            distance: "1.3 km",
            duration: "19 mins",
            instructions: "Take the crosswalk",
            travelMode: "WALKING",
          },
          {
            distance: "0.4 km",
            duration: "5 mins",
            instructions:
              'Continue onto <b>Westbourne Grove</b><div style="font-size:0.9em">Go through 1 roundabout</div>',
            travelMode: "WALKING",
          },
          {
            distance: "0.3 km",
            duration: "4 mins",
            instructions:
              "Slight <b>left</b> to stay on <b>Westbourne Grove</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.2 km",
            duration: "2 mins",
            instructions: "Continue onto <b>Ladbroke Gardens</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.2 km",
            duration: "3 mins",
            instructions: "Continue onto <b>Lansdowne Cres</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.2 km",
            duration: "2 mins",
            instructions: "Turn <b>right</b> onto <b>Lansdowne Rise</b>",
            travelMode: "WALKING",
          },
          {
            distance: "19 m",
            duration: "1 min",
            instructions: "Turn <b>left</b> onto <b>Clarendon Rd</b>",
            travelMode: "WALKING",
          },
          {
            distance: "71 m",
            duration: "1 min",
            instructions: "Turn <b>right</b> onto <b>Clarendon Cross</b>",
            travelMode: "WALKING",
          },
          {
            distance: "51 m",
            duration: "1 min",
            instructions: "Turn <b>left</b> onto <b>Portland Rd</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.2 km",
            duration: "3 mins",
            instructions: "Slight <b>right</b> onto <b>Penzance Pl</b>",
            travelMode: "WALKING",
          },
          {
            distance: "50 m",
            duration: "1 min",
            instructions: "Turn <b>left</b> onto <b>St James's Gardens</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.2 km",
            duration: "3 mins",
            instructions:
              'Turn <b>right</b> to stay on <b>St James\'s Gardens</b><div style="font-size:0.9em">Destination will be on the left</div>',
            travelMode: "WALKING",
          },
        ],
      },
      bicycling: {
        distances: {},
        path: [
          [-0.17163, 51.52116],
          [-0.17143000000000003, 51.521],
          [-0.17120000000000002, 51.52087],
          [-0.17077, 51.520520000000005],
          [-0.17046, 51.52028000000001],
          [-0.17019, 51.52009],
          [-0.16984000000000002, 51.51986],
          [-0.17002, 51.519830000000006],
          [-0.17064000000000001, 51.51984],
          [-0.17115000000000002, 51.519830000000006],
          [-0.17173000000000002, 51.519830000000006],
          [-0.17205, 51.519850000000005],
          [-0.17203000000000002, 51.519580000000005],
          [-0.17198000000000002, 51.519490000000005],
          [-0.17190000000000003, 51.51941000000001],
          [-0.17187000000000002, 51.519400000000005],
          [-0.17189000000000002, 51.51935],
          [-0.17191, 51.519290000000005],
          [-0.1721, 51.51923000000001],
          [-0.17226000000000002, 51.519180000000006],
          [-0.17247, 51.519130000000004],
          [-0.17243000000000003, 51.51905000000001],
          [-0.17231000000000002, 51.51892],
          [-0.17221, 51.518840000000004],
          [-0.17203000000000002, 51.51872],
          [-0.17195000000000002, 51.518730000000005],
          [-0.17177, 51.51863],
          [-0.17176000000000002, 51.518620000000006],
          [-0.17176000000000002, 51.51861],
          [-0.17177, 51.518600000000006],
          [-0.17233, 51.5185],
          [-0.17236, 51.518480000000004],
          [-0.17235, 51.51843],
          [-0.17218000000000003, 51.51805],
          [-0.17269, 51.517950000000006],
          [-0.17378000000000002, 51.517770000000006],
          [-0.17437000000000002, 51.51769],
          [-0.17511000000000002, 51.51756],
          [-0.1756, 51.51746000000001],
          [-0.17600000000000002, 51.51729],
          [-0.17670000000000002, 51.51778],
          [-0.17741, 51.518280000000004],
          [-0.17796, 51.51867000000001],
          [-0.17820000000000003, 51.51883],
          [-0.17875000000000002, 51.51919],
          [-0.17923000000000003, 51.5195],
          [-0.1794, 51.519540000000006],
          [-0.17953000000000002, 51.51964],
          [-0.17958000000000002, 51.51971],
          [-0.17965, 51.519800000000004],
          [-0.17998, 51.52002],
          [-0.18028000000000002, 51.520230000000005],
          [-0.18057, 51.52047],
          [-0.18102000000000001, 51.52084000000001],
          [-0.18116000000000002, 51.520900000000005],
          [-0.18156000000000003, 51.52096],
          [-0.18338000000000002, 51.520990000000005],
          [-0.1837, 51.52105],
          [-0.18383000000000002, 51.521100000000004],
          [-0.18398, 51.52105],
          [-0.18477000000000002, 51.52132],
          [-0.18543, 51.520270000000004],
          [-0.18555000000000002, 51.52009],
          [-0.18562, 51.52004],
          [-0.1857, 51.520010000000006],
          [-0.18561000000000002, 51.519940000000005],
          [-0.18585000000000002, 51.519920000000006],
          [-0.18639000000000003, 51.519940000000005],
          [-0.18658000000000002, 51.52],
          [-0.18688000000000002, 51.520010000000006],
          [-0.18755000000000002, 51.519980000000004],
          [-0.18780000000000002, 51.52],
          [-0.18789000000000003, 51.51999000000001],
          [-0.18798, 51.520030000000006],
          [-0.18829, 51.52009],
          [-0.18844000000000002, 51.520050000000005],
          [-0.18853, 51.52002],
          [-0.18904, 51.520010000000006],
          [-0.18906, 51.52002],
          [-0.18910000000000002, 51.519980000000004],
          [-0.18922000000000003, 51.519830000000006],
          [-0.18899000000000002, 51.51981000000001],
          [-0.18875000000000003, 51.51968],
          [-0.18871000000000002, 51.51964],
          [-0.18866000000000002, 51.51959],
          [-0.1887, 51.51944],
          [-0.18875000000000003, 51.51926],
          [-0.18878, 51.51915],
          [-0.18891000000000002, 51.518730000000005],
          [-0.18897000000000003, 51.51863],
          [-0.18901, 51.51832],
          [-0.18903, 51.518150000000006],
          [-0.18901, 51.51811000000001],
          [-0.18934, 51.51805],
          [-0.18993000000000002, 51.51796],
          [-0.19054000000000001, 51.517880000000005],
          [-0.19062, 51.517880000000005],
          [-0.19158000000000003, 51.518080000000005],
          [-0.19231, 51.518170000000005],
          [-0.19280000000000003, 51.518170000000005],
          [-0.19306, 51.51816],
          [-0.19329000000000002, 51.51816],
          [-0.19331, 51.51802000000001],
          [-0.19337000000000001, 51.517950000000006],
          [-0.19342, 51.51794],
          [-0.19454000000000002, 51.517720000000004],
          [-0.19663000000000003, 51.51733],
          [-0.19784000000000002, 51.517140000000005],
          [-0.19915000000000002, 51.51695],
          [-0.20045000000000002, 51.516780000000004],
          [-0.20171000000000003, 51.51655],
          [-0.20220000000000002, 51.516470000000005],
          [-0.20224, 51.51648],
          [-0.20273000000000002, 51.51635],
          [-0.20316, 51.51625000000001],
          [-0.20352, 51.51619],
          [-0.20414000000000002, 51.516070000000006],
          [-0.20587000000000003, 51.515710000000006],
          [-0.20586000000000002, 51.515710000000006],
          [-0.20585, 51.5157],
          [-0.20585, 51.515690000000006],
          [-0.20585, 51.515660000000004],
          [-0.20593000000000003, 51.515640000000005],
          [-0.20597000000000001, 51.51565],
          [-0.20774, 51.51529000000001],
          [-0.20821, 51.51518],
          [-0.20874, 51.51502000000001],
          [-0.20920000000000002, 51.51485],
          [-0.20964000000000002, 51.514630000000004],
          [-0.20992000000000002, 51.514480000000006],
          [-0.21052, 51.51409],
          [-0.21086000000000002, 51.5138],
          [-0.21108000000000002, 51.513580000000005],
          [-0.2114, 51.51319],
          [-0.21142000000000002, 51.51315],
          [-0.21114000000000002, 51.512750000000004],
          [-0.21082, 51.51232],
          [-0.21051000000000003, 51.51189],
          [-0.21026000000000003, 51.51153000000001],
          [-0.20954, 51.51055],
          [-0.21038, 51.5103],
          [-0.21063, 51.510250000000006],
          [-0.21117000000000002, 51.510090000000005],
          [-0.21126000000000003, 51.510070000000006],
          [-0.21130000000000002, 51.510070000000006],
          [-0.21126000000000003, 51.50996000000001],
          [-0.21119000000000002, 51.509980000000006],
          [-0.21116000000000001, 51.509980000000006],
          [-0.2111, 51.50996000000001],
          [-0.21061000000000002, 51.509440000000005],
          [-0.21052, 51.50936],
          [-0.21041, 51.509330000000006],
          [-0.21043, 51.509260000000005],
          [-0.21047000000000002, 51.509220000000006],
          [-0.21054, 51.509150000000005],
          [-0.21064000000000002, 51.50907],
          [-0.21072000000000002, 51.50902000000001],
          [-0.21115, 51.50893000000001],
          [-0.21201, 51.50876],
          [-0.21215, 51.50873000000001],
          [-0.21193, 51.50831],
          [-0.21309000000000003, 51.50808000000001],
          [-0.2141, 51.50788000000001],
          [-0.21485, 51.507720000000006],
        ],
        steps: [
          {
            distance: "0.2 km",
            duration: "1 min",
            instructions:
              "Head <b>southeast</b> on <b>Edgware Rd</b>/<wbr/><b>A5</b> toward <b>Newcastle Pl</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.2 km",
            duration: "1 min",
            instructions:
              "Turn <b>right</b> onto <b>Harrow Rd</b>/<wbr/><b>A404</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "54 m",
            duration: "1 min",
            instructions: "Turn <b>left</b> onto <b>Harbet Rd</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "55 m",
            duration: "1 min",
            instructions: "Turn <b>right</b> onto <b>Howard's Way</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "56 m",
            duration: "1 min",
            instructions: "Turn <b>left</b> toward <b>S Wharf Rd</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "6 m",
            duration: "1 min",
            instructions: "Turn <b>left</b> toward <b>S Wharf Rd</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "20 m",
            duration: "1 min",
            instructions: "Turn <b>right</b> toward <b>S Wharf Rd</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "94 m",
            duration: "1 min",
            instructions: "Turn <b>right</b> toward <b>S Wharf Rd</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.3 km",
            duration: "1 min",
            instructions: "Turn <b>right</b> onto <b>S Wharf Rd</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.7 km",
            duration: "2 mins",
            instructions: "Turn <b>right</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "11 m",
            duration: "1 min",
            instructions: "Turn <b>left</b> toward <b>Delamere Terrace</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "63 m",
            duration: "1 min",
            instructions: "Turn <b>right</b> onto <b>Delamere Terrace</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.2 km",
            duration: "1 min",
            instructions: "Turn <b>left</b> onto <b>Blomfield Villas</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "10 m",
            duration: "1 min",
            instructions: "Turn <b>left</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "69 m",
            duration: "1 min",
            instructions: "Turn <b>right</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.2 km",
            duration: "1 min",
            instructions: "Slight <b>left</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "24 m",
            duration: "1 min",
            instructions:
              "Turn <b>left</b> toward <b>Harrow Rd</b>/<wbr/><b>A404</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "50 m",
            duration: "1 min",
            instructions:
              "Turn <b>left</b> onto <b>Harrow Rd</b>/<wbr/><b>A404</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.2 km",
            duration: "1 min",
            instructions:
              'Turn <b>right</b> onto <b>Lord Hills Bridge</b>/<wbr/><b>B411</b><div style="font-size:0.9em">Continue to follow B411</div>',
            travelMode: "BICYCLING",
          },
          {
            distance: "0.3 km",
            duration: "1 min",
            instructions: "Turn <b>right</b> onto <b>Westbourne Park Rd</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.6 km",
            duration: "2 mins",
            instructions: "Turn <b>left</b> onto <b>Talbot Rd</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.1 km",
            duration: "1 min",
            instructions: "Continue onto <b>Powis Sq</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.2 km",
            duration: "1 min",
            instructions: "Slight <b>left</b> onto <b>Colville Square</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.6 km",
            duration: "2 mins",
            instructions:
              'Continue onto <b>Blenheim Cres</b><div style="font-size:0.9em">Go through 1 roundabout</div>',
            travelMode: "BICYCLING",
          },
          {
            distance: "0.3 km",
            duration: "1 min",
            instructions: "Slight <b>left</b> onto <b>Clarendon Rd</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.1 km",
            duration: "1 min",
            instructions: "Turn <b>right</b> onto <b>Clarendon Cross</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "12 m",
            duration: "1 min",
            instructions: "Turn <b>left</b> toward <b>Pottery Ln</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.1 km",
            duration: "1 min",
            instructions: "Turn <b>left</b> onto <b>Pottery Ln</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.1 km",
            duration: "1 min",
            instructions: "Turn <b>right</b> onto <b>Penzance Pl</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "50 m",
            duration: "1 min",
            instructions: "Turn <b>left</b> onto <b>St James's Gardens</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.2 km",
            duration: "1 min",
            instructions:
              'Turn <b>right</b> to stay on <b>St James\'s Gardens</b><div style="font-size:0.9em">Destination will be on the left</div>',
            travelMode: "BICYCLING",
          },
        ],
      },
      transit: {
        distances: {},
        path: [
          [-0.17170000000000002, 51.52112],
          [-0.17154000000000003, 51.521],
          [-0.17139000000000001, 51.521080000000005],
          [-0.17135, 51.521040000000006],
          [-0.17125, 51.520970000000005],
          [-0.17114000000000001, 51.520900000000005],
          [-0.17076000000000002, 51.520590000000006],
          [-0.17047, 51.520390000000006],
          [-0.17022, 51.52024],
          [-0.17011, 51.52013],
          [-0.16999, 51.520050000000005],
          [-0.17001000000000002, 51.520050000000005],
          [-0.16978000000000001, 51.519890000000004],
          [-0.16968000000000003, 51.519830000000006],
          [-0.16951000000000002, 51.51986],
          [-0.16902, 51.51993],
          [-0.16869, 51.51997],
          [-0.1685, 51.520010000000006],
          [-0.16839, 51.51988000000001],
          [-0.16812000000000002, 51.51957],
          [-0.16799, 51.519670000000005],
          [-0.16696000000000003, 51.520100000000006],
          [-0.16705, 51.52019000000001],
          [-0.16760000000000003, 51.51999000000001],
          [-0.16812000000000002, 51.51977],
          [-0.16873000000000002, 51.519470000000005],
          [-0.17022, 51.51859],
          [-0.1726, 51.51727],
          [-0.17325000000000002, 51.517030000000005],
          [-0.17385, 51.51684],
          [-0.17456000000000002, 51.51666],
          [-0.17489000000000002, 51.51659],
          [-0.17538, 51.516580000000005],
          [-0.17643, 51.516740000000006],
          [-0.17681000000000002, 51.51682],
          [-0.17713, 51.516920000000006],
          [-0.17739000000000002, 51.517050000000005],
          [-0.17832, 51.51771],
          [-0.17861000000000002, 51.517880000000005],
          [-0.17888, 51.518010000000004],
          [-0.17923000000000003, 51.51816],
          [-0.17959000000000003, 51.518280000000004],
          [-0.17992000000000002, 51.518370000000004],
          [-0.18030000000000002, 51.51843],
          [-0.18099, 51.51849000000001],
          [-0.18700000000000003, 51.51894000000001],
          [-0.18882000000000002, 51.519090000000006],
          [-0.19049000000000002, 51.51926],
          [-0.19266000000000003, 51.519510000000004],
          [-0.19418000000000002, 51.51973],
          [-0.19534, 51.519920000000006],
          [-0.19667, 51.52017000000001],
          [-0.19879000000000002, 51.520630000000004],
          [-0.1993, 51.520720000000004],
          [-0.19986, 51.52082000000001],
          [-0.20106000000000002, 51.520970000000005],
          [-0.20151000000000002, 51.521010000000004],
          [-0.20188, 51.52102000000001],
          [-0.20259000000000002, 51.520970000000005],
          [-0.20308, 51.52089],
          [-0.20357000000000003, 51.52076],
          [-0.20405, 51.520570000000006],
          [-0.20450000000000002, 51.52033],
          [-0.20501000000000003, 51.51997],
          [-0.20562000000000002, 51.51948],
          [-0.20624, 51.51901],
          [-0.20665000000000003, 51.51874],
          [-0.20703000000000002, 51.5185],
          [-0.20723000000000003, 51.51840000000001],
          [-0.20785, 51.51812],
          [-0.20850000000000002, 51.517880000000005],
          [-0.20919000000000001, 51.517700000000005],
          [-0.21036000000000002, 51.51744000000001],
          [-0.21149, 51.51719000000001],
          [-0.21218, 51.51702],
          [-0.21259000000000003, 51.516870000000004],
          [-0.21299, 51.51671],
          [-0.21337, 51.51655],
          [-0.21393, 51.51626],
          [-0.21450000000000002, 51.515910000000005],
          [-0.21523, 51.515390000000004],
          [-0.21593, 51.51487],
          [-0.21752000000000002, 51.513690000000004],
          [-0.21754, 51.51368],
          [-0.21749000000000002, 51.513650000000005],
          [-0.21754, 51.513780000000004],
          [-0.21758000000000002, 51.51379000000001],
          [-0.21760000000000002, 51.51371],
          [-0.21756000000000003, 51.51366],
          [-0.21759, 51.51341000000001],
          [-0.21759, 51.51328],
          [-0.21766000000000002, 51.51263],
          [-0.21769000000000002, 51.512530000000005],
          [-0.21769000000000002, 51.512420000000006],
          [-0.21764000000000003, 51.512240000000006],
          [-0.21739000000000003, 51.511880000000005],
          [-0.21735000000000002, 51.51178],
          [-0.21726, 51.511660000000006],
          [-0.21715, 51.51156],
          [-0.21667000000000003, 51.51091],
          [-0.21648, 51.51061000000001],
          [-0.21625000000000003, 51.510290000000005],
          [-0.21610000000000001, 51.510070000000006],
          [-0.21582, 51.509420000000006],
          [-0.21557, 51.50874],
          [-0.21537, 51.50826000000001],
          [-0.21533000000000002, 51.50815000000001],
          [-0.21532, 51.508030000000005],
          [-0.21524000000000001, 51.50795],
          [-0.21512, 51.50773],
          [-0.21506000000000003, 51.50762],
          [-0.21489000000000003, 51.507650000000005],
          [-0.21482, 51.507670000000005],
        ],
        steps: [
          {
            distance: "0.4 km",
            duration: "7 mins",
            instructions: "Walk to Edgware Road",
            travelMode: "WALKING",
          },
          {
            distance: "4.1 km",
            duration: "9 mins",
            instructions: "Subway towards Hammersmith",
            travelMode: "TRANSIT",
          },
          {
            distance: "0.8 km",
            duration: "12 mins",
            instructions: "Walk to 8b St James's Gardens, London W11 4RD, UK",
            travelMode: "WALKING",
          },
        ],
      },
    },
    distances: {
      DRIVING: {
        distance: "6.3 km",
        duration: "12 mins",
      },
      WALKING: {
        distance: "3.7 km",
        duration: "51 mins",
      },
      BICYCLING: {
        distance: "5.1 km",
        duration: "18 mins",
      },
      TRANSIT: {
        distance: "5.3 km",
        duration: "27 mins",
      },
    },
  },
  {
    name: "Westminster School",
    category: "Secondary Schools",
    coordinates: {
      lat: 51.498940866742664,
      lng: -0.1277783511802419,
    },
    id: "674d984fdeae072033604644",
    routes: {
      driving: {
        distances: {},
        path: [
          [-0.17163, 51.52116],
          [-0.17143000000000003, 51.521],
          [-0.17120000000000002, 51.52087],
          [-0.17077, 51.520520000000005],
          [-0.17046, 51.52028000000001],
          [-0.16955, 51.51966],
          [-0.16810000000000003, 51.518660000000004],
          [-0.16599000000000003, 51.5172],
          [-0.16319, 51.51529000000001],
          [-0.16155000000000003, 51.51422],
          [-0.1607, 51.513690000000004],
          [-0.16035000000000002, 51.51348],
          [-0.16011, 51.51335],
          [-0.15998, 51.51332000000001],
          [-0.15990000000000001, 51.51332000000001],
          [-0.15987, 51.51324],
          [-0.1597, 51.513250000000006],
          [-0.15942, 51.51328],
          [-0.15901, 51.51334000000001],
          [-0.15873, 51.513360000000006],
          [-0.15856, 51.51334000000001],
          [-0.15841000000000002, 51.51328],
          [-0.15831, 51.513270000000006],
          [-0.15824000000000002, 51.513160000000006],
          [-0.15796000000000002, 51.51274],
          [-0.15769000000000002, 51.51220000000001],
          [-0.15713000000000002, 51.51111],
          [-0.15683000000000002, 51.510580000000004],
          [-0.15663000000000002, 51.510310000000004],
          [-0.15654, 51.510220000000004],
          [-0.15612, 51.509890000000006],
          [-0.15588000000000002, 51.50974],
          [-0.1555, 51.5095],
          [-0.15507, 51.50918000000001],
          [-0.15376, 51.50797000000001],
          [-0.15304, 51.50735],
          [-0.15247000000000002, 51.506840000000004],
          [-0.15196, 51.506400000000006],
          [-0.15156, 51.506060000000005],
          [-0.15119000000000002, 51.50571000000001],
          [-0.15101, 51.505520000000004],
          [-0.15092, 51.50533],
          [-0.15092, 51.5052],
          [-0.1509, 51.504850000000005],
          [-0.15092, 51.50471],
          [-0.15102000000000002, 51.50441000000001],
          [-0.15108000000000002, 51.50415],
          [-0.15104, 51.50388],
          [-0.15089000000000002, 51.503440000000005],
          [-0.15083000000000002, 51.50336],
          [-0.15079, 51.503330000000005],
          [-0.15071, 51.5033],
          [-0.15045, 51.50332],
          [-0.15014000000000002, 51.50332],
          [-0.15005000000000002, 51.503310000000006],
          [-0.14995, 51.503260000000004],
          [-0.14987, 51.50321],
          [-0.14981, 51.50316],
          [-0.14976, 51.503060000000005],
          [-0.14977000000000001, 51.50292],
          [-0.14980000000000002, 51.502700000000004],
          [-0.14989000000000002, 51.502570000000006],
          [-0.14995, 51.50247],
          [-0.15007, 51.50242],
          [-0.1502, 51.502370000000006],
          [-0.1506, 51.50222],
          [-0.1511, 51.502030000000005],
          [-0.15113000000000001, 51.50197000000001],
          [-0.15121, 51.50191],
          [-0.15125000000000002, 51.501870000000004],
          [-0.15127000000000002, 51.50182],
          [-0.15126, 51.501760000000004],
          [-0.15112, 51.50162],
          [-0.15098, 51.50151],
          [-0.15096, 51.501450000000006],
          [-0.15023, 51.501000000000005],
          [-0.14925000000000002, 51.500370000000004],
          [-0.14893, 51.500150000000005],
          [-0.14831000000000003, 51.499590000000005],
          [-0.14798, 51.499300000000005],
          [-0.14764000000000002, 51.49895],
          [-0.14721, 51.49848],
          [-0.14715, 51.49842],
          [-0.14702, 51.49833],
          [-0.14688, 51.49826],
          [-0.1468, 51.498250000000006],
          [-0.14666, 51.49823000000001],
          [-0.1456, 51.498270000000005],
          [-0.14539000000000002, 51.49828],
          [-0.14520000000000002, 51.49828],
          [-0.14502, 51.498270000000005],
          [-0.14416, 51.498160000000006],
          [-0.14359000000000002, 51.49803000000001],
          [-0.14333, 51.49797],
          [-0.14317000000000002, 51.49794000000001],
          [-0.14301, 51.497910000000005],
          [-0.1426, 51.49785000000001],
          [-0.14248000000000002, 51.49781],
          [-0.14220000000000002, 51.49767000000001],
          [-0.14203000000000002, 51.49754],
          [-0.14194, 51.497370000000004],
          [-0.14185, 51.497130000000006],
          [-0.14174, 51.49682000000001],
          [-0.14168, 51.496750000000006],
          [-0.14158, 51.49669],
          [-0.14142000000000002, 51.49665],
          [-0.14135, 51.496640000000006],
          [-0.14094, 51.49671000000001],
          [-0.14066, 51.49676],
          [-0.14046, 51.496790000000004],
          [-0.13969, 51.49691000000001],
          [-0.13875, 51.497040000000005],
          [-0.13591, 51.49745000000001],
          [-0.13508, 51.49759],
          [-0.134, 51.497840000000004],
          [-0.13187000000000001, 51.49862],
          [-0.12969, 51.49942000000001],
          [-0.12955, 51.49947],
          [-0.1295, 51.49944000000001],
          [-0.12944, 51.4994],
          [-0.12915000000000001, 51.49938],
          [-0.1292, 51.499190000000006],
          [-0.12921000000000002, 51.49906000000001],
          [-0.1292, 51.499010000000006],
          [-0.12879000000000002, 51.49897000000001],
          [-0.12866000000000002, 51.49897000000001],
          [-0.12855, 51.49891],
          [-0.12854000000000002, 51.49889],
        ],
        steps: [
          {
            distance: "1.2 km",
            duration: "5 mins",
            instructions:
              "Head <b>southeast</b> on <b>Edgware Rd</b>/<wbr/><b>A5</b> toward <b>Newcastle Pl</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "69 m",
            duration: "1 min",
            instructions: "Keep <b>right</b> to continue on <b>Marble Arch</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "60 m",
            duration: "1 min",
            instructions: "Keep <b>right</b> to stay on <b>Marble Arch</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "1.3 km",
            duration: "3 mins",
            instructions: "Continue onto <b>Park Ln</b>/<wbr/><b>A4202</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "46 m",
            duration: "1 min",
            instructions: "Turn <b>left</b> onto <b>Piccadilly</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "0.2 km",
            duration: "1 min",
            instructions: "Turn <b>right</b> onto <b>Duke of Wellington Pl</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "1.0 km",
            duration: "3 mins",
            instructions:
              'Slight <b>left</b> onto <b>Grosvenor Pl</b>/<wbr/><b>A302</b><div style="font-size:0.9em">Continue to follow A302</div>',
            travelMode: "DRIVING",
          },
          {
            distance: "0.9 km",
            duration: "4 mins",
            instructions:
              'Slight <b>left</b> onto <b>Victoria St</b>/<wbr/><b>A302</b><div style="font-size:0.9em">Entering toll zone</div>',
            travelMode: "DRIVING",
          },
          {
            distance: "31 m",
            duration: "1 min",
            instructions: "Turn <b>right</b> onto <b>The Sanctuary</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "41 m",
            duration: "1 min",
            instructions: "Turn <b>right</b> onto <b>Dean's Yard</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "50 m",
            duration: "1 min",
            instructions: "Turn <b>left</b> to stay on <b>Dean's Yard</b>",
            travelMode: "DRIVING",
          },
        ],
      },
      walking: {
        distances: {},
        path: [
          [-0.17170000000000002, 51.52112],
          [-0.17154000000000003, 51.521],
          [-0.17139000000000001, 51.521080000000005],
          [-0.17135, 51.521040000000006],
          [-0.17125, 51.520970000000005],
          [-0.17114000000000001, 51.520900000000005],
          [-0.17076000000000002, 51.520590000000006],
          [-0.17047, 51.520390000000006],
          [-0.17022, 51.52024],
          [-0.17011, 51.52013],
          [-0.16999, 51.520050000000005],
          [-0.17001000000000002, 51.520050000000005],
          [-0.16978000000000001, 51.519890000000004],
          [-0.16951000000000002, 51.51973],
          [-0.16907000000000003, 51.519420000000004],
          [-0.169, 51.51935],
          [-0.16897, 51.519360000000006],
          [-0.16890000000000002, 51.5193],
          [-0.16892000000000001, 51.5193],
          [-0.16870000000000002, 51.51915],
          [-0.16849, 51.518980000000006],
          [-0.16757000000000002, 51.51834],
          [-0.16742, 51.51825],
          [-0.16741, 51.518260000000005],
          [-0.16726000000000002, 51.518170000000005],
          [-0.16723000000000002, 51.51814],
          [-0.16742, 51.51802000000001],
          [-0.16741, 51.518010000000004],
          [-0.16744, 51.517970000000005],
          [-0.16719, 51.51785],
          [-0.16712000000000002, 51.517700000000005],
          [-0.16699000000000003, 51.517610000000005],
          [-0.16684000000000002, 51.517540000000004],
          [-0.16637000000000002, 51.5172],
          [-0.16620000000000001, 51.51708000000001],
          [-0.16602, 51.517030000000005],
          [-0.1658, 51.51688000000001],
          [-0.16582000000000002, 51.516870000000004],
          [-0.16579000000000002, 51.516850000000005],
          [-0.16573000000000002, 51.51681000000001],
          [-0.16567, 51.51684],
          [-0.16551000000000002, 51.51671],
          [-0.16509000000000001, 51.51643000000001],
          [-0.16407000000000002, 51.51574],
          [-0.16379000000000002, 51.515550000000005],
          [-0.16349000000000002, 51.515350000000005],
          [-0.16307000000000002, 51.515060000000005],
          [-0.16310000000000002, 51.51505],
          [-0.16308, 51.515040000000006],
          [-0.16294, 51.514950000000006],
          [-0.16262000000000001, 51.51473000000001],
          [-0.16226000000000002, 51.51453000000001],
          [-0.16195, 51.51433],
          [-0.16184, 51.51426000000001],
          [-0.16188000000000002, 51.514250000000004],
          [-0.1617, 51.514140000000005],
          [-0.16166000000000003, 51.514140000000005],
          [-0.161, 51.51371],
          [-0.16086, 51.51362],
          [-0.16066000000000003, 51.513510000000004],
          [-0.16066000000000003, 51.51344],
          [-0.16066000000000003, 51.51341000000001],
          [-0.16059, 51.513400000000004],
          [-0.16046000000000002, 51.51337],
          [-0.16046000000000002, 51.51333],
          [-0.16031, 51.51333],
          [-0.16028, 51.513290000000005],
          [-0.16022, 51.513290000000005],
          [-0.1602, 51.51319],
          [-0.16025, 51.51317],
          [-0.16023, 51.51305000000001],
          [-0.16096000000000002, 51.51296000000001],
          [-0.16097, 51.51296000000001],
          [-0.16098, 51.51294000000001],
          [-0.16087, 51.51254],
          [-0.16096000000000002, 51.51240000000001],
          [-0.16094, 51.51239],
          [-0.16102000000000002, 51.51232],
          [-0.16095, 51.512330000000006],
          [-0.16093000000000002, 51.51227],
          [-0.16096000000000002, 51.51227],
          [-0.16086, 51.512190000000004],
          [-0.16083, 51.512060000000005],
          [-0.16077000000000002, 51.51205],
          [-0.16060000000000002, 51.512010000000004],
          [-0.1602, 51.511900000000004],
          [-0.15964, 51.511660000000006],
          [-0.15906, 51.511410000000005],
          [-0.15866000000000002, 51.5112],
          [-0.1585, 51.51111],
          [-0.15839, 51.51102],
          [-0.15830000000000002, 51.51086],
          [-0.15789, 51.50996000000001],
          [-0.15766000000000002, 51.509600000000006],
          [-0.15754, 51.50947000000001],
          [-0.15660000000000002, 51.50835000000001],
          [-0.1564, 51.50811],
          [-0.1555, 51.507110000000004],
          [-0.15409, 51.5054],
          [-0.15319000000000002, 51.504360000000005],
          [-0.15311000000000002, 51.50417],
          [-0.1531, 51.50408],
          [-0.1531, 51.50403000000001],
          [-0.15288000000000002, 51.503980000000006],
          [-0.15267, 51.503930000000004],
          [-0.15266000000000002, 51.503910000000005],
          [-0.15266000000000002, 51.50379],
          [-0.15274000000000001, 51.50363],
          [-0.15285, 51.50352],
          [-0.15273, 51.503460000000004],
          [-0.15257, 51.50320000000001],
          [-0.15252000000000002, 51.503080000000004],
          [-0.15248, 51.50309000000001],
          [-0.15247000000000002, 51.50302000000001],
          [-0.15249000000000001, 51.50300000000001],
          [-0.15243, 51.50294],
          [-0.15232, 51.502930000000006],
          [-0.15235, 51.502860000000005],
          [-0.15212, 51.50283],
          [-0.15208000000000002, 51.50289],
          [-0.15203000000000003, 51.50289],
          [-0.15193, 51.502810000000004],
          [-0.15189000000000002, 51.502770000000005],
          [-0.15184, 51.502770000000005],
          [-0.15176, 51.502770000000005],
          [-0.15147000000000002, 51.502720000000004],
          [-0.15035, 51.50269],
          [-0.14991000000000002, 51.502680000000005],
          [-0.14961000000000002, 51.50267],
          [-0.14951, 51.50267],
          [-0.14880000000000002, 51.50265],
          [-0.14779, 51.502660000000006],
          [-0.14517000000000002, 51.50255000000001],
          [-0.14359000000000002, 51.50247],
          [-0.14224, 51.50242],
          [-0.14214000000000002, 51.50244000000001],
          [-0.1421, 51.502410000000005],
          [-0.14201000000000003, 51.502410000000005],
          [-0.14197, 51.5024],
          [-0.14197, 51.502320000000005],
          [-0.14197, 51.502250000000004],
          [-0.14195000000000002, 51.50224000000001],
          [-0.14195000000000002, 51.502100000000006],
          [-0.14182, 51.502100000000006],
          [-0.14177, 51.50207],
          [-0.14165, 51.501960000000004],
          [-0.14125000000000001, 51.501560000000005],
          [-0.14087000000000002, 51.501180000000005],
          [-0.14073000000000002, 51.50106],
          [-0.14069, 51.50101],
          [-0.14083, 51.50077],
          [-0.14095000000000002, 51.500310000000006],
          [-0.14108, 51.500280000000004],
          [-0.14107, 51.500240000000005],
          [-0.14104, 51.500130000000006],
          [-0.14096, 51.50016],
          [-0.14065000000000003, 51.500150000000005],
          [-0.14061, 51.50012],
          [-0.14052, 51.50001],
          [-0.14044, 51.49996],
          [-0.14027, 51.49987],
          [-0.14008, 51.49978],
          [-0.13954000000000003, 51.499590000000005],
          [-0.13849, 51.49924000000001],
          [-0.13804000000000002, 51.49913],
          [-0.13795000000000002, 51.49911],
          [-0.13791, 51.49913],
          [-0.13784000000000002, 51.49916],
          [-0.13728, 51.49925],
          [-0.13699, 51.49927],
          [-0.1368, 51.499320000000004],
          [-0.1365, 51.49938],
          [-0.13608, 51.499500000000005],
          [-0.13561, 51.499610000000004],
          [-0.13508, 51.499700000000004],
          [-0.13478, 51.49972],
          [-0.13407000000000002, 51.49976],
          [-0.134, 51.49976],
          [-0.13395, 51.49967],
          [-0.13394, 51.49967],
          [-0.13393000000000002, 51.499660000000006],
          [-0.13392, 51.49965],
          [-0.13389, 51.49965],
          [-0.13385000000000002, 51.49964000000001],
          [-0.13361, 51.49964000000001],
          [-0.13334000000000001, 51.49967],
          [-0.13328, 51.499660000000006],
          [-0.13317, 51.49964000000001],
          [-0.13318000000000002, 51.499590000000005],
          [-0.13294, 51.499590000000005],
          [-0.13286, 51.499590000000005],
          [-0.13285000000000002, 51.49964000000001],
          [-0.13252, 51.49963],
          [-0.13217, 51.49964000000001],
          [-0.13135000000000002, 51.49964000000001],
          [-0.13101000000000002, 51.49963],
          [-0.13052, 51.4996],
          [-0.1298, 51.499590000000005],
          [-0.12965000000000002, 51.499590000000005],
          [-0.12960000000000002, 51.499550000000006],
          [-0.12963000000000002, 51.49954],
          [-0.12975, 51.499500000000005],
          [-0.12973, 51.499480000000005],
          [-0.12961, 51.49935000000001],
          [-0.12953, 51.49938],
          [-0.12949000000000002, 51.49936],
          [-0.12911, 51.499320000000004],
          [-0.12914, 51.49924000000001],
          [-0.12915000000000001, 51.499100000000006],
          [-0.12914, 51.499050000000004],
          [-0.12871000000000002, 51.49902],
          [-0.12860000000000002, 51.499010000000006],
          [-0.12851, 51.49897000000001],
          [-0.12847, 51.498870000000004],
          [-0.12848, 51.498470000000005],
          [-0.12792, 51.498490000000004],
          [-0.12791000000000002, 51.49855],
        ],
        steps: [
          {
            distance: "0.4 km",
            duration: "6 mins",
            instructions:
              "Head <b>southeast</b> on <b>Edgware Rd</b>/<wbr/><b>A5</b> toward <b>Newcastle Pl</b>",
            travelMode: "WALKING",
          },
          {
            distance: "30 m",
            duration: "1 min",
            instructions:
              "Turn <b>right</b> onto <b>Sussex Gardens</b>/<wbr/><b>A4209</b>",
            travelMode: "WALKING",
          },
          {
            distance: "52 m",
            duration: "1 min",
            instructions:
              "Sharp <b>left</b> toward <b>Edgware Rd</b>/<wbr/><b>A5</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.7 km",
            duration: "9 mins",
            instructions: "Continue onto <b>Edgware Rd</b>/<wbr/><b>A5</b>",
            travelMode: "WALKING",
          },
          {
            distance: "16 m",
            duration: "1 min",
            instructions: "Turn <b>left</b>",
            travelMode: "WALKING",
          },
          {
            distance: "33 m",
            duration: "1 min",
            instructions: "Turn <b>right</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.1 km",
            duration: "2 mins",
            instructions: "Turn <b>right</b>",
            travelMode: "WALKING",
          },
          {
            distance: "33 m",
            duration: "1 min",
            instructions: "Turn <b>left</b>",
            travelMode: "WALKING",
          },
          {
            distance: "1.1 km",
            duration: "14 mins",
            instructions: "Turn <b>left</b>",
            travelMode: "WALKING",
          },
          {
            distance: "36 m",
            duration: "1 min",
            instructions: "Turn <b>left</b> toward <b>S Carriage Dr</b>",
            travelMode: "WALKING",
          },
          {
            distance: "50 m",
            duration: "1 min",
            instructions: "Turn <b>right</b> onto <b>S Carriage Dr</b>",
            travelMode: "WALKING",
          },
          {
            distance: "69 m",
            duration: "1 min",
            instructions: "Turn <b>left</b> toward <b>Apsley Way</b>",
            travelMode: "WALKING",
          },
          {
            distance: "28 m",
            duration: "1 min",
            instructions: "Turn <b>left</b> toward <b>Apsley Way</b>",
            travelMode: "WALKING",
          },
          {
            distance: "16 m",
            duration: "1 min",
            instructions: "Slight <b>right</b> onto <b>Apsley Way</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.6 km",
            duration: "8 mins",
            instructions: "Turn <b>left</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.1 km",
            duration: "1 min",
            instructions: "Slight <b>right</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.2 km",
            duration: "3 mins",
            instructions: "Turn <b>right</b> toward <b>Spur Rd</b>",
            travelMode: "WALKING",
          },
          {
            distance: "89 m",
            duration: "1 min",
            instructions: "Turn <b>right</b> onto <b>Spur Rd</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.2 km",
            duration: "4 mins",
            instructions:
              "Turn <b>left</b> onto <b>Buckingham Gate</b>/<wbr/><b>B323</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.3 km",
            duration: "4 mins",
            instructions: "Turn <b>left</b> onto <b>Petty France</b>",
            travelMode: "WALKING",
          },
          {
            distance: "89 m",
            duration: "1 min",
            instructions:
              "At the roundabout, continue straight onto <b>Broadway</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.2 km",
            duration: "3 mins",
            instructions: "Continue onto <b>Tothill St</b>",
            travelMode: "WALKING",
          },
          {
            distance: "17 m",
            duration: "1 min",
            instructions: "Slight <b>right</b> onto <b>Storey's Gate</b>",
            travelMode: "WALKING",
          },
          {
            distance: "16 m",
            duration: "1 min",
            instructions:
              "Turn <b>right</b> onto <b>Victoria St</b>/<wbr/><b>A302</b>",
            travelMode: "WALKING",
          },
          {
            distance: "31 m",
            duration: "1 min",
            instructions: "Turn <b>left</b> onto <b>The Sanctuary</b>",
            travelMode: "WALKING",
          },
          {
            distance: "41 m",
            duration: "1 min",
            instructions: "Turn <b>right</b> onto <b>Dean's Yard</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.1 km",
            duration: "1 min",
            instructions: "Turn <b>left</b> to stay on <b>Dean's Yard</b>",
            travelMode: "WALKING",
          },
          {
            distance: "43 m",
            duration: "1 min",
            instructions: "Turn <b>left</b>",
            travelMode: "WALKING",
          },
          {
            distance: "7 m",
            duration: "1 min",
            instructions: "Turn <b>left</b>",
            travelMode: "WALKING",
          },
        ],
      },
      bicycling: {
        distances: {},
        path: [
          [-0.17163, 51.52116],
          [-0.17143000000000003, 51.521],
          [-0.17120000000000002, 51.52087],
          [-0.17077, 51.520520000000005],
          [-0.17046, 51.52028000000001],
          [-0.16955, 51.51966],
          [-0.16810000000000003, 51.518660000000004],
          [-0.16599000000000003, 51.5172],
          [-0.16319, 51.51529000000001],
          [-0.1628, 51.51503],
          [-0.16310000000000002, 51.51498],
          [-0.16382000000000002, 51.514860000000006],
          [-0.16322, 51.513940000000005],
          [-0.16317, 51.51381000000001],
          [-0.16295, 51.513470000000005],
          [-0.16273, 51.51314000000001],
          [-0.16269, 51.51306],
          [-0.16271000000000002, 51.5129],
          [-0.1627, 51.51281],
          [-0.16262000000000001, 51.512640000000005],
          [-0.16254000000000002, 51.51245],
          [-0.16244, 51.512260000000005],
          [-0.16238000000000002, 51.51216],
          [-0.16215000000000002, 51.512100000000004],
          [-0.16204000000000002, 51.51209000000001],
          [-0.16182000000000002, 51.51209000000001],
          [-0.16125, 51.51209000000001],
          [-0.16083, 51.512060000000005],
          [-0.16048, 51.51198],
          [-0.15996000000000002, 51.5118],
          [-0.1592, 51.511480000000006],
          [-0.15879000000000001, 51.511280000000006],
          [-0.15858000000000003, 51.51115000000001],
          [-0.15839, 51.51102],
          [-0.15826, 51.5108],
          [-0.15789, 51.50996000000001],
          [-0.15766000000000002, 51.509600000000006],
          [-0.15718000000000001, 51.509040000000006],
          [-0.15636, 51.50806000000001],
          [-0.15581, 51.50746],
          [-0.15493, 51.506420000000006],
          [-0.15381, 51.50508000000001],
          [-0.15335000000000001, 51.504540000000006],
          [-0.15319000000000002, 51.504360000000005],
          [-0.15317, 51.504310000000004],
          [-0.15312, 51.50421000000001],
          [-0.1531, 51.504110000000004],
          [-0.1531, 51.50403000000001],
          [-0.15261000000000002, 51.50392],
          [-0.1526, 51.50379],
          [-0.15264000000000003, 51.5037],
          [-0.15265, 51.50365000000001],
          [-0.15247000000000002, 51.50354],
          [-0.15243, 51.50348],
          [-0.15223, 51.503080000000004],
          [-0.15212, 51.502950000000006],
          [-0.15203000000000003, 51.50289],
          [-0.15189000000000002, 51.502770000000005],
          [-0.15181, 51.50265],
          [-0.15177000000000002, 51.502590000000005],
          [-0.15148, 51.502570000000006],
          [-0.15114000000000002, 51.50254],
          [-0.15095, 51.50245],
          [-0.15069000000000002, 51.50242],
          [-0.15027000000000001, 51.502520000000004],
          [-0.15006, 51.50256],
          [-0.14927, 51.50254],
          [-0.14693, 51.50244000000001],
          [-0.14369, 51.50231],
          [-0.14341, 51.50226000000001],
          [-0.14244, 51.50222],
          [-0.14196, 51.5022],
          [-0.14105, 51.50217000000001],
          [-0.14075000000000001, 51.50218],
          [-0.14059000000000002, 51.502190000000006],
          [-0.14044, 51.50218],
          [-0.14019, 51.502100000000006],
          [-0.1401, 51.502050000000004],
          [-0.14007, 51.502010000000006],
          [-0.14004, 51.50193],
          [-0.14003000000000002, 51.50182],
          [-0.14006000000000002, 51.50173],
          [-0.1401, 51.501540000000006],
          [-0.14011, 51.501470000000005],
          [-0.1401, 51.50144],
          [-0.13998000000000002, 51.501310000000004],
          [-0.13992000000000002, 51.501180000000005],
          [-0.13963, 51.500890000000005],
          [-0.13932, 51.500600000000006],
          [-0.13919, 51.50052],
          [-0.13915000000000002, 51.500490000000006],
          [-0.13907, 51.500460000000004],
          [-0.13899, 51.500440000000005],
          [-0.13870000000000002, 51.500440000000005],
          [-0.13662000000000002, 51.50065000000001],
          [-0.13554000000000002, 51.500750000000004],
          [-0.13183, 51.50114000000001],
          [-0.13072, 51.501250000000006],
          [-0.13026000000000001, 51.50128],
          [-0.12969, 51.50128],
          [-0.12953, 51.501270000000005],
          [-0.12955, 51.50112000000001],
          [-0.12957000000000002, 51.500910000000005],
          [-0.12960000000000002, 51.5007],
          [-0.12963000000000002, 51.50039],
          [-0.12958, 51.50023],
          [-0.12955, 51.500150000000005],
          [-0.12952000000000002, 51.500040000000006],
          [-0.12953, 51.49987],
          [-0.12953, 51.49972],
          [-0.12953, 51.49967],
          [-0.12936, 51.49956],
          [-0.12961, 51.49945],
          [-0.12976000000000001, 51.499390000000005],
          [-0.12975, 51.49924000000001],
          [-0.12976000000000001, 51.49916],
          [-0.12987, 51.4988],
          [-0.12997, 51.49844],
          [-0.12993000000000002, 51.49824],
          [-0.12985000000000002, 51.49806],
          [-0.12972, 51.49794000000001],
          [-0.12960000000000002, 51.497820000000004],
          [-0.12952000000000002, 51.49772],
          [-0.12945, 51.49745000000001],
          [-0.12864, 51.497510000000005],
          [-0.12862, 51.49768],
          [-0.12857000000000002, 51.49783000000001],
          [-0.12853, 51.497910000000005],
          [-0.12851, 51.49792000000001],
          [-0.12855, 51.49795],
          [-0.12857000000000002, 51.49799],
          [-0.12856, 51.49814000000001],
          [-0.12854000000000002, 51.498470000000005],
          [-0.12792, 51.498490000000004],
          [-0.12791000000000002, 51.49855],
        ],
        steps: [
          {
            distance: "0.9 km",
            duration: "3 mins",
            instructions:
              "Head <b>southeast</b> on <b>Edgware Rd</b>/<wbr/><b>A5</b> toward <b>Newcastle Pl</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "73 m",
            duration: "1 min",
            instructions:
              'Turn <b>right</b> onto <b>Connaught St</b>/<wbr/><b>Upper Berkeley St</b><div style="font-size:0.9em">Continue to follow Connaught St</div>',
            travelMode: "BICYCLING",
          },
          {
            distance: "0.1 km",
            duration: "1 min",
            instructions: "Turn <b>left</b> onto <b>Connaught Square</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.2 km",
            duration: "1 min",
            instructions: "Continue onto <b>Stanhope Pl</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "1.2 km",
            duration: "3 mins",
            instructions: "Turn <b>left</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "36 m",
            duration: "1 min",
            instructions: "Turn <b>left</b> toward <b>S Carriage Dr</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "30 m",
            duration: "1 min",
            instructions: "Turn <b>right</b> onto <b>S Carriage Dr</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "82 m",
            duration: "1 min",
            instructions: "Turn <b>left</b> toward <b>Apsley Way</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "54 m",
            duration: "1 min",
            instructions: "Continue onto <b>Apsley Way</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.1 km",
            duration: "1 min",
            instructions: "Turn <b>left</b> to stay on <b>Apsley Way</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.7 km",
            duration: "2 mins",
            instructions: "Continue onto <b>Constitution Hill</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.2 km",
            duration: "1 min",
            instructions: "Slight <b>right</b> onto <b>Spur Rd</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "50 m",
            duration: "1 min",
            instructions: "Keep <b>right</b> to stay on <b>Spur Rd</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.6 km",
            duration: "2 mins",
            instructions: "Continue onto <b>Birdcage Walk</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.2 km",
            duration: "1 min",
            instructions: "Turn <b>right</b> onto <b>Storey's Gate</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "33 m",
            duration: "1 min",
            instructions:
              "Turn <b>right</b> onto <b>Victoria St</b>/<wbr/><b>A302</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.2 km",
            duration: "1 min",
            instructions:
              "Turn <b>left</b> onto <b>Great Smith St</b>/<wbr/><b>B326</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "56 m",
            duration: "1 min",
            instructions:
              'Turn <b>left</b> onto <b>Little Smith St</b><div style="font-size:0.9em">Entering toll zone</div>',
            travelMode: "BICYCLING",
          },
          {
            distance: "47 m",
            duration: "1 min",
            instructions: "Turn <b>left</b> onto <b>Tufton St</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "26 m",
            duration: "1 min",
            instructions: "Turn <b>left</b> toward <b>Dean's Yard</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "36 m",
            duration: "1 min",
            instructions: "Continue straight onto <b>Dean's Yard</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "43 m",
            duration: "1 min",
            instructions:
              'Turn <b>right</b><div style="font-size:0.9em">Leaving toll zone</div>',
            travelMode: "BICYCLING",
          },
          {
            distance: "7 m",
            duration: "1 min",
            instructions: "Turn <b>left</b>",
            travelMode: "BICYCLING",
          },
        ],
      },
      transit: {
        distances: {},
        path: [
          [-0.17170000000000002, 51.52112],
          [-0.17154000000000003, 51.521],
          [-0.17139000000000001, 51.521080000000005],
          [-0.17135, 51.521040000000006],
          [-0.17125, 51.520970000000005],
          [-0.17114000000000001, 51.520900000000005],
          [-0.17076000000000002, 51.520590000000006],
          [-0.17047, 51.520390000000006],
          [-0.17022, 51.52024],
          [-0.17011, 51.52013],
          [-0.16999, 51.520050000000005],
          [-0.17001000000000002, 51.520050000000005],
          [-0.16978000000000001, 51.519890000000004],
          [-0.16968000000000003, 51.519830000000006],
          [-0.16951000000000002, 51.51986],
          [-0.16902, 51.51993],
          [-0.16869, 51.51997],
          [-0.1685, 51.520010000000006],
          [-0.16839, 51.51988000000001],
          [-0.16812000000000002, 51.51957],
          [-0.16799, 51.519670000000005],
          [-0.167, 51.52015],
          [-0.16705, 51.52019000000001],
          [-0.16760000000000003, 51.51999000000001],
          [-0.16812000000000002, 51.51977],
          [-0.16873000000000002, 51.519470000000005],
          [-0.17022, 51.51859],
          [-0.1726, 51.51727],
          [-0.17374, 51.51662],
          [-0.17555, 51.51558000000001],
          [-0.17768, 51.51436],
          [-0.17921, 51.51353],
          [-0.18014000000000002, 51.51317],
          [-0.18087, 51.512980000000006],
          [-0.18185, 51.51279],
          [-0.18276, 51.51265],
          [-0.1832, 51.512600000000006],
          [-0.1839, 51.512550000000005],
          [-0.18509, 51.51249000000001],
          [-0.18687, 51.51239],
          [-0.18887, 51.51225],
          [-0.19010000000000002, 51.51214],
          [-0.19102000000000002, 51.51202000000001],
          [-0.19233000000000003, 51.511790000000005],
          [-0.1937, 51.51145],
          [-0.1947, 51.51113],
          [-0.19504000000000002, 51.51098],
          [-0.19519, 51.51088000000001],
          [-0.19541000000000003, 51.51068],
          [-0.19559, 51.510470000000005],
          [-0.19576000000000002, 51.51021],
          [-0.19590000000000002, 51.50992],
          [-0.19598000000000002, 51.50965000000001],
          [-0.19605000000000003, 51.50932],
          [-0.19606, 51.509130000000006],
          [-0.19603, 51.50887],
          [-0.19598000000000002, 51.508680000000005],
          [-0.19589, 51.508390000000006],
          [-0.19515000000000002, 51.5063],
          [-0.19435000000000002, 51.50403000000001],
          [-0.19386, 51.50253000000001],
          [-0.19378, 51.50238],
          [-0.19309, 51.50151],
          [-0.19267, 51.501000000000005],
          [-0.19209, 51.500400000000006],
          [-0.19098, 51.49933000000001],
          [-0.19068000000000002, 51.499100000000006],
          [-0.18978, 51.49857],
          [-0.18960000000000002, 51.498450000000005],
          [-0.18945, 51.49832000000001],
          [-0.18851, 51.497260000000004],
          [-0.18819000000000002, 51.49689000000001],
          [-0.18741000000000002, 51.49604],
          [-0.18714000000000003, 51.495810000000006],
          [-0.18678, 51.49559000000001],
          [-0.18645, 51.49541000000001],
          [-0.18581, 51.49515],
          [-0.18536000000000002, 51.49503000000001],
          [-0.18315, 51.49457],
          [-0.18199, 51.49434],
          [-0.18141000000000002, 51.494260000000004],
          [-0.18059000000000003, 51.49419],
          [-0.17975000000000002, 51.494150000000005],
          [-0.17853000000000002, 51.49416],
          [-0.17499, 51.494200000000006],
          [-0.17356000000000002, 51.494170000000004],
          [-0.17099, 51.49409000000001],
          [-0.16999, 51.494060000000005],
          [-0.1685, 51.49398000000001],
          [-0.16379000000000002, 51.49381],
          [-0.16282000000000002, 51.493770000000005],
          [-0.16213000000000002, 51.49371000000001],
          [-0.16152000000000002, 51.49363],
          [-0.16089, 51.493520000000004],
          [-0.15972, 51.49325],
          [-0.15838000000000002, 51.49286000000001],
          [-0.15652000000000002, 51.492360000000005],
          [-0.15568, 51.49215],
          [-0.15516000000000002, 51.49206],
          [-0.15443, 51.491960000000006],
          [-0.15352000000000002, 51.491890000000005],
          [-0.15291000000000002, 51.491910000000004],
          [-0.15234, 51.49195],
          [-0.15176, 51.492020000000004],
          [-0.15116000000000002, 51.49212000000001],
          [-0.15052000000000001, 51.49231],
          [-0.14979, 51.4926],
          [-0.14924, 51.49291],
          [-0.14876, 51.493230000000004],
          [-0.14808000000000002, 51.49385],
          [-0.14763, 51.49432],
          [-0.14674, 51.49539000000001],
          [-0.1464, 51.495740000000005],
          [-0.14601, 51.496030000000005],
          [-0.14581000000000002, 51.496140000000004],
          [-0.14563, 51.496210000000005],
          [-0.14520000000000002, 51.49629],
          [-0.14441, 51.49635000000001],
          [-0.14366, 51.496370000000006],
          [-0.14309000000000002, 51.496410000000004],
          [-0.14254, 51.49653000000001],
          [-0.1421, 51.49667],
          [-0.14177, 51.49680000000001],
          [-0.14109000000000002, 51.497080000000004],
          [-0.14086, 51.49714],
          [-0.14058, 51.49719],
          [-0.13978000000000002, 51.497310000000006],
          [-0.13903000000000001, 51.497440000000005],
          [-0.13848000000000002, 51.49757],
          [-0.13807, 51.4977],
          [-0.13766, 51.497870000000006],
          [-0.13698000000000002, 51.49819],
          [-0.13581000000000001, 51.49879000000001],
          [-0.13519, 51.499050000000004],
          [-0.13452, 51.49929],
          [-0.13416, 51.499410000000005],
          [-0.13424, 51.499500000000005],
          [-0.13325, 51.49963],
          [-0.13324, 51.49965],
          [-0.13318000000000002, 51.49964000000001],
          [-0.13317, 51.49964000000001],
          [-0.13317, 51.499610000000004],
          [-0.13318000000000002, 51.499590000000005],
          [-0.13308, 51.499590000000005],
          [-0.13286, 51.499590000000005],
          [-0.13285000000000002, 51.49964000000001],
          [-0.13264, 51.49963],
          [-0.13233, 51.49964000000001],
          [-0.13164, 51.49964000000001],
          [-0.13069, 51.49962000000001],
          [-0.13005, 51.499590000000005],
          [-0.12986, 51.499590000000005],
          [-0.12971000000000002, 51.499590000000005],
          [-0.12965000000000002, 51.499590000000005],
          [-0.12960000000000002, 51.499550000000006],
          [-0.12975, 51.499500000000005],
          [-0.12963000000000002, 51.499370000000006],
          [-0.12961, 51.49935000000001],
          [-0.12954000000000002, 51.499370000000006],
          [-0.12953, 51.49938],
          [-0.12945, 51.49935000000001],
          [-0.12922, 51.49933000000001],
          [-0.12911, 51.499320000000004],
          [-0.12913000000000002, 51.49929],
          [-0.12914, 51.49915000000001],
          [-0.12915000000000001, 51.49907],
          [-0.12878, 51.49902],
          [-0.12865000000000001, 51.49902],
          [-0.12855, 51.498990000000006],
          [-0.12848, 51.498900000000006],
          [-0.12847, 51.49882],
          [-0.12848, 51.498470000000005],
          [-0.12816000000000002, 51.49848],
          [-0.12792, 51.498490000000004],
          [-0.12791000000000002, 51.49855],
        ],
        steps: [
          {
            distance: "0.4 km",
            duration: "7 mins",
            instructions: "Walk to Edgware Road",
            travelMode: "WALKING",
          },
          {
            distance: "8.2 km",
            duration: "18 mins",
            instructions: "Subway towards Hammersmith",
            travelMode: "TRANSIT",
          },
          {
            distance: "0.6 km",
            duration: "8 mins",
            instructions: "Walk to 19A Dean's Yard, London SW1P 3PA, UK",
            travelMode: "WALKING",
          },
        ],
      },
    },
    distances: {
      DRIVING: {
        distance: "4.8 km",
        duration: "17 mins",
      },
      WALKING: {
        distance: "4.8 km",
        duration: "1 hour 6 mins",
      },
      BICYCLING: {
        distance: "5.0 km",
        duration: "20 mins",
      },
      TRANSIT: {
        distance: "9.2 km",
        duration: "32 mins",
      },
    },
  },
  {
    name: "Eaton Square",
    category: "Secondary Schools",
    coordinates: {
      lat: 51.4929700564442,
      lng: -0.14283406665335652,
    },
    id: "674d987fdeae072033604645",
    routes: {
      driving: {
        distances: {},
        path: [
          [-0.17163, 51.52116],
          [-0.17143000000000003, 51.521],
          [-0.17120000000000002, 51.52087],
          [-0.17077, 51.520520000000005],
          [-0.17046, 51.52028000000001],
          [-0.16955, 51.51966],
          [-0.16810000000000003, 51.518660000000004],
          [-0.16599000000000003, 51.5172],
          [-0.16319, 51.51529000000001],
          [-0.16155000000000003, 51.51422],
          [-0.1607, 51.513690000000004],
          [-0.16035000000000002, 51.51348],
          [-0.16011, 51.51335],
          [-0.15998, 51.51332000000001],
          [-0.15990000000000001, 51.51332000000001],
          [-0.15987, 51.51324],
          [-0.1597, 51.513250000000006],
          [-0.15942, 51.51328],
          [-0.15901, 51.51334000000001],
          [-0.15873, 51.513360000000006],
          [-0.15856, 51.51334000000001],
          [-0.15841000000000002, 51.51328],
          [-0.15831, 51.513270000000006],
          [-0.15824000000000002, 51.513160000000006],
          [-0.15796000000000002, 51.51274],
          [-0.15769000000000002, 51.51220000000001],
          [-0.15713000000000002, 51.51111],
          [-0.15683000000000002, 51.510580000000004],
          [-0.15663000000000002, 51.510310000000004],
          [-0.15654, 51.510220000000004],
          [-0.15612, 51.509890000000006],
          [-0.15588000000000002, 51.50974],
          [-0.1555, 51.5095],
          [-0.15507, 51.50918000000001],
          [-0.15376, 51.50797000000001],
          [-0.15304, 51.50735],
          [-0.15247000000000002, 51.506840000000004],
          [-0.15196, 51.506400000000006],
          [-0.15156, 51.506060000000005],
          [-0.15119000000000002, 51.50571000000001],
          [-0.15101, 51.505520000000004],
          [-0.15092, 51.50533],
          [-0.15092, 51.5052],
          [-0.1509, 51.504850000000005],
          [-0.15092, 51.50471],
          [-0.15102000000000002, 51.50441000000001],
          [-0.15108000000000002, 51.50415],
          [-0.15104, 51.50388],
          [-0.15089000000000002, 51.503440000000005],
          [-0.15083000000000002, 51.50336],
          [-0.15079, 51.503330000000005],
          [-0.15071, 51.5033],
          [-0.15045, 51.50332],
          [-0.15014000000000002, 51.50332],
          [-0.15005000000000002, 51.503310000000006],
          [-0.14995, 51.503260000000004],
          [-0.14987, 51.50321],
          [-0.14981, 51.50316],
          [-0.14976, 51.503060000000005],
          [-0.14977000000000001, 51.50292],
          [-0.14980000000000002, 51.502700000000004],
          [-0.14989000000000002, 51.502570000000006],
          [-0.14995, 51.50247],
          [-0.15007, 51.50242],
          [-0.1502, 51.502370000000006],
          [-0.1506, 51.50222],
          [-0.1511, 51.502030000000005],
          [-0.15113000000000001, 51.50197000000001],
          [-0.15121, 51.50191],
          [-0.15125000000000002, 51.501870000000004],
          [-0.15127000000000002, 51.50182],
          [-0.15126, 51.501760000000004],
          [-0.15112, 51.50162],
          [-0.15098, 51.50151],
          [-0.15096, 51.501450000000006],
          [-0.15023, 51.501000000000005],
          [-0.14925000000000002, 51.500370000000004],
          [-0.14893, 51.500150000000005],
          [-0.14831000000000003, 51.499590000000005],
          [-0.14798, 51.499300000000005],
          [-0.14764000000000002, 51.49895],
          [-0.14721, 51.49848],
          [-0.14715, 51.49842],
          [-0.14702, 51.49833],
          [-0.14688, 51.49826],
          [-0.1468, 51.498250000000006],
          [-0.14666, 51.49823000000001],
          [-0.1456, 51.498270000000005],
          [-0.14539000000000002, 51.49828],
          [-0.14520000000000002, 51.49828],
          [-0.14502, 51.498270000000005],
          [-0.14416, 51.498160000000006],
          [-0.14359000000000002, 51.49803000000001],
          [-0.14333, 51.49797],
          [-0.14317000000000002, 51.49794000000001],
          [-0.14301, 51.497910000000005],
          [-0.1426, 51.49785000000001],
          [-0.14248000000000002, 51.49781],
          [-0.14220000000000002, 51.49767000000001],
          [-0.14203000000000002, 51.49754],
          [-0.14194, 51.497370000000004],
          [-0.14185, 51.497130000000006],
          [-0.14174, 51.49682000000001],
          [-0.14188, 51.496570000000006],
          [-0.14217000000000002, 51.496550000000006],
          [-0.14242000000000002, 51.496480000000005],
          [-0.14247, 51.49645],
          [-0.14251, 51.4964],
          [-0.14252, 51.49633000000001],
          [-0.14252, 51.496280000000006],
          [-0.14247, 51.496140000000004],
          [-0.1423, 51.49589],
          [-0.14213, 51.495630000000006],
          [-0.14202, 51.495450000000005],
          [-0.14183, 51.49523000000001],
          [-0.14182, 51.49513],
          [-0.14178000000000002, 51.495050000000006],
          [-0.14168, 51.49488],
          [-0.14168, 51.494820000000004],
          [-0.14170000000000002, 51.49476000000001],
          [-0.14178000000000002, 51.49466],
          [-0.14200000000000002, 51.494600000000005],
          [-0.14209000000000002, 51.494580000000006],
          [-0.14215, 51.49452],
          [-0.14219, 51.49447000000001],
          [-0.14222, 51.494400000000006],
          [-0.14223000000000002, 51.494330000000005],
          [-0.14220000000000002, 51.4943],
          [-0.14209000000000002, 51.494110000000006],
          [-0.14200000000000002, 51.493950000000005],
          [-0.14179, 51.49378],
          [-0.14221, 51.493550000000006],
          [-0.14253000000000002, 51.49342000000001],
          [-0.14289000000000002, 51.49324000000001],
          [-0.14306000000000002, 51.49315000000001],
        ],
        steps: [
          {
            distance: "1.2 km",
            duration: "5 mins",
            instructions:
              "Head <b>southeast</b> on <b>Edgware Rd</b>/<wbr/><b>A5</b> toward <b>Newcastle Pl</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "69 m",
            duration: "1 min",
            instructions: "Keep <b>right</b> to continue on <b>Marble Arch</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "60 m",
            duration: "1 min",
            instructions: "Keep <b>right</b> to stay on <b>Marble Arch</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "1.3 km",
            duration: "3 mins",
            instructions: "Continue onto <b>Park Ln</b>/<wbr/><b>A4202</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "46 m",
            duration: "1 min",
            instructions: "Turn <b>left</b> onto <b>Piccadilly</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "0.2 km",
            duration: "1 min",
            instructions: "Turn <b>right</b> onto <b>Duke of Wellington Pl</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "1.0 km",
            duration: "3 mins",
            instructions:
              'Slight <b>left</b> onto <b>Grosvenor Pl</b>/<wbr/><b>A302</b><div style="font-size:0.9em">Continue to follow A302</div>',
            travelMode: "DRIVING",
          },
          {
            distance: "20 m",
            duration: "1 min",
            instructions:
              "Turn <b>right</b> onto <b>Victoria St</b>/<wbr/><b>A302</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "0.2 km",
            duration: "1 min",
            instructions:
              "Slight <b>left</b> onto <b>Vauxhall Bridge Rd</b>/<wbr/><b>A202</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "89 m",
            duration: "1 min",
            instructions: "Slight <b>right</b> onto <b>Neathouse Pl</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "0.1 km",
            duration: "1 min",
            instructions: "Turn <b>left</b> onto <b>Wilton Rd</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "0.1 km",
            duration: "1 min",
            instructions:
              'Turn <b>right</b> onto <b>Gillingham St</b><div style="font-size:0.9em">Destination will be on the left</div>',
            travelMode: "DRIVING",
          },
        ],
      },
      walking: {
        distances: {},
        path: [
          [-0.17170000000000002, 51.52112],
          [-0.17154000000000003, 51.521],
          [-0.17139000000000001, 51.521080000000005],
          [-0.17135, 51.521040000000006],
          [-0.17125, 51.520970000000005],
          [-0.17114000000000001, 51.520900000000005],
          [-0.17076000000000002, 51.520590000000006],
          [-0.17047, 51.520390000000006],
          [-0.17022, 51.52024],
          [-0.17011, 51.52013],
          [-0.16999, 51.520050000000005],
          [-0.17001000000000002, 51.520050000000005],
          [-0.16978000000000001, 51.519890000000004],
          [-0.16951000000000002, 51.51973],
          [-0.16907000000000003, 51.519420000000004],
          [-0.169, 51.51935],
          [-0.16897, 51.519360000000006],
          [-0.16890000000000002, 51.5193],
          [-0.16892000000000001, 51.5193],
          [-0.16870000000000002, 51.51915],
          [-0.16849, 51.518980000000006],
          [-0.16757000000000002, 51.51834],
          [-0.16742, 51.51825],
          [-0.16741, 51.518260000000005],
          [-0.16726000000000002, 51.518170000000005],
          [-0.16723000000000002, 51.51814],
          [-0.16742, 51.51802000000001],
          [-0.16741, 51.518010000000004],
          [-0.16744, 51.517970000000005],
          [-0.16719, 51.51785],
          [-0.16712000000000002, 51.517700000000005],
          [-0.16699000000000003, 51.517610000000005],
          [-0.16684000000000002, 51.517540000000004],
          [-0.16637000000000002, 51.5172],
          [-0.16620000000000001, 51.51708000000001],
          [-0.16602, 51.517030000000005],
          [-0.1658, 51.51688000000001],
          [-0.16582000000000002, 51.516870000000004],
          [-0.16579000000000002, 51.516850000000005],
          [-0.16573000000000002, 51.51681000000001],
          [-0.16567, 51.51684],
          [-0.16551000000000002, 51.51671],
          [-0.16509000000000001, 51.51643000000001],
          [-0.16407000000000002, 51.51574],
          [-0.16379000000000002, 51.515550000000005],
          [-0.16349000000000002, 51.515350000000005],
          [-0.16307000000000002, 51.515060000000005],
          [-0.16310000000000002, 51.51505],
          [-0.16308, 51.515040000000006],
          [-0.16294, 51.514950000000006],
          [-0.16262000000000001, 51.51473000000001],
          [-0.16226000000000002, 51.51453000000001],
          [-0.16195, 51.51433],
          [-0.16184, 51.51426000000001],
          [-0.16188000000000002, 51.514250000000004],
          [-0.1617, 51.514140000000005],
          [-0.16166000000000003, 51.514140000000005],
          [-0.161, 51.51371],
          [-0.16086, 51.51362],
          [-0.16066000000000003, 51.513510000000004],
          [-0.16066000000000003, 51.51344],
          [-0.16066000000000003, 51.51341000000001],
          [-0.16059, 51.513400000000004],
          [-0.16046000000000002, 51.51337],
          [-0.16046000000000002, 51.51333],
          [-0.16031, 51.51333],
          [-0.16028, 51.513290000000005],
          [-0.16022, 51.513290000000005],
          [-0.1602, 51.51319],
          [-0.16025, 51.51317],
          [-0.16023, 51.51305000000001],
          [-0.16096000000000002, 51.51296000000001],
          [-0.16097, 51.51296000000001],
          [-0.16098, 51.51294000000001],
          [-0.16087, 51.51254],
          [-0.16096000000000002, 51.51240000000001],
          [-0.16094, 51.51239],
          [-0.16102000000000002, 51.51232],
          [-0.16095, 51.512330000000006],
          [-0.16093000000000002, 51.51227],
          [-0.16096000000000002, 51.51227],
          [-0.16086, 51.512190000000004],
          [-0.16083, 51.512060000000005],
          [-0.16077000000000002, 51.51205],
          [-0.16060000000000002, 51.512010000000004],
          [-0.1602, 51.511900000000004],
          [-0.15964, 51.511660000000006],
          [-0.15906, 51.511410000000005],
          [-0.15866000000000002, 51.5112],
          [-0.1585, 51.51111],
          [-0.15839, 51.51102],
          [-0.15830000000000002, 51.51086],
          [-0.15789, 51.50996000000001],
          [-0.15766000000000002, 51.509600000000006],
          [-0.15754, 51.50947000000001],
          [-0.15660000000000002, 51.50835000000001],
          [-0.1564, 51.50811],
          [-0.1555, 51.507110000000004],
          [-0.15409, 51.5054],
          [-0.15319000000000002, 51.504360000000005],
          [-0.15311000000000002, 51.50417],
          [-0.1531, 51.50408],
          [-0.1531, 51.50403000000001],
          [-0.15288000000000002, 51.503980000000006],
          [-0.15267, 51.503930000000004],
          [-0.15266000000000002, 51.503910000000005],
          [-0.15266000000000002, 51.50379],
          [-0.15274000000000001, 51.50363],
          [-0.15285, 51.50352],
          [-0.15273, 51.503460000000004],
          [-0.15257, 51.50320000000001],
          [-0.15252000000000002, 51.503080000000004],
          [-0.15248, 51.50309000000001],
          [-0.15247000000000002, 51.50302000000001],
          [-0.15249000000000001, 51.50300000000001],
          [-0.15243, 51.50294],
          [-0.15232, 51.502930000000006],
          [-0.15235, 51.502860000000005],
          [-0.15212, 51.50283],
          [-0.15208000000000002, 51.50289],
          [-0.15203000000000003, 51.50289],
          [-0.15193, 51.502810000000004],
          [-0.15187, 51.50274],
          [-0.15177000000000002, 51.502590000000005],
          [-0.15167, 51.502250000000004],
          [-0.15168, 51.5022],
          [-0.15161000000000002, 51.502100000000006],
          [-0.15151, 51.50208000000001],
          [-0.15155000000000002, 51.50197000000001],
          [-0.15173, 51.501940000000005],
          [-0.15185, 51.501920000000005],
          [-0.15181, 51.50188000000001],
          [-0.15175000000000002, 51.501870000000004],
          [-0.15138000000000001, 51.50159000000001],
          [-0.15105000000000002, 51.501380000000005],
          [-0.15001, 51.50072],
          [-0.14987, 51.50063],
          [-0.14989000000000002, 51.500620000000005],
          [-0.14980000000000002, 51.50056000000001],
          [-0.14976, 51.50058000000001],
          [-0.14957, 51.500460000000004],
          [-0.14922000000000002, 51.500220000000006],
          [-0.14889000000000002, 51.50000000000001],
          [-0.14894000000000002, 51.49998],
          [-0.14892000000000002, 51.499950000000005],
          [-0.14882, 51.49987],
          [-0.14828000000000002, 51.499370000000006],
          [-0.14800000000000002, 51.49917000000001],
          [-0.14804, 51.49915000000001],
          [-0.14802, 51.49913],
          [-0.14793, 51.49906000000001],
          [-0.14789000000000002, 51.49907],
          [-0.14781000000000002, 51.498990000000006],
          [-0.14775000000000002, 51.498850000000004],
          [-0.14749, 51.498610000000006],
          [-0.14731000000000002, 51.498450000000005],
          [-0.14726, 51.49839000000001],
          [-0.14720000000000003, 51.498250000000006],
          [-0.14724, 51.49822],
          [-0.14721, 51.49815],
          [-0.14718, 51.49814000000001],
          [-0.14715, 51.498160000000006],
          [-0.14713, 51.49814000000001],
          [-0.14691, 51.49788],
          [-0.14671, 51.49761],
          [-0.14654, 51.497350000000004],
          [-0.14653000000000002, 51.49729000000001],
          [-0.14642000000000002, 51.49725],
          [-0.14635, 51.49712],
          [-0.14628000000000002, 51.49700000000001],
          [-0.14616, 51.49680000000001],
          [-0.14596, 51.496480000000005],
          [-0.14562, 51.495990000000006],
          [-0.14556000000000002, 51.49588000000001],
          [-0.14568, 51.49570000000001],
          [-0.14571, 51.49571],
          [-0.14575000000000002, 51.49564],
          [-0.14591, 51.495400000000004],
          [-0.14604, 51.49521000000001],
          [-0.14621, 51.494980000000005],
          [-0.14645000000000002, 51.494710000000005],
          [-0.14656000000000002, 51.494580000000006],
          [-0.14681000000000002, 51.49423],
          [-0.14685, 51.49425],
          [-0.14686000000000002, 51.49423],
          [-0.1469, 51.49414],
          [-0.14686000000000002, 51.49412],
          [-0.14688, 51.494080000000004],
          [-0.14677, 51.494060000000005],
          [-0.14675000000000002, 51.494110000000006],
          [-0.14669000000000001, 51.49409000000001],
          [-0.14674, 51.49401],
          [-0.14663, 51.49398000000001],
          [-0.14659000000000003, 51.494040000000005],
          [-0.14642000000000002, 51.494020000000006],
          [-0.14626, 51.493970000000004],
          [-0.14592000000000002, 51.49382000000001],
          [-0.1456, 51.49372],
          [-0.14561000000000002, 51.49371000000001],
          [-0.14547000000000002, 51.49367],
          [-0.14526, 51.4936],
          [-0.14499, 51.49349],
          [-0.14452, 51.49326000000001],
          [-0.14453000000000002, 51.49325],
          [-0.14443, 51.4932],
          [-0.14437, 51.493190000000006],
          [-0.14421, 51.49311],
          [-0.14368, 51.49287],
          [-0.14348000000000002, 51.49277000000001],
          [-0.14335, 51.49288000000001],
          [-0.14333, 51.492900000000006],
          [-0.14335, 51.49291],
          [-0.14329, 51.49295000000001],
          [-0.14299, 51.49309],
        ],
        steps: [
          {
            distance: "0.4 km",
            duration: "6 mins",
            instructions:
              "Head <b>southeast</b> on <b>Edgware Rd</b>/<wbr/><b>A5</b> toward <b>Newcastle Pl</b>",
            travelMode: "WALKING",
          },
          {
            distance: "30 m",
            duration: "1 min",
            instructions:
              "Turn <b>right</b> onto <b>Sussex Gardens</b>/<wbr/><b>A4209</b>",
            travelMode: "WALKING",
          },
          {
            distance: "52 m",
            duration: "1 min",
            instructions:
              "Sharp <b>left</b> toward <b>Edgware Rd</b>/<wbr/><b>A5</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.7 km",
            duration: "9 mins",
            instructions: "Continue onto <b>Edgware Rd</b>/<wbr/><b>A5</b>",
            travelMode: "WALKING",
          },
          {
            distance: "16 m",
            duration: "1 min",
            instructions: "Turn <b>left</b>",
            travelMode: "WALKING",
          },
          {
            distance: "33 m",
            duration: "1 min",
            instructions: "Turn <b>right</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.1 km",
            duration: "2 mins",
            instructions: "Turn <b>right</b>",
            travelMode: "WALKING",
          },
          {
            distance: "33 m",
            duration: "1 min",
            instructions: "Turn <b>left</b>",
            travelMode: "WALKING",
          },
          {
            distance: "1.1 km",
            duration: "14 mins",
            instructions: "Turn <b>left</b>",
            travelMode: "WALKING",
          },
          {
            distance: "36 m",
            duration: "1 min",
            instructions: "Turn <b>left</b> toward <b>S Carriage Dr</b>",
            travelMode: "WALKING",
          },
          {
            distance: "50 m",
            duration: "1 min",
            instructions: "Turn <b>right</b> onto <b>S Carriage Dr</b>",
            travelMode: "WALKING",
          },
          {
            distance: "69 m",
            duration: "1 min",
            instructions: "Turn <b>left</b> toward <b>Apsley Way</b>",
            travelMode: "WALKING",
          },
          {
            distance: "28 m",
            duration: "1 min",
            instructions: "Turn <b>left</b> toward <b>Apsley Way</b>",
            travelMode: "WALKING",
          },
          {
            distance: "76 m",
            duration: "1 min",
            instructions: "Slight <b>right</b> onto <b>Apsley Way</b>",
            travelMode: "WALKING",
          },
          {
            distance: "26 m",
            duration: "1 min",
            instructions:
              'Slight <b>right</b> toward <b>Grosvenor Pl</b>/<wbr/><b>A302</b><div style="font-size:0.9em">Take the stairs</div>',
            travelMode: "WALKING",
          },
          {
            distance: "12 m",
            duration: "1 min",
            instructions:
              "Turn <b>right</b> toward <b>Grosvenor Pl</b>/<wbr/><b>A302</b>",
            travelMode: "WALKING",
          },
          {
            distance: "22 m",
            duration: "1 min",
            instructions:
              "Turn <b>right</b> toward <b>Grosvenor Pl</b>/<wbr/><b>A302</b>",
            travelMode: "WALKING",
          },
          {
            distance: "15 m",
            duration: "1 min",
            instructions:
              'Turn <b>left</b> toward <b>Grosvenor Pl</b>/<wbr/><b>A302</b><div style="font-size:0.9em">Take the stairs</div>',
            travelMode: "WALKING",
          },
          {
            distance: "0.6 km",
            duration: "9 mins",
            instructions:
              'Turn <b>right</b> onto <b>Grosvenor Pl</b>/<wbr/><b>A302</b><div style="font-size:0.9em">Continue to follow A302</div>',
            travelMode: "WALKING",
          },
          {
            distance: "0.2 km",
            duration: "2 mins",
            instructions:
              "Continue onto <b>Grosvenor Gardens</b>/<wbr/><b>A3215</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.2 km",
            duration: "3 mins",
            instructions:
              "Slight <b>right</b> onto <b>Buckingham Palace Rd</b>/<wbr/><b>A3214</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.3 km",
            duration: "4 mins",
            instructions:
              'Turn <b>left</b> onto <b>Eccleston Bridge</b>/<wbr/><b>A3213</b><div style="font-size:0.9em">Continue to follow A3213</div>',
            travelMode: "WALKING",
          },
          {
            distance: "43 m",
            duration: "1 min",
            instructions:
              'Turn <b>left</b> onto <b>Gillingham St</b><div style="font-size:0.9em">Destination will be on the right</div>',
            travelMode: "WALKING",
          },
        ],
      },
      bicycling: {
        distances: {},
        path: [
          [-0.17163, 51.52116],
          [-0.17143000000000003, 51.521],
          [-0.17120000000000002, 51.52087],
          [-0.17077, 51.520520000000005],
          [-0.17046, 51.52028000000001],
          [-0.16955, 51.51966],
          [-0.16810000000000003, 51.518660000000004],
          [-0.16599000000000003, 51.5172],
          [-0.16319, 51.51529000000001],
          [-0.1628, 51.51503],
          [-0.16310000000000002, 51.51498],
          [-0.16382000000000002, 51.514860000000006],
          [-0.16322, 51.513940000000005],
          [-0.16317, 51.51381000000001],
          [-0.16295, 51.513470000000005],
          [-0.16273, 51.51314000000001],
          [-0.16269, 51.51306],
          [-0.16271000000000002, 51.5129],
          [-0.1627, 51.51281],
          [-0.16262000000000001, 51.512640000000005],
          [-0.16254000000000002, 51.51245],
          [-0.16244, 51.512260000000005],
          [-0.16238000000000002, 51.51216],
          [-0.16215000000000002, 51.512100000000004],
          [-0.16204000000000002, 51.51209000000001],
          [-0.16182000000000002, 51.51209000000001],
          [-0.16125, 51.51209000000001],
          [-0.16083, 51.512060000000005],
          [-0.16048, 51.51198],
          [-0.15996000000000002, 51.5118],
          [-0.1592, 51.511480000000006],
          [-0.15879000000000001, 51.511280000000006],
          [-0.15858000000000003, 51.51115000000001],
          [-0.15839, 51.51102],
          [-0.15826, 51.5108],
          [-0.15789, 51.50996000000001],
          [-0.15766000000000002, 51.509600000000006],
          [-0.15718000000000001, 51.509040000000006],
          [-0.15636, 51.50806000000001],
          [-0.15581, 51.50746],
          [-0.15493, 51.506420000000006],
          [-0.15381, 51.50508000000001],
          [-0.15335000000000001, 51.504540000000006],
          [-0.15319000000000002, 51.504360000000005],
          [-0.15317, 51.504310000000004],
          [-0.15312, 51.50421000000001],
          [-0.1531, 51.504110000000004],
          [-0.1531, 51.50403000000001],
          [-0.15261000000000002, 51.50392],
          [-0.1526, 51.50379],
          [-0.15264000000000003, 51.5037],
          [-0.15265, 51.50365000000001],
          [-0.15276, 51.50354],
          [-0.15284, 51.50347000000001],
          [-0.15298, 51.50338000000001],
          [-0.1531, 51.503330000000005],
          [-0.1534, 51.50325],
          [-0.15389, 51.50318000000001],
          [-0.15486000000000003, 51.50309000000001],
          [-0.15769000000000002, 51.50283],
          [-0.15852000000000002, 51.502750000000006],
          [-0.15847, 51.502410000000005],
          [-0.15846000000000002, 51.50226000000001],
          [-0.15833000000000003, 51.502280000000006],
          [-0.15832000000000002, 51.502210000000005],
          [-0.15838000000000002, 51.502140000000004],
          [-0.15838000000000002, 51.50208000000001],
          [-0.15839, 51.501960000000004],
          [-0.15845, 51.501810000000006],
          [-0.15849000000000002, 51.501430000000006],
          [-0.15844000000000003, 51.501270000000005],
          [-0.15828, 51.500640000000004],
          [-0.15815, 51.5001],
          [-0.15798, 51.49953000000001],
          [-0.15799000000000002, 51.49944000000001],
          [-0.15785000000000002, 51.499],
          [-0.15754, 51.498780000000004],
          [-0.15623, 51.497910000000005],
          [-0.15607000000000001, 51.49776000000001],
          [-0.15599000000000002, 51.497640000000004],
          [-0.15594000000000002, 51.49738000000001],
          [-0.15589, 51.497130000000006],
          [-0.15584, 51.496880000000004],
          [-0.15582000000000001, 51.496770000000005],
          [-0.1557, 51.49671000000001],
          [-0.15555000000000002, 51.49663],
          [-0.15531, 51.496480000000005],
          [-0.15477000000000002, 51.49615000000001],
          [-0.15303, 51.49504],
          [-0.15151, 51.49407],
          [-0.15071, 51.493570000000005],
          [-0.15026, 51.49331],
          [-0.1501, 51.49322],
          [-0.14976, 51.493120000000005],
          [-0.14887, 51.492850000000004],
          [-0.14753000000000002, 51.492450000000005],
          [-0.14666, 51.49217],
          [-0.14596, 51.49188],
          [-0.14509000000000002, 51.49147000000001],
          [-0.14454, 51.491220000000006],
          [-0.14444, 51.4913],
          [-0.14302, 51.49248000000001],
          [-0.14288, 51.49259000000001],
          [-0.14335, 51.49282],
          [-0.14352, 51.492900000000006],
          [-0.14335, 51.493010000000005],
          [-0.14306000000000002, 51.49315000000001],
        ],
        steps: [
          {
            distance: "0.9 km",
            duration: "3 mins",
            instructions:
              "Head <b>southeast</b> on <b>Edgware Rd</b>/<wbr/><b>A5</b> toward <b>Newcastle Pl</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "73 m",
            duration: "1 min",
            instructions:
              'Turn <b>right</b> onto <b>Connaught St</b>/<wbr/><b>Upper Berkeley St</b><div style="font-size:0.9em">Continue to follow Connaught St</div>',
            travelMode: "BICYCLING",
          },
          {
            distance: "0.1 km",
            duration: "1 min",
            instructions: "Turn <b>left</b> onto <b>Connaught Square</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.2 km",
            duration: "1 min",
            instructions: "Continue onto <b>Stanhope Pl</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "1.2 km",
            duration: "3 mins",
            instructions: "Turn <b>left</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "36 m",
            duration: "1 min",
            instructions: "Turn <b>left</b> toward <b>S Carriage Dr</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.5 km",
            duration: "1 min",
            instructions: "Turn <b>right</b> onto <b>S Carriage Dr</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "55 m",
            duration: "1 min",
            instructions: "Turn <b>left</b> onto <b>Albert Gate</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "9 m",
            duration: "1 min",
            instructions:
              "Turn <b>left</b> onto <b>Knightsbridge</b>/<wbr/><b>A4</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.1 km",
            duration: "1 min",
            instructions: "Turn <b>right</b> onto <b>William St</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.3 km",
            duration: "1 min",
            instructions: "Continue onto <b>Lowndes Square</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.2 km",
            duration: "1 min",
            instructions:
              "<b>Lowndes Square</b> turns slightly <b>left</b> and becomes <b>Lowndes St</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.1 km",
            duration: "1 min",
            instructions: "Keep <b>right</b> to continue on <b>Chesham Pl</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.3 km",
            duration: "1 min",
            instructions:
              "<b>Chesham Pl</b> turns slightly <b>left</b> and becomes <b>Lyall St</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.5 km",
            duration: "3 mins",
            instructions: "Continue onto <b>Elizabeth St</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.1 km",
            duration: "1 min",
            instructions: "Continue onto <b>Elizabeth Bridge</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.1 km",
            duration: "1 min",
            instructions:
              "Continue onto <b>Eccleston Square</b>/<wbr/><b>St George's Dr</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.2 km",
            duration: "1 min",
            instructions: "Turn <b>left</b> onto <b>Eccleston Square</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "56 m",
            duration: "1 min",
            instructions:
              "Turn <b>left</b> onto <b>Eccleston Square</b>/<wbr/><b>A3213</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "43 m",
            duration: "1 min",
            instructions:
              'Turn <b>right</b> onto <b>Gillingham St</b><div style="font-size:0.9em">Destination will be on the right</div>',
            travelMode: "BICYCLING",
          },
        ],
      },
      transit: {
        distances: {},
        path: [
          [-0.17170000000000002, 51.52112],
          [-0.17154000000000003, 51.521],
          [-0.17139000000000001, 51.521080000000005],
          [-0.17135, 51.521040000000006],
          [-0.17125, 51.520970000000005],
          [-0.17114000000000001, 51.520900000000005],
          [-0.17076000000000002, 51.520590000000006],
          [-0.17047, 51.520390000000006],
          [-0.17022, 51.52024],
          [-0.17025, 51.520230000000005],
          [-0.17031000000000002, 51.520250000000004],
          [-0.17027, 51.52028000000001],
          [-0.16993000000000003, 51.520540000000004],
          [-0.16951000000000002, 51.52084000000001],
          [-0.16902, 51.52111000000001],
          [-0.16837000000000002, 51.521390000000004],
          [-0.16735000000000003, 51.521710000000006],
          [-0.16608, 51.52203],
          [-0.16368000000000002, 51.52237],
          [-0.16274000000000002, 51.522510000000004],
          [-0.16116000000000003, 51.52268],
          [-0.15709, 51.52311],
          [-0.15324000000000002, 51.52355000000001],
          [-0.15105000000000002, 51.52393000000001],
          [-0.14948, 51.52420000000001],
          [-0.14893, 51.524210000000004],
          [-0.14865, 51.52418],
          [-0.14837, 51.52412],
          [-0.14779, 51.52393000000001],
          [-0.14676, 51.52346000000001],
          [-0.1464, 51.52322],
          [-0.14628000000000002, 51.523070000000004],
          [-0.14616, 51.52290000000001],
          [-0.14408, 51.51841],
          [-0.14395000000000002, 51.51825],
          [-0.14317000000000002, 51.51791000000001],
          [-0.14301, 51.517810000000004],
          [-0.1429, 51.51771],
          [-0.14225000000000002, 51.516070000000006],
          [-0.14192000000000002, 51.516180000000006],
          [-0.14216, 51.516160000000006],
          [-0.14207, 51.51579],
          [-0.14191, 51.515190000000004],
          [-0.14183, 51.51462],
          [-0.14184000000000002, 51.514340000000004],
          [-0.1419, 51.51371],
          [-0.14211000000000001, 51.51286],
          [-0.14223000000000002, 51.51247000000001],
          [-0.14243, 51.512040000000006],
          [-0.1428, 51.51144000000001],
          [-0.14312000000000002, 51.51090000000001],
          [-0.1433, 51.51037],
          [-0.14339000000000002, 51.50985000000001],
          [-0.14341, 51.50959],
          [-0.14338, 51.50893000000001],
          [-0.14329, 51.508250000000004],
          [-0.14309000000000002, 51.50753],
          [-0.14287000000000002, 51.50674000000001],
          [-0.14282, 51.5063],
          [-0.14277, 51.50551],
          [-0.1428, 51.50419],
          [-0.14291, 51.50251],
          [-0.1431, 51.50029000000001],
          [-0.14350000000000002, 51.49566],
          [-0.14373000000000002, 51.49566],
          [-0.14319, 51.49570000000001],
          [-0.14309000000000002, 51.49566],
          [-0.14302, 51.4956],
          [-0.14297, 51.49550000000001],
          [-0.14286000000000001, 51.49526],
          [-0.14267000000000002, 51.494870000000006],
          [-0.14246, 51.49456000000001],
          [-0.14244, 51.494530000000005],
          [-0.14247, 51.49452],
          [-0.14246, 51.494510000000005],
          [-0.14236000000000001, 51.49436000000001],
          [-0.14227, 51.49421],
          [-0.14209000000000002, 51.49392],
          [-0.14197, 51.49380000000001],
          [-0.14181000000000002, 51.49369],
          [-0.14194, 51.493610000000004],
          [-0.14242000000000002, 51.49338],
          [-0.14292000000000002, 51.49313],
          [-0.14299, 51.49309],
        ],
        steps: [
          {
            distance: "0.1 km",
            duration: "3 mins",
            instructions: "Walk to Edgware Road",
            travelMode: "WALKING",
          },
          {
            distance: "2.6 km",
            duration: "7 mins",
            instructions: "Subway towards Elephant & Castle",
            travelMode: "TRANSIT",
          },
          {
            distance: "24 m",
            duration: "1 min",
            instructions: "Walk to Oxford Circus",
            travelMode: "WALKING",
          },
          {
            distance: "2.3 km",
            duration: "4 mins",
            instructions: "Subway towards Brixton",
            travelMode: "TRANSIT",
          },
          {
            distance: "0.4 km",
            duration: "7 mins",
            instructions:
              "Walk to Eccleston Hotel, Pimlico, London SW1V 1PS, UK",
            travelMode: "WALKING",
          },
        ],
      },
    },
    distances: {
      DRIVING: {
        distance: "4.3 km",
        duration: "15 mins",
      },
      WALKING: {
        distance: "4.1 km",
        duration: "59 mins",
      },
      BICYCLING: {
        distance: "5.0 km",
        duration: "20 mins",
      },
      TRANSIT: {
        distance: "4.3 km",
        duration: "26 mins",
      },
    },
  },
  {
    name: "Portland Place School",
    category: "Secondary Schools",
    coordinates: {
      lat: 51.52100631498087,
      lng: -0.14493424577346237,
    },
    id: "674d989bdeae072033604646",
    routes: {
      driving: {
        distances: {},
        path: [
          [-0.17163, 51.52116],
          [-0.17143000000000003, 51.521],
          [-0.17120000000000002, 51.52087],
          [-0.17077, 51.520520000000005],
          [-0.17046, 51.52028000000001],
          [-0.17019, 51.52009],
          [-0.16994, 51.520100000000006],
          [-0.16922, 51.520160000000004],
          [-0.16849, 51.52029],
          [-0.16758, 51.52049],
          [-0.16724000000000003, 51.520500000000006],
          [-0.16679000000000002, 51.520610000000005],
          [-0.16646000000000002, 51.520680000000006],
          [-0.16606, 51.52076],
          [-0.16464, 51.52094],
          [-0.16364, 51.52113000000001],
          [-0.16257000000000002, 51.52131000000001],
          [-0.16033, 51.5217],
          [-0.15892, 51.521950000000004],
          [-0.15717, 51.52225000000001],
          [-0.15316000000000002, 51.52297],
          [-0.15243, 51.52310000000001],
          [-0.15137, 51.52317000000001],
          [-0.1506, 51.523230000000005],
          [-0.14953000000000002, 51.52331],
          [-0.14888, 51.52338],
          [-0.14789000000000002, 51.52355000000001],
          [-0.14784, 51.52342],
          [-0.14780000000000001, 51.52337000000001],
          [-0.14772000000000002, 51.52326000000001],
          [-0.14758000000000002, 51.523160000000004],
          [-0.1474, 51.523050000000005],
          [-0.14717000000000002, 51.522960000000005],
          [-0.14693, 51.52290000000001],
          [-0.14672000000000002, 51.52288],
          [-0.14646, 51.522870000000005],
          [-0.14618, 51.52290000000001],
          [-0.14608000000000002, 51.522920000000006],
          [-0.14597000000000002, 51.522650000000006],
          [-0.14572000000000002, 51.522090000000006],
          [-0.14537, 51.521280000000004],
          [-0.14524, 51.520990000000005],
          [-0.14505, 51.52103],
          [-0.14495000000000002, 51.521040000000006],
        ],
        steps: [
          {
            distance: "0.2 km",
            duration: "1 min",
            instructions:
              "Head <b>southeast</b> on <b>Edgware Rd</b>/<wbr/><b>A5</b> toward <b>Newcastle Pl</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "0.2 km",
            duration: "1 min",
            instructions:
              "Turn <b>left</b> (signs for <b>Ring Rd E</b>/<wbr/><b>A400</b>/<wbr/><b>A1</b>/<wbr/><b>The City</b>/<wbr/><b>Euston</b>/<wbr/><b>Kings Cross</b>)",
            travelMode: "DRIVING",
          },
          {
            distance: "1.4 km",
            duration: "5 mins",
            instructions:
              'Merge onto <b>Marylebone Rd</b>/<wbr/><b>Marylebone Flyover</b>/<wbr/><b>A501</b><div style="font-size:0.9em">Continue to follow Marylebone Rd/<wbr/>A501</div>',
            travelMode: "DRIVING",
          },
          {
            distance: "0.2 km",
            duration: "1 min",
            instructions:
              'Turn <b>right</b> onto <b>Park Cres</b>/<wbr/><b>A4201</b><div style="font-size:0.9em">Entering toll zone</div>',
            travelMode: "DRIVING",
          },
          {
            distance: "0.2 km",
            duration: "1 min",
            instructions:
              "Turn <b>right</b> onto <b>Portland Pl</b>/<wbr/><b>A4201</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "21 m",
            duration: "1 min",
            instructions:
              'Turn <b>left</b> onto <b>Weymouth St</b><div style="font-size:0.9em">Destination will be on the right</div>',
            travelMode: "DRIVING",
          },
        ],
      },
      walking: {
        distances: {},
        path: [
          [-0.17170000000000002, 51.52112],
          [-0.17154000000000003, 51.521],
          [-0.17139000000000001, 51.521080000000005],
          [-0.17135, 51.521040000000006],
          [-0.17125, 51.520970000000005],
          [-0.17114000000000001, 51.520900000000005],
          [-0.17076000000000002, 51.520590000000006],
          [-0.17047, 51.520390000000006],
          [-0.17022, 51.52024],
          [-0.17013, 51.52013],
          [-0.17002, 51.520140000000005],
          [-0.16979000000000002, 51.52015],
          [-0.16945000000000002, 51.52018],
          [-0.16898000000000002, 51.52024],
          [-0.16848000000000002, 51.52033],
          [-0.16807000000000002, 51.520430000000005],
          [-0.16776000000000002, 51.520500000000006],
          [-0.16746000000000003, 51.520540000000004],
          [-0.16728, 51.520570000000006],
          [-0.16688, 51.52066000000001],
          [-0.16657000000000002, 51.520720000000004],
          [-0.16636, 51.520770000000006],
          [-0.16608, 51.52082000000001],
          [-0.16589, 51.52084000000001],
          [-0.16569, 51.520860000000006],
          [-0.16569, 51.52084000000001],
          [-0.16567, 51.52076],
          [-0.16553, 51.52078],
          [-0.16552, 51.52073000000001],
          [-0.16587000000000002, 51.520700000000005],
          [-0.16584000000000002, 51.52062],
          [-0.16584000000000002, 51.5206],
          [-0.16552, 51.52062],
          [-0.16552, 51.520610000000005],
          [-0.16541, 51.52062],
          [-0.16541, 51.52065],
          [-0.1653, 51.52066000000001],
          [-0.16533, 51.520630000000004],
          [-0.16528, 51.520610000000005],
          [-0.16522, 51.52065],
          [-0.16495, 51.520700000000005],
          [-0.16449000000000003, 51.52078],
          [-0.16410000000000002, 51.520860000000006],
          [-0.16409, 51.52084000000001],
          [-0.16394, 51.52087],
          [-0.16390000000000002, 51.52087],
          [-0.16391, 51.520900000000005],
          [-0.16379000000000002, 51.52091000000001],
          [-0.16328, 51.520990000000005],
          [-0.16291000000000003, 51.521060000000006],
          [-0.16290000000000002, 51.521060000000006],
          [-0.16281, 51.521080000000005],
          [-0.16282000000000002, 51.52109],
          [-0.16245, 51.52114],
          [-0.16209, 51.521190000000004],
          [-0.16157000000000002, 51.52127],
          [-0.16113000000000002, 51.521330000000006],
          [-0.16093000000000002, 51.52136],
          [-0.16095, 51.52141],
          [-0.16080000000000003, 51.52141],
          [-0.16059, 51.521440000000005],
          [-0.16033, 51.52149000000001],
          [-0.15966000000000002, 51.52161],
          [-0.15964, 51.521570000000004],
          [-0.15944000000000003, 51.52160000000001],
          [-0.15947, 51.52167000000001],
          [-0.15937, 51.52169000000001],
          [-0.15813000000000002, 51.521910000000005],
          [-0.15753, 51.522000000000006],
          [-0.15746000000000002, 51.52205000000001],
          [-0.15736, 51.522040000000004],
          [-0.15713000000000002, 51.522090000000006],
          [-0.15676, 51.52215],
          [-0.15653, 51.52219],
          [-0.15618, 51.52221],
          [-0.15575, 51.522290000000005],
          [-0.15509, 51.522450000000006],
          [-0.15335000000000001, 51.52277],
          [-0.15269000000000002, 51.522870000000005],
          [-0.15253, 51.522920000000006],
          [-0.15239000000000003, 51.52295],
          [-0.15214000000000003, 51.52295],
          [-0.15189000000000002, 51.522960000000005],
          [-0.15174, 51.52297],
          [-0.15156, 51.523010000000006],
          [-0.15124, 51.523030000000006],
          [-0.15123, 51.523],
          [-0.15105000000000002, 51.52302],
          [-0.15106, 51.52306],
          [-0.1509, 51.52306],
          [-0.15074, 51.523070000000004],
          [-0.15018, 51.52309],
          [-0.14973, 51.523140000000005],
          [-0.14938, 51.52318],
          [-0.14898, 51.52322],
          [-0.14896, 51.52319000000001],
          [-0.14881000000000003, 51.52322],
          [-0.14882, 51.523250000000004],
          [-0.14873, 51.523250000000004],
          [-0.1486, 51.523270000000004],
          [-0.14839000000000002, 51.523320000000005],
          [-0.14809, 51.52337000000001],
          [-0.14794000000000002, 51.523390000000006],
          [-0.14791, 51.523340000000005],
          [-0.14781000000000002, 51.523230000000005],
          [-0.14772000000000002, 51.52315],
          [-0.14753000000000002, 51.523030000000006],
          [-0.14728000000000002, 51.522920000000006],
          [-0.14704, 51.522850000000005],
          [-0.14671, 51.522800000000004],
          [-0.1464, 51.522800000000004],
          [-0.14631000000000002, 51.52281000000001],
          [-0.1463, 51.52273],
          [-0.14602, 51.522090000000006],
          [-0.14598, 51.521980000000006],
          [-0.14593, 51.52199],
          [-0.14591, 51.521930000000005],
          [-0.14570000000000002, 51.52147],
          [-0.14549, 51.521010000000004],
          [-0.14554, 51.521],
          [-0.14550000000000002, 51.52091000000001],
          [-0.14546, 51.52091000000001],
          [-0.14542000000000002, 51.52082000000001],
          [-0.14531000000000002, 51.520830000000004],
          [-0.14535, 51.52093000000001],
          [-0.14526, 51.52094],
          [-0.14524, 51.520900000000005],
          [-0.14513, 51.520920000000004],
          [-0.14514000000000002, 51.52094],
          [-0.14494, 51.520990000000005],
          [-0.14493, 51.520990000000005],
        ],
        steps: [
          {
            distance: "0.2 km",
            duration: "2 mins",
            instructions:
              "Head <b>southeast</b> on <b>Edgware Rd</b>/<wbr/><b>A5</b> toward <b>Newcastle Pl</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.2 km",
            duration: "3 mins",
            instructions:
              "Turn <b>left</b> (signs for <b>Ring Rd E</b>/<wbr/><b>A400</b>/<wbr/><b>A1</b>/<wbr/><b>The City</b>/<wbr/><b>Euston</b>/<wbr/><b>Kings Cross</b>)",
            travelMode: "WALKING",
          },
          {
            distance: "0.1 km",
            duration: "2 mins",
            instructions:
              'Continue onto <b>Marylebone Rd</b>/<wbr/><b>Marylebone Flyover</b>/<wbr/><b>A501</b><div style="font-size:0.9em">Continue to follow Marylebone Rd/<wbr/>A501</div>',
            travelMode: "WALKING",
          },
          {
            distance: "15 m",
            duration: "1 min",
            instructions:
              "Turn <b>right</b> onto <b>Cosway St</b>/<wbr/><b>Old Marylebone Rd</b>/<wbr/><b>A501</b>",
            travelMode: "WALKING",
          },
          {
            distance: "1.3 km",
            duration: "18 mins",
            instructions:
              "Turn <b>left</b> onto <b>Marylebone Rd</b>/<wbr/><b>A501</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.1 km",
            duration: "2 mins",
            instructions:
              "Turn <b>right</b> onto <b>Park Cres</b>/<wbr/><b>A4201</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.2 km",
            duration: "3 mins",
            instructions:
              "Turn <b>right</b> onto <b>Portland Pl</b>/<wbr/><b>A4201</b>",
            travelMode: "WALKING",
          },
          {
            distance: "33 m",
            duration: "1 min",
            instructions:
              'Turn <b>left</b> onto <b>Weymouth St</b><div style="font-size:0.9em">Destination will be on the right</div>',
            travelMode: "WALKING",
          },
        ],
      },
      bicycling: {
        distances: {},
        path: [
          [-0.17163, 51.52116],
          [-0.17143000000000003, 51.521],
          [-0.17120000000000002, 51.52087],
          [-0.17077, 51.520520000000005],
          [-0.17046, 51.52028000000001],
          [-0.16955, 51.51966],
          [-0.16810000000000003, 51.518660000000004],
          [-0.16721000000000003, 51.518040000000006],
          [-0.16667, 51.51766000000001],
          [-0.16634000000000002, 51.51789],
          [-0.16564, 51.51840000000001],
          [-0.16512000000000002, 51.51877],
          [-0.16489, 51.51885000000001],
          [-0.16455, 51.51888],
          [-0.16429000000000002, 51.51892],
          [-0.16343000000000002, 51.519070000000006],
          [-0.16236, 51.51928],
          [-0.16028, 51.519670000000005],
          [-0.15730000000000002, 51.52019000000001],
          [-0.15537, 51.520540000000004],
          [-0.15495, 51.520610000000005],
          [-0.15479, 51.52062],
          [-0.1547, 51.52062],
          [-0.15466000000000002, 51.520540000000004],
          [-0.15459, 51.520390000000006],
          [-0.15442, 51.520300000000006],
          [-0.15424000000000002, 51.52026000000001],
          [-0.15414, 51.52026000000001],
          [-0.15412, 51.520270000000004],
          [-0.15411000000000002, 51.520270000000004],
          [-0.15407, 51.52026000000001],
          [-0.15406, 51.52024],
          [-0.15407, 51.52024],
          [-0.1537, 51.52019000000001],
          [-0.15362, 51.519740000000006],
          [-0.15342, 51.51975],
          [-0.15298, 51.519780000000004],
          [-0.15274000000000001, 51.519800000000004],
          [-0.15249000000000001, 51.51981000000001],
          [-0.15176, 51.51986],
          [-0.15178000000000003, 51.519980000000004],
          [-0.15105000000000002, 51.520010000000006],
          [-0.15089000000000002, 51.520030000000006],
          [-0.14987, 51.520210000000006],
          [-0.14770000000000003, 51.52058],
          [-0.14495000000000002, 51.521040000000006],
        ],
        steps: [
          {
            distance: "0.5 km",
            duration: "2 mins",
            instructions:
              "Head <b>southeast</b> on <b>Edgware Rd</b>/<wbr/><b>A5</b> toward <b>Newcastle Pl</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.8 km",
            duration: "3 mins",
            instructions:
              'Turn <b>left</b> onto <b>Crawford Pl</b><div style="font-size:0.9em">Entering toll zone</div><div style="font-size:0.9em">Leaving toll zone</div>',
            travelMode: "BICYCLING",
          },
          {
            distance: "0.1 km",
            duration: "1 min",
            instructions:
              'Continue onto <b>Paddington St</b>/<wbr/><b>B524</b><div style="font-size:0.9em">Entering toll zone</div>',
            travelMode: "BICYCLING",
          },
          {
            distance: "28 m",
            duration: "1 min",
            instructions:
              'Turn <b>right</b> toward <b>Moxon St</b><div style="font-size:0.9em">Leaving toll zone</div>',
            travelMode: "BICYCLING",
          },
          {
            distance: "41 m",
            duration: "1 min",
            instructions: "Turn <b>left</b> toward <b>Moxon St</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "4 m",
            duration: "1 min",
            instructions: "Turn <b>right</b> toward <b>Moxon St</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "26 m",
            duration: "1 min",
            instructions: "Turn <b>left</b> toward <b>Moxon St</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "65 m",
            duration: "1 min",
            instructions: "Turn <b>right</b> toward <b>Moxon St</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.1 km",
            duration: "1 min",
            instructions:
              'Continue onto <b>Moxon St</b><div style="font-size:0.9em">Entering toll zone</div>',
            travelMode: "BICYCLING",
          },
          {
            distance: "13 m",
            duration: "1 min",
            instructions:
              "Turn <b>left</b> onto <b>Marylebone High St</b>/<wbr/><b>B524</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.5 km",
            duration: "2 mins",
            instructions:
              'Turn <b>right</b> onto <b>Weymouth St</b><div style="font-size:0.9em">Leaving toll zone</div><div style="font-size:0.9em">Destination will be on the right</div>',
            travelMode: "BICYCLING",
          },
        ],
      },
      transit: {
        distances: {},
        path: [
          [-0.17170000000000002, 51.52112],
          [-0.17154000000000003, 51.521],
          [-0.17139000000000001, 51.521080000000005],
          [-0.17135, 51.521040000000006],
          [-0.17125, 51.520970000000005],
          [-0.17114000000000001, 51.520900000000005],
          [-0.17076000000000002, 51.520590000000006],
          [-0.17047, 51.520390000000006],
          [-0.17022, 51.52024],
          [-0.17025, 51.520230000000005],
          [-0.17031000000000002, 51.520250000000004],
          [-0.17027, 51.52028000000001],
          [-0.16993000000000003, 51.520540000000004],
          [-0.16951000000000002, 51.52084000000001],
          [-0.16902, 51.52111000000001],
          [-0.16837000000000002, 51.521390000000004],
          [-0.16735000000000003, 51.521710000000006],
          [-0.16608, 51.52203],
          [-0.16368000000000002, 51.52237],
          [-0.16274000000000002, 51.522510000000004],
          [-0.16116000000000003, 51.52268],
          [-0.15709, 51.52311],
          [-0.15324000000000002, 51.52355000000001],
          [-0.15105000000000002, 51.52393000000001],
          [-0.14948, 51.52420000000001],
          [-0.14893, 51.524210000000004],
          [-0.14865, 51.52418],
          [-0.14837, 51.52412],
          [-0.14779, 51.52393000000001],
          [-0.14676, 51.52346000000001],
          [-0.14648, 51.523270000000004],
          [-0.14677, 51.52310000000001],
          [-0.14669000000000001, 51.5236],
          [-0.14682, 51.52351],
          [-0.14685, 51.52357000000001],
          [-0.14695000000000003, 51.52355000000001],
          [-0.14699, 51.52355000000001],
          [-0.14723, 51.523520000000005],
          [-0.14759, 51.52346000000001],
          [-0.14772000000000002, 51.52342],
          [-0.14771, 51.523410000000005],
          [-0.14792000000000002, 51.52337000000001],
          [-0.14789000000000002, 51.523320000000005],
          [-0.14776, 51.52318],
          [-0.14768, 51.52311],
          [-0.14747000000000002, 51.523],
          [-0.14722000000000002, 51.52290000000001],
          [-0.14696, 51.522830000000006],
          [-0.14663, 51.522800000000004],
          [-0.14631000000000002, 51.52281000000001],
          [-0.14615, 51.522380000000005],
          [-0.14602, 51.522090000000006],
          [-0.14598, 51.521980000000006],
          [-0.14593, 51.52199],
          [-0.14586000000000002, 51.521820000000005],
          [-0.14549, 51.521010000000004],
          [-0.14553000000000002, 51.520990000000005],
          [-0.14550000000000002, 51.52091000000001],
          [-0.14546, 51.52091000000001],
          [-0.14542000000000002, 51.52082000000001],
          [-0.14531000000000002, 51.520830000000004],
          [-0.14535, 51.52093000000001],
          [-0.14526, 51.52094],
          [-0.14524, 51.520900000000005],
          [-0.14513, 51.520920000000004],
          [-0.14514000000000002, 51.52094],
          [-0.14507, 51.520950000000006],
          [-0.14493, 51.520990000000005],
        ],
        steps: [
          {
            distance: "0.1 km",
            duration: "3 mins",
            instructions: "Walk to Edgware Road",
            travelMode: "WALKING",
          },
          {
            distance: "1.8 km",
            duration: "5 mins",
            instructions: "Subway towards Elephant & Castle",
            travelMode: "TRANSIT",
          },
          {
            distance: "0.5 km",
            duration: "9 mins",
            instructions: "Walk to 60 Portland Pl, Greater, London W1B 1NL, UK",
            travelMode: "WALKING",
          },
        ],
      },
    },
    distances: {
      DRIVING: {
        distance: "2.2 km",
        duration: "9 mins",
      },
      WALKING: {
        distance: "2.2 km",
        duration: "31 mins",
      },
      BICYCLING: {
        distance: "2.2 km",
        duration: "10 mins",
      },
      TRANSIT: {
        distance: "2.2 km",
        duration: "20 mins",
      },
    },
  },
  {
    name: "Francis Holland School",
    category: "Secondary Schools",
    coordinates: {
      lat: 51.49285970969156,
      lng: -0.15379046667602078,
    },
    id: "674d98b2deae072033604647",
    routes: {
      driving: {
        distances: {},
        path: [
          [-0.17163, 51.52116],
          [-0.17143000000000003, 51.521],
          [-0.17120000000000002, 51.52087],
          [-0.17077, 51.520520000000005],
          [-0.17046, 51.52028000000001],
          [-0.16955, 51.51966],
          [-0.16810000000000003, 51.518660000000004],
          [-0.16599000000000003, 51.5172],
          [-0.16319, 51.51529000000001],
          [-0.16155000000000003, 51.51422],
          [-0.1607, 51.513690000000004],
          [-0.16035000000000002, 51.51348],
          [-0.16011, 51.51335],
          [-0.15998, 51.51332000000001],
          [-0.15990000000000001, 51.51332000000001],
          [-0.15987, 51.51324],
          [-0.1597, 51.513250000000006],
          [-0.15942, 51.51328],
          [-0.15901, 51.51334000000001],
          [-0.15873, 51.513360000000006],
          [-0.15856, 51.51334000000001],
          [-0.15841000000000002, 51.51328],
          [-0.15831, 51.513270000000006],
          [-0.15824000000000002, 51.513160000000006],
          [-0.15796000000000002, 51.51274],
          [-0.15769000000000002, 51.51220000000001],
          [-0.15713000000000002, 51.51111],
          [-0.15683000000000002, 51.510580000000004],
          [-0.15663000000000002, 51.510310000000004],
          [-0.15654, 51.510220000000004],
          [-0.15612, 51.509890000000006],
          [-0.15588000000000002, 51.50974],
          [-0.1555, 51.5095],
          [-0.15507, 51.50918000000001],
          [-0.15376, 51.50797000000001],
          [-0.15304, 51.50735],
          [-0.15247000000000002, 51.506840000000004],
          [-0.15196, 51.506400000000006],
          [-0.15156, 51.506060000000005],
          [-0.15119000000000002, 51.50571000000001],
          [-0.15101, 51.505520000000004],
          [-0.15092, 51.50533],
          [-0.15092, 51.5052],
          [-0.1509, 51.504850000000005],
          [-0.15092, 51.50471],
          [-0.15102000000000002, 51.50441000000001],
          [-0.15108000000000002, 51.50415],
          [-0.15104, 51.50388],
          [-0.15089000000000002, 51.503440000000005],
          [-0.15083000000000002, 51.50336],
          [-0.15079, 51.503330000000005],
          [-0.15071, 51.5033],
          [-0.15045, 51.50332],
          [-0.15014000000000002, 51.50332],
          [-0.15005000000000002, 51.503310000000006],
          [-0.14995, 51.503260000000004],
          [-0.14987, 51.50321],
          [-0.14981, 51.50316],
          [-0.14976, 51.503060000000005],
          [-0.14977000000000001, 51.50292],
          [-0.14980000000000002, 51.502700000000004],
          [-0.14989000000000002, 51.502570000000006],
          [-0.14995, 51.50247],
          [-0.15007, 51.50242],
          [-0.1502, 51.502370000000006],
          [-0.1506, 51.50222],
          [-0.1511, 51.502030000000005],
          [-0.15122000000000002, 51.50204],
          [-0.15135, 51.501990000000006],
          [-0.15149, 51.50197000000001],
          [-0.15175000000000002, 51.502],
          [-0.15198, 51.502210000000005],
          [-0.15227000000000002, 51.50208000000001],
          [-0.15272000000000002, 51.50184],
          [-0.15295, 51.50170000000001],
          [-0.15315, 51.50151],
          [-0.15330000000000002, 51.50132000000001],
          [-0.15341000000000002, 51.50113],
          [-0.15348, 51.50094000000001],
          [-0.15345, 51.500840000000004],
          [-0.15345, 51.50066],
          [-0.15344000000000002, 51.50047000000001],
          [-0.1534, 51.50034],
          [-0.15326, 51.500240000000005],
          [-0.15304, 51.500040000000006],
          [-0.15271, 51.49982000000001],
          [-0.15235, 51.49958],
          [-0.15209, 51.49947],
          [-0.15198, 51.499390000000005],
          [-0.15185, 51.499300000000005],
          [-0.15181, 51.4992],
          [-0.15181, 51.499080000000006],
          [-0.15172000000000002, 51.499],
          [-0.15011000000000002, 51.497960000000006],
          [-0.14974, 51.497710000000005],
          [-0.14947000000000002, 51.49754],
          [-0.14924, 51.49739],
          [-0.14986000000000002, 51.49701],
          [-0.15057, 51.49656],
          [-0.15061000000000002, 51.49649],
          [-0.15091000000000002, 51.496300000000005],
          [-0.15102000000000002, 51.496280000000006],
          [-0.15142, 51.496030000000005],
          [-0.15316000000000002, 51.49497],
          [-0.15469000000000002, 51.493990000000004],
          [-0.15494000000000002, 51.49382000000001],
          [-0.15475000000000003, 51.49371000000001],
          [-0.15439, 51.49351000000001],
          [-0.15368, 51.493120000000005],
          [-0.15353, 51.493030000000005],
          [-0.15336000000000002, 51.492940000000004],
          [-0.15345, 51.49288000000001],
          [-0.15361000000000002, 51.492760000000004],
        ],
        steps: [
          {
            distance: "1.2 km",
            duration: "5 mins",
            instructions:
              "Head <b>southeast</b> on <b>Edgware Rd</b>/<wbr/><b>A5</b> toward <b>Newcastle Pl</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "69 m",
            duration: "1 min",
            instructions: "Keep <b>right</b> to continue on <b>Marble Arch</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "60 m",
            duration: "1 min",
            instructions: "Keep <b>right</b> to stay on <b>Marble Arch</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "1.3 km",
            duration: "3 mins",
            instructions: "Continue onto <b>Park Ln</b>/<wbr/><b>A4202</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "46 m",
            duration: "1 min",
            instructions: "Turn <b>left</b> onto <b>Piccadilly</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "0.2 km",
            duration: "1 min",
            instructions: "Turn <b>right</b> onto <b>Duke of Wellington Pl</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "28 m",
            duration: "1 min",
            instructions: "Turn <b>right</b> onto <b>Grosvenor Pl</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "0.4 km",
            duration: "1 min",
            instructions:
              'Turn <b>left</b> onto <b>Grosvenor Cres</b>/<wbr/><b>B310</b><div style="font-size:0.9em">Continue to follow B310</div>',
            travelMode: "DRIVING",
          },
          {
            distance: "67 m",
            duration: "1 min",
            instructions:
              "Slight <b>left</b> onto <b>Belgrave Square</b>/<wbr/><b>B310</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "0.3 km",
            duration: "1 min",
            instructions: "Slight <b>left</b> onto <b>Upper Belgrave St</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "0.6 km",
            duration: "2 mins",
            instructions:
              'Turn <b>right</b> onto <b>Eaton Square</b>/<wbr/><b>A3217</b><div style="font-size:0.9em">Continue to follow A3217</div>',
            travelMode: "DRIVING",
          },
          {
            distance: "0.1 km",
            duration: "1 min",
            instructions: "Turn <b>left</b> onto <b>Eaton Terrace</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "26 m",
            duration: "1 min",
            instructions:
              'Turn <b>right</b> onto <b>Chester Row</b><div style="font-size:0.9em">Destination will be on the right</div>',
            travelMode: "DRIVING",
          },
        ],
      },
      walking: {
        distances: {},
        path: [
          [-0.17170000000000002, 51.52112],
          [-0.17154000000000003, 51.521],
          [-0.17139000000000001, 51.521080000000005],
          [-0.17135, 51.521040000000006],
          [-0.17125, 51.520970000000005],
          [-0.17114000000000001, 51.520900000000005],
          [-0.17076000000000002, 51.520590000000006],
          [-0.17047, 51.520390000000006],
          [-0.17022, 51.52024],
          [-0.17011, 51.52013],
          [-0.16999, 51.520050000000005],
          [-0.17001000000000002, 51.520050000000005],
          [-0.16978000000000001, 51.519890000000004],
          [-0.16951000000000002, 51.51973],
          [-0.16907000000000003, 51.519420000000004],
          [-0.169, 51.51935],
          [-0.16897, 51.519360000000006],
          [-0.16890000000000002, 51.5193],
          [-0.16892000000000001, 51.5193],
          [-0.16870000000000002, 51.51915],
          [-0.16849, 51.518980000000006],
          [-0.16757000000000002, 51.51834],
          [-0.16742, 51.51825],
          [-0.16741, 51.518260000000005],
          [-0.16726000000000002, 51.518170000000005],
          [-0.16723000000000002, 51.51814],
          [-0.16742, 51.51802000000001],
          [-0.16741, 51.518010000000004],
          [-0.16744, 51.517970000000005],
          [-0.16719, 51.51785],
          [-0.16712000000000002, 51.517700000000005],
          [-0.16699000000000003, 51.517610000000005],
          [-0.16684000000000002, 51.517540000000004],
          [-0.16637000000000002, 51.5172],
          [-0.16620000000000001, 51.51708000000001],
          [-0.16602, 51.517030000000005],
          [-0.1658, 51.51688000000001],
          [-0.16582000000000002, 51.516870000000004],
          [-0.16579000000000002, 51.516850000000005],
          [-0.16573000000000002, 51.51681000000001],
          [-0.16567, 51.51684],
          [-0.16551000000000002, 51.51671],
          [-0.16509000000000001, 51.51643000000001],
          [-0.16407000000000002, 51.51574],
          [-0.16379000000000002, 51.515550000000005],
          [-0.16349000000000002, 51.515350000000005],
          [-0.16307000000000002, 51.515060000000005],
          [-0.16310000000000002, 51.51505],
          [-0.16308, 51.515040000000006],
          [-0.16295, 51.514950000000006],
          [-0.163, 51.51494],
          [-0.16336, 51.514880000000005],
          [-0.16371000000000002, 51.51482000000001],
          [-0.16357000000000002, 51.5146],
          [-0.16331, 51.514190000000006],
          [-0.16329000000000002, 51.514100000000006],
          [-0.16323000000000001, 51.51402],
          [-0.16317, 51.51390000000001],
          [-0.16331, 51.51389],
          [-0.16331, 51.513870000000004],
          [-0.16316, 51.51368],
          [-0.16314, 51.51362],
          [-0.16305, 51.51348],
          [-0.16297, 51.51341000000001],
          [-0.16284, 51.51321],
          [-0.16274000000000002, 51.513110000000005],
          [-0.16272, 51.51308],
          [-0.1628, 51.51308],
          [-0.16281, 51.513040000000004],
          [-0.16279000000000002, 51.5129],
          [-0.16271000000000002, 51.5129],
          [-0.1627, 51.51281],
          [-0.16254000000000002, 51.51245],
          [-0.16247, 51.51232],
          [-0.16251000000000002, 51.51234],
          [-0.16238000000000002, 51.51216],
          [-0.16221000000000002, 51.51167],
          [-0.16201000000000002, 51.511210000000005],
          [-0.16137, 51.50972],
          [-0.16122, 51.509370000000004],
          [-0.16128, 51.509150000000005],
          [-0.16127000000000002, 51.509150000000005],
          [-0.16126000000000001, 51.50914],
          [-0.16125, 51.509100000000004],
          [-0.16126000000000001, 51.50909000000001],
          [-0.16132000000000002, 51.509060000000005],
          [-0.16135000000000002, 51.509060000000005],
          [-0.16137, 51.50907],
          [-0.16138000000000002, 51.50907],
          [-0.16193000000000002, 51.50835000000001],
          [-0.16207000000000002, 51.50824],
          [-0.16218000000000002, 51.508210000000005],
          [-0.16226000000000002, 51.508160000000004],
          [-0.16232000000000002, 51.508100000000006],
          [-0.16235000000000002, 51.50802],
          [-0.16235000000000002, 51.50795],
          [-0.16235000000000002, 51.507920000000006],
          [-0.16244, 51.507920000000006],
          [-0.16266000000000003, 51.507810000000006],
          [-0.16335000000000002, 51.50751],
          [-0.16119, 51.50623],
          [-0.15987, 51.50547],
          [-0.15972, 51.505370000000006],
          [-0.15949000000000002, 51.505320000000005],
          [-0.15949000000000002, 51.50517000000001],
          [-0.15940000000000001, 51.505010000000006],
          [-0.15922, 51.504740000000005],
          [-0.15916000000000002, 51.504650000000005],
          [-0.15901, 51.50415],
          [-0.1589, 51.503800000000005],
          [-0.15882000000000002, 51.503490000000006],
          [-0.15869000000000003, 51.50287],
          [-0.15867, 51.50285],
          [-0.15862, 51.50285],
          [-0.15854000000000001, 51.50285],
          [-0.15852000000000002, 51.502720000000004],
          [-0.15851, 51.50262000000001],
          [-0.1584, 51.502520000000004],
          [-0.15837, 51.502340000000004],
          [-0.15834, 51.502340000000004],
          [-0.15833000000000003, 51.502320000000005],
          [-0.15832000000000002, 51.50215000000001],
          [-0.15838000000000002, 51.502140000000004],
          [-0.15838000000000002, 51.502030000000005],
          [-0.1584, 51.50189],
          [-0.15845, 51.501810000000006],
          [-0.15848, 51.50146],
          [-0.15835000000000002, 51.50146],
          [-0.15834, 51.501400000000004],
          [-0.1584, 51.50139],
          [-0.15838000000000002, 51.50137],
          [-0.15832000000000002, 51.50119],
          [-0.15823, 51.50083000000001],
          [-0.15809, 51.50029000000001],
          [-0.15788000000000002, 51.49953000000001],
          [-0.15789, 51.499430000000004],
          [-0.15776, 51.499030000000005],
          [-0.15794000000000002, 51.49895],
          [-0.15763000000000002, 51.498740000000005],
          [-0.15742, 51.4986],
          [-0.15630000000000002, 51.49788],
          [-0.15618, 51.49774000000001],
          [-0.15610000000000002, 51.497580000000006],
          [-0.15607000000000001, 51.49741],
          [-0.15602000000000002, 51.49712],
          [-0.15594000000000002, 51.49676],
          [-0.15589, 51.496390000000005],
          [-0.15571000000000002, 51.495470000000005],
          [-0.15567, 51.495340000000006],
          [-0.15560000000000002, 51.49528],
          [-0.1554, 51.495160000000006],
          [-0.15525, 51.495020000000004],
          [-0.15512, 51.49488],
          [-0.15497000000000002, 51.49481],
          [-0.15445, 51.494460000000004],
          [-0.15430000000000002, 51.49437],
          [-0.15432, 51.49436000000001],
          [-0.15428, 51.49434],
          [-0.15410000000000001, 51.494240000000005],
          [-0.15405000000000002, 51.49427000000001],
          [-0.1537, 51.49403],
          [-0.15348, 51.49389000000001],
          [-0.15316000000000002, 51.49367],
          [-0.15286000000000002, 51.493480000000005],
          [-0.15276, 51.49342000000001],
          [-0.15288000000000002, 51.49334],
          [-0.15299000000000001, 51.49325],
          [-0.15326, 51.49307],
          [-0.15362, 51.49284],
          [-0.15367, 51.49279000000001],
        ],
        steps: [
          {
            distance: "0.4 km",
            duration: "6 mins",
            instructions:
              "Head <b>southeast</b> on <b>Edgware Rd</b>/<wbr/><b>A5</b> toward <b>Newcastle Pl</b>",
            travelMode: "WALKING",
          },
          {
            distance: "30 m",
            duration: "1 min",
            instructions:
              "Turn <b>right</b> onto <b>Sussex Gardens</b>/<wbr/><b>A4209</b>",
            travelMode: "WALKING",
          },
          {
            distance: "52 m",
            duration: "1 min",
            instructions:
              "Sharp <b>left</b> toward <b>Edgware Rd</b>/<wbr/><b>A5</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.4 km",
            duration: "6 mins",
            instructions: "Continue onto <b>Edgware Rd</b>/<wbr/><b>A5</b>",
            travelMode: "WALKING",
          },
          {
            distance: "65 m",
            duration: "1 min",
            instructions:
              'Turn <b>right</b> onto <b>Connaught St</b>/<wbr/><b>Upper Berkeley St</b><div style="font-size:0.9em">Continue to follow Connaught St</div>',
            travelMode: "WALKING",
          },
          {
            distance: "0.1 km",
            duration: "1 min",
            instructions: "Turn <b>left</b> onto <b>Connaught Square</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.5 km",
            duration: "7 mins",
            instructions: "Continue onto <b>Stanhope Pl</b>",
            travelMode: "WALKING",
          },
          {
            distance: "25 m",
            duration: "1 min",
            instructions: "Continue onto <b>Nicholas Hemingway Walk</b>",
            travelMode: "WALKING",
          },
          {
            distance: "18 m",
            duration: "1 min",
            instructions: "Slight <b>left</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.1 km",
            duration: "2 mins",
            instructions: "Turn <b>left</b>",
            travelMode: "WALKING",
          },
          {
            distance: "85 m",
            duration: "1 min",
            instructions: "Turn <b>right</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.4 km",
            duration: "5 mins",
            instructions: "Turn <b>left</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.3 km",
            duration: "4 mins",
            instructions: "Turn <b>right</b>",
            travelMode: "WALKING",
          },
          {
            distance: "65 m",
            duration: "1 min",
            instructions: "Turn <b>right</b> onto <b>Albert Gate</b>",
            travelMode: "WALKING",
          },
          {
            distance: "9 m",
            duration: "1 min",
            instructions:
              "Turn <b>left</b> onto <b>Knightsbridge</b>/<wbr/><b>A4</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.1 km",
            duration: "2 mins",
            instructions: "Turn <b>right</b> onto <b>William St</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.3 km",
            duration: "4 mins",
            instructions: "Continue onto <b>Lowndes Square</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.2 km",
            duration: "2 mins",
            instructions:
              "<b>Lowndes Square</b> turns slightly <b>left</b> and becomes <b>Lowndes St</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.3 km",
            duration: "4 mins",
            instructions: "Continue onto <b>Chesham Pl</b>",
            travelMode: "WALKING",
          },
          {
            distance: "87 m",
            duration: "1 min",
            instructions: "Continue straight onto <b>Eaton Pl</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.1 km",
            duration: "2 mins",
            instructions: "Continue onto <b>Eaton Square</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.1 km",
            duration: "1 min",
            instructions: "Continue onto <b>S Eaton Pl</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.1 km",
            duration: "1 min",
            instructions:
              'Turn <b>right</b> onto <b>Chester Row</b><div style="font-size:0.9em">Destination will be on the right</div>',
            travelMode: "WALKING",
          },
        ],
      },
      bicycling: {
        distances: {},
        path: [
          [-0.17163, 51.52116],
          [-0.17143000000000003, 51.521],
          [-0.17120000000000002, 51.52087],
          [-0.17077, 51.520520000000005],
          [-0.17046, 51.52028000000001],
          [-0.16955, 51.51966],
          [-0.16810000000000003, 51.518660000000004],
          [-0.16599000000000003, 51.5172],
          [-0.16319, 51.51529000000001],
          [-0.1628, 51.51503],
          [-0.16310000000000002, 51.51498],
          [-0.16382000000000002, 51.514860000000006],
          [-0.16322, 51.513940000000005],
          [-0.16317, 51.51381000000001],
          [-0.16295, 51.513470000000005],
          [-0.16273, 51.51314000000001],
          [-0.16269, 51.51306],
          [-0.16271000000000002, 51.5129],
          [-0.1627, 51.51281],
          [-0.16262000000000001, 51.512640000000005],
          [-0.16254000000000002, 51.51245],
          [-0.16244, 51.512260000000005],
          [-0.16238000000000002, 51.51216],
          [-0.16215000000000002, 51.512100000000004],
          [-0.16204000000000002, 51.51209000000001],
          [-0.16182000000000002, 51.51209000000001],
          [-0.16125, 51.51209000000001],
          [-0.16083, 51.512060000000005],
          [-0.16048, 51.51198],
          [-0.15996000000000002, 51.5118],
          [-0.1592, 51.511480000000006],
          [-0.15879000000000001, 51.511280000000006],
          [-0.15858000000000003, 51.51115000000001],
          [-0.15839, 51.51102],
          [-0.15826, 51.5108],
          [-0.15789, 51.50996000000001],
          [-0.15766000000000002, 51.509600000000006],
          [-0.15718000000000001, 51.509040000000006],
          [-0.15636, 51.50806000000001],
          [-0.15581, 51.50746],
          [-0.15493, 51.506420000000006],
          [-0.15381, 51.50508000000001],
          [-0.15335000000000001, 51.504540000000006],
          [-0.15319000000000002, 51.504360000000005],
          [-0.15317, 51.504310000000004],
          [-0.15312, 51.50421000000001],
          [-0.1531, 51.504110000000004],
          [-0.1531, 51.50403000000001],
          [-0.15261000000000002, 51.50392],
          [-0.1526, 51.50379],
          [-0.15264000000000003, 51.5037],
          [-0.15265, 51.50365000000001],
          [-0.15276, 51.50354],
          [-0.15284, 51.50347000000001],
          [-0.15298, 51.50338000000001],
          [-0.1531, 51.503330000000005],
          [-0.1534, 51.50325],
          [-0.15389, 51.50318000000001],
          [-0.15486000000000003, 51.50309000000001],
          [-0.15769000000000002, 51.50283],
          [-0.15852000000000002, 51.502750000000006],
          [-0.15847, 51.502410000000005],
          [-0.15846000000000002, 51.50226000000001],
          [-0.15833000000000003, 51.502280000000006],
          [-0.15832000000000002, 51.502210000000005],
          [-0.15838000000000002, 51.502140000000004],
          [-0.15838000000000002, 51.50208000000001],
          [-0.15839, 51.501960000000004],
          [-0.15845, 51.501810000000006],
          [-0.15849000000000002, 51.501430000000006],
          [-0.15844000000000003, 51.501270000000005],
          [-0.15828, 51.500640000000004],
          [-0.15815, 51.5001],
          [-0.15798, 51.49953000000001],
          [-0.15799000000000002, 51.49944000000001],
          [-0.15785000000000002, 51.499],
          [-0.15754, 51.498780000000004],
          [-0.15623, 51.497910000000005],
          [-0.15607000000000001, 51.49776000000001],
          [-0.15599000000000002, 51.497640000000004],
          [-0.15594000000000002, 51.49738000000001],
          [-0.15589, 51.497130000000006],
          [-0.15584, 51.496880000000004],
          [-0.15582000000000001, 51.496770000000005],
          [-0.1557, 51.49671000000001],
          [-0.15555000000000002, 51.49663],
          [-0.15531, 51.496480000000005],
          [-0.15477000000000002, 51.49615000000001],
          [-0.15303, 51.49504],
          [-0.15207, 51.494420000000005],
          [-0.15171, 51.494200000000006],
          [-0.15161000000000002, 51.494130000000006],
          [-0.15191000000000002, 51.49392],
          [-0.15213000000000002, 51.49378],
          [-0.15266000000000002, 51.49342000000001],
          [-0.15336000000000002, 51.492940000000004],
          [-0.15361000000000002, 51.492760000000004],
        ],
        steps: [
          {
            distance: "0.9 km",
            duration: "3 mins",
            instructions:
              "Head <b>southeast</b> on <b>Edgware Rd</b>/<wbr/><b>A5</b> toward <b>Newcastle Pl</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "73 m",
            duration: "1 min",
            instructions:
              'Turn <b>right</b> onto <b>Connaught St</b>/<wbr/><b>Upper Berkeley St</b><div style="font-size:0.9em">Continue to follow Connaught St</div>',
            travelMode: "BICYCLING",
          },
          {
            distance: "0.1 km",
            duration: "1 min",
            instructions: "Turn <b>left</b> onto <b>Connaught Square</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.2 km",
            duration: "1 min",
            instructions: "Continue onto <b>Stanhope Pl</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "1.2 km",
            duration: "3 mins",
            instructions: "Turn <b>left</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "36 m",
            duration: "1 min",
            instructions: "Turn <b>left</b> toward <b>S Carriage Dr</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.5 km",
            duration: "1 min",
            instructions: "Turn <b>right</b> onto <b>S Carriage Dr</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "55 m",
            duration: "1 min",
            instructions: "Turn <b>left</b> onto <b>Albert Gate</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "9 m",
            duration: "1 min",
            instructions:
              "Turn <b>left</b> onto <b>Knightsbridge</b>/<wbr/><b>A4</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.1 km",
            duration: "1 min",
            instructions: "Turn <b>right</b> onto <b>William St</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.3 km",
            duration: "1 min",
            instructions: "Continue onto <b>Lowndes Square</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.2 km",
            duration: "1 min",
            instructions:
              "<b>Lowndes Square</b> turns slightly <b>left</b> and becomes <b>Lowndes St</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.1 km",
            duration: "1 min",
            instructions: "Keep <b>right</b> to continue on <b>Chesham Pl</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.3 km",
            duration: "1 min",
            instructions:
              "<b>Chesham Pl</b> turns slightly <b>left</b> and becomes <b>Lyall St</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.1 km",
            duration: "1 min",
            instructions: "Continue onto <b>Elizabeth St</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.2 km",
            duration: "1 min",
            instructions:
              'Turn <b>right</b> onto <b>Chester Row</b><div style="font-size:0.9em">Destination will be on the right</div>',
            travelMode: "BICYCLING",
          },
        ],
      },
      transit: {
        distances: {},
        path: [
          [-0.17170000000000002, 51.52112],
          [-0.17154000000000003, 51.521],
          [-0.17139000000000001, 51.521080000000005],
          [-0.17135, 51.521040000000006],
          [-0.17125, 51.520970000000005],
          [-0.17114000000000001, 51.520900000000005],
          [-0.17076000000000002, 51.520590000000006],
          [-0.17047, 51.520390000000006],
          [-0.17022, 51.52024],
          [-0.17011, 51.52013],
          [-0.16999, 51.520050000000005],
          [-0.17001000000000002, 51.520050000000005],
          [-0.16978000000000001, 51.519890000000004],
          [-0.16968000000000003, 51.519830000000006],
          [-0.16951000000000002, 51.51986],
          [-0.16902, 51.51993],
          [-0.16869, 51.51997],
          [-0.1685, 51.520010000000006],
          [-0.16839, 51.51988000000001],
          [-0.16812000000000002, 51.51957],
          [-0.16799, 51.519670000000005],
          [-0.167, 51.52015],
          [-0.16705, 51.52019000000001],
          [-0.16760000000000003, 51.51999000000001],
          [-0.16812000000000002, 51.51977],
          [-0.16873000000000002, 51.519470000000005],
          [-0.17022, 51.51859],
          [-0.1726, 51.51727],
          [-0.17374, 51.51662],
          [-0.17555, 51.51558000000001],
          [-0.17768, 51.51436],
          [-0.17921, 51.51353],
          [-0.18014000000000002, 51.51317],
          [-0.18087, 51.512980000000006],
          [-0.18185, 51.51279],
          [-0.18276, 51.51265],
          [-0.1832, 51.512600000000006],
          [-0.1839, 51.512550000000005],
          [-0.18509, 51.51249000000001],
          [-0.18687, 51.51239],
          [-0.18887, 51.51225],
          [-0.19010000000000002, 51.51214],
          [-0.19102000000000002, 51.51202000000001],
          [-0.19233000000000003, 51.511790000000005],
          [-0.1937, 51.51145],
          [-0.1947, 51.51113],
          [-0.19504000000000002, 51.51098],
          [-0.19519, 51.51088000000001],
          [-0.19541000000000003, 51.51068],
          [-0.19559, 51.510470000000005],
          [-0.19576000000000002, 51.51021],
          [-0.19590000000000002, 51.50992],
          [-0.19598000000000002, 51.50965000000001],
          [-0.19605000000000003, 51.50932],
          [-0.19606, 51.509130000000006],
          [-0.19603, 51.50887],
          [-0.19598000000000002, 51.508680000000005],
          [-0.19589, 51.508390000000006],
          [-0.19515000000000002, 51.5063],
          [-0.19435000000000002, 51.50403000000001],
          [-0.19386, 51.50253000000001],
          [-0.19378, 51.50238],
          [-0.19309, 51.50151],
          [-0.19267, 51.501000000000005],
          [-0.19209, 51.500400000000006],
          [-0.19098, 51.49933000000001],
          [-0.19068000000000002, 51.499100000000006],
          [-0.18978, 51.49857],
          [-0.18960000000000002, 51.498450000000005],
          [-0.18945, 51.49832000000001],
          [-0.18851, 51.497260000000004],
          [-0.18819000000000002, 51.49689000000001],
          [-0.18741000000000002, 51.49604],
          [-0.18714000000000003, 51.495810000000006],
          [-0.18678, 51.49559000000001],
          [-0.18645, 51.49541000000001],
          [-0.18581, 51.49515],
          [-0.18536000000000002, 51.49503000000001],
          [-0.18315, 51.49457],
          [-0.18199, 51.49434],
          [-0.18141000000000002, 51.494260000000004],
          [-0.18059000000000003, 51.49419],
          [-0.17975000000000002, 51.494150000000005],
          [-0.17853000000000002, 51.49416],
          [-0.17499, 51.494200000000006],
          [-0.17356000000000002, 51.494170000000004],
          [-0.17099, 51.49409000000001],
          [-0.16999, 51.494060000000005],
          [-0.1685, 51.49398000000001],
          [-0.16379000000000002, 51.49381],
          [-0.16282000000000002, 51.493770000000005],
          [-0.16213000000000002, 51.49371000000001],
          [-0.16152000000000002, 51.49363],
          [-0.16089, 51.493520000000004],
          [-0.15972, 51.49325],
          [-0.15838000000000002, 51.49286000000001],
          [-0.15652000000000002, 51.492360000000005],
          [-0.15616000000000002, 51.492270000000005],
          [-0.15612, 51.492340000000006],
          [-0.15653, 51.49235],
          [-0.15651, 51.492360000000005],
          [-0.15665, 51.49235],
          [-0.15664, 51.49232000000001],
          [-0.15633000000000002, 51.492200000000004],
          [-0.15613000000000002, 51.49215],
          [-0.15601, 51.49210000000001],
          [-0.15587, 51.491980000000005],
          [-0.15573, 51.491530000000004],
          [-0.15549000000000002, 51.49166],
          [-0.15534, 51.491690000000006],
          [-0.15514, 51.49179],
          [-0.15511000000000003, 51.49186],
          [-0.15480000000000002, 51.492020000000004],
          [-0.15482, 51.492000000000004],
          [-0.15472000000000002, 51.492050000000006],
          [-0.15461000000000003, 51.492140000000006],
          [-0.15417, 51.492450000000005],
          [-0.15367, 51.49279000000001],
        ],
        steps: [
          {
            distance: "0.4 km",
            duration: "7 mins",
            instructions: "Walk to Edgware Road",
            travelMode: "WALKING",
          },
          {
            distance: "6.4 km",
            duration: "14 mins",
            instructions: "Subway towards Hammersmith",
            travelMode: "TRANSIT",
          },
          {
            distance: "0.4 km",
            duration: "6 mins",
            instructions: "Walk to 34 Chester Row, London SW1W 8JP, UK",
            travelMode: "WALKING",
          },
        ],
      },
    },
    distances: {
      DRIVING: {
        distance: "4.3 km",
        duration: "14 mins",
      },
      WALKING: {
        distance: "3.9 km",
        duration: "53 mins",
      },
      BICYCLING: {
        distance: "4.3 km",
        duration: "16 mins",
      },
      TRANSIT: {
        distance: "7.2 km",
        duration: "27 mins",
      },
    },
  },
  {
    name: "Abercorn School",
    category: "Primary Schools",
    coordinates: {
      lat: 51.53290327486927,
      lng: -0.17967732857597382,
    },
    id: "674d98c9deae072033604648",
    routes: {
      driving: {
        distances: {},
        path: [
          [-0.17163, 51.52116],
          [-0.17204000000000003, 51.52145],
          [-0.17247, 51.52174],
          [-0.17257, 51.521750000000004],
          [-0.17300000000000001, 51.52201],
          [-0.17305, 51.522090000000006],
          [-0.17321, 51.522200000000005],
          [-0.17347, 51.522380000000005],
          [-0.17413, 51.52284],
          [-0.17479, 51.523300000000006],
          [-0.17569, 51.523920000000004],
          [-0.17658000000000001, 51.524480000000004],
          [-0.17673000000000003, 51.52452],
          [-0.1769, 51.524640000000005],
          [-0.17703000000000002, 51.524730000000005],
          [-0.17708000000000002, 51.52483],
          [-0.17732, 51.525020000000005],
          [-0.17777, 51.52539],
          [-0.17802, 51.52562],
          [-0.17819000000000002, 51.52579000000001],
          [-0.17804, 51.525800000000004],
          [-0.17773000000000003, 51.525940000000006],
          [-0.17723000000000003, 51.52617000000001],
          [-0.17652, 51.526520000000005],
          [-0.17916, 51.52875],
          [-0.18151, 51.53072],
          [-0.18226, 51.53135],
          [-0.18236000000000002, 51.53144],
          [-0.18245, 51.53144],
          [-0.18258000000000002, 51.531530000000004],
          [-0.18261000000000002, 51.531600000000005],
          [-0.18251, 51.531650000000006],
          [-0.18236000000000002, 51.531690000000005],
          [-0.1821, 51.531800000000004],
          [-0.1816, 51.532050000000005],
          [-0.18089000000000002, 51.5324],
          [-0.17975000000000002, 51.53296],
        ],
        steps: [
          {
            distance: "0.7 km",
            duration: "3 mins",
            instructions:
              'Head <b>northwest</b> on <b>Edgware Rd</b>/<wbr/><b>A5</b> toward <b>Broadley St</b><div style="font-size:0.9em">Continue to follow A5</div>',
            travelMode: "DRIVING",
          },
          {
            distance: "0.1 km",
            duration: "1 min",
            instructions:
              "Turn <b>right</b> onto <b>St John's Wood Rd</b>/<wbr/><b>A5205</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "0.7 km",
            duration: "2 mins",
            instructions: "Turn <b>left</b> onto <b>Hamilton Terrace</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "0.3 km",
            duration: "1 min",
            instructions:
              'Turn <b>right</b> onto <b>Abercorn Pl</b><div style="font-size:0.9em">Destination will be on the right</div>',
            travelMode: "DRIVING",
          },
        ],
      },
      walking: {
        distances: {},
        path: [
          [-0.17170000000000002, 51.52112],
          [-0.17187000000000002, 51.52122000000001],
          [-0.17211, 51.521390000000004],
          [-0.17256000000000002, 51.52169000000001],
          [-0.17270000000000002, 51.52178000000001],
          [-0.17272, 51.52176000000001],
          [-0.17284000000000002, 51.52183],
          [-0.17285, 51.52185000000001],
          [-0.17304000000000003, 51.52197],
          [-0.17329000000000003, 51.5221],
          [-0.17349, 51.52226],
          [-0.17384000000000002, 51.522490000000005],
          [-0.17393, 51.52261000000001],
          [-0.17405, 51.52266],
          [-0.17427, 51.52282],
          [-0.17441, 51.522920000000006],
          [-0.17493, 51.52329],
          [-0.17567000000000002, 51.523810000000005],
          [-0.17617000000000002, 51.52414],
          [-0.17639000000000002, 51.52425],
          [-0.17666, 51.52443],
          [-0.17685, 51.52454],
          [-0.17692000000000002, 51.52459],
          [-0.17697000000000002, 51.52463],
          [-0.17700000000000002, 51.52461],
          [-0.1771, 51.52469000000001],
          [-0.17708000000000002, 51.5247],
          [-0.17709000000000003, 51.52474],
          [-0.17757, 51.52514000000001],
          [-0.17771, 51.525330000000004],
          [-0.17793, 51.525400000000005],
          [-0.17804, 51.525490000000005],
          [-0.17836000000000002, 51.525800000000004],
          [-0.17814000000000002, 51.52590000000001],
          [-0.1781, 51.525870000000005],
          [-0.17800000000000002, 51.525920000000006],
          [-0.17770000000000002, 51.526030000000006],
          [-0.1774, 51.52617000000001],
          [-0.17728000000000002, 51.52628000000001],
          [-0.17709000000000003, 51.526320000000005],
          [-0.17678000000000002, 51.52647],
          [-0.17669, 51.52651],
          [-0.17673000000000003, 51.52655000000001],
          [-0.17651000000000003, 51.526650000000004],
          [-0.17663, 51.52678],
          [-0.17695000000000002, 51.52705],
          [-0.17742000000000002, 51.52745],
          [-0.17908000000000002, 51.528850000000006],
          [-0.17929, 51.52902],
          [-0.17947000000000002, 51.529180000000004],
          [-0.17946, 51.529180000000004],
          [-0.17957, 51.52928000000001],
          [-0.1796, 51.529300000000006],
          [-0.17962, 51.52929],
          [-0.17977, 51.52942],
          [-0.17983000000000002, 51.52948000000001],
          [-0.17996, 51.529560000000004],
          [-0.1809, 51.530350000000006],
          [-0.18128000000000002, 51.530680000000004],
          [-0.18201, 51.531290000000006],
          [-0.18227000000000002, 51.531510000000004],
          [-0.18236000000000002, 51.531600000000005],
          [-0.18214000000000002, 51.5317],
          [-0.18157, 51.531980000000004],
          [-0.18104, 51.53224],
          [-0.17968, 51.532900000000005],
        ],
        steps: [
          {
            distance: "87 m",
            duration: "1 min",
            instructions:
              "Head <b>northwest</b> on <b>Edgware Rd</b>/<wbr/><b>A5</b> toward <b>Broadley St</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.6 km",
            duration: "8 mins",
            instructions:
              'Slight <b>left</b> to stay on <b>Edgware Rd</b>/<wbr/><b>A5</b><div style="font-size:0.9em">Continue to follow A5</div>',
            travelMode: "WALKING",
          },
          {
            distance: "0.1 km",
            duration: "2 mins",
            instructions:
              "Turn <b>right</b> onto <b>St John's Wood Rd</b>/<wbr/><b>A5205</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.7 km",
            duration: "9 mins",
            instructions: "Turn <b>left</b> onto <b>Hamilton Terrace</b>",
            travelMode: "WALKING",
          },
          {
            distance: "19 m",
            duration: "1 min",
            instructions:
              "Slight <b>right</b> to stay on <b>Hamilton Terrace</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.2 km",
            duration: "3 mins",
            instructions:
              'Turn <b>right</b> onto <b>Abercorn Pl</b><div style="font-size:0.9em">Destination will be on the right</div>',
            travelMode: "WALKING",
          },
        ],
      },
      bicycling: {
        distances: {},
        path: [
          [-0.17163, 51.52116],
          [-0.17204000000000003, 51.52145],
          [-0.17247, 51.52174],
          [-0.17257, 51.521750000000004],
          [-0.17300000000000001, 51.52201],
          [-0.17305, 51.522090000000006],
          [-0.17321, 51.522200000000005],
          [-0.17347, 51.522380000000005],
          [-0.17413, 51.52284],
          [-0.17479, 51.523300000000006],
          [-0.17522000000000001, 51.523590000000006],
          [-0.1751, 51.52367],
          [-0.17467000000000002, 51.52393000000001],
          [-0.17464000000000002, 51.52396],
          [-0.17471, 51.524010000000004],
          [-0.17492000000000002, 51.524150000000006],
          [-0.17549, 51.524530000000006],
          [-0.17600000000000002, 51.524910000000006],
          [-0.17609000000000002, 51.524980000000006],
          [-0.1761, 51.525000000000006],
          [-0.17606000000000002, 51.52503],
          [-0.17589000000000002, 51.525130000000004],
          [-0.17624, 51.52541],
          [-0.17700000000000002, 51.52604],
          [-0.17713, 51.526120000000006],
          [-0.17723000000000003, 51.52617000000001],
          [-0.17697000000000002, 51.526300000000006],
          [-0.17652, 51.526520000000005],
          [-0.17672000000000002, 51.52669],
          [-0.17751, 51.527350000000006],
          [-0.17966000000000001, 51.529180000000004],
          [-0.18178000000000002, 51.530950000000004],
          [-0.18226, 51.53135],
          [-0.18236000000000002, 51.53144],
          [-0.18245, 51.53144],
          [-0.18258000000000002, 51.531530000000004],
          [-0.18261000000000002, 51.531600000000005],
          [-0.18251, 51.531650000000006],
          [-0.18236000000000002, 51.531690000000005],
          [-0.1821, 51.531800000000004],
          [-0.18104, 51.532320000000006],
          [-0.17975000000000002, 51.53296],
        ],
        steps: [
          {
            distance: "0.4 km",
            duration: "1 min",
            instructions:
              "Head <b>northwest</b> on <b>Edgware Rd</b>/<wbr/><b>A5</b> toward <b>Broadley St</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "58 m",
            duration: "1 min",
            instructions: "Turn <b>right</b> onto <b>Orchardson St</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.2 km",
            duration: "1 min",
            instructions: "Turn <b>left</b> onto <b>Lyons Pl</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "20 m",
            duration: "1 min",
            instructions: "Turn <b>right</b> onto <b>Aberdeen Pl</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.1 km",
            duration: "1 min",
            instructions: "Turn <b>left</b> onto <b>Northwick Ter</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "62 m",
            duration: "2 mins",
            instructions:
              "Turn <b>right</b> onto <b>St John's Wood Rd</b>/<wbr/><b>A5205</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.7 km",
            duration: "3 mins",
            instructions: "Turn <b>left</b> onto <b>Hamilton Terrace</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.2 km",
            duration: "1 min",
            instructions:
              'Turn <b>right</b> onto <b>Abercorn Pl</b><div style="font-size:0.9em">Destination will be on the right</div>',
            travelMode: "BICYCLING",
          },
        ],
      },
      transit: {
        distances: {},
        path: [
          [-0.17170000000000002, 51.52112],
          [-0.17154000000000003, 51.521],
          [-0.17139000000000001, 51.521080000000005],
          [-0.17135, 51.521040000000006],
          [-0.17125, 51.520970000000005],
          [-0.17114000000000001, 51.520900000000005],
          [-0.17076000000000002, 51.520590000000006],
          [-0.17047, 51.520390000000006],
          [-0.17022, 51.52024],
          [-0.17025, 51.52022],
          [-0.1703, 51.52024],
          [-0.17048000000000002, 51.52009],
          [-0.17099, 51.51964],
          [-0.17129000000000003, 51.51939],
          [-0.17169, 51.51912],
          [-0.17265000000000003, 51.51849000000001],
          [-0.1743, 51.51765],
          [-0.17488, 51.51749],
          [-0.17542000000000002, 51.517390000000006],
          [-0.17582, 51.51737000000001],
          [-0.17645000000000002, 51.51744000000001],
          [-0.1768, 51.517520000000005],
          [-0.17771, 51.51794],
          [-0.17891, 51.518550000000005],
          [-0.17953000000000002, 51.518890000000006],
          [-0.18001, 51.519180000000006],
          [-0.18048, 51.5195],
          [-0.18127000000000001, 51.52008000000001],
          [-0.18194000000000002, 51.52074],
          [-0.18253000000000003, 51.52143],
          [-0.18316000000000002, 51.522380000000005],
          [-0.18359, 51.523140000000005],
          [-0.18405000000000002, 51.52411000000001],
          [-0.18431, 51.52487000000001],
          [-0.18448, 51.525580000000005],
          [-0.18459, 51.526230000000005],
          [-0.18476, 51.52745],
          [-0.18486000000000002, 51.52803],
          [-0.18502000000000002, 51.528600000000004],
          [-0.18527000000000002, 51.52917000000001],
          [-0.18556, 51.52966000000001],
          [-0.18578000000000003, 51.529970000000006],
          [-0.18587, 51.52994],
          [-0.18580000000000002, 51.52995000000001],
          [-0.18577000000000002, 51.52994],
          [-0.18526, 51.53018],
          [-0.18518, 51.530240000000006],
          [-0.18504, 51.53027],
          [-0.18481, 51.53038],
          [-0.18447000000000002, 51.53054],
          [-0.18422000000000002, 51.53065],
          [-0.18417000000000003, 51.53067000000001],
          [-0.18412, 51.530620000000006],
          [-0.18397000000000002, 51.5307],
          [-0.18404, 51.53076],
          [-0.18389000000000003, 51.53083],
          [-0.18343, 51.53105000000001],
          [-0.18338000000000002, 51.531090000000006],
          [-0.18329, 51.53112],
          [-0.18264000000000002, 51.53144],
          [-0.18242000000000003, 51.53154000000001],
          [-0.18231000000000003, 51.531560000000006],
          [-0.18236000000000002, 51.531600000000005],
          [-0.18231000000000003, 51.53163000000001],
          [-0.18204, 51.53175],
          [-0.18154, 51.53199000000001],
          [-0.18093, 51.532300000000006],
          [-0.17968, 51.532900000000005],
        ],
        steps: [
          {
            distance: "0.1 km",
            duration: "3 mins",
            instructions: "Walk to Edgware Road",
            travelMode: "WALKING",
          },
          {
            distance: "2.2 km",
            duration: "5 mins",
            instructions: "Subway towards Stonebridge Park",
            travelMode: "TRANSIT",
          },
          {
            distance: "0.5 km",
            duration: "10 mins",
            instructions: "Walk to 30 Abercorn Pl, London NW8 9XP, UK",
            travelMode: "WALKING",
          },
        ],
      },
    },
    distances: {
      DRIVING: {
        distance: "1.8 km",
        duration: "6 mins",
      },
      WALKING: {
        distance: "1.8 km",
        duration: "25 mins",
      },
      BICYCLING: {
        distance: "1.8 km",
        duration: "8 mins",
      },
      TRANSIT: {
        distance: "2.0 km",
        duration: "14 mins",
      },
    },
  },
  {
    name: "St John’s Wood Pre-Preparatory",
    category: "Primary Schools",
    coordinates: {
      lat: 51.5307383846794,
      lng: -0.1680567322813868,
    },
    id: "674d98dedeae072033604649",
    routes: {
      driving: {
        distances: {},
        path: [
          [-0.17163, 51.52116],
          [-0.17204000000000003, 51.52145],
          [-0.17247, 51.52174],
          [-0.17257, 51.521750000000004],
          [-0.17300000000000001, 51.52201],
          [-0.17305, 51.522090000000006],
          [-0.17321, 51.522200000000005],
          [-0.17347, 51.522380000000005],
          [-0.17413, 51.52284],
          [-0.17479, 51.523300000000006],
          [-0.17432, 51.52357000000001],
          [-0.17397, 51.52389],
          [-0.17302, 51.52469000000001],
          [-0.17182, 51.525710000000004],
          [-0.17132000000000003, 51.52617000000001],
          [-0.17174, 51.526360000000004],
          [-0.17201000000000002, 51.52648000000001],
          [-0.17269, 51.52678],
          [-0.17301000000000002, 51.52694],
          [-0.17294, 51.52698],
          [-0.17283, 51.52704000000001],
          [-0.17183, 51.52751000000001],
          [-0.17041, 51.528180000000006],
          [-0.16953000000000001, 51.52859],
          [-0.16888, 51.52892000000001],
          [-0.16823000000000002, 51.52922],
          [-0.16754000000000002, 51.529520000000005],
          [-0.16729000000000002, 51.529630000000004],
          [-0.16735000000000003, 51.529700000000005],
          [-0.16759000000000002, 51.529810000000005],
          [-0.16781000000000001, 51.52991],
          [-0.16815000000000002, 51.53002000000001],
          [-0.16816, 51.530060000000006],
          [-0.16816, 51.53011000000001],
          [-0.16815000000000002, 51.53018],
          [-0.16813, 51.530210000000004],
          [-0.16786, 51.530330000000006],
          [-0.16757000000000002, 51.53063],
          [-0.16748000000000002, 51.53076],
          [-0.16741, 51.530860000000004],
          [-0.16752, 51.5309],
          [-0.16774, 51.53108],
          [-0.16816, 51.53087000000001],
          [-0.16817000000000001, 51.53083],
          [-0.16802, 51.530820000000006],
        ],
        steps: [
          {
            distance: "0.3 km",
            duration: "1 min",
            instructions:
              "Head <b>northwest</b> on <b>Edgware Rd</b>/<wbr/><b>A5</b> toward <b>Broadley St</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "0.4 km",
            duration: "2 mins",
            instructions: "Turn <b>right</b> onto <b>Frampton St</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "0.1 km",
            duration: "1 min",
            instructions:
              "Turn <b>left</b> onto <b>Lisson Grove</b>/<wbr/><b>B507</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "0.5 km",
            duration: "1 min",
            instructions: "Turn <b>right</b> onto <b>Lodge Rd</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "48 m",
            duration: "1 min",
            instructions:
              "Turn <b>left</b> onto <b>Park Rd</b>/<wbr/><b>A41</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "0.1 km",
            duration: "1 min",
            instructions:
              "At the roundabout, take the <b>2nd</b> exit onto <b>Prince Albert Rd</b>/<wbr/><b>A5205</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "33 m",
            duration: "1 min",
            instructions: "Turn <b>left</b> onto <b>St John's Wood High St</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "42 m",
            duration: "1 min",
            instructions:
              'Turn <b>left</b><div style="font-size:0.9em">Restricted usage road</div>',
            travelMode: "DRIVING",
          },
          {
            distance: "10 m",
            duration: "1 min",
            instructions:
              'Turn <b>left</b><div style="font-size:0.9em">Restricted usage road</div><div style="font-size:0.9em">Destination will be on the right</div>',
            travelMode: "DRIVING",
          },
        ],
      },
      walking: {
        distances: {},
        path: [
          [-0.17170000000000002, 51.52112],
          [-0.17187000000000002, 51.52122000000001],
          [-0.17211, 51.521390000000004],
          [-0.17256000000000002, 51.52169000000001],
          [-0.17270000000000002, 51.52178000000001],
          [-0.17272, 51.52176000000001],
          [-0.17284000000000002, 51.52183],
          [-0.17285, 51.52185000000001],
          [-0.17304000000000003, 51.52197],
          [-0.17329000000000003, 51.5221],
          [-0.17349, 51.52226],
          [-0.17384000000000002, 51.522490000000005],
          [-0.17393, 51.52261000000001],
          [-0.17405, 51.52266],
          [-0.17427, 51.52282],
          [-0.17441, 51.522920000000006],
          [-0.17462000000000003, 51.523070000000004],
          [-0.17475000000000002, 51.523160000000004],
          [-0.17472000000000001, 51.52317000000001],
          [-0.17456000000000002, 51.52326000000001],
          [-0.17465000000000003, 51.523320000000005],
          [-0.17443, 51.52344],
          [-0.17427, 51.523540000000004],
          [-0.17411000000000001, 51.523680000000006],
          [-0.17382, 51.52394],
          [-0.17364000000000002, 51.52412],
          [-0.17351000000000003, 51.524210000000004],
          [-0.17311, 51.524550000000005],
          [-0.17291, 51.52469000000001],
          [-0.17277, 51.52483],
          [-0.17202, 51.52546],
          [-0.17174, 51.525710000000004],
          [-0.17168000000000003, 51.52572000000001],
          [-0.1713, 51.526070000000004],
          [-0.17124, 51.52604],
          [-0.17122, 51.52606],
          [-0.17109000000000002, 51.52617000000001],
          [-0.17167000000000002, 51.52642],
          [-0.17169, 51.52644],
          [-0.17164000000000001, 51.526520000000005],
          [-0.17162000000000002, 51.52656],
          [-0.17156000000000002, 51.526590000000006],
          [-0.17146, 51.526610000000005],
          [-0.17142000000000002, 51.5266],
          [-0.17134000000000002, 51.52657000000001],
          [-0.17127, 51.526590000000006],
          [-0.17097, 51.52664000000001],
          [-0.17071, 51.526680000000006],
          [-0.17022, 51.526770000000006],
          [-0.16961, 51.52693000000001],
          [-0.16905, 51.52716],
          [-0.16875, 51.52731000000001],
          [-0.16842000000000001, 51.5275],
          [-0.16821000000000003, 51.52758000000001],
          [-0.16807000000000002, 51.527660000000004],
          [-0.16788, 51.527840000000005],
          [-0.16763, 51.528090000000006],
          [-0.16746000000000003, 51.528290000000005],
          [-0.16726000000000002, 51.528580000000005],
          [-0.16714, 51.528740000000006],
          [-0.16716, 51.528780000000005],
          [-0.16697, 51.52895],
          [-0.16687000000000002, 51.52904],
          [-0.16679000000000002, 51.52911],
          [-0.16694, 51.52919000000001],
          [-0.16734000000000002, 51.52951],
          [-0.16713, 51.529610000000005],
          [-0.16722, 51.529770000000006],
          [-0.16743000000000002, 51.530170000000005],
          [-0.16745000000000002, 51.53022000000001],
          [-0.16746000000000003, 51.530240000000006],
          [-0.16739, 51.53040000000001],
          [-0.16737000000000002, 51.5305],
          [-0.16727, 51.530710000000006],
          [-0.16754000000000002, 51.530770000000004],
          [-0.1675, 51.530820000000006],
          [-0.16769, 51.53094],
          [-0.16781000000000001, 51.53103],
          [-0.16815000000000002, 51.53087000000001],
          [-0.16801000000000002, 51.530860000000004],
          [-0.16802, 51.530820000000006],
        ],
        steps: [
          {
            distance: "87 m",
            duration: "1 min",
            instructions:
              "Head <b>northwest</b> on <b>Edgware Rd</b>/<wbr/><b>A5</b> toward <b>Broadley St</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.2 km",
            duration: "3 mins",
            instructions:
              "Slight <b>left</b> to stay on <b>Edgware Rd</b>/<wbr/><b>A5</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.4 km",
            duration: "6 mins",
            instructions: "Turn <b>right</b> onto <b>Frampton St</b>",
            travelMode: "WALKING",
          },
          {
            distance: "5 m",
            duration: "1 min",
            instructions:
              "Turn <b>right</b> onto <b>Lisson Grove</b>/<wbr/><b>B507</b>",
            travelMode: "WALKING",
          },
          {
            distance: "41 m",
            duration: "1 min",
            instructions: "Cross the road",
            travelMode: "WALKING",
          },
          {
            distance: "0.4 km",
            duration: "6 mins",
            instructions:
              'Turn <b>right</b> onto <b>Regent\'s Canal Towpath</b><div style="font-size:0.9em">May be closed at certain times or days</div>',
            travelMode: "WALKING",
          },
          {
            distance: "58 m",
            duration: "1 min",
            instructions:
              'Turn <b>left</b> toward <b>Park Rd</b>/<wbr/><b>A41</b><div style="font-size:0.9em">May be closed at certain times or days</div><div style="font-size:0.9em">Take the stairs</div>',
            travelMode: "WALKING",
          },
          {
            distance: "0.1 km",
            duration: "2 mins",
            instructions:
              "Turn <b>left</b> onto <b>Park Rd</b>/<wbr/><b>A41</b>",
            travelMode: "WALKING",
          },
          {
            distance: "91 m",
            duration: "1 min",
            instructions:
              "At the roundabout, take the <b>1st</b> exit onto <b>Prince Albert Rd</b>/<wbr/><b>A5205</b>",
            travelMode: "WALKING",
          },
          {
            distance: "44 m",
            duration: "1 min",
            instructions: "Turn <b>left</b> onto <b>St John's Wood High St</b>",
            travelMode: "WALKING",
          },
          {
            distance: "42 m",
            duration: "1 min",
            instructions:
              'Turn <b>left</b><div style="font-size:0.9em">Restricted usage road</div>',
            travelMode: "WALKING",
          },
          {
            distance: "10 m",
            duration: "1 min",
            instructions:
              'Turn <b>left</b><div style="font-size:0.9em">Restricted usage road</div><div style="font-size:0.9em">Destination will be on the left</div>',
            travelMode: "WALKING",
          },
        ],
      },
      bicycling: {
        distances: {},
        path: [
          [-0.17163, 51.52116],
          [-0.17204000000000003, 51.52145],
          [-0.17247, 51.52174],
          [-0.17257, 51.521750000000004],
          [-0.17300000000000001, 51.52201],
          [-0.17305, 51.522090000000006],
          [-0.17321, 51.522200000000005],
          [-0.17347, 51.522380000000005],
          [-0.17413, 51.52284],
          [-0.17479, 51.523300000000006],
          [-0.17522000000000001, 51.523590000000006],
          [-0.1751, 51.52367],
          [-0.17467000000000002, 51.52393000000001],
          [-0.17464000000000002, 51.52396],
          [-0.17471, 51.524010000000004],
          [-0.17492000000000002, 51.524150000000006],
          [-0.17549, 51.524530000000006],
          [-0.17600000000000002, 51.524910000000006],
          [-0.17609000000000002, 51.524980000000006],
          [-0.1761, 51.525000000000006],
          [-0.17606000000000002, 51.52503],
          [-0.17589000000000002, 51.525130000000004],
          [-0.17624, 51.52541],
          [-0.17700000000000002, 51.52604],
          [-0.17713, 51.526120000000006],
          [-0.17723000000000003, 51.52617000000001],
          [-0.17697000000000002, 51.526300000000006],
          [-0.17595000000000002, 51.52678],
          [-0.17565, 51.52693000000001],
          [-0.17525000000000002, 51.52713000000001],
          [-0.1741, 51.52767000000001],
          [-0.17213, 51.528600000000004],
          [-0.17090000000000002, 51.529180000000004],
          [-0.17026000000000002, 51.52949],
          [-0.16958, 51.52984000000001],
          [-0.16905, 51.530060000000006],
          [-0.16891, 51.53011000000001],
          [-0.16876000000000002, 51.53014],
          [-0.16844, 51.530120000000004],
          [-0.16835000000000003, 51.53014],
          [-0.16786, 51.530330000000006],
          [-0.16757000000000002, 51.53063],
          [-0.16748000000000002, 51.53076],
          [-0.16741, 51.530860000000004],
          [-0.16752, 51.5309],
          [-0.16774, 51.53108],
          [-0.16816, 51.53087000000001],
          [-0.16817000000000001, 51.53083],
          [-0.16802, 51.530820000000006],
        ],
        steps: [
          {
            distance: "0.4 km",
            duration: "1 min",
            instructions:
              "Head <b>northwest</b> on <b>Edgware Rd</b>/<wbr/><b>A5</b> toward <b>Broadley St</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "58 m",
            duration: "1 min",
            instructions: "Turn <b>right</b> onto <b>Orchardson St</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.2 km",
            duration: "1 min",
            instructions: "Turn <b>left</b> onto <b>Lyons Pl</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "20 m",
            duration: "1 min",
            instructions: "Turn <b>right</b> onto <b>Aberdeen Pl</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.1 km",
            duration: "1 min",
            instructions: "Turn <b>left</b> onto <b>Northwick Ter</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.7 km",
            duration: "4 mins",
            instructions:
              "Turn <b>right</b> onto <b>St John's Wood Rd</b>/<wbr/><b>A5205</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "48 m",
            duration: "1 min",
            instructions: "Continue onto <b>Wellington Rd</b>/<wbr/><b>A41</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "88 m",
            duration: "1 min",
            instructions:
              "At the roundabout, take the <b>1st</b> exit onto <b>Prince Albert Rd</b>/<wbr/><b>A5205</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "33 m",
            duration: "1 min",
            instructions: "Turn <b>left</b> onto <b>St John's Wood High St</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "42 m",
            duration: "1 min",
            instructions:
              'Turn <b>left</b><div style="font-size:0.9em">Restricted usage road</div>',
            travelMode: "BICYCLING",
          },
          {
            distance: "10 m",
            duration: "1 min",
            instructions:
              'Turn <b>left</b><div style="font-size:0.9em">Restricted usage road</div><div style="font-size:0.9em">Destination will be on the right</div>',
            travelMode: "BICYCLING",
          },
        ],
      },
      transit: {
        distances: {},
        path: [
          [-0.17170000000000002, 51.52112],
          [-0.17187000000000002, 51.52122000000001],
          [-0.17211, 51.521390000000004],
          [-0.17256000000000002, 51.52169000000001],
          [-0.17270000000000002, 51.52178000000001],
          [-0.17272, 51.52176000000001],
          [-0.17284000000000002, 51.52183],
          [-0.17285, 51.52185000000001],
          [-0.17304000000000003, 51.52197],
          [-0.17329000000000003, 51.5221],
          [-0.17349, 51.52226],
          [-0.17384000000000002, 51.522490000000005],
          [-0.17393, 51.52261000000001],
          [-0.17405, 51.52266],
          [-0.17427, 51.52282],
          [-0.17441, 51.522920000000006],
          [-0.17462000000000003, 51.523070000000004],
          [-0.17475000000000002, 51.523160000000004],
          [-0.17472000000000001, 51.52317000000001],
          [-0.17456000000000002, 51.52326000000001],
          [-0.17465000000000003, 51.523320000000005],
          [-0.17443, 51.52344],
          [-0.17427, 51.523540000000004],
          [-0.17411000000000001, 51.523680000000006],
          [-0.17382, 51.52394],
          [-0.17364000000000002, 51.52412],
          [-0.17351000000000003, 51.524210000000004],
          [-0.17311, 51.524550000000005],
          [-0.17291, 51.52469000000001],
          [-0.17277, 51.52483],
          [-0.17202, 51.52546],
          [-0.17174, 51.525710000000004],
          [-0.17168000000000003, 51.52572000000001],
          [-0.1713, 51.526070000000004],
          [-0.17124, 51.52604],
          [-0.17122, 51.52606],
          [-0.17109000000000002, 51.52617000000001],
          [-0.17167000000000002, 51.52642],
          [-0.17169, 51.52644],
          [-0.17164000000000001, 51.526520000000005],
          [-0.17162000000000002, 51.52656],
          [-0.17156000000000002, 51.526590000000006],
          [-0.17146, 51.526610000000005],
          [-0.17142000000000002, 51.5266],
          [-0.17134000000000002, 51.52657000000001],
          [-0.17127, 51.526590000000006],
          [-0.17097, 51.52664000000001],
          [-0.17071, 51.526680000000006],
          [-0.17022, 51.526770000000006],
          [-0.16961, 51.52693000000001],
          [-0.16905, 51.52716],
          [-0.16875, 51.52731000000001],
          [-0.16842000000000001, 51.5275],
          [-0.16821000000000003, 51.52758000000001],
          [-0.16807000000000002, 51.527660000000004],
          [-0.16788, 51.527840000000005],
          [-0.16763, 51.528090000000006],
          [-0.16746000000000003, 51.528290000000005],
          [-0.16726000000000002, 51.528580000000005],
          [-0.16714, 51.528740000000006],
          [-0.16716, 51.528780000000005],
          [-0.16697, 51.52895],
          [-0.16687000000000002, 51.52904],
          [-0.16679000000000002, 51.52911],
          [-0.16694, 51.52919000000001],
          [-0.16734000000000002, 51.52951],
          [-0.16713, 51.529610000000005],
          [-0.16722, 51.529770000000006],
          [-0.16743000000000002, 51.530170000000005],
          [-0.16745000000000002, 51.53022000000001],
          [-0.16746000000000003, 51.530240000000006],
          [-0.16739, 51.53040000000001],
          [-0.16737000000000002, 51.5305],
          [-0.16727, 51.530710000000006],
          [-0.16754000000000002, 51.530770000000004],
          [-0.1675, 51.530820000000006],
          [-0.16769, 51.53094],
          [-0.16781000000000001, 51.53103],
          [-0.16815000000000002, 51.53087000000001],
          [-0.16801000000000002, 51.530860000000004],
          [-0.16802, 51.530820000000006],
        ],
        steps: [
          {
            distance: "1.6 km",
            duration: "23 mins",
            instructions:
              "Walk to Saint John's House, St John's Wood High St, London NW8 7NE, UK",
            travelMode: "WALKING",
          },
        ],
      },
    },
    distances: {
      DRIVING: {
        distance: "1.6 km",
        duration: "6 mins",
      },
      WALKING: {
        distance: "1.6 km",
        duration: "23 mins",
      },
      BICYCLING: {
        distance: "1.7 km",
        duration: "8 mins",
      },
      TRANSIT: {
        distance: "1.9 km",
        duration: "22 mins",
      },
    },
  },
  {
    name: "Falkner House Boys",
    category: "Primary Schools",
    coordinates: {
      lat: 51.49125237478953,
      lng: -0.19353961693842495,
    },
    id: "674d98f1deae07203360464a",
    routes: {
      driving: {
        distances: {},
        path: [
          [-0.17163, 51.52116],
          [-0.17143000000000003, 51.521],
          [-0.17120000000000002, 51.52087],
          [-0.17077, 51.520520000000005],
          [-0.17046, 51.52028000000001],
          [-0.16955, 51.51966],
          [-0.16810000000000003, 51.518660000000004],
          [-0.16599000000000003, 51.5172],
          [-0.16558, 51.51693],
          [-0.16603, 51.516690000000004],
          [-0.16653, 51.51641000000001],
          [-0.1665, 51.51637],
          [-0.16643000000000002, 51.51628],
          [-0.16634000000000002, 51.5161],
          [-0.16633, 51.516000000000005],
          [-0.16636, 51.51585000000001],
          [-0.16644, 51.515710000000006],
          [-0.16633, 51.51563],
          [-0.16720000000000002, 51.51512],
          [-0.16769, 51.51485],
          [-0.16779000000000002, 51.51491000000001],
          [-0.16783, 51.514920000000004],
          [-0.16794, 51.51494],
          [-0.16811, 51.514920000000004],
          [-0.16827, 51.51491000000001],
          [-0.16821000000000003, 51.514680000000006],
          [-0.16812000000000002, 51.514300000000006],
          [-0.16805, 51.51399000000001],
          [-0.16804000000000002, 51.51399000000001],
          [-0.16802, 51.51399000000001],
          [-0.16801000000000002, 51.513980000000004],
          [-0.168, 51.51395],
          [-0.16801000000000002, 51.51393],
          [-0.16802, 51.51393],
          [-0.16803, 51.513920000000006],
          [-0.16783, 51.51324],
          [-0.16777, 51.513000000000005],
          [-0.16774, 51.512980000000006],
          [-0.16770000000000002, 51.512950000000004],
          [-0.16766, 51.51285000000001],
          [-0.16756000000000001, 51.512480000000004],
          [-0.16876000000000002, 51.512350000000005],
          [-0.16978000000000001, 51.51225],
          [-0.17176000000000002, 51.512060000000005],
          [-0.17222, 51.51202000000001],
          [-0.17215000000000003, 51.511860000000006],
          [-0.17213, 51.511750000000006],
          [-0.17222, 51.51164000000001],
          [-0.17229000000000003, 51.511570000000006],
          [-0.17239000000000002, 51.51153000000001],
          [-0.1726, 51.51144000000001],
          [-0.17266, 51.5114],
          [-0.17272, 51.51135000000001],
          [-0.17276000000000002, 51.51127],
          [-0.17275000000000001, 51.511160000000004],
          [-0.17268000000000003, 51.51106000000001],
          [-0.17247, 51.51095],
          [-0.17112000000000002, 51.510380000000005],
          [-0.17092000000000002, 51.510250000000006],
          [-0.17082000000000003, 51.51015],
          [-0.17070000000000002, 51.510020000000004],
          [-0.17064000000000001, 51.50988],
          [-0.1706, 51.50974],
          [-0.17055, 51.50941],
          [-0.17049, 51.508700000000005],
          [-0.17037000000000002, 51.50750000000001],
          [-0.17040000000000002, 51.507340000000006],
          [-0.17061, 51.50706],
          [-0.17073000000000002, 51.50696000000001],
          [-0.17088, 51.506840000000004],
          [-0.17107000000000003, 51.506730000000005],
          [-0.17122, 51.506690000000006],
          [-0.17139000000000001, 51.50668],
          [-0.17176000000000002, 51.506780000000006],
          [-0.17199, 51.506820000000005],
          [-0.17214000000000002, 51.50679],
          [-0.17224, 51.50674000000001],
          [-0.17236, 51.50661],
          [-0.17295000000000002, 51.505860000000006],
          [-0.17307, 51.50567],
          [-0.17315000000000003, 51.505340000000004],
          [-0.17320000000000002, 51.505210000000005],
          [-0.17351000000000003, 51.50475],
          [-0.17394, 51.504200000000004],
          [-0.17425000000000002, 51.503800000000005],
          [-0.17448000000000002, 51.50347000000001],
          [-0.17459000000000002, 51.50321],
          [-0.17464000000000002, 51.50300000000001],
          [-0.17466, 51.502520000000004],
          [-0.17462000000000003, 51.502430000000004],
          [-0.17457, 51.50224000000001],
          [-0.17455, 51.50216],
          [-0.17453000000000002, 51.501920000000005],
          [-0.17450000000000002, 51.50159000000001],
          [-0.17439000000000002, 51.500280000000004],
          [-0.17437000000000002, 51.50011000000001],
          [-0.17435, 51.50009000000001],
          [-0.17432, 51.50005],
          [-0.17433, 51.50001],
          [-0.17437000000000002, 51.499990000000004],
          [-0.17443, 51.499970000000005],
          [-0.17451000000000003, 51.499990000000004],
          [-0.17456000000000002, 51.500020000000006],
          [-0.17487000000000003, 51.50003],
          [-0.17601000000000003, 51.499950000000005],
          [-0.17864000000000002, 51.499770000000005],
          [-0.17926, 51.49972],
          [-0.17984000000000003, 51.499660000000006],
          [-0.17978000000000002, 51.499390000000005],
          [-0.17967000000000002, 51.498870000000004],
          [-0.17961000000000002, 51.49870000000001],
          [-0.17947000000000002, 51.49806],
          [-0.17942000000000002, 51.497780000000006],
          [-0.17927, 51.49705],
          [-0.17911000000000002, 51.49626000000001],
          [-0.17891, 51.49539000000001],
          [-0.1789, 51.49528],
          [-0.17906000000000002, 51.495270000000005],
          [-0.17968, 51.49523000000001],
          [-0.18236000000000002, 51.49503000000001],
          [-0.18364000000000003, 51.494930000000004],
          [-0.18705000000000002, 51.494670000000006],
          [-0.18791000000000002, 51.494600000000005],
          [-0.18857000000000002, 51.494620000000005],
          [-0.19051, 51.49468],
          [-0.19063000000000002, 51.494690000000006],
          [-0.19110000000000002, 51.494710000000005],
          [-0.19110000000000002, 51.49463],
          [-0.19113000000000002, 51.49441],
          [-0.19114, 51.49428],
          [-0.19111, 51.49418000000001],
          [-0.19057000000000002, 51.493680000000005],
          [-0.19044000000000003, 51.493570000000005],
          [-0.19060000000000002, 51.493480000000005],
          [-0.19078, 51.49336],
          [-0.19098, 51.49325],
          [-0.19178, 51.49279000000001],
          [-0.19267, 51.492270000000005],
          [-0.19284, 51.49215],
          [-0.19261, 51.491960000000006],
          [-0.19227000000000002, 51.491710000000005],
          [-0.19235000000000002, 51.491640000000004],
          [-0.19272, 51.491460000000004],
          [-0.19318000000000002, 51.49116],
          [-0.19327000000000003, 51.4911],
        ],
        steps: [
          {
            distance: "0.6 km",
            duration: "3 mins",
            instructions:
              "Head <b>southeast</b> on <b>Edgware Rd</b>/<wbr/><b>A5</b> toward <b>Newcastle Pl</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "88 m",
            duration: "1 min",
            instructions: "Turn <b>right</b> onto <b>Burwood Pl</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "82 m",
            duration: "1 min",
            instructions: "Turn <b>left</b> onto <b>Norfolk Cres</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "12 m",
            duration: "1 min",
            instructions: "Turn <b>left</b> to stay on <b>Norfolk Cres</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "0.2 km",
            duration: "1 min",
            instructions: "Turn <b>right</b> onto <b>Oxford Square</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "0.3 km",
            duration: "1 min",
            instructions:
              'Turn <b>left</b> onto <b>Hyde Park St</b><div style="font-size:0.9em">Go through 1 roundabout</div>',
            travelMode: "DRIVING",
          },
          {
            distance: "0.3 km",
            duration: "1 min",
            instructions:
              'Turn <b>right</b> onto <b>Bayswater Rd</b>/<wbr/><b>Hyde Park Pl</b>/<wbr/><b>A402</b><div style="font-size:0.9em">Continue to follow Bayswater Rd/<wbr/>A402</div>',
            travelMode: "DRIVING",
          },
          {
            distance: "1.4 km",
            duration: "5 mins",
            instructions: "Turn <b>left</b> onto <b>N Carriage Dr</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "0.2 km",
            duration: "1 min",
            instructions: "Continue onto <b>Exhibition Rd</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "0.4 km",
            duration: "1 min",
            instructions:
              "At the roundabout, take the <b>2nd</b> exit onto <b>Prince Consort Rd</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "0.5 km",
            duration: "1 min",
            instructions: "Turn <b>left</b> onto <b>Queen's Gate</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "0.9 km",
            duration: "3 mins",
            instructions:
              "Turn <b>right</b> onto <b>Cromwell Rd</b>/<wbr/><b>A4</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "0.1 km",
            duration: "1 min",
            instructions: "Turn <b>left</b> onto <b>Knaresborough Pl</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "0.2 km",
            duration: "1 min",
            instructions: "Turn <b>right</b> onto <b>Earls Court Gardens</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "63 m",
            duration: "1 min",
            instructions:
              "Turn <b>left</b> onto <b>Earls Ct Rd</b>/<wbr/><b>A3220</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "0.1 km",
            duration: "1 min",
            instructions:
              'Turn <b>right</b> onto <b>Penywern Rd</b><div style="font-size:0.9em">Destination will be on the right</div>',
            travelMode: "DRIVING",
          },
        ],
      },
      walking: {
        distances: {},
        path: [
          [-0.17170000000000002, 51.52112],
          [-0.17154000000000003, 51.521],
          [-0.17139000000000001, 51.521080000000005],
          [-0.17135, 51.521040000000006],
          [-0.17125, 51.520970000000005],
          [-0.17114000000000001, 51.520900000000005],
          [-0.17076000000000002, 51.520590000000006],
          [-0.17047, 51.520390000000006],
          [-0.17022, 51.52024],
          [-0.17011, 51.52013],
          [-0.16999, 51.520050000000005],
          [-0.17001000000000002, 51.520050000000005],
          [-0.16978000000000001, 51.519890000000004],
          [-0.16951000000000002, 51.51973],
          [-0.16907000000000003, 51.519420000000004],
          [-0.16902, 51.51937],
          [-0.16922, 51.51925000000001],
          [-0.16940000000000002, 51.51915],
          [-0.16952, 51.519090000000006],
          [-0.16970000000000002, 51.51903],
          [-0.16976000000000002, 51.519000000000005],
          [-0.16983, 51.518930000000005],
          [-0.17003000000000001, 51.51879],
          [-0.17055, 51.518510000000006],
          [-0.17073000000000002, 51.518420000000006],
          [-0.17089000000000001, 51.51831000000001],
          [-0.17111, 51.518170000000005],
          [-0.17132000000000003, 51.51807],
          [-0.17173000000000002, 51.51782000000001],
          [-0.17228000000000002, 51.51751],
          [-0.17274, 51.51726000000001],
          [-0.17300000000000001, 51.51711],
          [-0.17375000000000002, 51.516690000000004],
          [-0.17461000000000002, 51.51621],
          [-0.17489000000000002, 51.51605000000001],
          [-0.17515000000000003, 51.51596000000001],
          [-0.17529, 51.515930000000004],
          [-0.17543, 51.515820000000005],
          [-0.17563, 51.51572],
          [-0.17600000000000002, 51.51549000000001],
          [-0.17632, 51.515330000000006],
          [-0.17641, 51.51529000000001],
          [-0.17654, 51.51522000000001],
          [-0.17657, 51.51521],
          [-0.17651000000000003, 51.51518],
          [-0.1768, 51.515010000000004],
          [-0.17696, 51.51494],
          [-0.17732, 51.51474],
          [-0.17761000000000002, 51.514570000000006],
          [-0.1778, 51.51447],
          [-0.17802, 51.51435000000001],
          [-0.17820000000000003, 51.514230000000005],
          [-0.17842000000000002, 51.514120000000005],
          [-0.17861000000000002, 51.514010000000006],
          [-0.17863, 51.514030000000005],
          [-0.17876, 51.513960000000004],
          [-0.17879, 51.513940000000005],
          [-0.17877, 51.51393],
          [-0.17905000000000001, 51.513780000000004],
          [-0.17904, 51.51375],
          [-0.17914000000000002, 51.51371],
          [-0.17929, 51.51364],
          [-0.17949, 51.51355],
          [-0.17957, 51.513510000000004],
          [-0.17955000000000002, 51.513490000000004],
          [-0.18012, 51.51332000000001],
          [-0.18156000000000003, 51.51283],
          [-0.18239000000000002, 51.51256000000001],
          [-0.18272000000000002, 51.512480000000004],
          [-0.18309, 51.51240000000001],
          [-0.1832, 51.51236],
          [-0.18315, 51.512260000000005],
          [-0.18329, 51.51218],
          [-0.18322000000000002, 51.51196],
          [-0.1832, 51.51182000000001],
          [-0.18299, 51.51106000000001],
          [-0.18291000000000002, 51.51075],
          [-0.18287, 51.510650000000005],
          [-0.18287, 51.510630000000006],
          [-0.18275000000000002, 51.51066],
          [-0.1827, 51.51066],
          [-0.18266000000000002, 51.51052000000001],
          [-0.1836, 51.510450000000006],
          [-0.18355000000000002, 51.510310000000004],
          [-0.18353000000000003, 51.510220000000004],
          [-0.18356000000000003, 51.50997],
          [-0.18364000000000003, 51.509530000000005],
          [-0.18369000000000002, 51.50925],
          [-0.18383000000000002, 51.508790000000005],
          [-0.18405000000000002, 51.50808000000001],
          [-0.18421, 51.50766],
          [-0.18464000000000003, 51.50659],
          [-0.18485000000000001, 51.50598],
          [-0.18489000000000003, 51.50583],
          [-0.18477000000000002, 51.50555000000001],
          [-0.18468, 51.50533],
          [-0.18500000000000003, 51.505030000000005],
          [-0.18528000000000003, 51.50477000000001],
          [-0.18544000000000002, 51.50464],
          [-0.18542, 51.50459000000001],
          [-0.1857, 51.50455],
          [-0.18589000000000003, 51.50452000000001],
          [-0.18601, 51.504360000000005],
          [-0.18617, 51.50414000000001],
          [-0.18655000000000002, 51.503620000000005],
          [-0.18673, 51.50339],
          [-0.18679, 51.50336],
          [-0.18677000000000002, 51.5033],
          [-0.18676, 51.50327000000001],
          [-0.18681, 51.503240000000005],
          [-0.18685000000000002, 51.50320000000001],
          [-0.18702000000000002, 51.50298],
          [-0.18734, 51.50254],
          [-0.18741000000000002, 51.502430000000004],
          [-0.18738000000000002, 51.502410000000005],
          [-0.18722000000000003, 51.50238],
          [-0.18715, 51.50236],
          [-0.1872, 51.5022],
          [-0.18721000000000002, 51.50217000000001],
          [-0.18695, 51.50213],
          [-0.18683000000000002, 51.502120000000005],
          [-0.18684, 51.50204],
          [-0.18695, 51.50168000000001],
          [-0.18703, 51.501380000000005],
          [-0.18713000000000002, 51.50112000000001],
          [-0.18721000000000002, 51.501050000000006],
          [-0.18739000000000003, 51.501020000000004],
          [-0.18754, 51.50103000000001],
          [-0.18777000000000002, 51.501050000000006],
          [-0.18775000000000003, 51.50092],
          [-0.18785000000000002, 51.500640000000004],
          [-0.18787, 51.50058000000001],
          [-0.18784, 51.500510000000006],
          [-0.18765, 51.500420000000005],
          [-0.18783000000000002, 51.50020000000001],
          [-0.18778, 51.500060000000005],
          [-0.18782000000000001, 51.499930000000006],
          [-0.18795, 51.49953000000001],
          [-0.18799000000000002, 51.499390000000005],
          [-0.18806, 51.49929],
          [-0.18824000000000002, 51.499300000000005],
          [-0.18824000000000002, 51.499280000000006],
          [-0.18828, 51.498630000000006],
          [-0.18825000000000003, 51.49853],
          [-0.18827000000000002, 51.498340000000006],
          [-0.18830000000000002, 51.498250000000006],
          [-0.18832000000000002, 51.49792000000001],
          [-0.18832000000000002, 51.49757],
          [-0.18832000000000002, 51.49736000000001],
          [-0.18832000000000002, 51.49728],
          [-0.18833000000000003, 51.497170000000004],
          [-0.18867, 51.497170000000004],
          [-0.18884, 51.49716],
          [-0.18892, 51.49712],
          [-0.18907000000000002, 51.497110000000006],
          [-0.18917, 51.49709000000001],
          [-0.1892, 51.497060000000005],
          [-0.18922000000000003, 51.497040000000005],
          [-0.1892, 51.496970000000005],
          [-0.18908000000000003, 51.496640000000006],
          [-0.18904, 51.496590000000005],
          [-0.18910000000000002, 51.49658],
          [-0.1892, 51.49651],
          [-0.18945, 51.496340000000004],
          [-0.18957000000000002, 51.49622],
          [-0.18951, 51.496170000000006],
          [-0.18945, 51.496100000000006],
          [-0.18941000000000002, 51.49597000000001],
          [-0.18943000000000002, 51.49591],
          [-0.18951, 51.49578],
          [-0.18956, 51.49570000000001],
          [-0.1897, 51.49551],
          [-0.18987, 51.49533],
          [-0.1905, 51.494910000000004],
          [-0.19059, 51.49485000000001],
          [-0.19061000000000003, 51.494820000000004],
          [-0.19090000000000001, 51.49483000000001],
          [-0.19098, 51.49483000000001],
          [-0.19099000000000002, 51.49465000000001],
          [-0.19102000000000002, 51.49465000000001],
          [-0.19103, 51.49463],
          [-0.19104000000000002, 51.494460000000004],
          [-0.19104000000000002, 51.49429000000001],
          [-0.19104000000000002, 51.494260000000004],
          [-0.19102000000000002, 51.494200000000006],
          [-0.19121000000000002, 51.494040000000005],
          [-0.19134, 51.493950000000005],
          [-0.19147000000000003, 51.49385],
          [-0.19165000000000001, 51.493640000000006],
          [-0.19180000000000003, 51.49349],
          [-0.19216000000000003, 51.493230000000004],
          [-0.19265000000000002, 51.49288000000001],
          [-0.19293000000000002, 51.49244],
          [-0.19308000000000003, 51.492340000000006],
          [-0.19316000000000003, 51.492270000000005],
          [-0.19306, 51.492230000000006],
          [-0.19291000000000003, 51.492140000000006],
          [-0.19280000000000003, 51.492050000000006],
          [-0.19264, 51.49194000000001],
          [-0.19236, 51.491730000000004],
          [-0.19239, 51.4917],
          [-0.1927, 51.491550000000004],
          [-0.19288000000000002, 51.491440000000004],
          [-0.19334, 51.491130000000005],
        ],
        steps: [
          {
            distance: "0.3 km",
            duration: "4 mins",
            instructions:
              "Head <b>southeast</b> on <b>Edgware Rd</b>/<wbr/><b>A5</b> toward <b>Newcastle Pl</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.7 km",
            duration: "9 mins",
            instructions:
              "Turn <b>right</b> onto <b>Praed St</b>/<wbr/><b>A4205</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.6 km",
            duration: "8 mins",
            instructions:
              'Continue onto <b>Craven Rd</b>/<wbr/><b>B410</b><div style="font-size:0.9em">Continue to follow B410</div>',
            travelMode: "WALKING",
          },
          {
            distance: "0.2 km",
            duration: "3 mins",
            instructions:
              "Turn <b>left</b> onto <b>Leinster Terrace</b>/<wbr/><b>B410</b>",
            travelMode: "WALKING",
          },
          {
            distance: "59 m",
            duration: "1 min",
            instructions:
              "Turn <b>right</b> onto <b>Bayswater Rd</b>/<wbr/><b>A402</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.6 km",
            duration: "8 mins",
            instructions: "Turn <b>left</b>",
            travelMode: "WALKING",
          },
          {
            distance: "93 m",
            duration: "1 min",
            instructions: "Turn <b>right</b> toward <b>Broad Walk</b>",
            travelMode: "WALKING",
          },
          {
            distance: "6 m",
            duration: "1 min",
            instructions: "Turn <b>left</b> onto <b>Broad Walk</b>",
            travelMode: "WALKING",
          },
          {
            distance: "33 m",
            duration: "1 min",
            instructions: "Turn <b>right</b> toward <b>Dial Walk</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.1 km",
            duration: "2 mins",
            instructions: "Turn <b>left</b> toward <b>Dial Walk</b>",
            travelMode: "WALKING",
          },
          {
            distance: "10 m",
            duration: "1 min",
            instructions: "Turn <b>left</b> onto <b>Dial Walk</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.1 km",
            duration: "2 mins",
            instructions:
              "Turn <b>right</b> toward <b>Kensington High St</b>/<wbr/><b>A315</b>",
            travelMode: "WALKING",
          },
          {
            distance: "27 m",
            duration: "1 min",
            instructions:
              "Turn <b>left</b> onto <b>Kensington High St</b>/<wbr/><b>A315</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.2 km",
            duration: "2 mins",
            instructions: "Turn <b>right</b> onto <b>Kensington Ct</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.2 km",
            duration: "3 mins",
            instructions: "Turn <b>left</b> to stay on <b>Kensington Ct</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.2 km",
            duration: "3 mins",
            instructions: "Slight <b>left</b> onto <b>Stanford Rd</b>",
            travelMode: "WALKING",
          },
          {
            distance: "36 m",
            duration: "1 min",
            instructions: "Turn <b>right</b> onto <b>Cornwall Gardens</b>",
            travelMode: "WALKING",
          },
          {
            distance: "4 m",
            duration: "1 min",
            instructions: "Turn <b>left</b> onto <b>Cornwall Mews W</b>",
            travelMode: "WALKING",
          },
          {
            distance: "69 m",
            duration: "1 min",
            instructions:
              "Slight <b>right</b> onto <b>Cornwall Gardens Walk</b>",
            travelMode: "WALKING",
          },
          {
            distance: "54 m",
            duration: "1 min",
            instructions: "Turn <b>right</b> onto <b>Lexham Walk</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.2 km",
            duration: "3 mins",
            instructions: "Turn <b>left</b> onto <b>Lexham Gardens</b>",
            travelMode: "WALKING",
          },
          {
            distance: "37 m",
            duration: "1 min",
            instructions:
              "Turn <b>right</b> onto <b>Cromwell Rd</b>/<wbr/><b>A4</b>",
            travelMode: "WALKING",
          },
          {
            distance: "68 m",
            duration: "1 min",
            instructions: "Turn <b>left</b> onto <b>Knaresborough Pl</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.3 km",
            duration: "3 mins",
            instructions: "Turn <b>right</b> onto <b>Hogarth Rd</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.1 km",
            duration: "2 mins",
            instructions:
              "Turn <b>left</b> onto <b>Earls Ct Rd</b>/<wbr/><b>A3220</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.1 km",
            duration: "1 min",
            instructions:
              'Turn <b>right</b> onto <b>Penywern Rd</b><div style="font-size:0.9em">Destination will be on the right</div>',
            travelMode: "WALKING",
          },
        ],
      },
      bicycling: {
        distances: {},
        path: [
          [-0.17163, 51.52116],
          [-0.17143000000000003, 51.521],
          [-0.17120000000000002, 51.52087],
          [-0.17077, 51.520520000000005],
          [-0.17046, 51.52028000000001],
          [-0.16955, 51.51966],
          [-0.16810000000000003, 51.518660000000004],
          [-0.16599000000000003, 51.5172],
          [-0.16319, 51.51529000000001],
          [-0.1628, 51.51503],
          [-0.16310000000000002, 51.51498],
          [-0.16382000000000002, 51.514860000000006],
          [-0.16532000000000002, 51.5146],
          [-0.16673000000000002, 51.51437000000001],
          [-0.16698000000000002, 51.514320000000005],
          [-0.1668, 51.513600000000004],
          [-0.16660000000000003, 51.51286],
          [-0.16660000000000003, 51.512730000000005],
          [-0.16649000000000003, 51.51239],
          [-0.16643000000000002, 51.51212],
          [-0.16816, 51.51189],
          [-0.16925, 51.51174],
          [-0.17012000000000002, 51.511660000000006],
          [-0.17081000000000002, 51.511630000000004],
          [-0.17126000000000002, 51.511610000000005],
          [-0.17141, 51.511630000000004],
          [-0.17184000000000002, 51.51165],
          [-0.17217000000000002, 51.51169],
          [-0.17229000000000003, 51.511570000000006],
          [-0.17255, 51.51146000000001],
          [-0.17268000000000003, 51.51138],
          [-0.17275000000000001, 51.51131],
          [-0.17276000000000002, 51.511230000000005],
          [-0.17274, 51.511140000000005],
          [-0.17265000000000003, 51.51104],
          [-0.17204000000000003, 51.51077],
          [-0.17148000000000002, 51.510540000000006],
          [-0.17128000000000002, 51.51046],
          [-0.17102, 51.51032000000001],
          [-0.17079000000000003, 51.51012000000001],
          [-0.17069, 51.510000000000005],
          [-0.17063, 51.50983],
          [-0.17059000000000002, 51.509690000000006],
          [-0.17054000000000002, 51.50929000000001],
          [-0.17047, 51.50854],
          [-0.17039, 51.50771],
          [-0.17038, 51.50744],
          [-0.17042000000000002, 51.5073],
          [-0.17067000000000002, 51.50701],
          [-0.17095000000000002, 51.50679],
          [-0.17109000000000002, 51.50672],
          [-0.17125, 51.50668],
          [-0.17143000000000003, 51.50668],
          [-0.17187000000000002, 51.506800000000005],
          [-0.17202, 51.506820000000005],
          [-0.17218000000000003, 51.50677],
          [-0.17228000000000002, 51.5067],
          [-0.17237000000000002, 51.506600000000006],
          [-0.17300000000000001, 51.5058],
          [-0.17309000000000002, 51.50562000000001],
          [-0.17316, 51.505300000000005],
          [-0.17327, 51.50508000000001],
          [-0.17375000000000002, 51.50444],
          [-0.17417000000000002, 51.503910000000005],
          [-0.17434000000000002, 51.50368],
          [-0.17462000000000003, 51.50376000000001],
          [-0.17513, 51.50404],
          [-0.17619, 51.50417],
          [-0.17798000000000003, 51.504360000000005],
          [-0.17966000000000001, 51.504540000000006],
          [-0.18108000000000002, 51.50470000000001],
          [-0.18178000000000002, 51.504740000000005],
          [-0.18259, 51.504720000000006],
          [-0.18542, 51.50459000000001],
          [-0.18461000000000002, 51.50276],
          [-0.18428000000000003, 51.501990000000006],
          [-0.18427000000000002, 51.501940000000005],
          [-0.18431, 51.50182],
          [-0.18416000000000002, 51.50179000000001],
          [-0.18404, 51.50177000000001],
          [-0.18405000000000002, 51.501670000000004],
          [-0.18404, 51.5016],
          [-0.18404, 51.501450000000006],
          [-0.18397000000000002, 51.499970000000005],
          [-0.18391000000000002, 51.49985],
          [-0.18374000000000001, 51.499660000000006],
          [-0.18369000000000002, 51.49958],
          [-0.18368, 51.49949],
          [-0.18368, 51.499120000000005],
          [-0.18369000000000002, 51.49857],
          [-0.18374000000000001, 51.497870000000006],
          [-0.18375000000000002, 51.497640000000004],
          [-0.18367000000000003, 51.49734],
          [-0.18356000000000003, 51.497020000000006],
          [-0.18345, 51.496680000000005],
          [-0.18373, 51.49663],
          [-0.18412, 51.4966],
          [-0.18467000000000003, 51.496590000000005],
          [-0.18500000000000003, 51.496590000000005],
          [-0.18505000000000002, 51.49625],
          [-0.18501, 51.495850000000004],
          [-0.18497000000000002, 51.495380000000004],
          [-0.18494000000000002, 51.49513],
          [-0.18492000000000003, 51.49492000000001],
          [-0.18432, 51.493840000000006],
          [-0.18429, 51.49381],
          [-0.18427000000000002, 51.49381],
          [-0.18424000000000001, 51.49380000000001],
          [-0.18422000000000002, 51.493790000000004],
          [-0.18421, 51.493770000000005],
          [-0.18424000000000001, 51.49374],
          [-0.18425000000000002, 51.493730000000006],
          [-0.18430000000000002, 51.493730000000006],
          [-0.18434, 51.49374],
          [-0.18435, 51.493750000000006],
          [-0.18605000000000002, 51.493390000000005],
          [-0.18668, 51.49322],
          [-0.18698, 51.493880000000004],
          [-0.18757000000000001, 51.49383],
          [-0.18800000000000003, 51.49376],
          [-0.18829, 51.493700000000004],
          [-0.18877000000000002, 51.49353000000001],
          [-0.1892, 51.49331],
          [-0.18961000000000003, 51.493010000000005],
          [-0.18973, 51.49293],
          [-0.18988000000000002, 51.49288000000001],
          [-0.19014, 51.492760000000004],
          [-0.19179000000000002, 51.491800000000005],
          [-0.19199000000000002, 51.49168],
          [-0.19213000000000002, 51.491600000000005],
          [-0.19227000000000002, 51.491710000000005],
          [-0.19235000000000002, 51.491640000000004],
          [-0.19242, 51.49161],
          [-0.19273, 51.49145000000001],
          [-0.19327000000000003, 51.4911],
        ],
        steps: [
          {
            distance: "0.9 km",
            duration: "3 mins",
            instructions:
              "Head <b>southeast</b> on <b>Edgware Rd</b>/<wbr/><b>A5</b> toward <b>Newcastle Pl</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.3 km",
            duration: "1 min",
            instructions:
              'Turn <b>right</b> onto <b>Connaught St</b>/<wbr/><b>Upper Berkeley St</b><div style="font-size:0.9em">Continue to follow Connaught St</div>',
            travelMode: "BICYCLING",
          },
          {
            distance: "0.2 km",
            duration: "1 min",
            instructions: "Turn <b>left</b> onto <b>Albion St</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.3 km",
            duration: "1 min",
            instructions: "Turn <b>right</b> onto <b>N Carriage Dr</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "63 m",
            duration: "1 min",
            instructions: "Slight <b>right</b> to stay on <b>N Carriage Dr</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "1.1 km",
            duration: "3 mins",
            instructions: "Turn <b>left</b> onto <b>W Carriage Dr</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "69 m",
            duration: "1 min",
            instructions: "Turn <b>right</b> toward <b>Mt Walk</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.7 km",
            duration: "2 mins",
            instructions: "Continue onto <b>Mt Walk</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.3 km",
            duration: "1 min",
            instructions: "Turn <b>left</b> onto <b>Broad Walk</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "20 m",
            duration: "1 min",
            instructions:
              "Turn <b>left</b> onto <b>Kensington Rd.</b>/<wbr/><b>A315</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.6 km",
            duration: "2 mins",
            instructions:
              'Turn <b>right</b> onto <b>Palace Gate</b>/<wbr/><b>B325</b><div style="font-size:0.9em">Continue to follow B325</div>',
            travelMode: "BICYCLING",
          },
          {
            distance: "0.1 km",
            duration: "1 min",
            instructions: "Turn <b>right</b> onto <b>Cornwall Gardens</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.2 km",
            duration: "1 min",
            instructions: "Turn <b>left</b> onto <b>Grenville Pl</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.1 km",
            duration: "1 min",
            instructions: "Continue onto <b>Ashburn Pl</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.2 km",
            duration: "1 min",
            instructions:
              "At the roundabout, take the <b>3rd</b> exit onto <b>Courtfield Rd</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "77 m",
            duration: "1 min",
            instructions: "Turn <b>right</b> onto <b>Courtfield Gardens</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.2 km",
            duration: "1 min",
            instructions:
              "Turn <b>left</b> to stay on <b>Courtfield Gardens</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.2 km",
            duration: "1 min",
            instructions: "Continue onto <b>Barkston Gardens</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "15 m",
            duration: "1 min",
            instructions:
              'Turn <b>right</b> onto <b>Earls Ct Rd</b>/<wbr/><b>A3220</b><div style="font-size:0.9em">Walk your bicycle</div>',
            travelMode: "BICYCLING",
          },
          {
            distance: "0.1 km",
            duration: "1 min",
            instructions:
              'Turn <b>left</b> onto <b>Penywern Rd</b><div style="font-size:0.9em">Destination will be on the right</div>',
            travelMode: "BICYCLING",
          },
        ],
      },
      transit: {
        distances: {},
        path: [
          [-0.17170000000000002, 51.52112],
          [-0.17154000000000003, 51.521],
          [-0.17139000000000001, 51.521080000000005],
          [-0.17135, 51.521040000000006],
          [-0.17125, 51.520970000000005],
          [-0.17114000000000001, 51.520900000000005],
          [-0.17076000000000002, 51.520590000000006],
          [-0.17047, 51.520390000000006],
          [-0.17022, 51.52024],
          [-0.17011, 51.52013],
          [-0.16999, 51.520050000000005],
          [-0.17001000000000002, 51.520050000000005],
          [-0.16978000000000001, 51.519890000000004],
          [-0.16968000000000003, 51.519830000000006],
          [-0.16951000000000002, 51.51986],
          [-0.16902, 51.51993],
          [-0.16869, 51.51997],
          [-0.1685, 51.520010000000006],
          [-0.16839, 51.51988000000001],
          [-0.16812000000000002, 51.51957],
          [-0.16799, 51.519670000000005],
          [-0.16704000000000002, 51.520210000000006],
          [-0.167, 51.520160000000004],
          [-0.16720000000000002, 51.52009],
          [-0.16818000000000002, 51.519690000000004],
          [-0.16907000000000003, 51.51919],
          [-0.17206000000000002, 51.51755000000001],
          [-0.17374, 51.516630000000006],
          [-0.17555, 51.51558000000001],
          [-0.17768, 51.51436],
          [-0.17921, 51.51353],
          [-0.17971, 51.51332000000001],
          [-0.18037, 51.5131],
          [-0.18077000000000001, 51.51301],
          [-0.18185, 51.51279],
          [-0.18314000000000002, 51.512600000000006],
          [-0.18358000000000002, 51.51256000000001],
          [-0.18544000000000002, 51.51245],
          [-0.18801, 51.512280000000004],
          [-0.1902, 51.512100000000004],
          [-0.19177000000000002, 51.51192],
          [-0.19227000000000002, 51.51184000000001],
          [-0.19313000000000002, 51.511630000000004],
          [-0.19429000000000002, 51.51127],
          [-0.19459, 51.511160000000004],
          [-0.19503, 51.51097000000001],
          [-0.19535000000000002, 51.510720000000006],
          [-0.19568000000000002, 51.510310000000004],
          [-0.19590000000000002, 51.509930000000004],
          [-0.19601000000000002, 51.509510000000006],
          [-0.19606, 51.50912],
          [-0.19603, 51.508790000000005],
          [-0.19602000000000003, 51.508700000000005],
          [-0.19589, 51.508320000000005],
          [-0.19577000000000003, 51.508],
          [-0.19552000000000003, 51.50743000000001],
          [-0.19527000000000003, 51.506690000000006],
          [-0.19502000000000003, 51.505990000000004],
          [-0.19476000000000002, 51.505320000000005],
          [-0.19431, 51.50408],
          [-0.19383, 51.50273000000001],
          [-0.19385000000000002, 51.502480000000006],
          [-0.19382000000000002, 51.50242],
          [-0.19340000000000002, 51.501920000000005],
          [-0.19260000000000002, 51.50094000000001],
          [-0.19208000000000003, 51.50041],
          [-0.19147000000000003, 51.49980000000001],
          [-0.19089, 51.49924000000001],
          [-0.19029000000000001, 51.498780000000004],
          [-0.19010000000000002, 51.498650000000005],
          [-0.18955000000000002, 51.498310000000004],
          [-0.18933000000000003, 51.49812000000001],
          [-0.18905000000000002, 51.497800000000005],
          [-0.18841000000000002, 51.497080000000004],
          [-0.18827000000000002, 51.496840000000006],
          [-0.1882, 51.496640000000006],
          [-0.18819000000000002, 51.496430000000004],
          [-0.18823, 51.496190000000006],
          [-0.18834, 51.49597000000001],
          [-0.18846000000000002, 51.4958],
          [-0.18874000000000002, 51.495450000000005],
          [-0.18932000000000002, 51.49486],
          [-0.1902, 51.494150000000005],
          [-0.19039, 51.49401],
          [-0.19133000000000003, 51.49333000000001],
          [-0.19192, 51.492940000000004],
          [-0.19365000000000002, 51.49179],
          [-0.19369000000000003, 51.491760000000006],
          [-0.19362000000000001, 51.49172],
          [-0.19365000000000002, 51.49174000000001],
          [-0.19348, 51.49184],
          [-0.19359, 51.4919],
          [-0.19341000000000003, 51.492020000000004],
          [-0.19333000000000003, 51.49208],
          [-0.19328, 51.492110000000004],
          [-0.19324000000000002, 51.492140000000006],
          [-0.19319000000000003, 51.492110000000004],
          [-0.19303, 51.49221000000001],
          [-0.19289, 51.49213],
          [-0.19272, 51.492000000000004],
          [-0.19236, 51.491730000000004],
          [-0.19248, 51.49166],
          [-0.19282000000000002, 51.49148],
          [-0.19325, 51.49119],
          [-0.19334, 51.491130000000005],
        ],
        steps: [
          {
            distance: "0.4 km",
            duration: "7 mins",
            instructions: "Walk to Edgware Road",
            travelMode: "WALKING",
          },
          {
            distance: "4.7 km",
            duration: "12 mins",
            instructions: "Subway towards Wimbledon",
            travelMode: "TRANSIT",
          },
          {
            distance: "0.3 km",
            duration: "4 mins",
            instructions: "Walk to 22 Penywern Rd, London SW5 9SU, UK",
            travelMode: "WALKING",
          },
        ],
      },
    },
    distances: {
      DRIVING: {
        distance: "5.4 km",
        duration: "20 mins",
      },
      WALKING: {
        distance: "4.4 km",
        duration: "1 hour 0 mins",
      },
      BICYCLING: {
        distance: "5.9 km",
        duration: "22 mins",
      },
      TRANSIT: {
        distance: "5.4 km",
        duration: "23 mins",
      },
    },
  },
  {
    name: "Wetherby Preparatory School",
    category: "Primary Schools",
    coordinates: {
      lat: 51.51675644720059,
      lng: -0.16089408439604677,
    },
    id: "674d9904deae07203360464b",
    routes: {
      driving: {
        distances: {},
        path: [
          [-0.17163, 51.52116],
          [-0.17143000000000003, 51.521],
          [-0.17120000000000002, 51.52087],
          [-0.17077, 51.520520000000005],
          [-0.17046, 51.52028000000001],
          [-0.16955, 51.51966],
          [-0.16810000000000003, 51.518660000000004],
          [-0.16599000000000003, 51.5172],
          [-0.16528, 51.51673],
          [-0.16422, 51.516000000000005],
          [-0.16410000000000002, 51.515910000000005],
          [-0.16404000000000002, 51.51594000000001],
          [-0.16394, 51.515980000000006],
          [-0.16388000000000003, 51.51599],
          [-0.16351000000000002, 51.51608],
          [-0.16246000000000002, 51.516270000000006],
          [-0.16072, 51.51657],
          [-0.16082000000000002, 51.51677],
        ],
        steps: [
          {
            distance: "0.8 km",
            duration: "4 mins",
            instructions:
              "Head <b>southeast</b> on <b>Edgware Rd</b>/<wbr/><b>A5</b> toward <b>Newcastle Pl</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "0.2 km",
            duration: "1 min",
            instructions:
              'Turn <b>left</b> onto <b>George St</b><div style="font-size:0.9em">Entering toll zone</div>',
            travelMode: "DRIVING",
          },
          {
            distance: "24 m",
            duration: "1 min",
            instructions:
              'Turn <b>left</b> onto <b>Bryanston Square</b><div style="font-size:0.9em">Destination will be on the left</div>',
            travelMode: "DRIVING",
          },
        ],
      },
      walking: {
        distances: {},
        path: [
          [-0.17170000000000002, 51.52112],
          [-0.17154000000000003, 51.521],
          [-0.17139000000000001, 51.521080000000005],
          [-0.17135, 51.521040000000006],
          [-0.17125, 51.520970000000005],
          [-0.17114000000000001, 51.520900000000005],
          [-0.17076000000000002, 51.520590000000006],
          [-0.17047, 51.520390000000006],
          [-0.17022, 51.52024],
          [-0.17011, 51.52013],
          [-0.16999, 51.520050000000005],
          [-0.17001000000000002, 51.520050000000005],
          [-0.16978000000000001, 51.519890000000004],
          [-0.16951000000000002, 51.51973],
          [-0.16907000000000003, 51.519420000000004],
          [-0.169, 51.51935],
          [-0.16897, 51.519360000000006],
          [-0.16890000000000002, 51.5193],
          [-0.16892000000000001, 51.5193],
          [-0.16870000000000002, 51.51915],
          [-0.16849, 51.518980000000006],
          [-0.16757000000000002, 51.51834],
          [-0.16742, 51.51825],
          [-0.16727, 51.518170000000005],
          [-0.16722, 51.51820000000001],
          [-0.16723000000000002, 51.51816],
          [-0.16716, 51.518150000000006],
          [-0.16717, 51.518130000000006],
          [-0.16718000000000002, 51.51807],
          [-0.16668000000000002, 51.517720000000004],
          [-0.16597, 51.517250000000004],
          [-0.16562000000000002, 51.517030000000005],
          [-0.16554000000000002, 51.516940000000005],
          [-0.16548000000000002, 51.516960000000005],
          [-0.16539, 51.51688000000001],
          [-0.16540000000000002, 51.51688000000001],
          [-0.16528, 51.51679000000001],
          [-0.16523000000000002, 51.516760000000005],
          [-0.16469, 51.51639],
          [-0.16413000000000003, 51.515980000000006],
          [-0.16386, 51.51608],
          [-0.16372, 51.516110000000005],
          [-0.16349000000000002, 51.516160000000006],
          [-0.16243000000000002, 51.51635],
          [-0.16189, 51.51644],
          [-0.16187, 51.516450000000006],
          [-0.16172, 51.51646],
          [-0.16172, 51.51644],
          [-0.16135000000000002, 51.51650000000001],
          [-0.16112, 51.516540000000006],
          [-0.16084, 51.51659],
          [-0.16085000000000002, 51.51661000000001],
          [-0.16092, 51.51675],
        ],
        steps: [
          {
            distance: "0.4 km",
            duration: "6 mins",
            instructions:
              "Head <b>southeast</b> on <b>Edgware Rd</b>/<wbr/><b>A5</b> toward <b>Newcastle Pl</b>",
            travelMode: "WALKING",
          },
          {
            distance: "26 m",
            duration: "1 min",
            instructions:
              "Turn <b>left</b> onto <b>Old Marylebone Rd</b>/<wbr/><b>A501</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.4 km",
            duration: "5 mins",
            instructions:
              "Turn <b>right</b> onto <b>Edgware Rd</b>/<wbr/><b>A5</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.2 km",
            duration: "4 mins",
            instructions: "Turn <b>left</b> onto <b>George St</b>",
            travelMode: "WALKING",
          },
          {
            distance: "24 m",
            duration: "1 min",
            instructions:
              'Turn <b>left</b> onto <b>Bryanston Square</b><div style="font-size:0.9em">Destination will be on the left</div>',
            travelMode: "WALKING",
          },
        ],
      },
      bicycling: {
        distances: {},
        path: [
          [-0.17163, 51.52116],
          [-0.17143000000000003, 51.521],
          [-0.17120000000000002, 51.52087],
          [-0.17077, 51.520520000000005],
          [-0.17046, 51.52028000000001],
          [-0.16955, 51.51966],
          [-0.16810000000000003, 51.518660000000004],
          [-0.16599000000000003, 51.5172],
          [-0.16528, 51.51673],
          [-0.16422, 51.516000000000005],
          [-0.16410000000000002, 51.515910000000005],
          [-0.16404000000000002, 51.51594000000001],
          [-0.16394, 51.515980000000006],
          [-0.16388000000000003, 51.51599],
          [-0.16351000000000002, 51.51608],
          [-0.16246000000000002, 51.516270000000006],
          [-0.16072, 51.51657],
          [-0.16082000000000002, 51.51677],
        ],
        steps: [
          {
            distance: "0.8 km",
            duration: "3 mins",
            instructions:
              "Head <b>southeast</b> on <b>Edgware Rd</b>/<wbr/><b>A5</b> toward <b>Newcastle Pl</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.2 km",
            duration: "1 min",
            instructions:
              'Turn <b>left</b> onto <b>George St</b><div style="font-size:0.9em">Entering toll zone</div>',
            travelMode: "BICYCLING",
          },
          {
            distance: "24 m",
            duration: "1 min",
            instructions:
              'Turn <b>left</b> onto <b>Bryanston Square</b><div style="font-size:0.9em">Destination will be on the left</div>',
            travelMode: "BICYCLING",
          },
        ],
      },
      transit: {
        distances: {},
        path: [
          [-0.17170000000000002, 51.52112],
          [-0.17154000000000003, 51.521],
          [-0.17139000000000001, 51.521080000000005],
          [-0.17135, 51.521040000000006],
          [-0.17125, 51.520970000000005],
          [-0.17114000000000001, 51.520900000000005],
          [-0.17076000000000002, 51.520590000000006],
          [-0.17047, 51.520390000000006],
          [-0.17022, 51.52024],
          [-0.17011, 51.52013],
          [-0.16999, 51.520050000000005],
          [-0.17001000000000002, 51.520050000000005],
          [-0.16978000000000001, 51.519890000000004],
          [-0.16951000000000002, 51.51973],
          [-0.16907000000000003, 51.519420000000004],
          [-0.169, 51.51935],
          [-0.16897, 51.519360000000006],
          [-0.16890000000000002, 51.5193],
          [-0.16892000000000001, 51.5193],
          [-0.16870000000000002, 51.51915],
          [-0.16849, 51.518980000000006],
          [-0.16844, 51.51894000000001],
          [-0.16846000000000003, 51.51896000000001],
          [-0.1685, 51.518930000000005],
          [-0.16810000000000003, 51.518660000000004],
          [-0.16757000000000002, 51.518280000000004],
          [-0.16721000000000003, 51.518040000000006],
          [-0.16599000000000003, 51.5172],
          [-0.16558, 51.51693],
          [-0.16528, 51.51673],
          [-0.16458, 51.51624],
          [-0.16453, 51.516270000000006],
          [-0.16413000000000003, 51.515980000000006],
          [-0.16404000000000002, 51.516020000000005],
          [-0.16372, 51.516110000000005],
          [-0.16349000000000002, 51.516160000000006],
          [-0.16259, 51.51632000000001],
          [-0.16189, 51.51644],
          [-0.16187, 51.516450000000006],
          [-0.16172, 51.51646],
          [-0.16172, 51.51644],
          [-0.16135000000000002, 51.51650000000001],
          [-0.16112, 51.516540000000006],
          [-0.16084, 51.51659],
          [-0.16085000000000002, 51.51661000000001],
          [-0.16092, 51.51675],
        ],
        steps: [
          {
            distance: "0.3 km",
            duration: "5 mins",
            instructions: "Walk to Edgware Road / Praed Street (Stop ED)",
            travelMode: "WALKING",
          },
          {
            distance: "0.4 km",
            duration: "2 mins",
            instructions: "Bus towards New Cross Gate",
            travelMode: "TRANSIT",
          },
          {
            distance: "0.3 km",
            duration: "4 mins",
            instructions: "Walk to 55 Bryanston Square, London W1H 7LL, UK",
            travelMode: "WALKING",
          },
        ],
      },
    },
    distances: {
      DRIVING: {
        distance: "1.1 km",
        duration: "5 mins",
      },
      WALKING: {
        distance: "1.1 km",
        duration: "16 mins",
      },
      BICYCLING: {
        distance: "1.1 km",
        duration: "4 mins",
      },
      TRANSIT: {
        distance: "1.1 km",
        duration: "10 mins",
      },
    },
  },
  {
    name: "Hill House School",
    category: "Primary Schools",
    coordinates: {
      lat: 51.49762867300951,
      lng: -0.1602370169381853,
    },
    id: "674d9918deae07203360464c",
    routes: {
      driving: {
        distances: {},
        path: [
          [-0.17163, 51.52116],
          [-0.17143000000000003, 51.521],
          [-0.17120000000000002, 51.52087],
          [-0.17077, 51.520520000000005],
          [-0.17046, 51.52028000000001],
          [-0.16955, 51.51966],
          [-0.16810000000000003, 51.518660000000004],
          [-0.16599000000000003, 51.5172],
          [-0.16319, 51.51529000000001],
          [-0.16155000000000003, 51.51422],
          [-0.1607, 51.513690000000004],
          [-0.16035000000000002, 51.51348],
          [-0.16011, 51.51335],
          [-0.15998, 51.51332000000001],
          [-0.15990000000000001, 51.51332000000001],
          [-0.15987, 51.51324],
          [-0.1597, 51.513250000000006],
          [-0.15942, 51.51328],
          [-0.15901, 51.51334000000001],
          [-0.15873, 51.513360000000006],
          [-0.15856, 51.51334000000001],
          [-0.15841000000000002, 51.51328],
          [-0.15831, 51.513270000000006],
          [-0.15824000000000002, 51.513160000000006],
          [-0.15796000000000002, 51.51274],
          [-0.15769000000000002, 51.51220000000001],
          [-0.15713000000000002, 51.51111],
          [-0.15683000000000002, 51.510580000000004],
          [-0.15663000000000002, 51.510310000000004],
          [-0.15654, 51.510220000000004],
          [-0.15612, 51.509890000000006],
          [-0.15588000000000002, 51.50974],
          [-0.1555, 51.5095],
          [-0.15507, 51.50918000000001],
          [-0.15376, 51.50797000000001],
          [-0.15304, 51.50735],
          [-0.15247000000000002, 51.506840000000004],
          [-0.15196, 51.506400000000006],
          [-0.15156, 51.506060000000005],
          [-0.15119000000000002, 51.50571000000001],
          [-0.15101, 51.505520000000004],
          [-0.15092, 51.50533],
          [-0.15092, 51.5052],
          [-0.1509, 51.504850000000005],
          [-0.15092, 51.50471],
          [-0.15102000000000002, 51.50441000000001],
          [-0.15108000000000002, 51.50415],
          [-0.15104, 51.50388],
          [-0.15089000000000002, 51.503440000000005],
          [-0.15083000000000002, 51.50336],
          [-0.15079, 51.503330000000005],
          [-0.15071, 51.5033],
          [-0.15045, 51.50332],
          [-0.15014000000000002, 51.50332],
          [-0.15005000000000002, 51.503310000000006],
          [-0.14995, 51.503260000000004],
          [-0.14987, 51.50321],
          [-0.14981, 51.50316],
          [-0.14976, 51.503060000000005],
          [-0.14977000000000001, 51.50292],
          [-0.14980000000000002, 51.502700000000004],
          [-0.14989000000000002, 51.502570000000006],
          [-0.14995, 51.50247],
          [-0.15007, 51.50242],
          [-0.1502, 51.502370000000006],
          [-0.1506, 51.50222],
          [-0.1511, 51.502030000000005],
          [-0.15122000000000002, 51.50204],
          [-0.15135, 51.501990000000006],
          [-0.15149, 51.50197000000001],
          [-0.15175000000000002, 51.502],
          [-0.15198, 51.502210000000005],
          [-0.15213000000000002, 51.502460000000006],
          [-0.15225000000000002, 51.502680000000005],
          [-0.15235, 51.50273000000001],
          [-0.1524, 51.50278],
          [-0.15247000000000002, 51.50285],
          [-0.15255000000000002, 51.50289],
          [-0.15269000000000002, 51.502900000000004],
          [-0.15297000000000002, 51.502880000000005],
          [-0.15380000000000002, 51.502680000000005],
          [-0.15484, 51.50251],
          [-0.15531, 51.502430000000004],
          [-0.1559, 51.50236],
          [-0.15651, 51.502320000000005],
          [-0.15819000000000003, 51.50222],
          [-0.15881, 51.50213],
          [-0.15919000000000003, 51.502050000000004],
          [-0.15995, 51.50186000000001],
          [-0.16025, 51.501780000000004],
          [-0.1602, 51.501580000000004],
          [-0.16005000000000003, 51.50103000000001],
          [-0.15994000000000003, 51.500640000000004],
          [-0.15940000000000001, 51.498760000000004],
          [-0.15910000000000002, 51.49768],
          [-0.16021000000000002, 51.497550000000004],
        ],
        steps: [
          {
            distance: "1.2 km",
            duration: "5 mins",
            instructions:
              "Head <b>southeast</b> on <b>Edgware Rd</b>/<wbr/><b>A5</b> toward <b>Newcastle Pl</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "69 m",
            duration: "1 min",
            instructions: "Keep <b>right</b> to continue on <b>Marble Arch</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "60 m",
            duration: "1 min",
            instructions: "Keep <b>right</b> to stay on <b>Marble Arch</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "1.3 km",
            duration: "3 mins",
            instructions: "Continue onto <b>Park Ln</b>/<wbr/><b>A4202</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "46 m",
            duration: "1 min",
            instructions: "Turn <b>left</b> onto <b>Piccadilly</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "0.2 km",
            duration: "1 min",
            instructions: "Turn <b>right</b> onto <b>Duke of Wellington Pl</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "83 m",
            duration: "1 min",
            instructions: "Turn <b>right</b> onto <b>Grosvenor Pl</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "0.6 km",
            duration: "2 mins",
            instructions: "Slight <b>left</b> onto <b>Knightsbridge</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "0.5 km",
            duration: "2 mins",
            instructions:
              "Turn <b>left</b> onto <b>Sloane St</b>/<wbr/><b>A3216</b>",
            travelMode: "DRIVING",
          },
          {
            distance: "78 m",
            duration: "1 min",
            instructions:
              'Turn <b>right</b> onto <b>Hans St</b><div style="font-size:0.9em">Parts of this road may be closed at certain times or days</div><div style="font-size:0.9em">Destination will be on the right</div>',
            travelMode: "DRIVING",
          },
        ],
      },
      walking: {
        distances: {},
        path: [
          [-0.17170000000000002, 51.52112],
          [-0.17154000000000003, 51.521],
          [-0.17139000000000001, 51.521080000000005],
          [-0.17135, 51.521040000000006],
          [-0.17125, 51.520970000000005],
          [-0.17114000000000001, 51.520900000000005],
          [-0.17076000000000002, 51.520590000000006],
          [-0.17047, 51.520390000000006],
          [-0.17022, 51.52024],
          [-0.17011, 51.52013],
          [-0.16999, 51.520050000000005],
          [-0.17001000000000002, 51.520050000000005],
          [-0.16978000000000001, 51.519890000000004],
          [-0.16951000000000002, 51.51973],
          [-0.16907000000000003, 51.519420000000004],
          [-0.169, 51.51935],
          [-0.16897, 51.519360000000006],
          [-0.16890000000000002, 51.5193],
          [-0.16892000000000001, 51.5193],
          [-0.16870000000000002, 51.51915],
          [-0.16849, 51.518980000000006],
          [-0.16757000000000002, 51.51834],
          [-0.16742, 51.51825],
          [-0.16741, 51.518260000000005],
          [-0.16726000000000002, 51.518170000000005],
          [-0.16723000000000002, 51.51814],
          [-0.16742, 51.51802000000001],
          [-0.16741, 51.518010000000004],
          [-0.16744, 51.517970000000005],
          [-0.16719, 51.51785],
          [-0.16712000000000002, 51.517700000000005],
          [-0.16699000000000003, 51.517610000000005],
          [-0.16684000000000002, 51.517540000000004],
          [-0.16637000000000002, 51.5172],
          [-0.16620000000000001, 51.51708000000001],
          [-0.16602, 51.517030000000005],
          [-0.1658, 51.51688000000001],
          [-0.16582000000000002, 51.516870000000004],
          [-0.16579000000000002, 51.516850000000005],
          [-0.16573000000000002, 51.51681000000001],
          [-0.16567, 51.51684],
          [-0.16551000000000002, 51.51671],
          [-0.16509000000000001, 51.51643000000001],
          [-0.16407000000000002, 51.51574],
          [-0.16379000000000002, 51.515550000000005],
          [-0.16349000000000002, 51.515350000000005],
          [-0.16307000000000002, 51.515060000000005],
          [-0.16310000000000002, 51.51505],
          [-0.16308, 51.515040000000006],
          [-0.16295, 51.514950000000006],
          [-0.163, 51.51494],
          [-0.16336, 51.514880000000005],
          [-0.16371000000000002, 51.51482000000001],
          [-0.16357000000000002, 51.5146],
          [-0.16331, 51.514190000000006],
          [-0.16329000000000002, 51.514100000000006],
          [-0.16323000000000001, 51.51402],
          [-0.16317, 51.51390000000001],
          [-0.16331, 51.51389],
          [-0.16331, 51.513870000000004],
          [-0.16316, 51.51368],
          [-0.16314, 51.51362],
          [-0.16305, 51.51348],
          [-0.16297, 51.51341000000001],
          [-0.16284, 51.51321],
          [-0.16274000000000002, 51.513110000000005],
          [-0.16272, 51.51308],
          [-0.1628, 51.51308],
          [-0.16281, 51.513040000000004],
          [-0.16279000000000002, 51.5129],
          [-0.16271000000000002, 51.5129],
          [-0.1627, 51.51281],
          [-0.16254000000000002, 51.51245],
          [-0.16247, 51.51232],
          [-0.16251000000000002, 51.51234],
          [-0.16238000000000002, 51.51216],
          [-0.16221000000000002, 51.51167],
          [-0.16201000000000002, 51.511210000000005],
          [-0.16137, 51.50972],
          [-0.16122, 51.509370000000004],
          [-0.16128, 51.509150000000005],
          [-0.16127000000000002, 51.509150000000005],
          [-0.16126000000000001, 51.50914],
          [-0.16125, 51.509100000000004],
          [-0.16126000000000001, 51.50909000000001],
          [-0.16132000000000002, 51.509060000000005],
          [-0.16135000000000002, 51.509060000000005],
          [-0.16137, 51.50907],
          [-0.16138000000000002, 51.50907],
          [-0.16193000000000002, 51.50835000000001],
          [-0.16207000000000002, 51.50824],
          [-0.16218000000000002, 51.508210000000005],
          [-0.16226000000000002, 51.508160000000004],
          [-0.16232000000000002, 51.508100000000006],
          [-0.16235000000000002, 51.50802],
          [-0.16235000000000002, 51.50795],
          [-0.16235000000000002, 51.507920000000006],
          [-0.16244, 51.507920000000006],
          [-0.16266000000000003, 51.507810000000006],
          [-0.16335000000000002, 51.50751],
          [-0.16119, 51.50623],
          [-0.15987, 51.50547],
          [-0.15972, 51.505370000000006],
          [-0.15949000000000002, 51.505320000000005],
          [-0.15949000000000002, 51.50517000000001],
          [-0.15940000000000001, 51.505010000000006],
          [-0.15962, 51.50479000000001],
          [-0.15979000000000002, 51.50453],
          [-0.15997, 51.50423000000001],
          [-0.16016000000000002, 51.50401],
          [-0.16037, 51.503840000000004],
          [-0.16047, 51.50379],
          [-0.16068000000000002, 51.503820000000005],
          [-0.16086, 51.50365000000001],
          [-0.16089, 51.50357],
          [-0.16077000000000002, 51.50345],
          [-0.16074000000000002, 51.50318000000001],
          [-0.16073, 51.502790000000005],
          [-0.16065000000000002, 51.50271000000001],
          [-0.16061, 51.50262000000001],
          [-0.16046000000000002, 51.502250000000004],
          [-0.16044, 51.50204],
          [-0.16041000000000002, 51.50195],
          [-0.16037, 51.501960000000004],
          [-0.16019000000000003, 51.502010000000006],
          [-0.16015000000000001, 51.501920000000005],
          [-0.16024000000000002, 51.501900000000006],
          [-0.16023, 51.50184],
          [-0.16018000000000002, 51.501580000000004],
          [-0.16012, 51.50141000000001],
          [-0.15998, 51.50108],
          [-0.15989, 51.500780000000006],
          [-0.15973, 51.50027000000001],
          [-0.15945, 51.49929],
          [-0.15939, 51.4992],
          [-0.15930000000000002, 51.49888000000001],
          [-0.15925, 51.49870000000001],
          [-0.15917, 51.498400000000004],
          [-0.15937, 51.498380000000004],
          [-0.15941000000000002, 51.49837],
          [-0.15939, 51.49828],
          [-0.15923, 51.4977],
          [-0.15985000000000002, 51.49763],
          [-0.16022, 51.49759],
        ],
        steps: [
          {
            distance: "0.4 km",
            duration: "6 mins",
            instructions:
              "Head <b>southeast</b> on <b>Edgware Rd</b>/<wbr/><b>A5</b> toward <b>Newcastle Pl</b>",
            travelMode: "WALKING",
          },
          {
            distance: "30 m",
            duration: "1 min",
            instructions:
              "Turn <b>right</b> onto <b>Sussex Gardens</b>/<wbr/><b>A4209</b>",
            travelMode: "WALKING",
          },
          {
            distance: "52 m",
            duration: "1 min",
            instructions:
              "Sharp <b>left</b> toward <b>Edgware Rd</b>/<wbr/><b>A5</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.4 km",
            duration: "6 mins",
            instructions: "Continue onto <b>Edgware Rd</b>/<wbr/><b>A5</b>",
            travelMode: "WALKING",
          },
          {
            distance: "65 m",
            duration: "1 min",
            instructions:
              'Turn <b>right</b> onto <b>Connaught St</b>/<wbr/><b>Upper Berkeley St</b><div style="font-size:0.9em">Continue to follow Connaught St</div>',
            travelMode: "WALKING",
          },
          {
            distance: "0.1 km",
            duration: "1 min",
            instructions: "Turn <b>left</b> onto <b>Connaught Square</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.5 km",
            duration: "7 mins",
            instructions: "Continue onto <b>Stanhope Pl</b>",
            travelMode: "WALKING",
          },
          {
            distance: "25 m",
            duration: "1 min",
            instructions: "Continue onto <b>Nicholas Hemingway Walk</b>",
            travelMode: "WALKING",
          },
          {
            distance: "18 m",
            duration: "1 min",
            instructions: "Slight <b>left</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.1 km",
            duration: "2 mins",
            instructions: "Turn <b>left</b>",
            travelMode: "WALKING",
          },
          {
            distance: "85 m",
            duration: "1 min",
            instructions: "Turn <b>right</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.4 km",
            duration: "5 mins",
            instructions: "Turn <b>left</b>",
            travelMode: "WALKING",
          },
          {
            distance: "35 m",
            duration: "1 min",
            instructions: "Turn <b>right</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.2 km",
            duration: "2 mins",
            instructions: "Turn <b>right</b>",
            travelMode: "WALKING",
          },
          {
            distance: "15 m",
            duration: "1 min",
            instructions: "Turn <b>right</b> toward <b>Serpentine Walk</b>",
            travelMode: "WALKING",
          },
          {
            distance: "33 m",
            duration: "1 min",
            instructions: "Turn <b>left</b> toward <b>Serpentine Walk</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.1 km",
            duration: "1 min",
            instructions: "Turn <b>left</b> toward <b>Serpentine Walk</b>",
            travelMode: "WALKING",
          },
          {
            distance: "77 m",
            duration: "1 min",
            instructions: "Continue onto <b>Serpentine Walk</b>",
            travelMode: "WALKING",
          },
          {
            distance: "8 m",
            duration: "1 min",
            instructions:
              "Turn <b>left</b> onto <b>Knightsbridge</b>/<wbr/><b>A315</b>/<wbr/><b>A4</b>",
            travelMode: "WALKING",
          },
          {
            distance: "0.5 km",
            duration: "7 mins",
            instructions:
              "Turn <b>right</b> onto <b>Sloane St</b>/<wbr/><b>A3216</b>",
            travelMode: "WALKING",
          },
          {
            distance: "78 m",
            duration: "1 min",
            instructions:
              'Turn <b>right</b> onto <b>Hans St</b><div style="font-size:0.9em">Destination will be on the right</div>',
            travelMode: "WALKING",
          },
        ],
      },
      bicycling: {
        distances: {},
        path: [
          [-0.17163, 51.52116],
          [-0.17143000000000003, 51.521],
          [-0.17120000000000002, 51.52087],
          [-0.17077, 51.520520000000005],
          [-0.17046, 51.52028000000001],
          [-0.16955, 51.51966],
          [-0.16810000000000003, 51.518660000000004],
          [-0.16599000000000003, 51.5172],
          [-0.16319, 51.51529000000001],
          [-0.1628, 51.51503],
          [-0.16310000000000002, 51.51498],
          [-0.16382000000000002, 51.514860000000006],
          [-0.16322, 51.513940000000005],
          [-0.16317, 51.51381000000001],
          [-0.16295, 51.513470000000005],
          [-0.16273, 51.51314000000001],
          [-0.16269, 51.51306],
          [-0.16271000000000002, 51.5129],
          [-0.1627, 51.51281],
          [-0.16262000000000001, 51.512640000000005],
          [-0.16254000000000002, 51.51245],
          [-0.16244, 51.512260000000005],
          [-0.16238000000000002, 51.51216],
          [-0.16215000000000002, 51.512100000000004],
          [-0.16204000000000002, 51.51209000000001],
          [-0.16182000000000002, 51.51209000000001],
          [-0.16125, 51.51209000000001],
          [-0.16083, 51.512060000000005],
          [-0.16048, 51.51198],
          [-0.15996000000000002, 51.5118],
          [-0.1592, 51.511480000000006],
          [-0.15879000000000001, 51.511280000000006],
          [-0.15858000000000003, 51.51115000000001],
          [-0.15839, 51.51102],
          [-0.15826, 51.5108],
          [-0.15789, 51.50996000000001],
          [-0.15766000000000002, 51.509600000000006],
          [-0.15718000000000001, 51.509040000000006],
          [-0.15636, 51.50806000000001],
          [-0.15581, 51.50746],
          [-0.15493, 51.506420000000006],
          [-0.15381, 51.50508000000001],
          [-0.15335000000000001, 51.504540000000006],
          [-0.15319000000000002, 51.504360000000005],
          [-0.15317, 51.504310000000004],
          [-0.15312, 51.50421000000001],
          [-0.1531, 51.504110000000004],
          [-0.1531, 51.50403000000001],
          [-0.15261000000000002, 51.50392],
          [-0.1526, 51.50379],
          [-0.15264000000000003, 51.5037],
          [-0.15265, 51.50365000000001],
          [-0.15276, 51.50354],
          [-0.15284, 51.50347000000001],
          [-0.15298, 51.50338000000001],
          [-0.1531, 51.503330000000005],
          [-0.1534, 51.50325],
          [-0.15389, 51.50318000000001],
          [-0.15486000000000003, 51.50309000000001],
          [-0.15769000000000002, 51.50283],
          [-0.15852000000000002, 51.502750000000006],
          [-0.15847, 51.502410000000005],
          [-0.15846000000000002, 51.502190000000006],
          [-0.15881, 51.50213],
          [-0.15919000000000003, 51.502050000000004],
          [-0.15995, 51.50186000000001],
          [-0.16025, 51.501780000000004],
          [-0.1602, 51.501580000000004],
          [-0.16005000000000003, 51.50103000000001],
          [-0.15978, 51.5001],
          [-0.15910000000000002, 51.49768],
          [-0.16021000000000002, 51.497550000000004],
        ],
        steps: [
          {
            distance: "0.9 km",
            duration: "3 mins",
            instructions:
              "Head <b>southeast</b> on <b>Edgware Rd</b>/<wbr/><b>A5</b> toward <b>Newcastle Pl</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "73 m",
            duration: "1 min",
            instructions:
              'Turn <b>right</b> onto <b>Connaught St</b>/<wbr/><b>Upper Berkeley St</b><div style="font-size:0.9em">Continue to follow Connaught St</div>',
            travelMode: "BICYCLING",
          },
          {
            distance: "0.1 km",
            duration: "1 min",
            instructions: "Turn <b>left</b> onto <b>Connaught Square</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.2 km",
            duration: "1 min",
            instructions: "Continue onto <b>Stanhope Pl</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "1.2 km",
            duration: "3 mins",
            instructions: "Turn <b>left</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "36 m",
            duration: "1 min",
            instructions: "Turn <b>left</b> toward <b>S Carriage Dr</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.5 km",
            duration: "1 min",
            instructions: "Turn <b>right</b> onto <b>S Carriage Dr</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "63 m",
            duration: "1 min",
            instructions: "Turn <b>left</b> onto <b>Albert Gate</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.1 km",
            duration: "1 min",
            instructions:
              "Turn <b>right</b> onto <b>Knightsbridge</b>/<wbr/><b>A4</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "0.5 km",
            duration: "1 min",
            instructions:
              "Turn <b>left</b> onto <b>Sloane St</b>/<wbr/><b>A3216</b>",
            travelMode: "BICYCLING",
          },
          {
            distance: "78 m",
            duration: "1 min",
            instructions:
              'Turn <b>right</b> onto <b>Hans St</b><div style="font-size:0.9em">Destination will be on the right</div>',
            travelMode: "BICYCLING",
          },
        ],
      },
      transit: {
        distances: {},
        path: [
          [-0.17170000000000002, 51.52112],
          [-0.17154000000000003, 51.521],
          [-0.17139000000000001, 51.521080000000005],
          [-0.17135, 51.521040000000006],
          [-0.17125, 51.520970000000005],
          [-0.17114000000000001, 51.520900000000005],
          [-0.17076000000000002, 51.520590000000006],
          [-0.17047, 51.520390000000006],
          [-0.17022, 51.52024],
          [-0.17025, 51.520230000000005],
          [-0.17031000000000002, 51.520250000000004],
          [-0.17027, 51.52028000000001],
          [-0.16993000000000003, 51.520540000000004],
          [-0.16951000000000002, 51.52084000000001],
          [-0.16902, 51.52111000000001],
          [-0.16837000000000002, 51.521390000000004],
          [-0.16735000000000003, 51.521710000000006],
          [-0.16608, 51.52203],
          [-0.16368000000000002, 51.52237],
          [-0.16274000000000002, 51.522510000000004],
          [-0.16116000000000003, 51.52268],
          [-0.15709, 51.52311],
          [-0.15324000000000002, 51.52355000000001],
          [-0.15105000000000002, 51.52393000000001],
          [-0.14948, 51.52420000000001],
          [-0.14893, 51.524210000000004],
          [-0.14865, 51.52418],
          [-0.14837, 51.52412],
          [-0.14779, 51.52393000000001],
          [-0.14676, 51.52346000000001],
          [-0.1464, 51.52322],
          [-0.14628000000000002, 51.523070000000004],
          [-0.14616, 51.52290000000001],
          [-0.14408, 51.51841],
          [-0.14395000000000002, 51.51825],
          [-0.14317000000000002, 51.51791000000001],
          [-0.14301, 51.517810000000004],
          [-0.1429, 51.51771],
          [-0.14225000000000002, 51.516070000000006],
          [-0.14192000000000002, 51.51518],
          [-0.14171, 51.51453000000001],
          [-0.14159000000000002, 51.51426000000001],
          [-0.14135, 51.51391],
          [-0.13913, 51.51133],
          [-0.13827, 51.51039],
          [-0.13811, 51.51023000000001],
          [-0.13792000000000001, 51.510130000000004],
          [-0.13767000000000001, 51.510020000000004],
          [-0.13740000000000002, 51.50994000000001],
          [-0.137, 51.50986],
          [-0.13623000000000002, 51.509840000000004],
          [-0.13574, 51.5099],
          [-0.13533, 51.50997],
          [-0.13497, 51.510020000000004],
          [-0.13459000000000002, 51.51003000000001],
          [-0.13433, 51.510020000000004],
          [-0.13431, 51.51023000000001],
          [-0.13455, 51.50974],
          [-0.13459000000000002, 51.50979],
          [-0.1353, 51.50956000000001],
          [-0.13720000000000002, 51.50892],
          [-0.13902, 51.508340000000004],
          [-0.1405, 51.507830000000006],
          [-0.1419, 51.507200000000005],
          [-0.14294, 51.506690000000006],
          [-0.1441, 51.50605],
          [-0.14655, 51.50473],
          [-0.14754, 51.504200000000004],
          [-0.14813, 51.503930000000004],
          [-0.14881000000000003, 51.503690000000006],
          [-0.14996, 51.503350000000005],
          [-0.15048, 51.503220000000006],
          [-0.15118, 51.50312],
          [-0.15256, 51.502900000000004],
          [-0.15353, 51.50274],
          [-0.15503, 51.50251],
          [-0.15621000000000002, 51.502370000000006],
          [-0.15715, 51.50229],
          [-0.15818000000000002, 51.502230000000004],
          [-0.15877000000000002, 51.50216],
          [-0.15951, 51.502010000000006],
          [-0.16026, 51.501810000000006],
          [-0.16067, 51.501650000000005],
          [-0.16091000000000003, 51.501520000000006],
          [-0.16067, 51.501360000000005],
          [-0.16089, 51.50150000000001],
          [-0.16093000000000002, 51.50153],
          [-0.16119, 51.50137],
          [-0.16137, 51.50126],
          [-0.16106, 51.50099],
          [-0.16083, 51.50081],
          [-0.16080000000000003, 51.500780000000006],
          [-0.16087, 51.500690000000006],
          [-0.16074000000000002, 51.500640000000004],
          [-0.16069, 51.50059],
          [-0.16055000000000003, 51.50014],
          [-0.16046000000000002, 51.499880000000005],
          [-0.16043000000000002, 51.49974],
          [-0.16037, 51.49954],
          [-0.16033, 51.49947],
          [-0.16025, 51.499190000000006],
          [-0.16024000000000002, 51.499120000000005],
          [-0.16034, 51.49911],
          [-0.16035000000000002, 51.49888000000001],
          [-0.16035000000000002, 51.49879000000001],
          [-0.16026, 51.49870000000001],
          [-0.16021000000000002, 51.49859000000001],
          [-0.16001, 51.497870000000006],
          [-0.15997, 51.49774000000001],
          [-0.15998, 51.49766],
          [-0.15996000000000002, 51.497620000000005],
          [-0.16022, 51.49759],
        ],
        steps: [
          {
            distance: "0.1 km",
            duration: "3 mins",
            instructions: "Walk to Edgware Road",
            travelMode: "WALKING",
          },
          {
            distance: "3.7 km",
            duration: "9 mins",
            instructions: "Subway towards Elephant & Castle",
            travelMode: "TRANSIT",
          },
          {
            distance: "56 m",
            duration: "1 min",
            instructions: "Walk to Piccadilly Circus",
            travelMode: "WALKING",
          },
          {
            distance: "2.1 km",
            duration: "5 mins",
            instructions: "Subway towards Heathrow Terminal 5",
            travelMode: "TRANSIT",
          },
          {
            distance: "0.5 km",
            duration: "8 mins",
            instructions: "Walk to 15 Hans St, London SW1X 0NJ, UK",
            travelMode: "WALKING",
          },
        ],
      },
    },
    distances: {
      DRIVING: {
        distance: "4.1 km",
        duration: "15 mins",
      },
      WALKING: {
        distance: "3.3 km",
        duration: "45 mins",
      },
      BICYCLING: {
        distance: "3.7 km",
        duration: "13 mins",
      },
      TRANSIT: {
        distance: "3.8 km",
        duration: "30 mins",
      },
    },
  },
]
